// prettier-ignore
export var schools = [{
  "OBJECTID": 1,
  "TEA": 47,
  "SLN": 47,
  "SCHOOLNAME": "Franklin International Exploratory Academy Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "6920 Meadow Rd.",
  "CITY": "Dallas",
  "ZIP": 75230,
  "PHONE": 9725027100,
  "WEBSITE": "http://www.dallasisd.org/franklin",
  "POINT_X": -96.78454417,
  "POINT_Y": 32.88553957,
  "MasterID": "'057905047",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 53502,
  "dem_popwh": 33922,
  "dem_popbl": 5921,
  "dem_popas": 38,
  "dem_pophi": 8376,
  "dem_popm": 25566,
  "dem_popf": 27935,
  "dem_thh": 24126,
  "dem_popse": 9409,
  "dem_popch": 10996,
  "dem_perwh": 0.634032373,
  "dem_perbl": 0.11066876,
  "dem_peras": 0.000710254,
  "dem_perhi": 0.156554895,
  "dem_perm": 0.477851295,
  "dem_perf": 0.522130014,
  "dem_perse": 0.175862585,
  "dem_perch": 0.205525027,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.867834141,
  "comm_bvp": 0.10636434,
  "comm_cctrcap": 0.377969186,
  "comm_incarpct": 0.002039827,
  "comm_juvcrimecap": 177.0733357,
  "comm_libcap": 0.56695378,
  "comm_ltbvp": 0.082310969,
  "comm_ltrvp": 0.009458271,
  "comm_ocb": 3290.436463,
  "comm_ocbp": 0.289519351,
  "comm_parkcap": 0.077057149,
  "comm_rcb": 5881.831889,
  "comm_rcbp": 0.461070425,
  "comm_rvp": 0.011980106,
  "comm_u18bbp": 0.8729181,
  "comm_evrate": 135.407461,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.199699915,
  "econ_fincap": 6.803445354,
  "econ_medinc": 66860.29751,
  "econ_paydaycap": 1.322892152,
  "econ_pctlwjobs": 0.240340321,
  "econ_pctmwjobs": 0.301547049,
  "econ_totjobs": 66643,
  "econ_pr": 0.126577637,
  "econ_pyr": 0.1442962,
  "econ_ur": 0.035465137,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1744.660956,
  "edu_perbach": 0.359941298,
  "edu_perearlyed": 0.524279211,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.738871202,
  "fam_lcckids": 19.17209841,
  "fam_tphh": 4496.577626,
  "fam_tphhpct": 0.764938618,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2943.973709,
  "hel_castthma": 756.5578697,
  "hel_checkup": 6293.738391,
  "hel_fruitsveggies": 480.1993815,
  "hel_le": 80.95198647,
  "hel_mhlth": 1042.12486,
  "hel_obesity": 2595.530588,
  "hel_perpri": 0.720997033,
  "hel_perpub": 0.256571612,
  "hel_prtopu": 2.810120056,
  "hel_pharmacap": 9.638214252,
  "hel_phlth": 1002.438585,
  "hel_sleep": 2718.903313,
  "hel_stroke": 260.1476987,
  "hel_perins": 0.87159136,
  "hel_perunin": 0.128351947,
  "hel_clincap": 1.511876745,
  "hel_groccap": 2.267815118,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 52,
  "ci_index": 73,
  "eci_index": 72,
  "edi_index": 80,
  "fi_index": 86,
  "hi_index": 60,
  "cri_index": 71,
  "ci_weight": 73,
  "eci_weight": 72,
  "edi_weight": 80,
  "fi_weight": 86,
  "hi_weight": 60,
  "cri_weight": 71,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 2,
  "TEA": 69,
  "SLN": 69,
  "SCHOOLNAME": "Seagoville Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "950 Woody Rd.",
  "CITY": "Dallas",
  "ZIP": 75253,
  "PHONE": 9728927100,
  "WEBSITE": "http://www.dallasisd.org/seagovillems",
  "POINT_X": -96.58334471,
  "POINT_Y": 32.68191098,
  "MasterID": "'057905069",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 22121,
  "dem_popwh": 5136,
  "dem_popbl": 3120,
  "dem_popas": 60,
  "dem_pophi": 13501,
  "dem_popm": 11072,
  "dem_popf": 11048,
  "dem_thh": 5977,
  "dem_popse": 1273,
  "dem_popch": 7960,
  "dem_perwh": 0.232177569,
  "dem_perbl": 0.141042448,
  "dem_peras": 0.002712355,
  "dem_perhi": 0.610325031,
  "dem_perm": 0.500519868,
  "dem_perf": 0.499434926,
  "dem_perse": 0.057547127,
  "dem_perch": 0.359839067,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.798295538,
  "comm_bvp": 0.072101507,
  "comm_cctrcap": 0.456550534,
  "comm_incarpct": 0.003921928,
  "comm_juvcrimecap": 209.6667103,
  "comm_libcap": 0.456550534,
  "comm_ltbvp": 0.064999427,
  "comm_ltrvp": 0.014239275,
  "comm_ocb": 1006.678972,
  "comm_ocbp": 0.266973225,
  "comm_parkcap": 0.047272998,
  "comm_rcb": 1018.285323,
  "comm_rcbp": 0.461893225,
  "comm_rvp": 0.016688784,
  "comm_u18bbp": 0.811098317,
  "comm_evrate": 306.3454083,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.285842823,
  "econ_fincap": 0,
  "econ_medinc": 23866.97191,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.22863485,
  "econ_pctmwjobs": 0.384017758,
  "econ_totjobs": 1802,
  "econ_pr": 0.21151262,
  "econ_pyr": 0.252354987,
  "econ_ur": 0.048997093,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 296.641947,
  "edu_perbach": 0.051455258,
  "edu_perearlyed": 0.243113772,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.267700628,
  "fam_lcckids": 1.267700628,
  "fam_tphh": 1677.366396,
  "fam_tphhpct": 0.562008183,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2829.849125,
  "hel_castthma": 887.5478239,
  "hel_checkup": 5652.418886,
  "hel_fruitsveggies": 346.2496274,
  "hel_le": 75.21327492,
  "hel_mhlth": 1628.540698,
  "hel_obesity": 3409.110314,
  "hel_perpri": 0.333211961,
  "hel_perpub": 0.383277957,
  "hel_prtopu": 0.869374184,
  "hel_pharmacap": 0.782667793,
  "hel_phlth": 1450.829663,
  "hel_sleep": 3272.683747,
  "hel_stroke": 282.4068078,
  "hel_perins": 0.697828956,
  "hel_perunin": 0.3020345,
  "hel_clincap": 0.391333897,
  "hel_groccap": 0.391333897,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 35,
  "ci_index": 67,
  "eci_index": 34,
  "edi_index": 42,
  "fi_index": 6,
  "hi_index": 29,
  "cri_index": 42,
  "ci_weight": 67,
  "eci_weight": 34,
  "edi_weight": 42,
  "fi_weight": 6,
  "hi_weight": 29,
  "cri_weight": 35,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 0,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 3,
  "TEA": 354,
  "SLN": 354,
  "SCHOOLNAME": "Kennedy-Curry Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "6605 Sebring Dr.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9729251600,
  "WEBSITE": "http://www.dallasisd.org/kennedycurry",
  "POINT_X": -96.75786656,
  "POINT_Y": 32.66095638,
  "MasterID": "'057905354",
  "Feeder": "Wilmer-Hutchins",
  "HIGH_SLN": 380,
  "dem_totp": 17892,
  "dem_popwh": 469,
  "dem_popbl": 14107,
  "dem_popas": 21,
  "dem_pophi": 2874,
  "dem_popm": 7997,
  "dem_popf": 9895,
  "dem_thh": 6186,
  "dem_popse": 2241,
  "dem_popch": 5208,
  "dem_perwh": 0.026212833,
  "dem_perbl": 0.78845294,
  "dem_peras": 0.001173709,
  "dem_perhi": 0.160630449,
  "dem_perm": 0.446959535,
  "dem_perf": 0.553040465,
  "dem_perse": 0.125251509,
  "dem_perch": 0.291079812,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.526532614,
  "comm_bvp": 0.058081582,
  "comm_cctrcap": 1.137946837,
  "comm_incarpct": 0.013335252,
  "comm_juvcrimecap": 586.1822976,
  "comm_libcap": 0.568973418,
  "comm_ltbvp": 0.055230513,
  "comm_ltrvp": 0.03043793,
  "comm_ocb": 869.0054697,
  "comm_ocbp": 0.252006811,
  "comm_parkcap": 0.288045242,
  "comm_rcb": 1391.076063,
  "comm_rcbp": 0.508801372,
  "comm_rvp": 0.033466012,
  "comm_u18bbp": 0.472652396,
  "comm_evrate": 209.6667047,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 1,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.367400488,
  "econ_fincap": 0,
  "econ_medinc": 20214.39982,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.246826987,
  "econ_pctmwjobs": 0.458583834,
  "econ_totjobs": 2994,
  "econ_pr": 0.262244768,
  "econ_pyr": 0.21498518,
  "econ_ur": 0.096046849,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 0,
  "edu_oostkids": 1086.770161,
  "edu_perbach": 0.072654979,
  "edu_perearlyed": 0.507462687,
  "edu_qeckids": 1.933754735,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 7.73501894,
  "fam_lcckids": 11.60252841,
  "fam_tphh": 619.7622563,
  "fam_tphhpct": 0.325935707,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4801.453813,
  "hel_castthma": 1170.508057,
  "hel_checkup": 7539.524803,
  "hel_fruitsveggies": 316.2828945,
  "hel_le": 72.62156284,
  "hel_mhlth": 1632.706637,
  "hel_obesity": 4418.977902,
  "hel_perpri": 0.412608256,
  "hel_perpub": 0.435777753,
  "hel_prtopu": 0.946831849,
  "hel_pharmacap": 1.706920255,
  "hel_phlth": 1702.183104,
  "hel_sleep": 4114.973346,
  "hel_stroke": 586.1836685,
  "hel_perins": 0.812731976,
  "hel_perunin": 0.187099314,
  "hel_clincap": 0.568973418,
  "hel_groccap": 0.568973418,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 8,
  "ci_index": 56,
  "eci_index": 27,
  "edi_index": 74,
  "fi_index": 21,
  "hi_index": 17,
  "cri_index": 39,
  "ci_weight": 56,
  "eci_weight": 27,
  "edi_weight": 74,
  "fi_weight": 21,
  "hi_weight": 17,
  "cri_weight": 30,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 4,
  "TEA": 62,
  "SLN": 62,
  "SCHOOLNAME": "Dade Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2727 Grand Ave.",
  "CITY": "Dallas",
  "ZIP": 75215,
  "PHONE": 9727493800,
  "WEBSITE": "http://www.dallasisd.org/dade",
  "POINT_X": -96.77341356,
  "POINT_Y": 32.77121228,
  "MasterID": "'057905062",
  "Feeder": "Madison",
  "HIGH_SLN": 32,
  "dem_totp": 45890,
  "dem_popwh": 11438,
  "dem_popbl": 19027,
  "dem_popas": 31,
  "dem_pophi": 13600,
  "dem_popm": 23999,
  "dem_popf": 21863,
  "dem_thh": 20061,
  "dem_popse": 4404,
  "dem_popch": 8440,
  "dem_perwh": 0.249248202,
  "dem_perbl": 0.414621922,
  "dem_peras": 0.000675528,
  "dem_perhi": 0.296360863,
  "dem_perm": 0.522967967,
  "dem_perf": 0.476421878,
  "dem_perse": 0.095968621,
  "dem_perch": 0.183918065,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 2,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.637824061,
  "comm_bvp": 0.099628511,
  "comm_cctrcap": 2.652784211,
  "comm_incarpct": 0.011797443,
  "comm_juvcrimecap": 794.0729227,
  "comm_libcap": 0.442130702,
  "comm_ltbvp": 0.094974252,
  "comm_ltrvp": 0.050152963,
  "comm_ocb": 1218.484404,
  "comm_ocbp": 0.253399935,
  "comm_parkcap": 0.246331279,
  "comm_rcb": 6592.787328,
  "comm_rcbp": 0.43195239,
  "comm_rvp": 0.055861722,
  "comm_u18bbp": 0.55728437,
  "comm_evrate": 433.5091531,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.473722277,
  "econ_fincap": 9.94794079,
  "econ_medinc": 26579.17634,
  "econ_paydaycap": 2.652784211,
  "econ_pctlwjobs": 0.11955272,
  "econ_pctmwjobs": 0.221239497,
  "econ_totjobs": 158290,
  "econ_pr": 0.306414973,
  "econ_pyr": 0.260761048,
  "econ_ur": 0.070888611,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 1,
  "edu_oostkids": 3873.846765,
  "edu_perbach": 0.202820806,
  "edu_perearlyed": 0.481675393,
  "edu_qeckids": 2.42342619,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 18.17569642,
  "fam_lcckids": 36.35139285,
  "fam_tphh": 1191.533824,
  "fam_tphhpct": 0.383777708,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 3790.462471,
  "hel_castthma": 1027.672649,
  "hel_checkup": 6778.810842,
  "hel_fruitsveggies": 326.4774997,
  "hel_le": 70.45256033,
  "hel_mhlth": 1613.020918,
  "hel_obesity": 3949.040474,
  "hel_perpri": 0.436033391,
  "hel_perpub": 0.347604128,
  "hel_prtopu": 1.25439647,
  "hel_pharmacap": 6.631960527,
  "hel_phlth": 1559.717759,
  "hel_sleep": 3788.532849,
  "hel_stroke": 451.4808807,
  "hel_perins": 0.761157731,
  "hel_perunin": 0.238382156,
  "hel_clincap": 3.315980263,
  "hel_groccap": 1.547457456,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 20,
  "ci_index": 41,
  "eci_index": 41,
  "edi_index": 79,
  "fi_index": 49,
  "hi_index": 34,
  "cri_index": 44,
  "ci_weight": 41,
  "eci_weight": 41,
  "edi_weight": 79,
  "fi_weight": 49,
  "hi_weight": 34,
  "cri_weight": 39,
  "ci_weight_sd": 2,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 5,
  "TEA": 76,
  "SLN": 76,
  "SCHOOLNAME": "Lang Sr. Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "1678 Chenault St.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9729252400,
  "WEBSITE": "http://www.dallasisd.org/lang",
  "POINT_X": -96.68679803,
  "POINT_Y": 32.80176309,
  "MasterID": "'057905076",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 65193,
  "dem_popwh": 14841,
  "dem_popbl": 16687,
  "dem_popas": 51,
  "dem_pophi": 31837,
  "dem_popm": 31880,
  "dem_popf": 33311,
  "dem_thh": 23163,
  "dem_popse": 5994,
  "dem_popch": 18971,
  "dem_perwh": 0.22764714,
  "dem_perbl": 0.255963064,
  "dem_peras": 0.000782293,
  "dem_perhi": 0.488349976,
  "dem_perm": 0.489009556,
  "dem_perf": 0.510959766,
  "dem_perse": 0.091942386,
  "dem_perch": 0.2909975,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.728446203,
  "comm_bvp": 0.192078189,
  "comm_cctrcap": 0.308243518,
  "comm_incarpct": 0.00682517,
  "comm_juvcrimecap": 266.7475485,
  "comm_libcap": 0.308243518,
  "comm_ltbvp": 0.172348887,
  "comm_ltrvp": 0.025670741,
  "comm_ocb": 2823.926258,
  "comm_ocbp": 0.253615976,
  "comm_parkcap": 0.026207603,
  "comm_rcb": 5929.523366,
  "comm_rcbp": 0.492645306,
  "comm_rvp": 0.033503458,
  "comm_u18bbp": 0.70835831,
  "comm_evrate": 254.9173898,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.334491936,
  "econ_fincap": 1.695339352,
  "econ_medinc": 28924.03619,
  "econ_paydaycap": 1.078852315,
  "econ_pctlwjobs": 0.247213241,
  "econ_pctmwjobs": 0.357718477,
  "econ_totjobs": 20723,
  "econ_pr": 0.218171795,
  "econ_pyr": 0.224159443,
  "econ_ur": 0.045778881,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 785.6299953,
  "edu_perbach": 0.137345017,
  "edu_perearlyed": 0.300987548,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 9.011950014,
  "fam_lcckids": 12.72275296,
  "fam_tphh": 4464.810346,
  "fam_tphhpct": 0.600717148,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3545.629188,
  "hel_castthma": 1004.630954,
  "hel_checkup": 6729.490512,
  "hel_fruitsveggies": 379.7554312,
  "hel_le": 77.2372448,
  "hel_mhlth": 1617.373442,
  "hel_obesity": 3732.492353,
  "hel_perpri": 0.48465861,
  "hel_perpub": 0.323931953,
  "hel_prtopu": 1.496174136,
  "hel_pharmacap": 1.674655068,
  "hel_phlth": 1533.667715,
  "hel_sleep": 3661.603383,
  "hel_stroke": 372.036216,
  "hel_perins": 0.759033177,
  "hel_perunin": 0.241089985,
  "hel_clincap": 0.257639241,
  "hel_groccap": 0.386458862,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 27,
  "ci_index": 49,
  "eci_index": 36,
  "edi_index": 55,
  "fi_index": 79,
  "hi_index": 30,
  "cri_index": 43,
  "ci_weight": 49,
  "eci_weight": 36,
  "edi_weight": 55,
  "fi_weight": 79,
  "hi_weight": 30,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 6,
  "TEA": 353,
  "SLN": 353,
  "SCHOOLNAME": "Richards STEAM Academy Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "3831 N. Prairie Creek Rd.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9728925400,
  "WEBSITE": "http://www.dallasisd.org/annrichards",
  "POINT_X": -96.66629604,
  "POINT_Y": 32.77002209,
  "MasterID": "'057905353",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 57337,
  "dem_popwh": 5936,
  "dem_popbl": 15547,
  "dem_popas": 128,
  "dem_pophi": 34872,
  "dem_popm": 27946,
  "dem_popf": 29381,
  "dem_thh": 17086,
  "dem_popse": 4216,
  "dem_popch": 19433,
  "dem_perwh": 0.103528263,
  "dem_perbl": 0.271151264,
  "dem_peras": 0.002232415,
  "dem_perhi": 0.608193662,
  "dem_perm": 0.487399062,
  "dem_perf": 0.512426531,
  "dem_perse": 0.073530181,
  "dem_perch": 0.338925999,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.669526617,
  "comm_bvp": 0.103850847,
  "comm_cctrcap": 0.176156296,
  "comm_incarpct": 0.007229725,
  "comm_juvcrimecap": 239.8132694,
  "comm_libcap": 0,
  "comm_ltbvp": 0.100326882,
  "comm_ltrvp": 0.017933905,
  "comm_ocb": 2784.188663,
  "comm_ocbp": 0.300993543,
  "comm_parkcap": 0.022700599,
  "comm_rcb": 4258.440271,
  "comm_rcbp": 0.543318619,
  "comm_rvp": 0.022531241,
  "comm_u18bbp": 0.660950231,
  "comm_evrate": 272.161477,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.364865161,
  "econ_fincap": 0.176156296,
  "econ_medinc": 24000.54389,
  "econ_paydaycap": 0.352312592,
  "econ_pctlwjobs": 0.201921301,
  "econ_pctmwjobs": 0.387354517,
  "econ_totjobs": 21652,
  "econ_pr": 0.255749147,
  "econ_pyr": 0.311541038,
  "econ_ur": 0.046125092,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 432.1229225,
  "edu_perbach": 0.063909414,
  "edu_perearlyed": 0.19524838,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.212580488,
  "fam_lcckids": 6.255096586,
  "fam_tphh": 4176.602226,
  "fam_tphhpct": 0.580557648,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3563.744819,
  "hel_castthma": 1024.092574,
  "hel_checkup": 6648.151649,
  "hel_fruitsveggies": 352.3435,
  "hel_le": 75.7514036,
  "hel_mhlth": 1730.269062,
  "hel_obesity": 3982.59944,
  "hel_perpri": 0.394460145,
  "hel_perpub": 0.356439467,
  "hel_prtopu": 1.10666798,
  "hel_pharmacap": 1.585406662,
  "hel_phlth": 1621.848407,
  "hel_sleep": 3818.566763,
  "hel_stroke": 377.6329423,
  "hel_perins": 0.720268918,
  "hel_perunin": 0.279625761,
  "hel_clincap": 0.176156296,
  "hel_groccap": 0.704625183,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 23,
  "ci_index": 54,
  "eci_index": 35,
  "edi_index": 42,
  "fi_index": 72,
  "hi_index": 22,
  "cri_index": 40,
  "ci_weight": 54,
  "eci_weight": 35,
  "edi_weight": 42,
  "fi_weight": 72,
  "hi_weight": 22,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 7,
  "TEA": 53,
  "SLN": 53,
  "SCHOOLNAME": "Long Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "6116 Reiger Ave.",
  "CITY": "Dallas",
  "ZIP": 75214,
  "PHONE": 9725024700,
  "WEBSITE": "http://www.dallasisd.org/long",
  "POINT_X": -96.75029681,
  "POINT_Y": 32.80694386,
  "MasterID": "'057905053",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 68180,
  "dem_popwh": 30548,
  "dem_popbl": 7175,
  "dem_popas": 253,
  "dem_pophi": 27247,
  "dem_popm": 34723,
  "dem_popf": 33427,
  "dem_thh": 29475,
  "dem_popse": 6121,
  "dem_popch": 14793,
  "dem_perwh": 0.448049281,
  "dem_perbl": 0.10523614,
  "dem_peras": 0.003710766,
  "dem_perhi": 0.399633324,
  "dem_perm": 0.509284248,
  "dem_perf": 0.490275741,
  "dem_perse": 0.089777061,
  "dem_perch": 0.216969786,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 4,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.789413137,
  "comm_bvp": 0.090026924,
  "comm_cctrcap": 0.589532574,
  "comm_incarpct": 0.00525034,
  "comm_juvcrimecap": 257.8860742,
  "comm_libcap": 0.147383143,
  "comm_ltbvp": 0.086065122,
  "comm_ltrvp": 0.02030096,
  "comm_ocb": 2705.23811,
  "comm_ocbp": 0.247140284,
  "comm_parkcap": 0.220043551,
  "comm_rcb": 7523.984128,
  "comm_rcbp": 0.406100736,
  "comm_rvp": 0.025100083,
  "comm_u18bbp": 0.754235674,
  "comm_evrate": 167.7957088,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.31559659,
  "econ_fincap": 2.505513439,
  "econ_medinc": 44739.60769,
  "econ_paydaycap": 1.621214578,
  "econ_pctlwjobs": 0.301018421,
  "econ_pctmwjobs": 0.358339362,
  "econ_totjobs": 17969,
  "econ_pr": 0.193233299,
  "econ_pyr": 0.303796788,
  "econ_ur": 0.04242219,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1627.183121,
  "edu_perbach": 0.277481435,
  "edu_perearlyed": 0.531858407,
  "edu_qeckids": 0.682829677,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 4.77980774,
  "fam_lcckids": 21.85054967,
  "fam_tphh": 4180.763472,
  "fam_tphhpct": 0.627005478,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2842.229761,
  "hel_castthma": 869.4951639,
  "hel_checkup": 6352.323399,
  "hel_fruitsveggies": 398.6607257,
  "hel_le": 79.14742549,
  "hel_mhlth": 1390.038113,
  "hel_obesity": 3255.527985,
  "hel_perpri": 0.568534933,
  "hel_perpub": 0.248210375,
  "hel_prtopu": 2.290536539,
  "hel_pharmacap": 1.915980865,
  "hel_phlth": 1231.351667,
  "hel_sleep": 3270.208632,
  "hel_stroke": 262.3150135,
  "hel_perins": 0.786626685,
  "hel_perunin": 0.213196925,
  "hel_clincap": 0.736915717,
  "hel_groccap": 1.473831435,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 41,
  "ci_index": 60,
  "eci_index": 34,
  "edi_index": 87,
  "fi_index": 91,
  "hi_index": 43,
  "cri_index": 48,
  "ci_weight": 60,
  "eci_weight": 34,
  "edi_weight": 87,
  "fi_weight": 91,
  "hi_weight": 43,
  "cri_weight": 51,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 8,
  "TEA": 55,
  "SLN": 55,
  "SCHOOLNAME": "Rusk Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2929 Inwood Rd.",
  "CITY": "Dallas",
  "ZIP": 75235,
  "PHONE": 9729252000,
  "WEBSITE": "http://www.dallasisd.org/rusk",
  "POINT_X": -96.83487183,
  "POINT_Y": 32.82671808,
  "MasterID": "'057905055",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 51408,
  "dem_popwh": 27931,
  "dem_popbl": 6014,
  "dem_popas": 159,
  "dem_pophi": 13820,
  "dem_popm": 27284,
  "dem_popf": 24122,
  "dem_thh": 24402,
  "dem_popse": 5510,
  "dem_popch": 7856,
  "dem_perwh": 0.543320106,
  "dem_perbl": 0.116985683,
  "dem_peras": 0.003092904,
  "dem_perhi": 0.268829754,
  "dem_perm": 0.530734516,
  "dem_perf": 0.46922658,
  "dem_perse": 0.107181762,
  "dem_perch": 0.152816682,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.845873362,
  "comm_bvp": 0.118332951,
  "comm_cctrcap": 1.207356456,
  "comm_incarpct": 0.002556032,
  "comm_juvcrimecap": 231.9802503,
  "comm_libcap": 0.402452152,
  "comm_ltbvp": 0.111557518,
  "comm_ltrvp": 0.008985156,
  "comm_ocb": 2359.058386,
  "comm_ocbp": 0.259963037,
  "comm_parkcap": 0.033781868,
  "comm_rcb": 5887.503378,
  "comm_rcbp": 0.384017556,
  "comm_rvp": 0.01083729,
  "comm_u18bbp": 0.793873968,
  "comm_evrate": 159.3710522,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.168253067,
  "econ_fincap": 5.030651899,
  "econ_medinc": 34882.46792,
  "econ_paydaycap": 2.01226076,
  "econ_pctlwjobs": 0.134632778,
  "econ_pctmwjobs": 0.263894272,
  "econ_totjobs": 108354,
  "econ_pr": 0.131012195,
  "econ_pyr": 0.101928863,
  "econ_ur": 0.030319519,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 2021.243622,
  "edu_perbach": 0.304174849,
  "edu_perearlyed": 0.586549063,
  "edu_qeckids": 1.291529471,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 7.749176824,
  "fam_lcckids": 15.49835365,
  "fam_tphh": 2776.625509,
  "fam_tphhpct": 0.728137468,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2390.095481,
  "hel_castthma": 692.072539,
  "hel_checkup": 5504.998582,
  "hel_fruitsveggies": 422.3894884,
  "hel_le": 79.35501278,
  "hel_mhlth": 1058.8427,
  "hel_obesity": 2643.204821,
  "hel_perpri": 0.684860181,
  "hel_perpub": 0.206461211,
  "hel_prtopu": 3.317137293,
  "hel_pharmacap": 10.46375595,
  "hel_phlth": 918.4934797,
  "hel_sleep": 2764.881575,
  "hel_stroke": 199.3496374,
  "hel_perins": 0.829061375,
  "hel_perunin": 0.170858211,
  "hel_clincap": 2.817165064,
  "hel_groccap": 2.01226076,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 61,
  "ci_index": 72,
  "eci_index": 67,
  "edi_index": 92,
  "fi_index": 80,
  "hi_index": 63,
  "cri_index": 65,
  "ci_weight": 72,
  "eci_weight": 67,
  "edi_weight": 92,
  "fi_weight": 80,
  "hi_weight": 63,
  "cri_weight": 72,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 9,
  "TEA": 79,
  "SLN": 79,
  "SCHOOLNAME": "Medrano Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "9815 Brockbank Dr",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9729251300,
  "WEBSITE": "http://www.dallasisd.org/panchomedrano",
  "POINT_X": -96.87636135,
  "POINT_Y": 32.87256123,
  "MasterID": "'057905079",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 55979,
  "dem_popwh": 21554,
  "dem_popbl": 2157,
  "dem_popas": 23,
  "dem_pophi": 30753,
  "dem_popm": 29944,
  "dem_popf": 26030,
  "dem_thh": 18542,
  "dem_popse": 3755,
  "dem_popch": 15365,
  "dem_perwh": 0.385037246,
  "dem_perbl": 0.038532307,
  "dem_peras": 0.000410868,
  "dem_perhi": 0.549366727,
  "dem_perm": 0.534914879,
  "dem_perf": 0.464995802,
  "dem_perse": 0.067078726,
  "dem_perch": 0.274477929,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 0,
  "dem_perch_sd": 2,
  "comm_bbp": 0.681479482,
  "comm_bvp": 0.109630964,
  "comm_cctrcap": 0.179934284,
  "comm_incarpct": 0.0024324,
  "comm_juvcrimecap": 259.781195,
  "comm_libcap": 0.179934284,
  "comm_ltbvp": 0.104891869,
  "comm_ltrvp": 0.007523216,
  "comm_ocb": 1662.010227,
  "comm_ocbp": 0.246887538,
  "comm_parkcap": 0.152921297,
  "comm_rcb": 5386.792182,
  "comm_rcbp": 0.455897547,
  "comm_rvp": 0.009052763,
  "comm_u18bbp": 0.672663597,
  "comm_evrate": 158.6120713,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.27654101,
  "econ_fincap": 2.159211407,
  "econ_medinc": 34485.92189,
  "econ_paydaycap": 4.13848853,
  "econ_pctlwjobs": 0.239117556,
  "econ_pctmwjobs": 0.352266534,
  "econ_totjobs": 42201,
  "econ_pr": 0.177860775,
  "econ_pyr": 0.315465287,
  "econ_ur": 0.047282984,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 484.2681715,
  "edu_perbach": 0.139096885,
  "edu_perearlyed": 0.40388114,
  "edu_qeckids": 0.657080287,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 2.628321148,
  "fam_lcckids": 3.942481722,
  "fam_tphh": 4879.248425,
  "fam_tphhpct": 0.719549378,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2857.107009,
  "hel_castthma": 874.1547207,
  "hel_checkup": 6085.927788,
  "hel_fruitsveggies": 392.7682587,
  "hel_le": 77.42418754,
  "hel_mhlth": 1655.657174,
  "hel_obesity": 3574.622646,
  "hel_perpri": 0.361305027,
  "hel_perpub": 0.255567719,
  "hel_prtopu": 1.413734991,
  "hel_pharmacap": 1.799342839,
  "hel_phlth": 1486.648211,
  "hel_sleep": 3485.177362,
  "hel_stroke": 259.3302539,
  "hel_perins": 0.590833229,
  "hel_perunin": 0.409077042,
  "hel_clincap": 0.359868568,
  "hel_groccap": 0.89967142,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 35,
  "ci_index": 62,
  "eci_index": 39,
  "edi_index": 70,
  "fi_index": 74,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 39,
  "edi_weight": 70,
  "fi_weight": 74,
  "hi_weight": 32,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 10,
  "TEA": 77,
  "SLN": 77,
  "SCHOOLNAME": "Garcia Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "700 E. Eighth St.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 9725025500,
  "WEBSITE": "http://www.dallasisd.org/garcia",
  "POINT_X": -96.81388591,
  "POINT_Y": 32.74985591,
  "MasterID": "'057905077",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 53070,
  "dem_popwh": 9318,
  "dem_popbl": 12812,
  "dem_popas": 62,
  "dem_pophi": 29934,
  "dem_popm": 27632,
  "dem_popf": 25409,
  "dem_thh": 18861,
  "dem_popse": 4929,
  "dem_popch": 13623,
  "dem_perwh": 0.175579423,
  "dem_perbl": 0.241416996,
  "dem_peras": 0.001168268,
  "dem_perhi": 0.564047484,
  "dem_perm": 0.520670812,
  "dem_perf": 0.47878274,
  "dem_perse": 0.092877332,
  "dem_perch": 0.2566987,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.775699602,
  "comm_bvp": 0.136797897,
  "comm_cctrcap": 0.380609718,
  "comm_incarpct": 0.007487672,
  "comm_juvcrimecap": 351.5707942,
  "comm_libcap": 0.190304859,
  "comm_ltbvp": 0.132165585,
  "comm_ltrvp": 0.058050416,
  "comm_ocb": 1795.70157,
  "comm_ocbp": 0.240732394,
  "comm_parkcap": 0.271998686,
  "comm_rcb": 4989.989219,
  "comm_rcbp": 0.437038641,
  "comm_rvp": 0.061676681,
  "comm_u18bbp": 0.812826849,
  "comm_evrate": 151.5778201,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.373366264,
  "econ_fincap": 1.903048589,
  "econ_medinc": 26630.39922,
  "econ_paydaycap": 1.71274373,
  "econ_pctlwjobs": 0.223588654,
  "econ_pctmwjobs": 0.397232118,
  "econ_totjobs": 29192,
  "econ_pr": 0.248490693,
  "econ_pyr": 0.58137134,
  "econ_ur": 0.082066404,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1599.400315,
  "edu_perbach": 0.171017442,
  "edu_perearlyed": 0.53972154,
  "edu_qeckids": 1.494068487,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 8.96441092,
  "fam_lcckids": 17.92882184,
  "fam_tphh": 2513.04769,
  "fam_tphhpct": 0.503883162,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3557.766573,
  "hel_castthma": 951.322011,
  "hel_checkup": 6606.497976,
  "hel_fruitsveggies": 340.6369272,
  "hel_le": 73.53754382,
  "hel_mhlth": 1585.070831,
  "hel_obesity": 3852.010286,
  "hel_perpri": 0.426638366,
  "hel_perpub": 0.342000531,
  "hel_prtopu": 1.247478666,
  "hel_pharmacap": 2.093353448,
  "hel_phlth": 1559.570533,
  "hel_sleep": 3659.663433,
  "hel_stroke": 394.9218188,
  "hel_perins": 0.743016336,
  "hel_perunin": 0.256737293,
  "hel_clincap": 0.951524294,
  "hel_groccap": 1.332134012,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 3,
  "hi_gen": 26,
  "ci_index": 57,
  "eci_index": 32,
  "edi_index": 81,
  "fi_index": 73,
  "hi_index": 28,
  "cri_index": 45,
  "ci_weight": 57,
  "eci_weight": 32,
  "edi_weight": 81,
  "fi_weight": 73,
  "hi_weight": 28,
  "cri_weight": 41,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 11,
  "TEA": 68,
  "SLN": 68,
  "SCHOOLNAME": "Quintanilla Sr. Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2700 Remond Dr.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725023200,
  "WEBSITE": "http://www.dallasisd.org/quintanilla",
  "POINT_X": -96.86566636,
  "POINT_Y": 32.76196999,
  "MasterID": "'057905068",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 53899,
  "dem_popwh": 8644,
  "dem_popbl": 6536,
  "dem_popas": 80,
  "dem_pophi": 37504,
  "dem_popm": 28145,
  "dem_popf": 25736,
  "dem_thh": 17516,
  "dem_popse": 5020,
  "dem_popch": 15184,
  "dem_perwh": 0.160374033,
  "dem_perbl": 0.121263845,
  "dem_peras": 0.001484258,
  "dem_perhi": 0.69581996,
  "dem_perm": 0.522180374,
  "dem_perf": 0.477485668,
  "dem_perse": 0.093137164,
  "dem_perch": 0.281712091,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.709914332,
  "comm_bvp": 0.070362826,
  "comm_cctrcap": 0.935655955,
  "comm_incarpct": 0.0060478,
  "comm_juvcrimecap": 274.5623135,
  "comm_libcap": 0.187131191,
  "comm_ltbvp": 0.069516197,
  "comm_ltrvp": 0.021835137,
  "comm_ocb": 1974.328393,
  "comm_ocbp": 0.232021774,
  "comm_parkcap": 0.110311825,
  "comm_rcb": 4036.698049,
  "comm_rcbp": 0.44740824,
  "comm_rvp": 0.022312184,
  "comm_u18bbp": 0.685066138,
  "comm_evrate": 129.7754809,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.377290763,
  "econ_fincap": 1.871311909,
  "econ_medinc": 24997.85854,
  "econ_paydaycap": 1.684180718,
  "econ_pctlwjobs": 0.182211242,
  "econ_pctmwjobs": 0.36287832,
  "econ_totjobs": 22666,
  "econ_pr": 0.242694845,
  "econ_pyr": 0.227679103,
  "econ_ur": 0.064323516,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 1817.240844,
  "edu_perbach": 0.132198953,
  "edu_perearlyed": 0.430080483,
  "edu_qeckids": 0.673052164,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 12.11493896,
  "fam_lcckids": 15.48019978,
  "fam_tphh": 3448.335523,
  "fam_tphhpct": 0.616270361,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3304.640925,
  "hel_castthma": 911.5457898,
  "hel_checkup": 6425.116271,
  "hel_fruitsveggies": 342.1239956,
  "hel_le": 76.02701976,
  "hel_mhlth": 1607.664697,
  "hel_obesity": 3726.665533,
  "hel_perpri": 0.426123957,
  "hel_perpub": 0.320288151,
  "hel_prtopu": 1.330439343,
  "hel_pharmacap": 2.432705482,
  "hel_phlth": 1575.007502,
  "hel_sleep": 3522.976554,
  "hel_stroke": 345.2494554,
  "hel_perins": 0.717876939,
  "hel_perunin": 0.281768471,
  "hel_clincap": 1.309918336,
  "hel_groccap": 1.309918336,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 32,
  "ci_index": 60,
  "eci_index": 37,
  "edi_index": 73,
  "fi_index": 83,
  "hi_index": 34,
  "cri_index": 46,
  "ci_weight": 60,
  "eci_weight": 37,
  "edi_weight": 73,
  "fi_weight": 83,
  "hi_weight": 34,
  "cri_weight": 46,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 12,
  "TEA": 59,
  "SLN": 59,
  "SCHOOLNAME": "Stockard Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2300 S. Ravinia Dr.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727945700,
  "WEBSITE": "http://www.dallasisd.org/stockard",
  "POINT_X": -96.86730849,
  "POINT_Y": 32.72280038,
  "MasterID": "'057905059",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 88881,
  "dem_popwh": 7041,
  "dem_popbl": 9579,
  "dem_popas": 57,
  "dem_pophi": 71250,
  "dem_popm": 45215,
  "dem_popf": 43640,
  "dem_thh": 25229,
  "dem_popse": 7964,
  "dem_popch": 27025,
  "dem_perwh": 0.079218281,
  "dem_perbl": 0.107773315,
  "dem_peras": 0.000641307,
  "dem_perhi": 0.801633645,
  "dem_perm": 0.508713898,
  "dem_perf": 0.490993576,
  "dem_perse": 0.089602952,
  "dem_perch": 0.304058235,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.715156504,
  "comm_bvp": 0.088287248,
  "comm_cctrcap": 0.226256798,
  "comm_incarpct": 0.003251074,
  "comm_juvcrimecap": 150.7026784,
  "comm_libcap": 0.226256798,
  "comm_ltbvp": 0.084426023,
  "comm_ltrvp": 0.020590363,
  "comm_ocb": 3292.915441,
  "comm_ocbp": 0.229489837,
  "comm_parkcap": 0.075525025,
  "comm_rcb": 5252.251789,
  "comm_rcbp": 0.482028684,
  "comm_rvp": 0.021863893,
  "comm_u18bbp": 0.713790643,
  "comm_evrate": 89.14517832,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.291705164,
  "econ_fincap": 0.791898792,
  "econ_medinc": 24607.46518,
  "econ_paydaycap": 1.923182781,
  "econ_pctlwjobs": 0.303096298,
  "econ_pctmwjobs": 0.475239087,
  "econ_totjobs": 10561,
  "econ_pr": 0.206446674,
  "econ_pyr": 0.331164546,
  "econ_ur": 0.07078337,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 1,
  "edu_oostkids": 583.0371198,
  "edu_perbach": 0.073345399,
  "edu_perearlyed": 0.484375,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.858642665,
  "fam_lcckids": 6.353609639,
  "fam_tphh": 5603.22357,
  "fam_tphhpct": 0.6054942,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3252.314963,
  "hel_castthma": 920.1413855,
  "hel_checkup": 6370.151483,
  "hel_fruitsveggies": 357.9146636,
  "hel_le": 78.13178871,
  "hel_mhlth": 1652.621141,
  "hel_obesity": 3761.358489,
  "hel_perpri": 0.415254811,
  "hel_perpub": 0.330092269,
  "hel_prtopu": 1.257996173,
  "hel_pharmacap": 1.357540787,
  "hel_phlth": 1611.783683,
  "hel_sleep": 3547.83071,
  "hel_stroke": 336.2163968,
  "hel_perins": 0.717508516,
  "hel_perunin": 0.282265888,
  "hel_clincap": 0.226256798,
  "hel_groccap": 1.131283989,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 63,
  "eci_index": 31,
  "edi_index": 61,
  "fi_index": 85,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 63,
  "eci_weight": 31,
  "edi_weight": 61,
  "fi_weight": 85,
  "hi_weight": 32,
  "cri_weight": 43,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 13,
  "TEA": 48,
  "SLN": 48,
  "SCHOOLNAME": "Gaston Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "9565 Mercer Dr.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9725025400,
  "WEBSITE": "http://www.dallasisd.org/gaston",
  "POINT_X": -96.69408557,
  "POINT_Y": 32.82476871,
  "MasterID": "'057905048",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 63836,
  "dem_popwh": 22521,
  "dem_popbl": 10318,
  "dem_popas": 25,
  "dem_pophi": 28992,
  "dem_popm": 30766,
  "dem_popf": 33084,
  "dem_thh": 24339,
  "dem_popse": 7020,
  "dem_popch": 16628,
  "dem_perwh": 0.352794661,
  "dem_perbl": 0.161632934,
  "dem_peras": 0.000391629,
  "dem_perhi": 0.454163795,
  "dem_perm": 0.481953757,
  "dem_perf": 0.518265555,
  "dem_perse": 0.109969296,
  "dem_perch": 0.26047998,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.742929591,
  "comm_bvp": 0.207860365,
  "comm_cctrcap": 0.314564922,
  "comm_incarpct": 0.005437206,
  "comm_juvcrimecap": 266.4119955,
  "comm_libcap": 0.314564922,
  "comm_ltbvp": 0.175851887,
  "comm_ltrvp": 0.022207538,
  "comm_ocb": 3084.943653,
  "comm_ocbp": 0.231775967,
  "comm_parkcap": 0.116056681,
  "comm_rcb": 5009.903616,
  "comm_rcbp": 0.453780128,
  "comm_rvp": 0.031398263,
  "comm_u18bbp": 0.703448956,
  "comm_evrate": 189.0535179,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.295622536,
  "econ_fincap": 1.572824609,
  "econ_medinc": 38614.91374,
  "econ_paydaycap": 1.572824609,
  "econ_pctlwjobs": 0.27980069,
  "econ_pctmwjobs": 0.387600613,
  "econ_totjobs": 10436,
  "econ_pr": 0.182438158,
  "econ_pyr": 0.247163613,
  "econ_ur": 0.042708077,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1101.81643,
  "edu_perbach": 0.184630594,
  "edu_perearlyed": 0.291112294,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.662991055,
  "fam_lcckids": 16.35461441,
  "fam_tphh": 4492.242532,
  "fam_tphhpct": 0.655540081,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3390.492365,
  "hel_castthma": 959.7704537,
  "hel_checkup": 6656.182743,
  "hel_fruitsveggies": 400.6344556,
  "hel_le": 78.11415317,
  "hel_mhlth": 1541.356477,
  "hel_obesity": 3548.349777,
  "hel_perpri": 0.532365966,
  "hel_perpub": 0.294104714,
  "hel_prtopu": 1.810123879,
  "hel_pharmacap": 1.510424844,
  "hel_phlth": 1463.919441,
  "hel_sleep": 3483.80806,
  "hel_stroke": 346.3066338,
  "hel_perins": 0.771223971,
  "hel_perunin": 0.228885957,
  "hel_clincap": 0.125868737,
  "hel_groccap": 0.881081159,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 48,
  "eci_index": 34,
  "edi_index": 57,
  "fi_index": 90,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 48,
  "eci_weight": 34,
  "edi_weight": 57,
  "fi_weight": 90,
  "hi_weight": 32,
  "cri_weight": 39,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 14,
  "TEA": 50,
  "SLN": 50,
  "SCHOOLNAME": "Hill Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "505 Easton Rd.",
  "CITY": "Dallas",
  "ZIP": 75218,
  "PHONE": 9725025700,
  "WEBSITE": "http://www.dallasisd.org/hill",
  "POINT_X": -96.70414493,
  "POINT_Y": 32.85544612,
  "MasterID": "'057905050",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 52688,
  "dem_popwh": 28551,
  "dem_popbl": 5716,
  "dem_popas": 173,
  "dem_pophi": 15507,
  "dem_popm": 25881,
  "dem_popf": 26811,
  "dem_thh": 21766,
  "dem_popse": 7413,
  "dem_popch": 12640,
  "dem_perwh": 0.541888096,
  "dem_perbl": 0.108487701,
  "dem_peras": 0.00328348,
  "dem_perhi": 0.294317492,
  "dem_perm": 0.49121242,
  "dem_perf": 0.508863498,
  "dem_perse": 0.140696174,
  "dem_perch": 0.239902824,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 1,
  "comm_bbp": 0.80644761,
  "comm_bvp": 0.152025436,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.002899829,
  "comm_juvcrimecap": 280.4799325,
  "comm_libcap": 0.191362014,
  "comm_ltbvp": 0.136534206,
  "comm_ltrvp": 0.013145099,
  "comm_ocb": 2624.967407,
  "comm_ocbp": 0.204670677,
  "comm_parkcap": 0.320093569,
  "comm_rcb": 4425.60864,
  "comm_rcbp": 0.494868142,
  "comm_rvp": 0.019089065,
  "comm_u18bbp": 0.814025855,
  "comm_evrate": 167.9201677,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.219907408,
  "econ_fincap": 1.148172087,
  "econ_medinc": 46480.78985,
  "econ_paydaycap": 1.530896116,
  "econ_pctlwjobs": 0.313563403,
  "econ_pctmwjobs": 0.392215088,
  "econ_totjobs": 12460,
  "econ_pr": 0.133133531,
  "econ_pyr": 0.276356128,
  "econ_ur": 0.030155395,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 4,
  "edu_oostkids": 1633.98803,
  "edu_perbach": 0.280044191,
  "edu_perearlyed": 0.406542056,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.563188819,
  "fam_lcckids": 19.07379024,
  "fam_tphh": 4710.325102,
  "fam_tphhpct": 0.763916539,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 3144.455927,
  "hel_castthma": 865.184691,
  "hel_checkup": 6679.871616,
  "hel_fruitsveggies": 430.0877331,
  "hel_le": 79.42105588,
  "hel_mhlth": 1272.180878,
  "hel_obesity": 3066.610375,
  "hel_perpri": 0.637773147,
  "hel_perpub": 0.251438622,
  "hel_prtopu": 2.53649635,
  "hel_pharmacap": 2.296344173,
  "hel_phlth": 1201.507055,
  "hel_sleep": 3123.94853,
  "hel_stroke": 289.2513432,
  "hel_perins": 0.816047565,
  "hel_perunin": 0.183875963,
  "hel_clincap": 0,
  "hel_groccap": 0.956810072,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 38,
  "ci_index": 56,
  "eci_index": 39,
  "edi_index": 62,
  "fi_index": 96,
  "hi_index": 42,
  "cri_index": 46,
  "ci_weight": 56,
  "eci_weight": 39,
  "edi_weight": 62,
  "fi_weight": 96,
  "hi_weight": 42,
  "cri_weight": 48,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 15,
  "TEA": 72,
  "SLN": 72,
  "SCHOOLNAME": "Zumwalt Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2445 E. Ledbetter Dr.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9727493600,
  "WEBSITE": "http://www.dallasisd.org/zumwalt",
  "POINT_X": -96.78254939,
  "POINT_Y": 32.69131048,
  "MasterID": "'057905072",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 41941,
  "dem_popwh": 1016,
  "dem_popbl": 28765,
  "dem_popas": 61,
  "dem_pophi": 11557,
  "dem_popm": 19159,
  "dem_popf": 22788,
  "dem_thh": 15542,
  "dem_popse": 5728,
  "dem_popch": 11577,
  "dem_perwh": 0.024224506,
  "dem_perbl": 0.6858444,
  "dem_peras": 0.001454424,
  "dem_perhi": 0.275553754,
  "dem_perm": 0.456808374,
  "dem_perf": 0.543334684,
  "dem_perse": 0.136572805,
  "dem_perch": 0.276030614,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.442411404,
  "comm_bvp": 0.090906652,
  "comm_cctrcap": 1.20161706,
  "comm_incarpct": 0.0141246,
  "comm_juvcrimecap": 633.2628712,
  "comm_libcap": 0.480646824,
  "comm_ltbvp": 0.085499563,
  "comm_ltrvp": 0.049699639,
  "comm_ocb": 2014.421345,
  "comm_ocbp": 0.280936541,
  "comm_parkcap": 0.174496247,
  "comm_rcb": 4507.512587,
  "comm_rcbp": 0.538237092,
  "comm_rvp": 0.056270406,
  "comm_u18bbp": 0.473250626,
  "comm_evrate": 312.6607589,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.471500247,
  "econ_fincap": 1.20161706,
  "econ_medinc": 17948.00277,
  "econ_paydaycap": 1.20161706,
  "econ_pctlwjobs": 0.326020015,
  "econ_pctmwjobs": 0.41878368,
  "econ_totjobs": 2598,
  "econ_pr": 0.354205229,
  "econ_pyr": 0.308050441,
  "econ_ur": 0.088229765,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 2250.495454,
  "edu_perbach": 0.044526482,
  "edu_perearlyed": 0.44126506,
  "edu_qeckids": 6.075383023,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 24.30153209,
  "fam_lcckids": 21.69779651,
  "fam_tphh": 1344.593893,
  "fam_tphhpct": 0.341523831,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4987.461969,
  "hel_castthma": 1225.255565,
  "hel_checkup": 7463.331106,
  "hel_fruitsveggies": 268.2125097,
  "hel_le": 70.24027884,
  "hel_mhlth": 1848.927953,
  "hel_obesity": 4686.747292,
  "hel_perpri": 0.291449601,
  "hel_perpub": 0.491468719,
  "hel_prtopu": 0.593017602,
  "hel_pharmacap": 1.922587295,
  "hel_phlth": 1994.214269,
  "hel_sleep": 4256.51627,
  "hel_stroke": 693.7300345,
  "hel_perins": 0.756846533,
  "hel_perunin": 0.243033982,
  "hel_clincap": 0.240323412,
  "hel_groccap": 0.961293648,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 1,
  "ci_index": 14,
  "eci_index": 3,
  "edi_index": 76,
  "fi_index": 47,
  "hi_index": 3,
  "cri_index": 10,
  "ci_weight": 14,
  "eci_weight": 3,
  "edi_weight": 76,
  "fi_weight": 47,
  "hi_weight": 3,
  "cri_weight": 7,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 16,
  "TEA": 43,
  "SLN": 43,
  "SCHOOLNAME": "Browne Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "3333 Sprague Dr.",
  "CITY": "Dallas",
  "ZIP": 75233,
  "PHONE": 9725052500,
  "WEBSITE": "http://www.dallasisd.org/browne",
  "POINT_X": -96.87628509,
  "POINT_Y": 32.69681812,
  "MasterID": "'057905043",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 50114,
  "dem_popwh": 3584,
  "dem_popbl": 16306,
  "dem_popas": 28,
  "dem_pophi": 29271,
  "dem_popm": 24026,
  "dem_popf": 26059,
  "dem_thh": 16093,
  "dem_popse": 5257,
  "dem_popch": 15085,
  "dem_perwh": 0.071516941,
  "dem_perbl": 0.325378138,
  "dem_peras": 0.000558726,
  "dem_perhi": 0.584088279,
  "dem_perm": 0.479426907,
  "dem_perf": 0.519994413,
  "dem_perse": 0.104900826,
  "dem_perch": 0.301013689,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.66518099,
  "comm_bvp": 0.113767782,
  "comm_cctrcap": 0.401992741,
  "comm_incarpct": 0.005649291,
  "comm_juvcrimecap": 229.8498216,
  "comm_libcap": 0.200996371,
  "comm_ltbvp": 0.108426594,
  "comm_ltrvp": 0.018080218,
  "comm_ocb": 1856.663633,
  "comm_ocbp": 0.253931385,
  "comm_parkcap": 0.16339211,
  "comm_rcb": 4560.019815,
  "comm_rcbp": 0.518916858,
  "comm_rvp": 0.019100488,
  "comm_u18bbp": 0.674736453,
  "comm_evrate": 278.5809698,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.326135183,
  "econ_fincap": 1.406974595,
  "econ_medinc": 24645.82547,
  "econ_paydaycap": 0.803985483,
  "econ_pctlwjobs": 0.205979001,
  "econ_pctmwjobs": 0.413560952,
  "econ_totjobs": 12477,
  "econ_pr": 0.239658128,
  "econ_pyr": 0.389599131,
  "econ_ur": 0.075489134,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 1,
  "edu_oostkids": 1006.548321,
  "edu_perbach": 0.080266758,
  "edu_perearlyed": 0.555126792,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.98847874,
  "fam_lcckids": 9.985598424,
  "fam_tphh": 2617.925564,
  "fam_tphhpct": 0.492219383,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3645.278367,
  "hel_castthma": 1005.369079,
  "hel_checkup": 6709.563043,
  "hel_fruitsveggies": 348.4435975,
  "hel_le": 77.2232272,
  "hel_mhlth": 1625.393862,
  "hel_obesity": 3894.3295,
  "hel_perpri": 0.429590589,
  "hel_perpub": 0.345243582,
  "hel_prtopu": 1.244311586,
  "hel_pharmacap": 2.009963707,
  "hel_phlth": 1581.445695,
  "hel_sleep": 3703.595065,
  "hel_stroke": 395.3784831,
  "hel_perins": 0.73942406,
  "hel_perunin": 0.260175147,
  "hel_clincap": 0.401992741,
  "hel_groccap": 0.803985483,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 24,
  "ci_index": 57,
  "eci_index": 30,
  "edi_index": 64,
  "fi_index": 70,
  "hi_index": 25,
  "cri_index": 39,
  "ci_weight": 57,
  "eci_weight": 30,
  "edi_weight": 64,
  "fi_weight": 70,
  "hi_weight": 25,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 17,
  "TEA": 100,
  "SLN": 100,
  "SCHOOLNAME": "Holmes Jr. Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2939 St. Rita Dr.",
  "CITY": "Dallas",
  "ZIP": 75233,
  "PHONE": 2149327800,
  "WEBSITE": "http://www.dallasisd.org/zwholmes",
  "POINT_X": -96.86848385,
  "POINT_Y": 32.71094913,
  "MasterID": "'057905100",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 76190,
  "dem_popwh": 5605,
  "dem_popbl": 12964,
  "dem_popas": 43,
  "dem_pophi": 56651,
  "dem_popm": 37774,
  "dem_popf": 38379,
  "dem_thh": 22301,
  "dem_popse": 7282,
  "dem_popch": 23529,
  "dem_perwh": 0.073566085,
  "dem_perbl": 0.170153563,
  "dem_peras": 0.000564379,
  "dem_perhi": 0.743549022,
  "dem_perm": 0.495786849,
  "dem_perf": 0.503727523,
  "dem_perse": 0.095576847,
  "dem_perch": 0.308820055,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.702864498,
  "comm_bvp": 0.095859238,
  "comm_cctrcap": 0.263888964,
  "comm_incarpct": 0.004104669,
  "comm_juvcrimecap": 190.7186807,
  "comm_libcap": 0.131944482,
  "comm_ltbvp": 0.094128365,
  "comm_ltrvp": 0.019219604,
  "comm_ocb": 2913.930399,
  "comm_ocbp": 0.237237669,
  "comm_parkcap": 0.094547061,
  "comm_rcb": 5066.839249,
  "comm_rcbp": 0.504954504,
  "comm_rvp": 0.020371655,
  "comm_u18bbp": 0.704891638,
  "comm_evrate": 165.5243529,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.306231556,
  "econ_fincap": 1.055555858,
  "econ_medinc": 24810.44785,
  "econ_paydaycap": 1.18750034,
  "econ_pctlwjobs": 0.294951085,
  "econ_pctmwjobs": 0.426290341,
  "econ_totjobs": 8893,
  "econ_pr": 0.219525129,
  "econ_pyr": 0.361367295,
  "econ_ur": 0.075289591,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 1,
  "edu_oostkids": 662.5316931,
  "edu_perbach": 0.072805775,
  "edu_perearlyed": 0.485753996,
  "edu_qeckids": 0.42799205,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 6.419880747,
  "fam_lcckids": 8.987833046,
  "fam_tphh": 4563.960955,
  "fam_tphhpct": 0.569964272,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3411.200503,
  "hel_castthma": 954.0082698,
  "hel_checkup": 6497.770243,
  "hel_fruitsveggies": 354.8178855,
  "hel_le": 77.76338855,
  "hel_mhlth": 1660.902147,
  "hel_obesity": 3833.07777,
  "hel_perpri": 0.423394846,
  "hel_perpub": 0.34052439,
  "hel_prtopu": 1.243361293,
  "hel_pharmacap": 1.451389304,
  "hel_phlth": 1625.406153,
  "hel_sleep": 3612.701106,
  "hel_stroke": 362.2548294,
  "hel_perins": 0.733053413,
  "hel_perunin": 0.266617527,
  "hel_clincap": 0.263888964,
  "hel_groccap": 0.923611375,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 28,
  "ci_index": 59,
  "eci_index": 27,
  "edi_index": 70,
  "fi_index": 81,
  "hi_index": 28,
  "cri_index": 44,
  "ci_weight": 59,
  "eci_weight": 27,
  "edi_weight": 70,
  "fi_weight": 81,
  "hi_weight": 28,
  "cri_weight": 40,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 18,
  "TEA": 284,
  "SLN": 284,
  "SCHOOLNAME": "Highland Meadows Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "8939 Whitewing Lane",
  "CITY": "Dallas",
  "ZIP": 75238,
  "PHONE": 9725025200,
  "WEBSITE": "http://www.dallasisd.org/hmeadows",
  "POINT_X": -96.68785493,
  "POINT_Y": 32.8705869,
  "MasterID": "'057905284",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 51807,
  "dem_popwh": 20780,
  "dem_popbl": 7561,
  "dem_popas": 199,
  "dem_pophi": 20331,
  "dem_popm": 25634,
  "dem_popf": 26164,
  "dem_thh": 19525,
  "dem_popse": 6184,
  "dem_popch": 14044,
  "dem_perwh": 0.401104098,
  "dem_perbl": 0.145945529,
  "dem_peras": 0.00384118,
  "dem_perhi": 0.392437315,
  "dem_perm": 0.494798,
  "dem_perf": 0.505028278,
  "dem_perse": 0.119366109,
  "dem_perch": 0.271083058,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.772869185,
  "comm_bvp": 0.148830774,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.003663937,
  "comm_juvcrimecap": 203.7050275,
  "comm_libcap": 0.194331964,
  "comm_ltbvp": 0.141424868,
  "comm_ltrvp": 0.013405705,
  "comm_ocb": 2142.669517,
  "comm_ocbp": 0.211997454,
  "comm_parkcap": 0.094182063,
  "comm_rcb": 4920.289136,
  "comm_rcbp": 0.5221385,
  "comm_rvp": 0.018671379,
  "comm_u18bbp": 0.782486784,
  "comm_evrate": 167.7084845,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.300831535,
  "econ_fincap": 0.777327854,
  "econ_medinc": 33643.78869,
  "econ_paydaycap": 1.554655708,
  "econ_pctlwjobs": 0.198643173,
  "econ_pctmwjobs": 0.36634332,
  "econ_totjobs": 32576,
  "econ_pr": 0.179632063,
  "econ_pyr": 0.316583902,
  "econ_ur": 0.040826675,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1487.157518,
  "edu_perbach": 0.215405086,
  "edu_perearlyed": 0.366474544,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.431724011,
  "fam_lcckids": 17.15126403,
  "fam_tphh": 4254.018185,
  "fam_tphhpct": 0.690921549,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3198.561233,
  "hel_castthma": 905.6489386,
  "hel_checkup": 6584.941201,
  "hel_fruitsveggies": 389.8161631,
  "hel_le": 78.58773356,
  "hel_mhlth": 1438.992312,
  "hel_obesity": 3305.232119,
  "hel_perpri": 0.538092649,
  "hel_perpub": 0.287655807,
  "hel_prtopu": 1.870612851,
  "hel_pharmacap": 1.554655708,
  "hel_phlth": 1344.671376,
  "hel_sleep": 3338.875757,
  "hel_stroke": 312.1374121,
  "hel_perins": 0.764512872,
  "hel_perunin": 0.235331806,
  "hel_clincap": 0.194331964,
  "hel_groccap": 0.582995891,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 34,
  "ci_index": 55,
  "eci_index": 39,
  "edi_index": 57,
  "fi_index": 91,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 55,
  "eci_weight": 39,
  "edi_weight": 57,
  "fi_weight": 91,
  "hi_weight": 32,
  "cri_weight": 42,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 19,
  "TEA": 280,
  "SLN": 280,
  "SCHOOLNAME": "Frank Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5201 Celestial Rd.",
  "CITY": "Dallas",
  "ZIP": 75254,
  "PHONE": 9725025900,
  "WEBSITE": "http://www.dallasisd.org/frank",
  "POINT_X": -96.81790826,
  "POINT_Y": 32.94775852,
  "MasterID": "'057905280",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 67633,
  "dem_popwh": 26406,
  "dem_popbl": 11207,
  "dem_popas": 51,
  "dem_pophi": 22183,
  "dem_popm": 33226,
  "dem_popf": 34408,
  "dem_thh": 33300,
  "dem_popse": 7302,
  "dem_popch": 12831,
  "dem_perwh": 0.390430707,
  "dem_perbl": 0.165703133,
  "dem_peras": 0.00075407,
  "dem_perhi": 0.327990774,
  "dem_perm": 0.491269055,
  "dem_perf": 0.508745731,
  "dem_perse": 0.107965047,
  "dem_perch": 0.18971508,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 4,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.835133896,
  "comm_bvp": 0.156304401,
  "comm_cctrcap": 0.148400325,
  "comm_incarpct": 0.001559655,
  "comm_juvcrimecap": 107.9445987,
  "comm_libcap": 0,
  "comm_ltbvp": 0.133416394,
  "comm_ltrvp": 0.006415627,
  "comm_ocb": 1757.296108,
  "comm_ocbp": 0.2339574,
  "comm_parkcap": 0.024683885,
  "comm_rcb": 9821.489124,
  "comm_rcbp": 0.380828315,
  "comm_rvp": 0.00857384,
  "comm_u18bbp": 0.794102338,
  "comm_evrate": 233.7305121,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.197817013,
  "econ_fincap": 4.452009754,
  "econ_medinc": 49624.9277,
  "econ_paydaycap": 1.484003251,
  "econ_pctlwjobs": 0.162095598,
  "econ_pctmwjobs": 0.254029239,
  "econ_totjobs": 152262,
  "econ_pr": 0.105476211,
  "econ_pyr": 0.15812269,
  "econ_ur": 0.034440619,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 513.5889823,
  "edu_perbach": 0.323599877,
  "edu_perearlyed": 0.43858598,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.697460204,
  "fam_lcckids": 8.612010375,
  "fam_tphh": 3384.108376,
  "fam_tphhpct": 0.501624457,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2387.020085,
  "hel_castthma": 742.8156221,
  "hel_checkup": 5733.034813,
  "hel_fruitsveggies": 470.9418689,
  "hel_le": 80.63746918,
  "hel_mhlth": 1076.994613,
  "hel_obesity": 2596.392539,
  "hel_perpri": 0.63780334,
  "hel_perpub": 0.199243043,
  "hel_prtopu": 3.2011323,
  "hel_pharmacap": 2.077604552,
  "hel_phlth": 885.9922221,
  "hel_sleep": 2811.141702,
  "hel_stroke": 194.1611483,
  "hel_perins": 0.780779221,
  "hel_perunin": 0.218998145,
  "hel_clincap": 0.29680065,
  "hel_groccap": 0.593601301,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 60,
  "ci_index": 69,
  "eci_index": 69,
  "edi_index": 65,
  "fi_index": 71,
  "hi_index": 65,
  "cri_index": 62,
  "ci_weight": 69,
  "eci_weight": 69,
  "edi_weight": 65,
  "fi_weight": 71,
  "hi_weight": 65,
  "cri_weight": 68,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 20,
  "TEA": 169,
  "SLN": 169,
  "SCHOOLNAME": "Kramer Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7131 Midbury Dr.",
  "CITY": "Dallas",
  "ZIP": 75230,
  "PHONE": 9727948300,
  "WEBSITE": "http://www.dallasisd.org/kramer",
  "POINT_X": -96.78327495,
  "POINT_Y": 32.90221796,
  "MasterID": "'057905169",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 47216,
  "dem_popwh": 28683,
  "dem_popbl": 7116,
  "dem_popas": 28,
  "dem_pophi": 7899,
  "dem_popm": 22597,
  "dem_popf": 24635,
  "dem_thh": 21773,
  "dem_popse": 9058,
  "dem_popch": 8453,
  "dem_perwh": 0.607484751,
  "dem_perbl": 0.150711623,
  "dem_peras": 0.000593019,
  "dem_perhi": 0.167294985,
  "dem_perm": 0.478587767,
  "dem_perf": 0.521751101,
  "dem_perse": 0.191841749,
  "dem_perch": 0.179028295,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 1,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.875748771,
  "comm_bvp": 0.119956544,
  "comm_cctrcap": 0.858294999,
  "comm_incarpct": 0.002977552,
  "comm_juvcrimecap": 104.9694713,
  "comm_libcap": 0.21457375,
  "comm_ltbvp": 0.095152617,
  "comm_ltrvp": 0.00732589,
  "comm_ocb": 2794.42707,
  "comm_ocbp": 0.265686493,
  "comm_parkcap": 0.091036817,
  "comm_rcb": 4833.313209,
  "comm_rcbp": 0.429580101,
  "comm_rvp": 0.009270355,
  "comm_u18bbp": 0.896920721,
  "comm_evrate": 152.2400755,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.152679836,
  "econ_fincap": 7.295507494,
  "econ_medinc": 60602.00238,
  "econ_paydaycap": 1.072868749,
  "econ_pctlwjobs": 0.187214225,
  "econ_pctmwjobs": 0.283474457,
  "econ_totjobs": 70860,
  "econ_pr": 0.097808382,
  "econ_pyr": 0.131949616,
  "econ_ur": 0.031428001,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 3266.201567,
  "edu_perbach": 0.340918949,
  "edu_perearlyed": 0.543478261,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.923470378,
  "fam_lcckids": 30.80204597,
  "fam_tphh": 3281.654277,
  "fam_tphhpct": 0.700760138,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3286.358956,
  "hel_castthma": 816.4876036,
  "hel_checkup": 6978.494644,
  "hel_fruitsveggies": 475.2142838,
  "hel_le": 80.50677964,
  "hel_mhlth": 1050.740941,
  "hel_obesity": 2779.890778,
  "hel_perpri": 0.733364815,
  "hel_perpub": 0.246737357,
  "hel_prtopu": 2.972248804,
  "hel_pharmacap": 9.226671243,
  "hel_phlth": 1043.588175,
  "hel_sleep": 2926.060695,
  "hel_stroke": 291.1818327,
  "hel_perins": 0.869816262,
  "hel_perunin": 0.130183738,
  "hel_clincap": 0.4291475,
  "hel_groccap": 1.502016249,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 38,
  "ci_index": 81,
  "eci_index": 84,
  "edi_index": 82,
  "fi_index": 99,
  "hi_index": 46,
  "cri_index": 66,
  "ci_weight": 81,
  "eci_weight": 84,
  "edi_weight": 82,
  "fi_weight": 99,
  "hi_weight": 46,
  "cri_weight": 70,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 21,
  "TEA": 167,
  "SLN": 167,
  "SCHOOLNAME": "Kleberg Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1450 Edd Rd.",
  "CITY": "Dallas",
  "ZIP": 75253,
  "PHONE": 9727496500,
  "WEBSITE": "http://www.dallasisd.org/kleberg",
  "POINT_X": -96.60049237,
  "POINT_Y": 32.68434393,
  "MasterID": "'057905167",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 23032,
  "dem_popwh": 4933,
  "dem_popbl": 3767,
  "dem_popas": 50,
  "dem_pophi": 13920,
  "dem_popm": 11572,
  "dem_popf": 11458,
  "dem_thh": 6244,
  "dem_popse": 1287,
  "dem_popch": 8271,
  "dem_perwh": 0.214180271,
  "dem_perbl": 0.163555054,
  "dem_peras": 0.002170893,
  "dem_perhi": 0.60437652,
  "dem_perm": 0.5024314,
  "dem_perf": 0.497481765,
  "dem_perse": 0.055878777,
  "dem_perch": 0.359109066,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.795220951,
  "comm_bvp": 0.054120441,
  "comm_cctrcap": 0.437994656,
  "comm_incarpct": 0.005523753,
  "comm_juvcrimecap": 200.0348251,
  "comm_libcap": 0.437994656,
  "comm_ltbvp": 0.048972376,
  "comm_ltrvp": 0.010020638,
  "comm_ocb": 1032.932716,
  "comm_ocbp": 0.266707396,
  "comm_parkcap": 0.055620737,
  "comm_rcb": 1147.209911,
  "comm_rcbp": 0.484081157,
  "comm_rvp": 0.011907059,
  "comm_u18bbp": 0.814797459,
  "comm_evrate": 309.0052295,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.271602995,
  "econ_fincap": 0,
  "econ_medinc": 23468.78624,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.266279819,
  "econ_pctmwjobs": 0.420373952,
  "econ_totjobs": 1551,
  "econ_pr": 0.208754309,
  "econ_pyr": 0.245243939,
  "econ_ur": 0.051980234,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 285.5474276,
  "edu_perbach": 0.052988144,
  "edu_perearlyed": 0.252356021,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.220288152,
  "fam_lcckids": 1.220288152,
  "fam_tphh": 1671.815551,
  "fam_tphhpct": 0.559689642,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2602.006871,
  "hel_castthma": 834.9051684,
  "hel_checkup": 5258.820436,
  "hel_fruitsveggies": 340.7907022,
  "hel_le": 74.95866554,
  "hel_mhlth": 1513.670328,
  "hel_obesity": 3167.259795,
  "hel_perpri": 0.344832103,
  "hel_perpub": 0.365005895,
  "hel_prtopu": 0.944730231,
  "hel_pharmacap": 0.854801088,
  "hel_phlth": 1319.598305,
  "hel_sleep": 3069.685039,
  "hel_stroke": 256.8586491,
  "hel_perins": 0.692895507,
  "hel_perunin": 0.307017161,
  "hel_clincap": 0.427400544,
  "hel_groccap": 0.427400544,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 40,
  "ci_index": 72,
  "eci_index": 34,
  "edi_index": 44,
  "fi_index": 5,
  "hi_index": 30,
  "cri_index": 43,
  "ci_weight": 72,
  "eci_weight": 34,
  "edi_weight": 44,
  "fi_weight": 5,
  "hi_weight": 30,
  "cri_weight": 37,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 0,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 22,
  "TEA": 187,
  "SLN": 187,
  "SCHOOLNAME": "Moseley Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10400 Rylie Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496700,
  "WEBSITE": "http://www.dallasisd.org/moseley",
  "POINT_X": -96.6423473,
  "POINT_Y": 32.68935608,
  "MasterID": "'057905187",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 21325,
  "dem_popwh": 2490,
  "dem_popbl": 3679,
  "dem_popas": 6,
  "dem_pophi": 14952,
  "dem_popm": 10692,
  "dem_popf": 10638,
  "dem_thh": 5769,
  "dem_popse": 1406,
  "dem_popch": 7089,
  "dem_perwh": 0.116764361,
  "dem_perbl": 0.172520516,
  "dem_peras": 0.00028136,
  "dem_perhi": 0.701148886,
  "dem_perm": 0.501383353,
  "dem_perf": 0.498851114,
  "dem_perse": 0.065932005,
  "dem_perch": 0.332426729,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.662697361,
  "comm_bvp": 0.04472692,
  "comm_cctrcap": 0.469602137,
  "comm_incarpct": 0.013930505,
  "comm_juvcrimecap": 148.5085818,
  "comm_libcap": 0,
  "comm_ltbvp": 0.043662008,
  "comm_ltrvp": 0.01101382,
  "comm_ocb": 1173.264112,
  "comm_ocbp": 0.305899122,
  "comm_parkcap": 0.105836002,
  "comm_rcb": 854.852921,
  "comm_rcbp": 0.441318179,
  "comm_rvp": 0.011779665,
  "comm_u18bbp": 0.657317331,
  "comm_evrate": 62.22228311,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.322968819,
  "econ_fincap": 0,
  "econ_medinc": 23379.1445,
  "econ_paydaycap": 0.939204273,
  "econ_pctlwjobs": 0.215882073,
  "econ_pctmwjobs": 0.387066096,
  "econ_totjobs": 2103,
  "econ_pr": 0.244631949,
  "econ_pyr": 0.153845677,
  "econ_ur": 0.046727967,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 389.8943446,
  "edu_perbach": 0.041450777,
  "edu_perearlyed": 0.178960097,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.25339285,
  "fam_lcckids": 4.25339285,
  "fam_tphh": 1640.956815,
  "fam_tphhpct": 0.674024498,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3148.0283,
  "hel_castthma": 948.5443795,
  "hel_checkup": 5955.829405,
  "hel_fruitsveggies": 329.4847014,
  "hel_le": 75.26125971,
  "hel_mhlth": 1762.113009,
  "hel_obesity": 3768.005252,
  "hel_perpri": 0.311855187,
  "hel_perpub": 0.359547927,
  "hel_prtopu": 0.867353593,
  "hel_pharmacap": 0,
  "hel_phlth": 1637.371171,
  "hel_sleep": 3531.65059,
  "hel_stroke": 334.9589173,
  "hel_perins": 0.662586757,
  "hel_perunin": 0.337319452,
  "hel_clincap": 0,
  "hel_groccap": 0,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 83,
  "eci_index": 26,
  "edi_index": 31,
  "fi_index": 50,
  "hi_index": 15,
  "cri_index": 41,
  "ci_weight": 83,
  "eci_weight": 26,
  "edi_weight": 31,
  "fi_weight": 50,
  "hi_weight": 15,
  "cri_weight": 33,
  "ci_weight_sd": 4,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 23,
  "TEA": 305,
  "SLN": 305,
  "SCHOOLNAME": "Halliday Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10210 Teagarden Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9729251800,
  "WEBSITE": "http://www.dallasisd.org/ebbyhalliday",
  "POINT_X": -96.6470033,
  "POINT_Y": 32.67269409,
  "MasterID": "'057905305",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 11596,
  "dem_popwh": 1426,
  "dem_popbl": 1937,
  "dem_popas": 0,
  "dem_pophi": 8095,
  "dem_popm": 5903,
  "dem_popf": 5694,
  "dem_thh": 3142,
  "dem_popse": 814,
  "dem_popch": 3813,
  "dem_perwh": 0.122973439,
  "dem_perbl": 0.167040359,
  "dem_peras": 0,
  "dem_perhi": 0.698085547,
  "dem_perm": 0.509054846,
  "dem_perf": 0.49103139,
  "dem_perse": 0.07019662,
  "dem_perch": 0.328820283,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.645110864,
  "comm_bvp": 0.030069204,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.021936833,
  "comm_juvcrimecap": 129.5250415,
  "comm_libcap": 0,
  "comm_ltbvp": 0.029369598,
  "comm_ltrvp": 0.006586998,
  "comm_ocb": 595.0360405,
  "comm_ocbp": 0.271341204,
  "comm_parkcap": 0.175064247,
  "comm_rcb": 396.9584902,
  "comm_rcbp": 0.417342021,
  "comm_rvp": 0.006994208,
  "comm_u18bbp": 0.6009059,
  "comm_evrate": 57.68076713,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.291080566,
  "econ_fincap": 0,
  "econ_medinc": 22625.69032,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.226158038,
  "econ_pctmwjobs": 0.35626703,
  "econ_totjobs": 1468,
  "econ_pr": 0.210797055,
  "econ_pyr": 0.184168563,
  "econ_ur": 0.047745377,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 0,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 314.2044229,
  "edu_perbach": 0.042071197,
  "edu_perearlyed": 0.163170163,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.280746603,
  "fam_lcckids": 5.280746603,
  "fam_tphh": 819.045117,
  "fam_tphhpct": 0.645225531,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3329.186555,
  "hel_castthma": 994.7215558,
  "hel_checkup": 6274.473808,
  "hel_fruitsveggies": 333.3110154,
  "hel_le": 76.46621077,
  "hel_mhlth": 1843.916201,
  "hel_obesity": 3935.441824,
  "hel_perpri": 0.337575758,
  "hel_perpub": 0.370995671,
  "hel_prtopu": 0.90991832,
  "hel_pharmacap": 0,
  "hel_phlth": 1731.204307,
  "hel_sleep": 3696.078895,
  "hel_stroke": 352.8261228,
  "hel_perins": 0.693246753,
  "hel_perunin": 0.306493506,
  "hel_clincap": 0,
  "hel_groccap": 0,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 28,
  "ci_index": 98,
  "eci_index": 34,
  "edi_index": 29,
  "fi_index": 59,
  "hi_index": 16,
  "cri_index": 41,
  "ci_weight": 98,
  "eci_weight": 34,
  "edi_weight": 29,
  "fi_weight": 59,
  "hi_weight": 16,
  "cri_weight": 41,
  "ci_weight_sd": 4,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 24,
  "TEA": 142,
  "SLN": 142,
  "SCHOOLNAME": "Ervin Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3722 Black Oak Dr.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9727493700,
  "WEBSITE": "http://www.dallasisd.org/ervin",
  "POINT_X": -96.76222554,
  "POINT_Y": 32.67964113,
  "MasterID": "'057905142",
  "Feeder": "Wilmer-Hutchins",
  "HIGH_SLN": 380,
  "dem_totp": 24481,
  "dem_popwh": 430,
  "dem_popbl": 19174,
  "dem_popas": 44,
  "dem_pophi": 4457,
  "dem_popm": 10878,
  "dem_popf": 13606,
  "dem_thh": 9047,
  "dem_popse": 3199,
  "dem_popch": 6804,
  "dem_perwh": 0.017564642,
  "dem_perbl": 0.78321964,
  "dem_peras": 0.001797312,
  "dem_perhi": 0.182059556,
  "dem_perm": 0.444344594,
  "dem_perf": 0.55577795,
  "dem_perse": 0.130672767,
  "dem_perch": 0.277929823,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.436937744,
  "comm_bvp": 0.070821629,
  "comm_cctrcap": 1.651269924,
  "comm_incarpct": 0.014651883,
  "comm_juvcrimecap": 790.6009353,
  "comm_libcap": 0.412817481,
  "comm_ltbvp": 0.06867832,
  "comm_ltrvp": 0.053143738,
  "comm_ocb": 1122.085795,
  "comm_ocbp": 0.264125342,
  "comm_parkcap": 0.299230825,
  "comm_rcb": 2547.056385,
  "comm_rcbp": 0.530801322,
  "comm_rvp": 0.057579608,
  "comm_u18bbp": 0.417285621,
  "comm_evrate": 350.2756327,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.440325983,
  "econ_fincap": 0.412817481,
  "econ_medinc": 17385.30329,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.270790175,
  "econ_pctmwjobs": 0.438295354,
  "econ_totjobs": 3379,
  "econ_pr": 0.322597939,
  "econ_pyr": 0.289058537,
  "econ_ur": 0.097775694,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 1505.121297,
  "edu_perbach": 0.058544817,
  "edu_perearlyed": 0.40832396,
  "edu_qeckids": 5.90243646,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 17.70730938,
  "fam_lcckids": 17.70730938,
  "fam_tphh": 592.8208051,
  "fam_tphhpct": 0.250977234,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4948.055403,
  "hel_castthma": 1231.312479,
  "hel_checkup": 7555.752149,
  "hel_fruitsveggies": 274.0287803,
  "hel_le": 70.57404547,
  "hel_mhlth": 1796.859363,
  "hel_obesity": 4637.438863,
  "hel_perpri": 0.330454713,
  "hel_perpub": 0.477796423,
  "hel_prtopu": 0.691622409,
  "hel_pharmacap": 2.476904886,
  "hel_phlth": 1874.60844,
  "hel_sleep": 4268.525632,
  "hel_stroke": 653.8200062,
  "hel_perins": 0.781156632,
  "hel_perunin": 0.218597798,
  "hel_clincap": 0,
  "hel_groccap": 1.238452443,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 3,
  "hi_gen": 2,
  "ci_index": 22,
  "eci_index": 17,
  "edi_index": 77,
  "fi_index": 0,
  "hi_index": 7,
  "cri_index": 21,
  "ci_weight": 22,
  "eci_weight": 17,
  "edi_weight": 77,
  "fi_weight": 0,
  "hi_weight": 7,
  "cri_weight": 12,
  "ci_weight_sd": 1,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 0,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 25,
  "TEA": 301,
  "SLN": 301,
  "SCHOOLNAME": "Wilmer-Hutchins Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7475 J.J. Lemmon Rd.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9729252600,
  "WEBSITE": "http://www.dallasisd.org/wilmerhutchinses",
  "POINT_X": -96.72769528,
  "POINT_Y": 32.65418876,
  "MasterID": "'057905301",
  "Feeder": "Wilmer-Hutchins",
  "HIGH_SLN": 380,
  "dem_totp": 8622,
  "dem_popwh": 812,
  "dem_popbl": 5381,
  "dem_popas": 11,
  "dem_pophi": 2198,
  "dem_popm": 4533,
  "dem_popf": 4089,
  "dem_thh": 2460,
  "dem_popse": 920,
  "dem_popch": 2330,
  "dem_perwh": 0.094177685,
  "dem_perbl": 0.624101137,
  "dem_peras": 0.001275806,
  "dem_perhi": 0.254929251,
  "dem_perm": 0.525748086,
  "dem_perf": 0.474251914,
  "dem_perse": 0.106703781,
  "dem_perch": 0.270238924,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.661414948,
  "comm_bvp": 0.053005176,
  "comm_cctrcap": 2.684414341,
  "comm_incarpct": 0.017662215,
  "comm_juvcrimecap": 164.6482635,
  "comm_libcap": 1.342207171,
  "comm_ltbvp": 0.047203532,
  "comm_ltrvp": 0.025128061,
  "comm_ocb": 427.6435317,
  "comm_ocbp": 0.272585723,
  "comm_parkcap": 0.08234579,
  "comm_rcb": 421.035517,
  "comm_rcbp": 0.472091211,
  "comm_rvp": 0.028150339,
  "comm_u18bbp": 0.662285375,
  "comm_evrate": 111.4031952,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.382568156,
  "econ_fincap": 0,
  "econ_medinc": 20070.77898,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.275335615,
  "econ_pctmwjobs": 0.381152935,
  "econ_totjobs": 3799,
  "econ_pr": 0.248504764,
  "econ_pyr": 0.375574412,
  "econ_ur": 0.087651041,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1226.725219,
  "edu_perbach": 0.064533821,
  "edu_perearlyed": 0.370165746,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 8.95419868,
  "fam_lcckids": 13.43129802,
  "fam_tphh": 329.044779,
  "fam_tphhpct": 0.402100962,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": -1,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 3753.92358,
  "hel_castthma": 831.7405046,
  "hel_checkup": 5760.153474,
  "hel_fruitsveggies": 338.7855511,
  "hel_le": 75.45372184,
  "hel_mhlth": 1143.474471,
  "hel_obesity": 3282.945481,
  "hel_perpri": 0.414699571,
  "hel_perpub": 0.419259657,
  "hel_prtopu": 0.98912348,
  "hel_pharmacap": 2.684414341,
  "hel_phlth": 1291.534678,
  "hel_sleep": 3016.74759,
  "hel_stroke": 461.6174325,
  "hel_perins": 0.796271459,
  "hel_perunin": 0.203594421,
  "hel_clincap": 1.342207171,
  "hel_groccap": 0,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 87,
  "eci_index": 23,
  "edi_index": 58,
  "fi_index": 28,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 87,
  "eci_weight": 23,
  "edi_weight": 58,
  "fi_weight": 28,
  "hi_weight": 32,
  "cri_weight": 44,
  "ci_weight_sd": 4,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 1,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 26,
  "TEA": 235,
  "SLN": 235,
  "SCHOOLNAME": "Alexander Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1830 Goldwood Dr.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727493100,
  "WEBSITE": "http://www.dallasisd.org/alexander",
  "POINT_X": -96.84764344,
  "POINT_Y": 32.65600928,
  "MasterID": "'057905235",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 41808,
  "dem_popwh": 2331,
  "dem_popbl": 27468,
  "dem_popas": 28,
  "dem_pophi": 11434,
  "dem_popm": 18979,
  "dem_popf": 22819,
  "dem_thh": 15008,
  "dem_popse": 5932,
  "dem_popch": 12008,
  "dem_perwh": 0.055754879,
  "dem_perbl": 0.657003444,
  "dem_peras": 0.000669728,
  "dem_perhi": 0.273488328,
  "dem_perm": 0.453956181,
  "dem_perf": 0.545804631,
  "dem_perse": 0.14188672,
  "dem_perch": 0.287217757,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.559883837,
  "comm_bvp": 0.111341074,
  "comm_cctrcap": 0.480750212,
  "comm_incarpct": 0.009549583,
  "comm_juvcrimecap": 387.7517431,
  "comm_libcap": 0.240375106,
  "comm_ltbvp": 0.105705544,
  "comm_ltrvp": 0.009188031,
  "comm_ocb": 1821.992491,
  "comm_ocbp": 0.290087436,
  "comm_parkcap": 0.089894192,
  "comm_rcb": 5058.148519,
  "comm_rcbp": 0.579016143,
  "comm_rvp": 0.009669133,
  "comm_u18bbp": 0.541620578,
  "comm_evrate": 338.5683369,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.450036482,
  "econ_fincap": 1.923000849,
  "econ_medinc": 21770.91779,
  "econ_paydaycap": 1.442250637,
  "econ_pctlwjobs": 0.274215067,
  "econ_pctmwjobs": 0.35666637,
  "econ_totjobs": 11243,
  "econ_pr": 0.309424319,
  "econ_pyr": 0.320797733,
  "econ_ur": 0.080943571,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 2216.416035,
  "edu_perbach": 0.084899068,
  "edu_perearlyed": 0.518695306,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 16.77197151,
  "fam_lcckids": 18.44916866,
  "fam_tphh": 1264.450506,
  "fam_tphhpct": 0.31302774,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4394.480128,
  "hel_castthma": 1170.382301,
  "hel_checkup": 7330.444019,
  "hel_fruitsveggies": 322.2370572,
  "hel_le": 75.43868067,
  "hel_mhlth": 1700.248641,
  "hel_obesity": 4366.544246,
  "hel_perpri": 0.406346694,
  "hel_perpub": 0.433354921,
  "hel_prtopu": 0.937676427,
  "hel_pharmacap": 3.605626591,
  "hel_phlth": 1650.066639,
  "hel_sleep": 4084.752921,
  "hel_stroke": 496.8745797,
  "hel_perins": 0.786116908,
  "hel_perunin": 0.213979036,
  "hel_clincap": 0.240375106,
  "hel_groccap": 0.721125318,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 11,
  "ci_index": 53,
  "eci_index": 18,
  "edi_index": 64,
  "fi_index": 31,
  "hi_index": 17,
  "cri_index": 34,
  "ci_weight": 53,
  "eci_weight": 18,
  "edi_weight": 64,
  "fi_weight": 31,
  "hi_weight": 17,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 27,
  "TEA": 175,
  "SLN": 175,
  "SCHOOLNAME": "U. Lee Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7808 Racine Dr.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727493900,
  "WEBSITE": "http://www.dallasisd.org/ulee",
  "POINT_X": -96.83546657,
  "POINT_Y": 32.65277236,
  "MasterID": "'057905175",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 40056,
  "dem_popwh": 2212,
  "dem_popbl": 26196,
  "dem_popas": 23,
  "dem_pophi": 11112,
  "dem_popm": 18348,
  "dem_popf": 21699,
  "dem_thh": 14037,
  "dem_popse": 5826,
  "dem_popch": 11517,
  "dem_perwh": 0.055222688,
  "dem_perbl": 0.653984422,
  "dem_peras": 0.000574196,
  "dem_perhi": 0.277411624,
  "dem_perm": 0.458058718,
  "dem_perf": 0.541716597,
  "dem_perse": 0.145446375,
  "dem_perch": 0.287522469,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.575454807,
  "comm_bvp": 0.091194507,
  "comm_cctrcap": 0.250954781,
  "comm_incarpct": 0.009555565,
  "comm_juvcrimecap": 281.1951889,
  "comm_libcap": 0.250954781,
  "comm_ltbvp": 0.085932421,
  "comm_ltrvp": 0.011517988,
  "comm_ocb": 1912.930635,
  "comm_ocbp": 0.294008792,
  "comm_parkcap": 0.044732438,
  "comm_rcb": 4374.92504,
  "comm_rcbp": 0.580521676,
  "comm_rvp": 0.012539855,
  "comm_u18bbp": 0.567007011,
  "comm_evrate": 212.3077445,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.428866067,
  "econ_fincap": 1.254773904,
  "econ_medinc": 22266.40648,
  "econ_paydaycap": 0.250954781,
  "econ_pctlwjobs": 0.253035221,
  "econ_pctmwjobs": 0.423969227,
  "econ_totjobs": 8319,
  "econ_pr": 0.29796947,
  "econ_pyr": 0.289359331,
  "econ_ur": 0.084758157,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 1724.410556,
  "edu_perbach": 0.082600274,
  "edu_perearlyed": 0.536398467,
  "edu_qeckids": 0.874447544,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 19.23784596,
  "fam_lcckids": 17.48895088,
  "fam_tphh": 1289.116293,
  "fam_tphhpct": 0.3327719,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4449.085387,
  "hel_castthma": 1166.602712,
  "hel_checkup": 7357.600222,
  "hel_fruitsveggies": 338.3946545,
  "hel_le": 75.22401961,
  "hel_mhlth": 1687.914985,
  "hel_obesity": 4372.420221,
  "hel_perpri": 0.412895956,
  "hel_perpub": 0.435332415,
  "hel_prtopu": 0.948461317,
  "hel_pharmacap": 1.254773904,
  "hel_phlth": 1664.598323,
  "hel_sleep": 4073.166402,
  "hel_stroke": 511.4762993,
  "hel_perins": 0.788932015,
  "hel_perunin": 0.211168148,
  "hel_clincap": 0,
  "hel_groccap": 0.752864342,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 1,
  "hi_gen": 11,
  "ci_index": 55,
  "eci_index": 17,
  "edi_index": 73,
  "fi_index": 39,
  "hi_index": 18,
  "cri_index": 36,
  "ci_weight": 55,
  "eci_weight": 17,
  "edi_weight": 73,
  "fi_weight": 39,
  "hi_weight": 18,
  "cri_weight": 29,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 28,
  "TEA": 264,
  "SLN": 264,
  "SCHOOLNAME": "McNair Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3150 Bainbridge Ave.",
  "CITY": "Dallas",
  "ZIP": 75237,
  "PHONE": 9727946200,
  "WEBSITE": "http://www.dallasisd.org/mcnair",
  "POINT_X": -96.86327079,
  "POINT_Y": 32.65617942,
  "MasterID": "'057905264",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 40958,
  "dem_popwh": 2610,
  "dem_popbl": 26772,
  "dem_popas": 36,
  "dem_pophi": 10775,
  "dem_popm": 18392,
  "dem_popf": 22562,
  "dem_thh": 15530,
  "dem_popse": 4831,
  "dem_popch": 12080,
  "dem_perwh": 0.063723815,
  "dem_perbl": 0.653645198,
  "dem_peras": 0.000878949,
  "dem_perhi": 0.263074369,
  "dem_perm": 0.449045364,
  "dem_perf": 0.550856975,
  "dem_perse": 0.117950095,
  "dem_perch": 0.294936276,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.574812094,
  "comm_bvp": 0.141077827,
  "comm_cctrcap": 0.491805004,
  "comm_incarpct": 0.008601533,
  "comm_juvcrimecap": 398.5534624,
  "comm_libcap": 0.245902502,
  "comm_ltbvp": 0.13337682,
  "comm_ltrvp": 0.006621683,
  "comm_ocb": 1574.061505,
  "comm_ocbp": 0.294850648,
  "comm_parkcap": 0.082151623,
  "comm_rcb": 5912.087329,
  "comm_rcbp": 0.579668945,
  "comm_rvp": 0.007114875,
  "comm_u18bbp": 0.542321135,
  "comm_evrate": 517.5018159,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.42886438,
  "econ_fincap": 1.967220018,
  "econ_medinc": 22848.95557,
  "econ_paydaycap": 2.459025022,
  "econ_pctlwjobs": 0.27522604,
  "econ_pctmwjobs": 0.380289331,
  "econ_totjobs": 16590,
  "econ_pr": 0.300305187,
  "econ_pyr": 0.387784131,
  "econ_ur": 0.082317742,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 4065.419759,
  "edu_perbach": 0.097346205,
  "edu_perearlyed": 0.49965541,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 20.85258391,
  "fam_lcckids": 24.18899734,
  "fam_tphh": 1188.42365,
  "fam_tphhpct": 0.275705127,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 3733.420147,
  "hel_castthma": 1037.004132,
  "hel_checkup": 6401.573244,
  "hel_fruitsveggies": 319.0574983,
  "hel_le": 75.78612537,
  "hel_mhlth": 1514.864399,
  "hel_obesity": 3824.901135,
  "hel_perpri": 0.436362298,
  "hel_perpub": 0.41021049,
  "hel_prtopu": 1.063752168,
  "hel_pharmacap": 5.655757551,
  "hel_phlth": 1404.716183,
  "hel_sleep": 3619.424345,
  "hel_stroke": 404.3112213,
  "hel_perins": 0.80108925,
  "hel_perunin": 0.199156077,
  "hel_clincap": 0.245902502,
  "hel_groccap": 0.737707507,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 23,
  "ci_index": 54,
  "eci_index": 22,
  "edi_index": 65,
  "fi_index": 26,
  "hi_index": 28,
  "cri_index": 41,
  "ci_weight": 54,
  "eci_weight": 22,
  "edi_weight": 65,
  "fi_weight": 26,
  "hi_weight": 28,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 29,
  "TEA": 226,
  "SLN": 226,
  "SCHOOLNAME": "Weiss Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "8601 Willoughby Blvd.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727494000,
  "WEBSITE": "http://www.dallasisd.org/weiss",
  "POINT_X": -96.83046939,
  "POINT_Y": 32.64382799,
  "MasterID": "'057905226",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 32426,
  "dem_popwh": 2032,
  "dem_popbl": 19953,
  "dem_popas": 35,
  "dem_pophi": 9979,
  "dem_popm": 14815,
  "dem_popf": 17611,
  "dem_thh": 11301,
  "dem_popse": 4744,
  "dem_popch": 9431,
  "dem_perwh": 0.062665762,
  "dem_perbl": 0.615339542,
  "dem_peras": 0.001079381,
  "dem_perhi": 0.30774687,
  "dem_perm": 0.456886449,
  "dem_perf": 0.543113551,
  "dem_perse": 0.14630235,
  "dem_perch": 0.290846851,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 2,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.59384931,
  "comm_bvp": 0.089167573,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.010309011,
  "comm_juvcrimecap": 245.6172172,
  "comm_libcap": 0.310734022,
  "comm_ltbvp": 0.080881377,
  "comm_ltrvp": 0.01228149,
  "comm_ocb": 1535.030294,
  "comm_ocbp": 0.300159043,
  "comm_parkcap": 0.051402558,
  "comm_rcb": 3551.62931,
  "comm_rcbp": 0.573690883,
  "comm_rvp": 0.013539949,
  "comm_u18bbp": 0.590807367,
  "comm_evrate": 198.2483061,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.408516649,
  "econ_fincap": 1.242936089,
  "econ_medinc": 22243.78046,
  "econ_paydaycap": 0.310734022,
  "econ_pctlwjobs": 0.257366159,
  "econ_pctmwjobs": 0.367409144,
  "econ_totjobs": 12795,
  "econ_pr": 0.292808662,
  "econ_pyr": 0.32190087,
  "econ_ur": 0.090923542,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 1577.931065,
  "edu_perbach": 0.073176823,
  "edu_perearlyed": 0.531830239,
  "edu_qeckids": 1.069783773,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 16.0467566,
  "fam_lcckids": 14.97697282,
  "fam_tphh": 1185.114595,
  "fam_tphhpct": 0.368835095,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4239.96794,
  "hel_castthma": 1119.909686,
  "hel_checkup": 7001.098259,
  "hel_fruitsveggies": 329.6067933,
  "hel_le": 75.51221754,
  "hel_mhlth": 1655.76892,
  "hel_obesity": 4200.519285,
  "hel_perpri": 0.414442895,
  "hel_perpub": 0.431613203,
  "hel_prtopu": 0.960218297,
  "hel_pharmacap": 1.242936089,
  "hel_phlth": 1634.713729,
  "hel_sleep": 3907.430791,
  "hel_stroke": 497.0294044,
  "hel_perins": 0.787261739,
  "hel_perunin": 0.213017201,
  "hel_clincap": 0,
  "hel_groccap": 0.932202066,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 13,
  "ci_index": 56,
  "eci_index": 18,
  "edi_index": 72,
  "fi_index": 40,
  "hi_index": 19,
  "cri_index": 37,
  "ci_weight": 56,
  "eci_weight": 18,
  "edi_weight": 72,
  "fi_weight": 40,
  "hi_weight": 19,
  "cri_weight": 30,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 30,
  "TEA": 109,
  "SLN": 109,
  "SCHOOLNAME": "Blair Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7720 Gayglen Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727941600,
  "WEBSITE": "http://www.dallasisd.org/blair",
  "POINT_X": -96.68872096,
  "POINT_Y": 32.70874949,
  "MasterID": "'057905109",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 35607,
  "dem_popwh": 2013,
  "dem_popbl": 10377,
  "dem_popas": 1,
  "dem_pophi": 23097,
  "dem_popm": 16906,
  "dem_popf": 18709,
  "dem_thh": 9840,
  "dem_popse": 2752,
  "dem_popch": 12358,
  "dem_perwh": 0.056533828,
  "dem_perbl": 0.29143146,
  "dem_peras": 0.0000281,
  "dem_perhi": 0.648664588,
  "dem_perm": 0.474794282,
  "dem_perf": 0.525430393,
  "dem_perse": 0.077288174,
  "dem_perch": 0.347066588,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.544870665,
  "comm_bvp": 0.107036194,
  "comm_cctrcap": 0.844590652,
  "comm_incarpct": 0.011342082,
  "comm_juvcrimecap": 359.5973676,
  "comm_libcap": 0.281530217,
  "comm_ltbvp": 0.105474516,
  "comm_ltrvp": 0.024611332,
  "comm_ocb": 1342.452742,
  "comm_ocbp": 0.255424747,
  "comm_parkcap": 0.320783485,
  "comm_rcb": 2407.041358,
  "comm_rcbp": 0.525170777,
  "comm_rvp": 0.025357871,
  "comm_u18bbp": 0.545258094,
  "comm_evrate": 141.7504645,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.436130865,
  "econ_fincap": 0,
  "econ_medinc": 20555.39135,
  "econ_paydaycap": 2.533771956,
  "econ_pctlwjobs": 0.258080557,
  "econ_pctmwjobs": 0.363003481,
  "econ_totjobs": 4022,
  "econ_pr": 0.308393139,
  "econ_pyr": 0.068277673,
  "econ_ur": 0.043002765,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 1023.356258,
  "edu_perbach": 0.030594813,
  "edu_perearlyed": 0.250491803,
  "edu_qeckids": 1.629548182,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 6.518192728,
  "fam_lcckids": 8.14774091,
  "fam_tphh": 2468.103216,
  "fam_tphhpct": 0.578616138,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3631.221416,
  "hel_castthma": 1056.069635,
  "hel_checkup": 6541.438909,
  "hel_fruitsveggies": 298.2298381,
  "hel_le": 75.22056545,
  "hel_mhlth": 1888.864324,
  "hel_obesity": 4163.931817,
  "hel_perpri": 0.285786503,
  "hel_perpub": 0.396466987,
  "hel_prtopu": 0.720833038,
  "hel_pharmacap": 1.689181304,
  "hel_phlth": 1796.215567,
  "hel_sleep": 3889.890674,
  "hel_stroke": 420.4073012,
  "hel_perins": 0.665936473,
  "hel_perunin": 0.333670346,
  "hel_clincap": 0.281530217,
  "hel_groccap": 0.563060435,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 19,
  "ci_index": 45,
  "eci_index": 28,
  "edi_index": 39,
  "fi_index": 66,
  "hi_index": 13,
  "cri_index": 32,
  "ci_weight": 45,
  "eci_weight": 28,
  "edi_weight": 39,
  "fi_weight": 66,
  "hi_weight": 13,
  "cri_weight": 24,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 31,
  "TEA": 117,
  "SLN": 117,
  "SCHOOLNAME": "Burleson Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6300 Elam Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727494500,
  "WEBSITE": "http://www.dallasisd.org/burleson",
  "POINT_X": -96.71317289,
  "POINT_Y": 32.7187234,
  "MasterID": "'057905117",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 29492,
  "dem_popwh": 1231,
  "dem_popbl": 9553,
  "dem_popas": 0,
  "dem_pophi": 18594,
  "dem_popm": 14092,
  "dem_popf": 15404,
  "dem_thh": 8275,
  "dem_popse": 2580,
  "dem_popch": 10078,
  "dem_perwh": 0.041740133,
  "dem_perbl": 0.323918351,
  "dem_peras": 0,
  "dem_perhi": 0.630476061,
  "dem_perm": 0.477824495,
  "dem_perf": 0.522311135,
  "dem_perse": 0.087481351,
  "dem_perch": 0.341719788,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.488886994,
  "comm_bvp": 0.105169065,
  "comm_cctrcap": 0.339800406,
  "comm_incarpct": 0.017506876,
  "comm_juvcrimecap": 356.4806193,
  "comm_libcap": 0.339800406,
  "comm_ltbvp": 0.103942005,
  "comm_ltrvp": 0.028894476,
  "comm_ocb": 914.7169235,
  "comm_ocbp": 0.225362993,
  "comm_parkcap": 0.761319678,
  "comm_rcb": 2126.535551,
  "comm_rcbp": 0.504477391,
  "comm_rvp": 0.03032882,
  "comm_u18bbp": 0.483471261,
  "comm_evrate": 153.0800831,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.48811189,
  "econ_fincap": 0,
  "econ_medinc": 19431.08595,
  "econ_paydaycap": 1.019401219,
  "econ_pctlwjobs": 0.213800501,
  "econ_pctmwjobs": 0.34358241,
  "econ_totjobs": 2797,
  "econ_pr": 0.328031092,
  "econ_pyr": 0.039780348,
  "econ_ur": 0.041491786,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 768.037327,
  "edu_perbach": 0.033734197,
  "edu_perearlyed": 0.345757335,
  "edu_qeckids": 1.997496299,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 6.991237047,
  "fam_lcckids": 7.989985196,
  "fam_tphh": 1721.083191,
  "fam_tphhpct": 0.522456229,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3712.165346,
  "hel_castthma": 1065.950102,
  "hel_checkup": 6624.066139,
  "hel_fruitsveggies": 283.0116818,
  "hel_le": 74.80098605,
  "hel_mhlth": 1867.346253,
  "hel_obesity": 4164.715348,
  "hel_perpri": 0.268208328,
  "hel_perpub": 0.419537502,
  "hel_prtopu": 0.63929524,
  "hel_pharmacap": 0.339800406,
  "hel_phlth": 1788.119021,
  "hel_sleep": 3909.714846,
  "hel_stroke": 439.3567713,
  "hel_perins": 0.665231249,
  "hel_perunin": 0.334633121,
  "hel_clincap": 0,
  "hel_groccap": 0.679600813,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 1,
  "hi_gen": 17,
  "ci_index": 48,
  "eci_index": 30,
  "edi_index": 57,
  "fi_index": 62,
  "hi_index": 12,
  "cri_index": 31,
  "ci_weight": 48,
  "eci_weight": 30,
  "edi_weight": 57,
  "fi_weight": 62,
  "hi_weight": 12,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 32,
  "TEA": 266,
  "SLN": 266,
  "SCHOOLNAME": "Douglass Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "226 N. Jim Miller Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727941400,
  "WEBSITE": "http://www.dallasisd.org/douglas",
  "POINT_X": -96.69750014,
  "POINT_Y": 32.715607,
  "MasterID": "'057905266",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 39312,
  "dem_popwh": 2037,
  "dem_popbl": 10575,
  "dem_popas": 0,
  "dem_pophi": 26566,
  "dem_popm": 18763,
  "dem_popf": 20559,
  "dem_thh": 10854,
  "dem_popse": 3177,
  "dem_popch": 13540,
  "dem_perwh": 0.051816239,
  "dem_perbl": 0.269001832,
  "dem_peras": 0,
  "dem_perhi": 0.675773301,
  "dem_perm": 0.47728429,
  "dem_perf": 0.522970085,
  "dem_perse": 0.080815018,
  "dem_perch": 0.344424094,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.522583899,
  "comm_bvp": 0.104907127,
  "comm_cctrcap": 1.019320079,
  "comm_incarpct": 0.010549588,
  "comm_juvcrimecap": 318.8045587,
  "comm_libcap": 0.25483002,
  "comm_ltbvp": 0.102372974,
  "comm_ltrvp": 0.024494956,
  "comm_ocb": 1447.561558,
  "comm_ocbp": 0.246605095,
  "comm_parkcap": 0.295794486,
  "comm_rcb": 2638.484796,
  "comm_rcbp": 0.529513594,
  "comm_rvp": 0.025115793,
  "comm_u18bbp": 0.518101249,
  "comm_evrate": 131.7471202,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.438188764,
  "econ_fincap": 0.509660039,
  "econ_medinc": 20436.8402,
  "econ_paydaycap": 2.038640158,
  "econ_pctlwjobs": 0.260362077,
  "econ_pctmwjobs": 0.373034778,
  "econ_totjobs": 4198,
  "econ_pr": 0.305785652,
  "econ_pyr": 0.059564235,
  "econ_ur": 0.040242928,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 890.1209269,
  "edu_perbach": 0.030039304,
  "edu_perearlyed": 0.285885167,
  "edu_qeckids": 1.484772188,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 7.423860942,
  "fam_lcckids": 8.166247036,
  "fam_tphh": 2649.90498,
  "fam_tphhpct": 0.581720206,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3613.33338,
  "hel_castthma": 1043.630379,
  "hel_checkup": 6538.323235,
  "hel_fruitsveggies": 296.4474234,
  "hel_le": 75.48872452,
  "hel_mhlth": 1861.173155,
  "hel_obesity": 4120.906068,
  "hel_perpri": 0.286121286,
  "hel_perpub": 0.397435897,
  "hel_prtopu": 0.719918075,
  "hel_pharmacap": 0.764490059,
  "hel_phlth": 1780.316832,
  "hel_sleep": 3862.395001,
  "hel_stroke": 417.369026,
  "hel_perins": 0.664707977,
  "hel_perunin": 0.334783272,
  "hel_clincap": 0,
  "hel_groccap": 1.274150099,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 3,
  "hi_gen": 20,
  "ci_index": 47,
  "eci_index": 35,
  "edi_index": 44,
  "fi_index": 68,
  "hi_index": 15,
  "cri_index": 36,
  "ci_weight": 47,
  "eci_weight": 35,
  "edi_weight": 44,
  "fi_weight": 68,
  "hi_weight": 15,
  "cri_weight": 28,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 33,
  "TEA": 108,
  "SLN": 108,
  "SCHOOLNAME": "Bayles Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2444 Telegraph Ave.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9727498900,
  "WEBSITE": "http://www.dallasisd.org/bayles",
  "POINT_X": -96.70605338,
  "POINT_Y": 32.8010691,
  "MasterID": "'057905108",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 59667,
  "dem_popwh": 15907,
  "dem_popbl": 14969,
  "dem_popas": 65,
  "dem_pophi": 27036,
  "dem_popm": 29243,
  "dem_popf": 30427,
  "dem_thh": 22691,
  "dem_popse": 5674,
  "dem_popch": 16231,
  "dem_perwh": 0.266596276,
  "dem_perbl": 0.250875693,
  "dem_peras": 0.001089379,
  "dem_perhi": 0.453114787,
  "dem_perm": 0.490103407,
  "dem_perf": 0.509946872,
  "dem_perse": 0.095094441,
  "dem_perch": 0.272026413,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.730385315,
  "comm_bvp": 0.154501704,
  "comm_cctrcap": 0.336992925,
  "comm_incarpct": 0.007224841,
  "comm_juvcrimecap": 302.0999084,
  "comm_libcap": 0.336992925,
  "comm_ltbvp": 0.141923316,
  "comm_ltrvp": 0.023419429,
  "comm_ocb": 2567.212268,
  "comm_ocbp": 0.250245584,
  "comm_parkcap": 0.208391862,
  "comm_rcb": 5759.42414,
  "comm_rcbp": 0.462559746,
  "comm_rvp": 0.031168377,
  "comm_u18bbp": 0.693078117,
  "comm_evrate": 221.572848,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.339660524,
  "econ_fincap": 2.358950473,
  "econ_medinc": 34249.41169,
  "econ_paydaycap": 1.347971699,
  "econ_pctlwjobs": 0.259195118,
  "econ_pctmwjobs": 0.384545604,
  "econ_totjobs": 12126,
  "econ_pr": 0.210279074,
  "econ_pyr": 0.284110951,
  "econ_ur": 0.044320398,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1024.357323,
  "edu_perbach": 0.172994553,
  "edu_perearlyed": 0.348837209,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 9.312339296,
  "fam_lcckids": 14.89974287,
  "fam_tphh": 4140.398111,
  "fam_tphhpct": 0.624662048,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3447.037158,
  "hel_castthma": 985.6978201,
  "hel_checkup": 6729.380909,
  "hel_fruitsveggies": 385.9019196,
  "hel_le": 77.34306313,
  "hel_mhlth": 1546.372846,
  "hel_obesity": 3631.566589,
  "hel_perpri": 0.509212674,
  "hel_perpub": 0.305793468,
  "hel_prtopu": 1.665217631,
  "hel_pharmacap": 1.991133623,
  "hel_phlth": 1451.219591,
  "hel_sleep": 3594.963947,
  "hel_stroke": 352.2114527,
  "hel_perins": 0.76871561,
  "hel_perunin": 0.231486311,
  "hel_clincap": 0.153164125,
  "hel_groccap": 0.612656499,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 30,
  "ci_index": 50,
  "eci_index": 34,
  "edi_index": 55,
  "fi_index": 82,
  "hi_index": 31,
  "cri_index": 44,
  "ci_weight": 50,
  "eci_weight": 34,
  "edi_weight": 55,
  "fi_weight": 82,
  "hi_weight": 31,
  "cri_weight": 39,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 34,
  "TEA": 129,
  "SLN": 129,
  "SCHOOLNAME": "Conner Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3037 Greenmeadow Dr.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9727498200,
  "WEBSITE": "http://www.dallasisd.org/conner",
  "POINT_X": -96.69475098,
  "POINT_Y": 32.80824293,
  "MasterID": "'057905129",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 64136,
  "dem_popwh": 17787,
  "dem_popbl": 15455,
  "dem_popas": 54,
  "dem_pophi": 28937,
  "dem_popm": 31114,
  "dem_popf": 33032,
  "dem_thh": 24071,
  "dem_popse": 6214,
  "dem_popch": 17695,
  "dem_perwh": 0.277332543,
  "dem_perbl": 0.240972309,
  "dem_peras": 0.000841961,
  "dem_perhi": 0.451181864,
  "dem_perm": 0.485125359,
  "dem_perf": 0.51503056,
  "dem_perse": 0.096887863,
  "dem_perch": 0.275898092,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.736711025,
  "comm_bvp": 0.194848711,
  "comm_cctrcap": 0.313016335,
  "comm_incarpct": 0.006326467,
  "comm_juvcrimecap": 299.4424516,
  "comm_libcap": 0.313016335,
  "comm_ltbvp": 0.167816045,
  "comm_ltrvp": 0.02538003,
  "comm_ocb": 2823.462742,
  "comm_ocbp": 0.244665871,
  "comm_parkcap": 0.109408005,
  "comm_rcb": 5937.417237,
  "comm_rcbp": 0.473384816,
  "comm_rvp": 0.034363752,
  "comm_u18bbp": 0.70628313,
  "comm_evrate": 243.7614706,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.328695418,
  "econ_fincap": 2.504130678,
  "econ_medinc": 33615.07561,
  "econ_paydaycap": 1.095557171,
  "econ_pctlwjobs": 0.237282573,
  "econ_pctmwjobs": 0.36613062,
  "econ_totjobs": 15235,
  "econ_pr": 0.20632978,
  "econ_pyr": 0.243027517,
  "econ_ur": 0.044753956,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 819.5776955,
  "edu_perbach": 0.165563242,
  "edu_perearlyed": 0.312442396,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 8.531343118,
  "fam_lcckids": 13.08139278,
  "fam_tphh": 4367.292055,
  "fam_tphhpct": 0.607745094,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3492.696193,
  "hel_castthma": 992.544928,
  "hel_checkup": 6733.351127,
  "hel_fruitsveggies": 390.534526,
  "hel_le": 77.41228938,
  "hel_mhlth": 1574.295638,
  "hel_obesity": 3657.213691,
  "hel_perpri": 0.514091883,
  "hel_perpub": 0.30781736,
  "hel_prtopu": 1.670119846,
  "hel_pharmacap": 1.976787836,
  "hel_phlth": 1485.528148,
  "hel_sleep": 3602.033568,
  "hel_stroke": 360.2827608,
  "hel_perins": 0.771137824,
  "hel_perunin": 0.229002861,
  "hel_clincap": 0.263571711,
  "hel_groccap": 0.527143423,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 29,
  "ci_index": 46,
  "eci_index": 36,
  "edi_index": 55,
  "fi_index": 80,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 46,
  "eci_weight": 36,
  "edi_weight": 55,
  "fi_weight": 80,
  "hi_weight": 32,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 35,
  "TEA": 218,
  "SLN": 218,
  "SCHOOLNAME": "Truett Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1811 Gross Rd.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9727498000,
  "WEBSITE": "http://www.dallasisd.org/truett",
  "POINT_X": -96.68349102,
  "POINT_Y": 32.81642912,
  "MasterID": "'057905218",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 67564,
  "dem_popwh": 19184,
  "dem_popbl": 12442,
  "dem_popas": 26,
  "dem_pophi": 34082,
  "dem_popm": 32678,
  "dem_popf": 34888,
  "dem_thh": 24191,
  "dem_popse": 6651,
  "dem_popch": 19164,
  "dem_perwh": 0.283938192,
  "dem_perbl": 0.184151323,
  "dem_peras": 0.00038482,
  "dem_perhi": 0.504440234,
  "dem_perm": 0.483659937,
  "dem_perf": 0.516369664,
  "dem_perse": 0.098439998,
  "dem_perch": 0.283642176,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.73759776,
  "comm_bvp": 0.234139842,
  "comm_cctrcap": 0.445231463,
  "comm_incarpct": 0.005991387,
  "comm_juvcrimecap": 227.3364632,
  "comm_libcap": 0.148410488,
  "comm_ltbvp": 0.203565557,
  "comm_ltrvp": 0.024713947,
  "comm_ocb": 2989.474339,
  "comm_ocbp": 0.235108967,
  "comm_parkcap": 0.039705911,
  "comm_rcb": 5384.474994,
  "comm_rcbp": 0.468884904,
  "comm_rvp": 0.033586207,
  "comm_u18bbp": 0.712502581,
  "comm_evrate": 214.0821285,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.290735621,
  "econ_fincap": 1.92933634,
  "econ_medinc": 31468.78161,
  "econ_paydaycap": 1.187283902,
  "econ_pctlwjobs": 0.261512605,
  "econ_pctmwjobs": 0.382521008,
  "econ_totjobs": 14875,
  "econ_pr": 0.193618405,
  "econ_pyr": 0.227359395,
  "econ_ur": 0.048063048,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 623.7691751,
  "edu_perbach": 0.146312727,
  "edu_perearlyed": 0.263863216,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.344632844,
  "fam_lcckids": 13.64003242,
  "fam_tphh": 4691.951894,
  "fam_tphhpct": 0.62364306,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3428.913031,
  "hel_castthma": 975.2957124,
  "hel_checkup": 6627.165966,
  "hel_fruitsveggies": 384.437121,
  "hel_le": 77.68084767,
  "hel_mhlth": 1604.62167,
  "hel_obesity": 3643.857533,
  "hel_perpri": 0.486764488,
  "hel_perpub": 0.312123907,
  "hel_prtopu": 1.559523244,
  "hel_pharmacap": 1.914577462,
  "hel_phlth": 1524.924918,
  "hel_sleep": 3559.103646,
  "hel_stroke": 356.8232551,
  "hel_perins": 0.747932414,
  "hel_perunin": 0.252052764,
  "hel_clincap": 0.225244407,
  "hel_groccap": 0.675733222,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 30,
  "ci_index": 47,
  "eci_index": 35,
  "edi_index": 56,
  "fi_index": 85,
  "hi_index": 31,
  "cri_index": 44,
  "ci_weight": 47,
  "eci_weight": 35,
  "edi_weight": 56,
  "fi_weight": 85,
  "hi_weight": 31,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 36,
  "TEA": 216,
  "SLN": 216,
  "SCHOOLNAME": "Titche Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "9560 Highfield Dr.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727942100,
  "WEBSITE": "http://www.dallasisd.org/titche",
  "POINT_X": -96.65855703,
  "POINT_Y": 32.75476245,
  "MasterID": "'057905216",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 66572,
  "dem_popwh": 5465,
  "dem_popbl": 17114,
  "dem_popas": 93,
  "dem_pophi": 43176,
  "dem_popm": 31765,
  "dem_popf": 34803,
  "dem_thh": 18559,
  "dem_popse": 4444,
  "dem_popch": 23251,
  "dem_perwh": 0.08209157,
  "dem_perbl": 0.257075047,
  "dem_peras": 0.001396984,
  "dem_perhi": 0.648560957,
  "dem_perm": 0.477152557,
  "dem_perf": 0.522787358,
  "dem_perse": 0.066754792,
  "dem_perch": 0.349260951,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.656424922,
  "comm_bvp": 0.101958195,
  "comm_cctrcap": 0.151042753,
  "comm_incarpct": 0.006201284,
  "comm_juvcrimecap": 227.9205951,
  "comm_libcap": 0.151042753,
  "comm_ltbvp": 0.097888741,
  "comm_ltrvp": 0.019179311,
  "comm_ocb": 3644.955655,
  "comm_ocbp": 0.322902817,
  "comm_parkcap": 0.023973454,
  "comm_rcb": 3849.953844,
  "comm_rcbp": 0.528969104,
  "comm_rvp": 0.022473421,
  "comm_u18bbp": 0.653976679,
  "comm_evrate": 173.0949949,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.359927092,
  "econ_fincap": 0.755213765,
  "econ_medinc": 23026.97762,
  "econ_paydaycap": 1.51042753,
  "econ_pctlwjobs": 0.209103329,
  "econ_pctmwjobs": 0.406773567,
  "econ_totjobs": 13907,
  "econ_pr": 0.262943894,
  "econ_pyr": 0.330643016,
  "econ_ur": 0.048737797,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 3,
  "edu_oostkids": 553.2114061,
  "edu_perbach": 0.046162465,
  "edu_perearlyed": 0.240062967,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.791594856,
  "fam_lcckids": 6.098393453,
  "fam_tphh": 4968.093007,
  "fam_tphhpct": 0.599041944,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3548.790989,
  "hel_castthma": 1025.771725,
  "hel_checkup": 6553.792977,
  "hel_fruitsveggies": 347.3699179,
  "hel_le": 75.11190531,
  "hel_mhlth": 1774.516512,
  "hel_obesity": 4026.671564,
  "hel_perpri": 0.369652849,
  "hel_perpub": 0.369412189,
  "hel_prtopu": 1.000651466,
  "hel_pharmacap": 1.51042753,
  "hel_phlth": 1671.177734,
  "hel_sleep": 3802.255526,
  "hel_stroke": 380.5787796,
  "hel_perins": 0.710847723,
  "hel_perunin": 0.288971783,
  "hel_clincap": 0.151042753,
  "hel_groccap": 1.208342024,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 23,
  "ci_index": 58,
  "eci_index": 33,
  "edi_index": 41,
  "fi_index": 79,
  "hi_index": 21,
  "cri_index": 41,
  "ci_weight": 58,
  "eci_weight": 33,
  "edi_weight": 41,
  "fi_weight": 79,
  "hi_weight": 21,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 37,
  "TEA": 139,
  "SLN": 139,
  "SCHOOLNAME": "Dunbar Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "4200 Metropolitan Ave.",
  "CITY": "Dallas",
  "ZIP": 75210,
  "PHONE": 9727946600,
  "WEBSITE": "http://www.dallasisd.org/dunbar",
  "POINT_X": -96.74920121,
  "POINT_Y": 32.77482727,
  "MasterID": "'057905139",
  "Feeder": "Madison",
  "HIGH_SLN": 32,
  "dem_totp": 46703,
  "dem_popwh": 6559,
  "dem_popbl": 16839,
  "dem_popas": 91,
  "dem_pophi": 22535,
  "dem_popm": 23505,
  "dem_popf": 23179,
  "dem_thh": 16828,
  "dem_popse": 4974,
  "dem_popch": 12336,
  "dem_perwh": 0.140440657,
  "dem_perbl": 0.360554996,
  "dem_peras": 0.001948483,
  "dem_perhi": 0.482517183,
  "dem_perm": 0.503286727,
  "dem_perf": 0.496306447,
  "dem_perse": 0.106502794,
  "dem_perch": 0.264137207,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.587855763,
  "comm_bvp": 0.096717884,
  "comm_cctrcap": 2.804642927,
  "comm_incarpct": 0.012770972,
  "comm_juvcrimecap": 727.1408139,
  "comm_libcap": 0.215741764,
  "comm_ltbvp": 0.095561368,
  "comm_ltrvp": 0.045697097,
  "comm_ocb": 1589.973886,
  "comm_ocbp": 0.260984128,
  "comm_parkcap": 0.322132671,
  "comm_rcb": 5075.776276,
  "comm_rcbp": 0.472276226,
  "comm_rvp": 0.050018143,
  "comm_u18bbp": 0.579600398,
  "comm_evrate": 276.9045536,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.40626045,
  "econ_fincap": 1.294450582,
  "econ_medinc": 22191.20715,
  "econ_paydaycap": 1.941675873,
  "econ_pctlwjobs": 0.230938316,
  "econ_pctmwjobs": 0.334936118,
  "econ_totjobs": 14558,
  "econ_pr": 0.293836584,
  "econ_pyr": 0.308583709,
  "econ_ur": 0.077009904,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 1,
  "edu_oostkids": 2482.960873,
  "edu_perbach": 0.109974848,
  "edu_perearlyed": 0.430322581,
  "edu_qeckids": 0.81783955,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 10.63191415,
  "fam_lcckids": 16.356791,
  "fam_tphh": 2094.125291,
  "fam_tphhpct": 0.500308501,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3976.698124,
  "hel_castthma": 1057.923245,
  "hel_checkup": 6782.120929,
  "hel_fruitsveggies": 282.8172195,
  "hel_le": 72.29107646,
  "hel_mhlth": 1755.78358,
  "hel_obesity": 4161.532216,
  "hel_perpri": 0.324317351,
  "hel_perpub": 0.406256719,
  "hel_prtopu": 0.79830643,
  "hel_pharmacap": 4.099093509,
  "hel_phlth": 1782.480608,
  "hel_sleep": 3872.632497,
  "hel_stroke": 493.6112328,
  "hel_perins": 0.711481402,
  "hel_perunin": 0.288260589,
  "hel_clincap": 1.941675873,
  "hel_groccap": 0.862967055,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 16,
  "ci_index": 36,
  "eci_index": 26,
  "edi_index": 74,
  "fi_index": 68,
  "hi_index": 16,
  "cri_index": 31,
  "ci_weight": 36,
  "eci_weight": 26,
  "edi_weight": 74,
  "fi_weight": 68,
  "hi_weight": 16,
  "cri_weight": 26,
  "ci_weight_sd": 1,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 38,
  "TEA": 240,
  "SLN": 240,
  "SCHOOLNAME": "Guzick Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5000 Berridge Ln",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9725023900,
  "WEBSITE": "http://www.dallasisd.org/guzick",
  "POINT_X": -96.69273539,
  "POINT_Y": 32.78472564,
  "MasterID": "'057905240",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 62452,
  "dem_popwh": 9468,
  "dem_popbl": 16821,
  "dem_popas": 75,
  "dem_pophi": 34616,
  "dem_popm": 31054,
  "dem_popf": 31407,
  "dem_thh": 20718,
  "dem_popse": 5396,
  "dem_popch": 19082,
  "dem_perwh": 0.151604432,
  "dem_perbl": 0.269342855,
  "dem_peras": 0.001200922,
  "dem_perhi": 0.554281688,
  "dem_perm": 0.497245885,
  "dem_perf": 0.502898226,
  "dem_perse": 0.086402357,
  "dem_perch": 0.30554666,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.681805942,
  "comm_bvp": 0.138284955,
  "comm_cctrcap": 0.161451544,
  "comm_incarpct": 0.007836412,
  "comm_juvcrimecap": 283.0619976,
  "comm_libcap": 0.161451544,
  "comm_ltbvp": 0.135217531,
  "comm_ltrvp": 0.023416353,
  "comm_ocb": 2753.425772,
  "comm_ocbp": 0.273529442,
  "comm_parkcap": 0.073683532,
  "comm_rcb": 5345.713649,
  "comm_rcbp": 0.501473697,
  "comm_rvp": 0.029279563,
  "comm_u18bbp": 0.660390325,
  "comm_evrate": 254.2054553,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.374935658,
  "econ_fincap": 1.937418523,
  "econ_medinc": 25163.99935,
  "econ_paydaycap": 1.130160805,
  "econ_pctlwjobs": 0.221364931,
  "econ_pctmwjobs": 0.381188574,
  "econ_totjobs": 21774,
  "econ_pr": 0.245169654,
  "econ_pyr": 0.243041305,
  "econ_ur": 0.045721622,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 536.899189,
  "edu_perbach": 0.100130215,
  "edu_perearlyed": 0.269450549,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.383682363,
  "fam_lcckids": 8.965900012,
  "fam_tphh": 4487.069219,
  "fam_tphhpct": 0.621180107,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3575.286899,
  "hel_castthma": 1013.533369,
  "hel_checkup": 6713.970714,
  "hel_fruitsveggies": 358.4991161,
  "hel_le": 76.56805159,
  "hel_mhlth": 1654.923205,
  "hel_obesity": 3836.873144,
  "hel_perpri": 0.429979195,
  "hel_perpub": 0.340773834,
  "hel_prtopu": 1.261772919,
  "hel_pharmacap": 2.235481195,
  "hel_phlth": 1571.44157,
  "hel_sleep": 3751.730319,
  "hel_stroke": 378.2753158,
  "hel_perins": 0.730835605,
  "hel_perunin": 0.269148267,
  "hel_clincap": 0.298064159,
  "hel_groccap": 0.745160398,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 25,
  "ci_index": 49,
  "eci_index": 35,
  "edi_index": 53,
  "fi_index": 87,
  "hi_index": 26,
  "cri_index": 44,
  "ci_weight": 49,
  "eci_weight": 35,
  "edi_weight": 53,
  "fi_weight": 87,
  "hi_weight": 26,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 39,
  "TEA": 128,
  "SLN": 128,
  "SCHOOLNAME": "King Jr. Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "1817 Warren Ave.",
  "CITY": "Dallas",
  "ZIP": 75215,
  "PHONE": 9725028100,
  "WEBSITE": "http://www.dallasisd.org/mlk",
  "POINT_X": -96.77349716,
  "POINT_Y": 32.76100571,
  "MasterID": "'057905128",
  "Feeder": "Madison",
  "HIGH_SLN": 32,
  "dem_totp": 33629,
  "dem_popwh": 6059,
  "dem_popbl": 18539,
  "dem_popas": 9,
  "dem_pophi": 8252,
  "dem_popm": 17364,
  "dem_popf": 16243,
  "dem_thh": 13753,
  "dem_popse": 3344,
  "dem_popch": 6697,
  "dem_perwh": 0.180171875,
  "dem_perbl": 0.551280145,
  "dem_peras": 0.000267626,
  "dem_perhi": 0.245383449,
  "dem_perm": 0.516340064,
  "dem_perf": 0.483005739,
  "dem_perse": 0.099437985,
  "dem_perch": 0.199143596,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.604817912,
  "comm_bvp": 0.098480224,
  "comm_cctrcap": 2.715834366,
  "comm_incarpct": 0.016385627,
  "comm_juvcrimecap": 958.3626403,
  "comm_libcap": 0.603518748,
  "comm_ltbvp": 0.096533358,
  "comm_ltrvp": 0.083912709,
  "comm_ocb": 923.2878532,
  "comm_ocbp": 0.247995468,
  "comm_parkcap": 0.385952354,
  "comm_rcb": 4604.844295,
  "comm_rcbp": 0.458459071,
  "comm_rvp": 0.089485121,
  "comm_u18bbp": 0.572261924,
  "comm_evrate": 433.1755814,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.466107781,
  "econ_fincap": 3.01759374,
  "econ_medinc": 23021.2005,
  "econ_paydaycap": 2.112315618,
  "econ_pctlwjobs": 0.143484926,
  "econ_pctmwjobs": 0.256637711,
  "econ_totjobs": 48925,
  "econ_pr": 0.324376465,
  "econ_pyr": 0.312087364,
  "econ_ur": 0.082995598,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 3984.158192,
  "edu_perbach": 0.17364043,
  "edu_perearlyed": 0.49339207,
  "edu_qeckids": 3.062381393,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 19.90547905,
  "fam_lcckids": 30.62381393,
  "fam_tphh": 743.2508795,
  "fam_tphhpct": 0.314393097,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4288.651975,
  "hel_castthma": 1099.141879,
  "hel_checkup": 7054.586712,
  "hel_fruitsveggies": 302.9671308,
  "hel_le": 69.41595684,
  "hel_mhlth": 1684.228311,
  "hel_obesity": 4242.577771,
  "hel_perpri": 0.390294285,
  "hel_perpub": 0.388168727,
  "hel_prtopu": 1.00547586,
  "hel_pharmacap": 6.336946854,
  "hel_phlth": 1712.794897,
  "hel_sleep": 3986.423285,
  "hel_stroke": 552.3279713,
  "hel_perins": 0.756608688,
  "hel_perunin": 0.242792564,
  "hel_clincap": 2.414074992,
  "hel_groccap": 1.207037496,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 12,
  "ci_index": 32,
  "eci_index": 40,
  "edi_index": 79,
  "fi_index": 19,
  "hi_index": 21,
  "cri_index": 39,
  "ci_weight": 32,
  "eci_weight": 40,
  "edi_weight": 79,
  "fi_weight": 19,
  "hi_weight": 21,
  "cri_weight": 28,
  "ci_weight_sd": 1,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 0,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 40,
  "TEA": 200,
  "SLN": 200,
  "SCHOOLNAME": "Rhoads Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "4401 Second Ave.",
  "CITY": "Dallas",
  "ZIP": 75210,
  "PHONE": 9727491000,
  "WEBSITE": "http://www.dallasisd.org/rhoads",
  "POINT_X": -96.74872774,
  "POINT_Y": 32.7634209,
  "MasterID": "'057905200",
  "Feeder": "Lincoln",
  "HIGH_SLN": 9,
  "dem_totp": 31779,
  "dem_popwh": 1861,
  "dem_popbl": 16972,
  "dem_popas": 5,
  "dem_pophi": 12671,
  "dem_popm": 15917,
  "dem_popf": 15851,
  "dem_thh": 11211,
  "dem_popse": 3731,
  "dem_popch": 8838,
  "dem_perwh": 0.058560685,
  "dem_perbl": 0.534063375,
  "dem_peras": 0.000157337,
  "dem_perhi": 0.398722427,
  "dem_perm": 0.500865351,
  "dem_perf": 0.498788508,
  "dem_perse": 0.117404575,
  "dem_perch": 0.278108185,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.500248743,
  "comm_bvp": 0.092612437,
  "comm_cctrcap": 3.806643502,
  "comm_incarpct": 0.020319832,
  "comm_juvcrimecap": 998.9691426,
  "comm_libcap": 0.317220292,
  "comm_ltbvp": 0.092282267,
  "comm_ltrvp": 0.048088954,
  "comm_ocb": 1147.759045,
  "comm_ocbp": 0.275812199,
  "comm_parkcap": 0.676269657,
  "comm_rcb": 3520.812021,
  "comm_rcbp": 0.498634788,
  "comm_rvp": 0.052534991,
  "comm_u18bbp": 0.520432433,
  "comm_evrate": 351.7973036,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.435897355,
  "econ_fincap": 1.268881167,
  "econ_medinc": 19711.05375,
  "econ_paydaycap": 1.586101459,
  "econ_pctlwjobs": 0.237024221,
  "econ_pctmwjobs": 0.349019608,
  "econ_totjobs": 8670,
  "econ_pr": 0.331447906,
  "econ_pyr": 0.318554021,
  "econ_ur": 0.099411693,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 3199.441408,
  "edu_perbach": 0.061328453,
  "edu_perearlyed": 0.492895204,
  "edu_qeckids": 1.1422497,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 15.99149579,
  "fam_lcckids": 21.70274429,
  "fam_tphh": 1237.391102,
  "fam_tphhpct": 0.432144666,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4586.619841,
  "hel_castthma": 1156.920375,
  "hel_checkup": 7114.020944,
  "hel_fruitsveggies": 253.3697935,
  "hel_le": 71.02052781,
  "hel_mhlth": 1858.455311,
  "hel_obesity": 4512.830526,
  "hel_perpri": 0.267010407,
  "hel_perpub": 0.467054693,
  "hel_prtopu": 0.571689807,
  "hel_pharmacap": 3.48942321,
  "hel_phlth": 1980.971203,
  "hel_sleep": 4125.678829,
  "hel_stroke": 621.3671971,
  "hel_perins": 0.714674343,
  "hel_perunin": 0.284914434,
  "hel_clincap": 2.220542043,
  "hel_groccap": 0.951660875,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 6,
  "ci_index": 22,
  "eci_index": 14,
  "edi_index": 73,
  "fi_index": 52,
  "hi_index": 6,
  "cri_index": 17,
  "ci_weight": 22,
  "eci_weight": 14,
  "edi_weight": 73,
  "fi_weight": 52,
  "hi_weight": 6,
  "cri_weight": 14,
  "ci_weight_sd": 1,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 41,
  "TEA": 201,
  "SLN": 201,
  "SCHOOLNAME": "Rice Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "2425 Pine St.",
  "CITY": "Dallas",
  "ZIP": 75215,
  "PHONE": 9727491100,
  "WEBSITE": "http://www.dallasisd.org/rice",
  "POINT_X": -96.7621251,
  "POINT_Y": 32.75648937,
  "MasterID": "'057905201",
  "Feeder": "Lincoln",
  "HIGH_SLN": 9,
  "dem_totp": 27307,
  "dem_popwh": 2457,
  "dem_popbl": 17595,
  "dem_popas": 5,
  "dem_pophi": 6933,
  "dem_popm": 13770,
  "dem_popf": 13533,
  "dem_thh": 10333,
  "dem_popse": 2978,
  "dem_popch": 6595,
  "dem_perwh": 0.089976929,
  "dem_perbl": 0.644340279,
  "dem_peras": 0.000183103,
  "dem_perhi": 0.253890944,
  "dem_perm": 0.504266305,
  "dem_perf": 0.495587212,
  "dem_perse": 0.109056286,
  "dem_perch": 0.241513165,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.519658259,
  "comm_bvp": 0.093226024,
  "comm_cctrcap": 4.070914803,
  "comm_incarpct": 0.023840062,
  "comm_juvcrimecap": 1171.919694,
  "comm_libcap": 0.370083164,
  "comm_ltbvp": 0.092657337,
  "comm_ltrvp": 0.084769424,
  "comm_ocb": 802.3744387,
  "comm_ocbp": 0.259042327,
  "comm_parkcap": 0.741733967,
  "comm_rcb": 3551.565303,
  "comm_rcbp": 0.489700996,
  "comm_rvp": 0.089859577,
  "comm_u18bbp": 0.522465304,
  "comm_evrate": 410.9773535,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.465485465,
  "econ_fincap": 0.740166328,
  "econ_medinc": 20211.09732,
  "econ_paydaycap": 1.850415819,
  "econ_pctlwjobs": 0.230080573,
  "econ_pctmwjobs": 0.367837959,
  "econ_totjobs": 8936,
  "econ_pr": 0.343447509,
  "econ_pyr": 0.31152585,
  "econ_ur": 0.099108372,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 3361.195753,
  "edu_perbach": 0.104882558,
  "edu_perearlyed": 0.40472879,
  "edu_qeckids": 3.087915253,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 21.61540677,
  "fam_lcckids": 26.24727965,
  "fam_tphh": 704.5585159,
  "fam_tphhpct": 0.321501017,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4750.802578,
  "hel_castthma": 1176.474965,
  "hel_checkup": 7272.979222,
  "hel_fruitsveggies": 267.9168865,
  "hel_le": 69.92672566,
  "hel_mhlth": 1808.518627,
  "hel_obesity": 4552.392719,
  "hel_perpri": 0.307978625,
  "hel_perpub": 0.458374793,
  "hel_prtopu": 0.671892587,
  "hel_pharmacap": 4.070914803,
  "hel_phlth": 1922.205833,
  "hel_sleep": 4181.851817,
  "hel_stroke": 645.8205441,
  "hel_perins": 0.742472821,
  "hel_perunin": 0.257195504,
  "hel_clincap": 2.590582147,
  "hel_groccap": 1.110249492,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 4,
  "ci_index": 20,
  "eci_index": 12,
  "edi_index": 77,
  "fi_index": 21,
  "hi_index": 10,
  "cri_index": 19,
  "ci_weight": 20,
  "eci_weight": 12,
  "edi_weight": 77,
  "fi_weight": 21,
  "hi_weight": 10,
  "cri_weight": 13,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 42,
  "TEA": 232,
  "SLN": 232,
  "SCHOOLNAME": "Rowe Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4918 Hovenkamp Dr.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727498000,
  "WEBSITE": "http://www.dallasisd.org/rowe",
  "POINT_X": -96.70673618,
  "POINT_Y": 32.78543679,
  "MasterID": "'057905232",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 57236,
  "dem_popwh": 9862,
  "dem_popbl": 14744,
  "dem_popas": 66,
  "dem_pophi": 31333,
  "dem_popm": 28943,
  "dem_popf": 28293,
  "dem_thh": 19616,
  "dem_popse": 5265,
  "dem_popch": 16688,
  "dem_perwh": 0.172304144,
  "dem_perbl": 0.257600112,
  "dem_peras": 0.00115312,
  "dem_perhi": 0.547435181,
  "dem_perm": 0.505678244,
  "dem_perf": 0.494321756,
  "dem_perse": 0.09198756,
  "dem_perch": 0.291564749,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.678367527,
  "comm_bvp": 0.135003514,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.008774558,
  "comm_juvcrimecap": 305.0504102,
  "comm_libcap": 0.176287318,
  "comm_ltbvp": 0.131775554,
  "comm_ltrvp": 0.025293765,
  "comm_ocb": 2458.234978,
  "comm_ocbp": 0.266225391,
  "comm_parkcap": 0.245605354,
  "comm_rcb": 4963.152033,
  "comm_rcbp": 0.47729987,
  "comm_rvp": 0.031162922,
  "comm_u18bbp": 0.652354724,
  "comm_evrate": 202.9948465,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.371791098,
  "econ_fincap": 1.939160497,
  "econ_medinc": 26586.10289,
  "econ_paydaycap": 0.881436589,
  "econ_pctlwjobs": 0.220008953,
  "econ_pctmwjobs": 0.399134587,
  "econ_totjobs": 13404,
  "econ_pr": 0.239237693,
  "econ_pyr": 0.268104098,
  "econ_ur": 0.050592959,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 724.9303558,
  "edu_perbach": 0.118783737,
  "edu_perearlyed": 0.298653042,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 9.649655318,
  "fam_lcckids": 12.06206915,
  "fam_tphh": 4096.99606,
  "fam_tphhpct": 0.645676733,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3535.092633,
  "hel_castthma": 991.4920819,
  "hel_checkup": 6695.022836,
  "hel_fruitsveggies": 348.9129941,
  "hel_le": 76.21528448,
  "hel_mhlth": 1606.058812,
  "hel_obesity": 3762.590991,
  "hel_perpri": 0.432247723,
  "hel_perpub": 0.331706973,
  "hel_prtopu": 1.303101105,
  "hel_pharmacap": 2.253625173,
  "hel_phlth": 1545.701231,
  "hel_sleep": 3679.303326,
  "hel_stroke": 376.9743224,
  "hel_perins": 0.727194265,
  "hel_perunin": 0.272929033,
  "hel_clincap": 0.346711565,
  "hel_groccap": 0.520067348,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 26,
  "ci_index": 51,
  "eci_index": 35,
  "edi_index": 55,
  "fi_index": 79,
  "hi_index": 27,
  "cri_index": 43,
  "ci_weight": 51,
  "eci_weight": 35,
  "edi_weight": 55,
  "fi_weight": 79,
  "hi_weight": 27,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 43,
  "TEA": 209,
  "SLN": 209,
  "SCHOOLNAME": "Silberstein Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5940 Hollis Ave.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727941900,
  "WEBSITE": "http://www.dallasisd.org/silberstein",
  "POINT_X": -96.72052825,
  "POINT_Y": 32.76720471,
  "MasterID": "'057905209",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 41497,
  "dem_popwh": 3510,
  "dem_popbl": 13448,
  "dem_popas": 31,
  "dem_pophi": 24066,
  "dem_popm": 20798,
  "dem_popf": 20695,
  "dem_thh": 12768,
  "dem_popse": 4110,
  "dem_popch": 13025,
  "dem_perwh": 0.084584428,
  "dem_perbl": 0.32407162,
  "dem_peras": 0.000747042,
  "dem_perhi": 0.579945538,
  "dem_perm": 0.501192857,
  "dem_perf": 0.49871075,
  "dem_perse": 0.099043304,
  "dem_perch": 0.313878112,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.59159399,
  "comm_bvp": 0.118904259,
  "comm_cctrcap": 0.972796301,
  "comm_incarpct": 0.013919267,
  "comm_juvcrimecap": 425.0250216,
  "comm_libcap": 0.243199075,
  "comm_ltbvp": 0.117161503,
  "comm_ltrvp": 0.034659995,
  "comm_ocb": 1842.440694,
  "comm_ocbp": 0.277969259,
  "comm_parkcap": 0.644859015,
  "comm_rcb": 2946.407455,
  "comm_rcbp": 0.478802775,
  "comm_rvp": 0.038797109,
  "comm_u18bbp": 0.591936775,
  "comm_evrate": 144.8250493,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 1,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.391507103,
  "econ_fincap": 0,
  "econ_medinc": 22192.80992,
  "econ_paydaycap": 0.486398151,
  "econ_pctlwjobs": 0.197276016,
  "econ_pctmwjobs": 0.39242392,
  "econ_totjobs": 4699,
  "econ_pr": 0.280428084,
  "econ_pyr": 0.179555017,
  "econ_ur": 0.066645837,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 855.1797696,
  "edu_perbach": 0.070151251,
  "edu_perearlyed": 0.375899281,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.174583174,
  "fam_lcckids": 6.946406071,
  "fam_tphh": 2661.344199,
  "fam_tphhpct": 0.590153936,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3893.532445,
  "hel_castthma": 1048.65411,
  "hel_checkup": 6760.84715,
  "hel_fruitsveggies": 296.2580913,
  "hel_le": 74.18529011,
  "hel_mhlth": 1754.648049,
  "hel_obesity": 4095.185094,
  "hel_perpri": 0.339733619,
  "hel_perpub": 0.402586039,
  "hel_prtopu": 0.84387829,
  "hel_pharmacap": 1.459194452,
  "hel_phlth": 1771.292179,
  "hel_sleep": 3865.657581,
  "hel_stroke": 468.7315605,
  "hel_perins": 0.714466265,
  "hel_perunin": 0.28560665,
  "hel_clincap": 0.729597226,
  "hel_groccap": 0,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 17,
  "ci_index": 43,
  "eci_index": 28,
  "edi_index": 57,
  "fi_index": 63,
  "hi_index": 16,
  "cri_index": 30,
  "ci_weight": 43,
  "eci_weight": 28,
  "edi_weight": 57,
  "fi_weight": 63,
  "hi_weight": 16,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 44,
  "TEA": 155,
  "SLN": 155,
  "SCHOOLNAME": "Tatum Jr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3002 N. St. Augustine Rd.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9725022000,
  "WEBSITE": "http://www.dallasisd.org/tatum",
  "POINT_X": -96.65553633,
  "POINT_Y": 32.763373,
  "MasterID": "'057905155",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 58026,
  "dem_popwh": 5683,
  "dem_popbl": 15990,
  "dem_popas": 119,
  "dem_pophi": 35410,
  "dem_popm": 27688,
  "dem_popf": 30328,
  "dem_thh": 16788,
  "dem_popse": 4013,
  "dem_popch": 19922,
  "dem_perwh": 0.097938855,
  "dem_perbl": 0.275566126,
  "dem_peras": 0.002050805,
  "dem_perhi": 0.610243684,
  "dem_perm": 0.477165409,
  "dem_perf": 0.522662255,
  "dem_perse": 0.069158653,
  "dem_perch": 0.343328853,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.678112815,
  "comm_bvp": 0.094024179,
  "comm_cctrcap": 0.173345728,
  "comm_incarpct": 0.006672372,
  "comm_juvcrimecap": 199.3734463,
  "comm_libcap": 0.173345728,
  "comm_ltbvp": 0.091017179,
  "comm_ltrvp": 0.018939931,
  "comm_ocb": 3128.116408,
  "comm_ocbp": 0.318954443,
  "comm_parkcap": 0.017560716,
  "comm_rcb": 3784.029271,
  "comm_rcbp": 0.541310257,
  "comm_rvp": 0.023247321,
  "comm_u18bbp": 0.675130341,
  "comm_evrate": 183.1397619,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.356902716,
  "econ_fincap": 0.173345728,
  "econ_medinc": 23494.29632,
  "econ_paydaycap": 0.346691457,
  "econ_pctlwjobs": 0.206926854,
  "econ_pctmwjobs": 0.390178341,
  "econ_totjobs": 19345,
  "econ_pr": 0.254513031,
  "econ_pyr": 0.354553418,
  "econ_ur": 0.049900518,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 541.9612194,
  "edu_perbach": 0.058019499,
  "edu_perearlyed": 0.224398931,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.555509406,
  "fam_lcckids": 4.063439321,
  "fam_tphh": 4187.978705,
  "fam_tphhpct": 0.576621104,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3552.170866,
  "hel_castthma": 1026.691858,
  "hel_checkup": 6618.784822,
  "hel_fruitsveggies": 355.9426043,
  "hel_le": 75.50407886,
  "hel_mhlth": 1741.028145,
  "hel_obesity": 3992.845327,
  "hel_perpri": 0.382261518,
  "hel_perpub": 0.371330386,
  "hel_prtopu": 1.029437753,
  "hel_pharmacap": 1.560111555,
  "hel_phlth": 1628.092943,
  "hel_sleep": 3801.694644,
  "hel_stroke": 374.8084216,
  "hel_perins": 0.722352697,
  "hel_perunin": 0.277509152,
  "hel_clincap": 0.173345728,
  "hel_groccap": 0.520037185,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 23,
  "ci_index": 59,
  "eci_index": 33,
  "edi_index": 43,
  "fi_index": 58,
  "hi_index": 23,
  "cri_index": 40,
  "ci_weight": 59,
  "eci_weight": 33,
  "edi_weight": 43,
  "fi_weight": 58,
  "hi_weight": 23,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 45,
  "TEA": 247,
  "SLN": 247,
  "SCHOOLNAME": "Callejo Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7817 Military Pkwy",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9728925700,
  "WEBSITE": "http://www.dallasisd.org/callejo",
  "POINT_X": -96.68666861,
  "POINT_Y": 32.77139754,
  "MasterID": "'057905247",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 57496,
  "dem_popwh": 5792,
  "dem_popbl": 15021,
  "dem_popas": 98,
  "dem_pophi": 35675,
  "dem_popm": 28529,
  "dem_popf": 28960,
  "dem_thh": 17324,
  "dem_popse": 4704,
  "dem_popch": 18664,
  "dem_perwh": 0.100737443,
  "dem_perbl": 0.261252957,
  "dem_peras": 0.001704466,
  "dem_perhi": 0.620477946,
  "dem_perm": 0.496191039,
  "dem_perf": 0.503687213,
  "dem_perse": 0.081814387,
  "dem_perch": 0.324613886,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.660203595,
  "comm_bvp": 0.11574947,
  "comm_cctrcap": 0.175598049,
  "comm_incarpct": 0.008449543,
  "comm_juvcrimecap": 243.1175824,
  "comm_libcap": 0.175598049,
  "comm_ltbvp": 0.112583189,
  "comm_ltrvp": 0.02015227,
  "comm_ocb": 2729.14558,
  "comm_ocbp": 0.284040459,
  "comm_parkcap": 0.179688784,
  "comm_rcb": 4057.669934,
  "comm_rcbp": 0.525527505,
  "comm_rvp": 0.024652328,
  "comm_u18bbp": 0.652916535,
  "comm_evrate": 193.0700545,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.374200183,
  "econ_fincap": 1.053588292,
  "econ_medinc": 24152.88363,
  "econ_paydaycap": 0.877990243,
  "econ_pctlwjobs": 0.23832455,
  "econ_pctmwjobs": 0.399736507,
  "econ_totjobs": 22012,
  "econ_pr": 0.253313766,
  "econ_pyr": 0.243346624,
  "econ_ur": 0.041296869,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 646.3087754,
  "edu_perbach": 0.07192604,
  "edu_perearlyed": 0.229609929,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.571818289,
  "fam_lcckids": 8.653506616,
  "fam_tphh": 4246.606315,
  "fam_tphhpct": 0.624934307,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3556.608441,
  "hel_castthma": 1003.276579,
  "hel_checkup": 6660.88227,
  "hel_fruitsveggies": 348.2257567,
  "hel_le": 75.91355517,
  "hel_mhlth": 1674.633035,
  "hel_obesity": 3911.04407,
  "hel_perpri": 0.39939019,
  "hel_perpub": 0.342141693,
  "hel_prtopu": 1.167323944,
  "hel_pharmacap": 2.098641596,
  "hel_phlth": 1593.611315,
  "hel_sleep": 3787.457004,
  "hel_stroke": 375.7391683,
  "hel_perins": 0.710217814,
  "hel_perunin": 0.289764663,
  "hel_clincap": 0.349773599,
  "hel_groccap": 0.699547199,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 24,
  "ci_index": 51,
  "eci_index": 35,
  "edi_index": 48,
  "fi_index": 86,
  "hi_index": 23,
  "cri_index": 43,
  "ci_weight": 51,
  "eci_weight": 35,
  "edi_weight": 48,
  "fi_weight": 86,
  "hi_weight": 23,
  "cri_weight": 35,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 46,
  "TEA": 162,
  "SLN": 162,
  "SCHOOLNAME": "Mockingbird Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5828 E. Mockingbird Lane",
  "CITY": "Dallas",
  "ZIP": 75206,
  "PHONE": 9727497200,
  "WEBSITE": "http://www.dallasisd.org/mockingbird",
  "POINT_X": -96.76734035,
  "POINT_Y": 32.83562313,
  "MasterID": "'057905162",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 79287,
  "dem_popwh": 57304,
  "dem_popbl": 3318,
  "dem_popas": 199,
  "dem_pophi": 12351,
  "dem_popm": 38978,
  "dem_popf": 40320,
  "dem_thh": 37374,
  "dem_popse": 8385,
  "dem_popch": 13298,
  "dem_perwh": 0.722741433,
  "dem_perbl": 0.04184797,
  "dem_peras": 0.002509869,
  "dem_perhi": 0.155775852,
  "dem_perm": 0.491606442,
  "dem_perf": 0.508532294,
  "dem_perse": 0.105755042,
  "dem_perch": 0.167719803,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.921567818,
  "comm_bvp": 0.052708296,
  "comm_cctrcap": 0.130790294,
  "comm_incarpct": 0.002590721,
  "comm_juvcrimecap": 66.48194497,
  "comm_libcap": 0.392370882,
  "comm_ltbvp": 0.050006817,
  "comm_ltrvp": 0.008388555,
  "comm_ocb": 4260.378573,
  "comm_ocbp": 0.255054061,
  "comm_parkcap": 0.024084098,
  "comm_rcb": 7281.719278,
  "comm_rcbp": 0.352154796,
  "comm_rvp": 0.012042088,
  "comm_u18bbp": 0.938927858,
  "comm_evrate": 68.2071383,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.091463551,
  "econ_fincap": 3.923708819,
  "econ_medinc": 61906.83964,
  "econ_paydaycap": 1.30790294,
  "econ_pctlwjobs": 0.267446646,
  "econ_pctmwjobs": 0.313892645,
  "econ_totjobs": 51027,
  "econ_pr": 0.093899174,
  "econ_pyr": 0.191364827,
  "econ_ur": 0.026876419,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 1198.066535,
  "edu_perbach": 0.42096645,
  "edu_perearlyed": 0.702479339,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.289299111,
  "fam_lcckids": 22.12989141,
  "fam_tphh": 6128.524234,
  "fam_tphhpct": 0.795051283,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 1877.321162,
  "hel_castthma": 631.8715971,
  "hel_checkup": 5139.641909,
  "hel_fruitsveggies": 471.0612782,
  "hel_le": 82.00837284,
  "hel_mhlth": 851.3258511,
  "hel_obesity": 2081.069212,
  "hel_perpri": 0.828140589,
  "hel_perpub": 0.152675516,
  "hel_prtopu": 5.424187278,
  "hel_pharmacap": 3.269757349,
  "hel_phlth": 646.8699837,
  "hel_sleep": 2334.04123,
  "hel_stroke": 138.7022249,
  "hel_perins": 0.915787878,
  "hel_perunin": 0.083921648,
  "hel_clincap": 0.261580588,
  "hel_groccap": 1.700273821,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 80,
  "ci_index": 97,
  "eci_index": 80,
  "edi_index": 97,
  "fi_index": 93,
  "hi_index": 96,
  "cri_index": 96,
  "ci_weight": 97,
  "eci_weight": 80,
  "edi_weight": 97,
  "fi_weight": 93,
  "hi_weight": 96,
  "cri_weight": 99,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 47,
  "TEA": 174,
  "SLN": 174,
  "SCHOOLNAME": "Geneva Heights Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2911 Delmar Ave.",
  "CITY": "Dallas",
  "ZIP": 75206,
  "PHONE": 9727497400,
  "WEBSITE": "http://www.dallasisd.org/genevaheights",
  "POINT_X": -96.76636546,
  "POINT_Y": 32.82416138,
  "MasterID": "'057905174",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 84869,
  "dem_popwh": 52870,
  "dem_popbl": 5492,
  "dem_popas": 255,
  "dem_pophi": 20568,
  "dem_popm": 42534,
  "dem_popf": 42340,
  "dem_thh": 39789,
  "dem_popse": 8000,
  "dem_popch": 14525,
  "dem_perwh": 0.622960091,
  "dem_perbl": 0.064711497,
  "dem_peras": 0.003004631,
  "dem_perhi": 0.242349975,
  "dem_perm": 0.501172395,
  "dem_perf": 0.498886519,
  "dem_perse": 0.094262923,
  "dem_perch": 0.171146119,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.869495745,
  "comm_bvp": 0.063910542,
  "comm_cctrcap": 0.243344893,
  "comm_incarpct": 0.003047974,
  "comm_juvcrimecap": 122.2278456,
  "comm_libcap": 0.243344893,
  "comm_ltbvp": 0.060323677,
  "comm_ltrvp": 0.011326917,
  "comm_ocb": 4007.222227,
  "comm_ocbp": 0.250801616,
  "comm_parkcap": 0.034785416,
  "comm_rcb": 8980.044424,
  "comm_rcbp": 0.377124041,
  "comm_rvp": 0.015580079,
  "comm_u18bbp": 0.846245689,
  "comm_evrate": 132.3796218,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.203409658,
  "econ_fincap": 3.041811163,
  "econ_medinc": 55881.36768,
  "econ_paydaycap": 1.460069358,
  "econ_pctlwjobs": 0.270464217,
  "econ_pctmwjobs": 0.316363636,
  "econ_totjobs": 51700,
  "econ_pr": 0.13462875,
  "econ_pyr": 0.180635833,
  "econ_ur": 0.031589165,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 1438.663677,
  "edu_perbach": 0.363202861,
  "edu_perearlyed": 0.677852349,
  "edu_qeckids": 0.699059124,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.495295618,
  "fam_lcckids": 22.36989196,
  "fam_tphh": 5389.619971,
  "fam_tphhpct": 0.694804404,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2257.156227,
  "hel_castthma": 736.3842384,
  "hel_checkup": 5731.644995,
  "hel_fruitsveggies": 452.7438719,
  "hel_le": 81.21975945,
  "hel_mhlth": 1076.363102,
  "hel_obesity": 2576.498935,
  "hel_perpri": 0.732867496,
  "hel_perpub": 0.183163759,
  "hel_prtopu": 4.001159943,
  "hel_pharmacap": 2.555121377,
  "hel_phlth": 867.5694246,
  "hel_sleep": 2753.302765,
  "hel_stroke": 180.1087312,
  "hel_perins": 0.867283586,
  "hel_perunin": 0.132586577,
  "hel_clincap": 0.243344893,
  "hel_groccap": 1.703414251,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 63,
  "ci_index": 81,
  "eci_index": 65,
  "edi_index": 100,
  "fi_index": 92,
  "hi_index": 73,
  "cri_index": 67,
  "ci_weight": 81,
  "eci_weight": 65,
  "edi_weight": 100,
  "fi_weight": 92,
  "hi_weight": 73,
  "cri_weight": 80,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 48,
  "TEA": 177,
  "SLN": 177,
  "SCHOOLNAME": "Lipscomb Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5801 Worth St.",
  "CITY": "Dallas",
  "ZIP": 75214,
  "PHONE": 9727947300,
  "WEBSITE": "http://www.dallasisd.org/lipscomb",
  "POINT_X": -96.75702231,
  "POINT_Y": 32.80716173,
  "MasterID": "'057905177",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 74743,
  "dem_popwh": 34631,
  "dem_popbl": 7633,
  "dem_popas": 260,
  "dem_pophi": 28469,
  "dem_popm": 38519,
  "dem_popf": 36206,
  "dem_thh": 33419,
  "dem_popse": 6437,
  "dem_popch": 15121,
  "dem_perwh": 0.463334359,
  "dem_perbl": 0.102123276,
  "dem_peras": 0.003478587,
  "dem_perhi": 0.380891856,
  "dem_perm": 0.515352608,
  "dem_perf": 0.484406567,
  "dem_perse": 0.086121777,
  "dem_perch": 0.202306571,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.8003019,
  "comm_bvp": 0.084343407,
  "comm_cctrcap": 0.672563609,
  "comm_incarpct": 0.004970799,
  "comm_juvcrimecap": 245.5608444,
  "comm_libcap": 0.134512722,
  "comm_ltbvp": 0.080971875,
  "comm_ltrvp": 0.018365137,
  "comm_ocb": 2849.105369,
  "comm_ocbp": 0.246387908,
  "comm_parkcap": 0.187753897,
  "comm_rcb": 8697.061412,
  "comm_rcbp": 0.397965747,
  "comm_rvp": 0.022643397,
  "comm_u18bbp": 0.755131401,
  "comm_evrate": 162.4241115,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.314724296,
  "econ_fincap": 3.0937926,
  "econ_medinc": 44606.55391,
  "econ_paydaycap": 1.479639939,
  "econ_pctlwjobs": 0.15992172,
  "econ_pctmwjobs": 0.293192309,
  "econ_totjobs": 66939,
  "econ_pr": 0.190512059,
  "econ_pyr": 0.263707823,
  "econ_ur": 0.040387895,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1515.041091,
  "edu_perbach": 0.289795532,
  "edu_perearlyed": 0.572365544,
  "edu_qeckids": 0.668302201,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 4.009813208,
  "fam_lcckids": 21.38567044,
  "fam_tphh": 4273.317902,
  "fam_tphhpct": 0.613741637,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2742.27387,
  "hel_castthma": 856.0110606,
  "hel_checkup": 6317.866282,
  "hel_fruitsveggies": 401.7171544,
  "hel_le": 79.23244921,
  "hel_mhlth": 1354.702028,
  "hel_obesity": 3187.086458,
  "hel_perpri": 0.590511174,
  "hel_perpub": 0.236362661,
  "hel_prtopu": 2.498326811,
  "hel_pharmacap": 3.228305322,
  "hel_phlth": 1167.334577,
  "hel_sleep": 3237.728239,
  "hel_stroke": 244.4453819,
  "hel_perins": 0.798023943,
  "hel_perunin": 0.201707935,
  "hel_clincap": 0.672563609,
  "hel_groccap": 1.479639939,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 43,
  "ci_index": 62,
  "eci_index": 44,
  "edi_index": 91,
  "fi_index": 87,
  "hi_index": 46,
  "cri_index": 51,
  "ci_weight": 62,
  "eci_weight": 44,
  "edi_weight": 91,
  "fi_weight": 87,
  "hi_weight": 46,
  "cri_weight": 56,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 49,
  "TEA": 184,
  "SLN": 184,
  "SCHOOLNAME": "Milam Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4200 McKinney Ave.",
  "CITY": "Dallas",
  "ZIP": 75205,
  "PHONE": 9727495600,
  "WEBSITE": "http://www.dallasisd.org/milam",
  "POINT_X": -96.79015005,
  "POINT_Y": 32.81637614,
  "MasterID": "'057905184",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 105444,
  "dem_popwh": 66661,
  "dem_popbl": 8086,
  "dem_popas": 228,
  "dem_pophi": 22346,
  "dem_popm": 54739,
  "dem_popf": 50713,
  "dem_thh": 56363,
  "dem_popse": 9926,
  "dem_popch": 13787,
  "dem_perwh": 0.632193392,
  "dem_perbl": 0.076685255,
  "dem_peras": 0.002162285,
  "dem_perhi": 0.211922916,
  "dem_perm": 0.519128637,
  "dem_perf": 0.480947233,
  "dem_perse": 0.094135276,
  "dem_perch": 0.130751868,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.871719638,
  "comm_bvp": 0.091624499,
  "comm_cctrcap": 0.576964743,
  "comm_incarpct": 0.002584541,
  "comm_juvcrimecap": 172.3586777,
  "comm_libcap": 0.192321581,
  "comm_ltbvp": 0.082626881,
  "comm_ltrvp": 0.012732687,
  "comm_ocb": 4782.808492,
  "comm_ocbp": 0.256207861,
  "comm_parkcap": 0.031992134,
  "comm_rcb": 13223.18528,
  "comm_rcbp": 0.350701058,
  "comm_rvp": 0.017733206,
  "comm_u18bbp": 0.805114603,
  "comm_evrate": 162.5598162,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.241802656,
  "econ_fincap": 5.096521893,
  "econ_medinc": 59030.0105,
  "econ_paydaycap": 1.442411856,
  "econ_pctlwjobs": 0.159801845,
  "econ_pctmwjobs": 0.263603403,
  "econ_totjobs": 139285,
  "econ_pr": 0.130419291,
  "econ_pyr": 0.108061514,
  "econ_ur": 0.02801829,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1441.362611,
  "edu_perbach": 0.385445886,
  "edu_perearlyed": 0.642506812,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.671326059,
  "fam_lcckids": 21.29369114,
  "fam_tphh": 4736.96157,
  "fam_tphhpct": 0.643340824,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2021.709717,
  "hel_castthma": 696.7056871,
  "hel_checkup": 5436.504307,
  "hel_fruitsveggies": 455.8940034,
  "hel_le": 80.3713072,
  "hel_mhlth": 1005.538351,
  "hel_obesity": 2412.759205,
  "hel_perpri": 0.756281216,
  "hel_perpub": 0.170822493,
  "hel_prtopu": 4.427292941,
  "hel_pharmacap": 3.750270827,
  "hel_phlth": 765.6349837,
  "hel_sleep": 2647.079997,
  "hel_stroke": 154.4141508,
  "hel_perins": 0.879645631,
  "hel_perunin": 0.120259415,
  "hel_clincap": 0.673125533,
  "hel_groccap": 1.538572647,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 69,
  "ci_index": 72,
  "eci_index": 73,
  "edi_index": 92,
  "fi_index": 87,
  "hi_index": 81,
  "cri_index": 77,
  "ci_weight": 72,
  "eci_weight": 73,
  "edi_weight": 92,
  "fi_weight": 87,
  "hi_weight": 81,
  "cri_weight": 82,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 50,
  "TEA": 203,
  "SLN": 203,
  "SCHOOLNAME": "Rogers Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5314 Abrams Rd.",
  "CITY": "Dallas",
  "ZIP": 75214,
  "PHONE": 9727948800,
  "WEBSITE": "http://www.dallasisd.org/rogers",
  "POINT_X": -96.75169716,
  "POINT_Y": 32.85205256,
  "MasterID": "'057905203",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 76379,
  "dem_popwh": 44060,
  "dem_popbl": 9142,
  "dem_popas": 163,
  "dem_pophi": 15343,
  "dem_popm": 37982,
  "dem_popf": 38408,
  "dem_thh": 34488,
  "dem_popse": 7950,
  "dem_popch": 15687,
  "dem_perwh": 0.576860132,
  "dem_perbl": 0.119692586,
  "dem_peras": 0.002134094,
  "dem_perhi": 0.200879823,
  "dem_perm": 0.497283285,
  "dem_perf": 0.502860734,
  "dem_perse": 0.104086202,
  "dem_perch": 0.205383679,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.859573996,
  "comm_bvp": 0.090214732,
  "comm_cctrcap": 0.270558973,
  "comm_incarpct": 0.003049657,
  "comm_juvcrimecap": 129.0836163,
  "comm_libcap": 0.270558973,
  "comm_ltbvp": 0.082109279,
  "comm_ltrvp": 0.007372008,
  "comm_ocb": 2965.667581,
  "comm_ocbp": 0.24039245,
  "comm_parkcap": 0.213301249,
  "comm_rcb": 9245.590277,
  "comm_rcbp": 0.417202402,
  "comm_rvp": 0.010671366,
  "comm_u18bbp": 0.867147017,
  "comm_evrate": 127.4332763,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.231763098,
  "econ_fincap": 3.517266649,
  "econ_medinc": 55526.32861,
  "econ_paydaycap": 2.164471784,
  "econ_pctlwjobs": 0.290552027,
  "econ_pctmwjobs": 0.310405471,
  "econ_totjobs": 51175,
  "econ_pr": 0.155479209,
  "econ_pyr": 0.200556605,
  "econ_ur": 0.038611592,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 1399.58454,
  "edu_perbach": 0.345753097,
  "edu_perearlyed": 0.533002481,
  "edu_qeckids": 0.647955805,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 1.943867416,
  "fam_lcckids": 15.55093933,
  "fam_tphh": 6142.344681,
  "fam_tphhpct": 0.759335318,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2499.322209,
  "hel_castthma": 782.3526915,
  "hel_checkup": 6021.053668,
  "hel_fruitsveggies": 448.6100563,
  "hel_le": 81.94313737,
  "hel_mhlth": 1163.412951,
  "hel_obesity": 2712.108657,
  "hel_perpri": 0.694135875,
  "hel_perpub": 0.219661756,
  "hel_prtopu": 3.16002152,
  "hel_pharmacap": 4.193664081,
  "hel_phlth": 954.0263286,
  "hel_sleep": 2927.155178,
  "hel_stroke": 209.524644,
  "hel_perins": 0.847790121,
  "hel_perunin": 0.152104835,
  "hel_clincap": 0.946956405,
  "hel_groccap": 1.623353838,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 56,
  "ci_index": 88,
  "eci_index": 54,
  "edi_index": 89,
  "fi_index": 86,
  "hi_index": 64,
  "cri_index": 70,
  "ci_weight": 88,
  "eci_weight": 54,
  "edi_weight": 89,
  "fi_weight": 86,
  "hi_weight": 64,
  "cri_weight": 74,
  "ci_weight_sd": 4,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 51,
  "TEA": 281,
  "SLN": 281,
  "SCHOOLNAME": "Chavez Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "1710 N. Carroll",
  "CITY": "Dallas",
  "ZIP": 75204,
  "PHONE": 9729251000,
  "WEBSITE": "http://www.dallasisd.org/chavez",
  "POINT_X": -96.78056439,
  "POINT_Y": 32.80372416,
  "MasterID": "'057905281",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 101973,
  "dem_popwh": 57744,
  "dem_popbl": 9731,
  "dem_popas": 255,
  "dem_pophi": 27018,
  "dem_popm": 53197,
  "dem_popf": 48777,
  "dem_thh": 54655,
  "dem_popse": 8970,
  "dem_popch": 12999,
  "dem_perwh": 0.566267541,
  "dem_perbl": 0.095427221,
  "dem_peras": 0.002500662,
  "dem_perhi": 0.264952487,
  "dem_perm": 0.521677307,
  "dem_perf": 0.4783325,
  "dem_perse": 0.087964461,
  "dem_perch": 0.12747492,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.848022461,
  "comm_bvp": 0.107376231,
  "comm_cctrcap": 0.492757141,
  "comm_incarpct": 0.003642516,
  "comm_juvcrimecap": 241.9137214,
  "comm_libcap": 0.394205713,
  "comm_ltbvp": 0.096553028,
  "comm_ltrvp": 0.015771968,
  "comm_ocb": 3882.399063,
  "comm_ocbp": 0.2488057,
  "comm_parkcap": 0.051863016,
  "comm_rcb": 13675.03768,
  "comm_rcbp": 0.350133966,
  "comm_rvp": 0.021627112,
  "comm_u18bbp": 0.754454442,
  "comm_evrate": 216.7145907,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.338211737,
  "econ_fincap": 7.78556283,
  "econ_medinc": 48819.33009,
  "econ_paydaycap": 1.576822852,
  "econ_pctlwjobs": 0.13713871,
  "econ_pctmwjobs": 0.239970371,
  "econ_totjobs": 201154,
  "econ_pr": 0.158071403,
  "econ_pyr": 0.128589795,
  "econ_ur": 0.031378208,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 2076.091818,
  "edu_perbach": 0.364558579,
  "edu_perearlyed": 0.591825308,
  "edu_qeckids": 0.778729114,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.893645571,
  "fam_lcckids": 27.255519,
  "fam_tphh": 3615.259603,
  "fam_tphhpct": 0.565568427,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2338.624439,
  "hel_castthma": 796.1040423,
  "hel_checkup": 6089.429872,
  "hel_fruitsveggies": 428.1455081,
  "hel_le": 78.83440123,
  "hel_mhlth": 1177.501143,
  "hel_obesity": 2796.0641,
  "hel_perpri": 0.702669247,
  "hel_perpub": 0.192525715,
  "hel_prtopu": 3.649742307,
  "hel_pharmacap": 4.730468555,
  "hel_phlth": 921.4241842,
  "hel_sleep": 3010.974147,
  "hel_stroke": 187.5435983,
  "hel_perins": 0.855780094,
  "hel_perunin": 0.144072542,
  "hel_clincap": 1.08406571,
  "hel_groccap": 1.773925708,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 55,
  "ci_index": 60,
  "eci_index": 55,
  "edi_index": 95,
  "fi_index": 89,
  "hi_index": 63,
  "cri_index": 58,
  "ci_weight": 60,
  "eci_weight": 55,
  "edi_weight": 95,
  "fi_weight": 89,
  "hi_weight": 63,
  "cri_weight": 67,
  "ci_weight_sd": 2,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 52,
  "TEA": 145,
  "SLN": 145,
  "SCHOOLNAME": "Foster Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3700 Clover Lane",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9727948100,
  "WEBSITE": "http://www.dallasisd.org/foster",
  "POINT_X": -96.85376516,
  "POINT_Y": 32.86996983,
  "MasterID": "'057905145",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 58548,
  "dem_popwh": 26325,
  "dem_popbl": 1906,
  "dem_popas": 38,
  "dem_pophi": 28874,
  "dem_popm": 31131,
  "dem_popf": 27411,
  "dem_thh": 20192,
  "dem_popse": 5082,
  "dem_popch": 15535,
  "dem_perwh": 0.449631072,
  "dem_perbl": 0.032554485,
  "dem_peras": 0.00064904,
  "dem_perhi": 0.493167999,
  "dem_perm": 0.531717565,
  "dem_perf": 0.468179955,
  "dem_perse": 0.086800574,
  "dem_perch": 0.265337842,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 2,
  "comm_bbp": 0.717198274,
  "comm_bvp": 0.096858531,
  "comm_cctrcap": 0.34285769,
  "comm_incarpct": 0.002301219,
  "comm_juvcrimecap": 197.8391654,
  "comm_libcap": 0.171428845,
  "comm_ltbvp": 0.094348067,
  "comm_ltrvp": 0.011337593,
  "comm_ocb": 2350.347667,
  "comm_ocbp": 0.26084017,
  "comm_parkcap": 0.050185491,
  "comm_rcb": 4963.354704,
  "comm_rcbp": 0.443638328,
  "comm_rvp": 0.014295079,
  "comm_u18bbp": 0.707251611,
  "comm_evrate": 132.2573539,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.253574503,
  "econ_fincap": 1.02857307,
  "econ_medinc": 44023.33775,
  "econ_paydaycap": 2.742861519,
  "econ_pctlwjobs": 0.163987388,
  "econ_pctmwjobs": 0.249353872,
  "econ_totjobs": 38692,
  "econ_pr": 0.159133917,
  "econ_pyr": 0.291383663,
  "econ_ur": 0.044135993,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 615.2483409,
  "edu_perbach": 0.180146668,
  "edu_perearlyed": 0.433682912,
  "edu_qeckids": 0.649681458,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.898088749,
  "fam_lcckids": 7.146496039,
  "fam_tphh": 5287.01204,
  "fam_tphhpct": 0.752335144,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2894.888285,
  "hel_castthma": 863.3290439,
  "hel_checkup": 6195.631187,
  "hel_fruitsveggies": 448.4371908,
  "hel_le": 80.76583044,
  "hel_mhlth": 1564.032752,
  "hel_obesity": 3453.483093,
  "hel_perpri": 0.42508121,
  "hel_perpub": 0.25262438,
  "hel_prtopu": 1.682661072,
  "hel_pharmacap": 1.542859604,
  "hel_phlth": 1416.3787,
  "hel_sleep": 3375.671714,
  "hel_stroke": 257.5034732,
  "hel_perins": 0.635681313,
  "hel_perunin": 0.364028039,
  "hel_clincap": 0.34285769,
  "hel_groccap": 1.02857307,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 38,
  "ci_index": 67,
  "eci_index": 39,
  "edi_index": 72,
  "fi_index": 100,
  "hi_index": 33,
  "cri_index": 46,
  "ci_weight": 67,
  "eci_weight": 39,
  "edi_weight": 72,
  "fi_weight": 100,
  "hi_weight": 33,
  "cri_weight": 49,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 53,
  "TEA": 168,
  "SLN": 168,
  "SCHOOLNAME": "Knight Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2615 Anson Rd.",
  "CITY": "Dallas",
  "ZIP": 75235,
  "PHONE": 9727495300,
  "WEBSITE": "http://www.dallasisd.org/knight",
  "POINT_X": -96.85181791,
  "POINT_Y": 32.83686461,
  "MasterID": "'057905168",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 42015,
  "dem_popwh": 16463,
  "dem_popbl": 5227,
  "dem_popas": 100,
  "dem_pophi": 18337,
  "dem_popm": 22947,
  "dem_popf": 19061,
  "dem_thh": 16474,
  "dem_popse": 3585,
  "dem_popch": 8168,
  "dem_perwh": 0.391836249,
  "dem_perbl": 0.12440795,
  "dem_peras": 0.002380102,
  "dem_perhi": 0.436439367,
  "dem_perm": 0.546162085,
  "dem_perf": 0.453671308,
  "dem_perse": 0.085326669,
  "dem_perch": 0.194406759,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 0,
  "dem_thh_sd": 2,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.750721122,
  "comm_bvp": 0.128756013,
  "comm_cctrcap": 1.751811679,
  "comm_incarpct": 0.002801288,
  "comm_juvcrimecap": 210.1215501,
  "comm_libcap": 0.500517623,
  "comm_ltbvp": 0.125028867,
  "comm_ltrvp": 0.007868094,
  "comm_ocb": 1270.970332,
  "comm_ocbp": 0.260539466,
  "comm_parkcap": 0.146596957,
  "comm_rcb": 4831.410282,
  "comm_rcbp": 0.416389503,
  "comm_rvp": 0.009434451,
  "comm_u18bbp": 0.704901694,
  "comm_evrate": 160.415898,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.255052345,
  "econ_fincap": 6.256470283,
  "econ_medinc": 24170.02391,
  "econ_paydaycap": 4.004140981,
  "econ_pctlwjobs": 0.131791764,
  "econ_pctmwjobs": 0.253976859,
  "econ_totjobs": 112526,
  "econ_pr": 0.170654217,
  "econ_pyr": 0.203551671,
  "econ_ur": 0.042222697,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 2280.884082,
  "edu_perbach": 0.197673628,
  "edu_perearlyed": 0.512223516,
  "edu_qeckids": 2.483270639,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 7.449811918,
  "fam_lcckids": 14.89962384,
  "fam_tphh": 2535.638681,
  "fam_tphhpct": 0.723904736,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2832.811557,
  "hel_castthma": 833.4137515,
  "hel_checkup": 6215.494314,
  "hel_fruitsveggies": 403.6325851,
  "hel_le": 79.38591862,
  "hel_mhlth": 1441.750212,
  "hel_obesity": 3359.503229,
  "hel_perpri": 0.499388127,
  "hel_perpub": 0.24212682,
  "hel_prtopu": 2.062506447,
  "hel_pharmacap": 8.508799585,
  "hel_phlth": 1273.987323,
  "hel_sleep": 3362.347052,
  "hel_stroke": 247.9987216,
  "hel_perins": 0.696036563,
  "hel_perunin": 0.303913489,
  "hel_clincap": 2.502588113,
  "hel_groccap": 1.501552868,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 40,
  "ci_index": 63,
  "eci_index": 42,
  "edi_index": 81,
  "fi_index": 79,
  "hi_index": 39,
  "cri_index": 49,
  "ci_weight": 63,
  "eci_weight": 42,
  "edi_weight": 81,
  "fi_weight": 79,
  "hi_weight": 39,
  "cri_weight": 51,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 54,
  "TEA": 181,
  "SLN": 181,
  "SCHOOLNAME": "Maple Lawn Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3120 Inwood Rd.",
  "CITY": "Dallas",
  "ZIP": 75235,
  "PHONE": 9729252500,
  "WEBSITE": "http://www.dallasisd.org/maplelawn",
  "POINT_X": -96.82985703,
  "POINT_Y": 32.82588427,
  "MasterID": "'057905181",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 56509,
  "dem_popwh": 32450,
  "dem_popbl": 5952,
  "dem_popas": 180,
  "dem_pophi": 13984,
  "dem_popm": 29776,
  "dem_popf": 26733,
  "dem_thh": 27644,
  "dem_popse": 6517,
  "dem_popch": 8412,
  "dem_perwh": 0.574244811,
  "dem_perbl": 0.105328355,
  "dem_peras": 0.003185333,
  "dem_perhi": 0.247465006,
  "dem_perm": 0.526924915,
  "dem_perf": 0.473075085,
  "dem_perse": 0.115326762,
  "dem_perch": 0.148861243,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 4,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.857748929,
  "comm_bvp": 0.114043658,
  "comm_cctrcap": 1.453349543,
  "comm_incarpct": 0.002437988,
  "comm_juvcrimecap": 218.3876271,
  "comm_libcap": 0.545006079,
  "comm_ltbvp": 0.106982825,
  "comm_ltrvp": 0.010314633,
  "comm_ocb": 2870.627042,
  "comm_ocbp": 0.262844937,
  "comm_parkcap": 0.045209509,
  "comm_rcb": 6270.924326,
  "comm_rcbp": 0.374817848,
  "comm_rvp": 0.012683303,
  "comm_u18bbp": 0.809808094,
  "comm_evrate": 146.3341321,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.158343452,
  "econ_fincap": 5.086723401,
  "econ_medinc": 40398.45874,
  "econ_paydaycap": 1.998355622,
  "econ_pctlwjobs": 0.13159075,
  "econ_pctmwjobs": 0.262616387,
  "econ_totjobs": 111482,
  "econ_pr": 0.122255231,
  "econ_pyr": 0.091763801,
  "econ_ur": 0.027999957,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 2074.16532,
  "edu_perbach": 0.321461376,
  "edu_perearlyed": 0.617558022,
  "edu_qeckids": 1.20591007,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 7.235460419,
  "fam_lcckids": 15.67683091,
  "fam_tphh": 3039.577334,
  "fam_tphhpct": 0.727342447,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2321.261194,
  "hel_castthma": 668.3316655,
  "hel_checkup": 5387.936577,
  "hel_fruitsveggies": 431.1693118,
  "hel_le": 79.53135725,
  "hel_mhlth": 1004.174176,
  "hel_obesity": 2533.206465,
  "hel_perpri": 0.708176786,
  "hel_perpub": 0.20310373,
  "hel_prtopu": 3.486773905,
  "hel_pharmacap": 9.083434644,
  "hel_phlth": 870.9096525,
  "hel_sleep": 2662.17184,
  "hel_stroke": 191.3428564,
  "hel_perins": 0.845085761,
  "hel_perunin": 0.154805336,
  "hel_clincap": 2.361693008,
  "hel_groccap": 1.998355622,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 64,
  "ci_index": 75,
  "eci_index": 74,
  "edi_index": 95,
  "fi_index": 82,
  "hi_index": 69,
  "cri_index": 70,
  "ci_weight": 75,
  "eci_weight": 74,
  "edi_weight": 95,
  "fi_weight": 82,
  "hi_weight": 69,
  "cri_weight": 77,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 55,
  "TEA": 283,
  "SLN": 283,
  "SCHOOLNAME": "Medrano Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2221 Lucas Dr.",
  "CITY": "Dallas",
  "ZIP": 75219,
  "PHONE": 9727943300,
  "WEBSITE": "http://www.dallasisd.org/hopemedrano",
  "POINT_X": -96.82713676,
  "POINT_Y": 32.80863285,
  "MasterID": "'057905283",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 70953,
  "dem_popwh": 40371,
  "dem_popbl": 7823,
  "dem_popas": 142,
  "dem_pophi": 17424,
  "dem_popm": 38140,
  "dem_popf": 32821,
  "dem_thh": 37971,
  "dem_popse": 6691,
  "dem_popch": 7529,
  "dem_perwh": 0.568982284,
  "dem_perbl": 0.110256085,
  "dem_peras": 0.002001325,
  "dem_perhi": 0.245571012,
  "dem_perm": 0.537538934,
  "dem_perf": 0.462573816,
  "dem_perse": 0.094301862,
  "dem_perch": 0.106112497,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 3,
  "dem_thh_sd": 4,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.857914952,
  "comm_bvp": 0.113937177,
  "comm_cctrcap": 0.871979403,
  "comm_incarpct": 0.002882929,
  "comm_juvcrimecap": 192.0883209,
  "comm_libcap": 0.145329901,
  "comm_ltbvp": 0.105102471,
  "comm_ltrvp": 0.012167137,
  "comm_ocb": 2744.412005,
  "comm_ocbp": 0.24400084,
  "comm_parkcap": 0.226674107,
  "comm_rcb": 8984.56745,
  "comm_rcbp": 0.336088335,
  "comm_rvp": 0.015192615,
  "comm_u18bbp": 0.738798879,
  "comm_evrate": 175.7765147,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.257368014,
  "econ_fincap": 6.975835226,
  "econ_medinc": 38389.65464,
  "econ_paydaycap": 1.889288707,
  "econ_pctlwjobs": 0.126835001,
  "econ_pctmwjobs": 0.252227336,
  "econ_totjobs": 142098,
  "econ_pr": 0.127176948,
  "econ_pyr": 0.086720572,
  "econ_ur": 0.0274695,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1392.180118,
  "edu_perbach": 0.355845549,
  "edu_perearlyed": 0.628140704,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.411778886,
  "fam_lcckids": 16.23533666,
  "fam_tphh": 2281.967094,
  "fam_tphhpct": 0.631211629,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2275.161287,
  "hel_castthma": 746.8262709,
  "hel_checkup": 5877.615666,
  "hel_fruitsveggies": 413.8154927,
  "hel_le": 78.47498995,
  "hel_mhlth": 1095.646851,
  "hel_obesity": 2659.729372,
  "hel_perpri": 0.724182988,
  "hel_perpub": 0.180054879,
  "hel_prtopu": 4.022012579,
  "hel_pharmacap": 7.411824927,
  "hel_phlth": 876.1941617,
  "hel_sleep": 2901.90935,
  "hel_stroke": 184.6337253,
  "hel_perins": 0.851899708,
  "hel_perunin": 0.148027701,
  "hel_clincap": 1.889288707,
  "hel_groccap": 1.162639204,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 60,
  "ci_index": 69,
  "eci_index": 65,
  "edi_index": 89,
  "fi_index": 78,
  "hi_index": 67,
  "cri_index": 65,
  "ci_weight": 69,
  "eci_weight": 65,
  "edi_weight": 89,
  "fi_weight": 78,
  "hi_weight": 67,
  "cri_weight": 72,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 56,
  "TEA": 188,
  "SLN": 188,
  "SCHOOLNAME": "Mount Auburn STEAM Academy Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6012 E. Grand Ave.",
  "CITY": "Dallas",
  "ZIP": 75223,
  "PHONE": 9727498500,
  "WEBSITE": "http://www.dallasisd.org/mountauburn",
  "POINT_X": -96.74402702,
  "POINT_Y": 32.79583042,
  "MasterID": "'057905188",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 61611,
  "dem_popwh": 20651,
  "dem_popbl": 11511,
  "dem_popas": 200,
  "dem_pophi": 27268,
  "dem_popm": 31134,
  "dem_popf": 30450,
  "dem_thh": 24925,
  "dem_popse": 5817,
  "dem_popch": 14710,
  "dem_perwh": 0.335183652,
  "dem_perbl": 0.18683352,
  "dem_peras": 0.003246174,
  "dem_perhi": 0.442583305,
  "dem_perm": 0.50533184,
  "dem_perf": 0.494229926,
  "dem_perse": 0.094414958,
  "dem_perch": 0.238756066,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.72417816,
  "comm_bvp": 0.104293637,
  "comm_cctrcap": 1.305398672,
  "comm_incarpct": 0.007603431,
  "comm_juvcrimecap": 398.25526,
  "comm_libcap": 0.163174834,
  "comm_ltbvp": 0.100358486,
  "comm_ltrvp": 0.030343048,
  "comm_ocb": 2215.3582,
  "comm_ocbp": 0.244607818,
  "comm_parkcap": 0.279654675,
  "comm_rcb": 6734.221996,
  "comm_rcbp": 0.424276589,
  "comm_rvp": 0.035396302,
  "comm_u18bbp": 0.690205906,
  "comm_evrate": 202.4183815,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 1,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.353620106,
  "econ_fincap": 2.610797344,
  "econ_medinc": 34056.10198,
  "econ_paydaycap": 1.305398672,
  "econ_pctlwjobs": 0.270750864,
  "econ_pctmwjobs": 0.363933396,
  "econ_totjobs": 15915,
  "econ_pr": 0.22928241,
  "econ_pyr": 0.33887458,
  "econ_ur": 0.055247483,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 1488.9323,
  "edu_perbach": 0.215897424,
  "edu_perearlyed": 0.435538387,
  "edu_qeckids": 1.369762925,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 6.163933164,
  "fam_lcckids": 15.06739218,
  "fam_tphh": 3595.358264,
  "fam_tphhpct": 0.596447889,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3239.955517,
  "hel_castthma": 938.8797475,
  "hel_checkup": 6501.335921,
  "hel_fruitsveggies": 353.9771045,
  "hel_le": 76.72967217,
  "hel_mhlth": 1529.950972,
  "hel_obesity": 3573.892245,
  "hel_perpri": 0.480272906,
  "hel_perpub": 0.306661456,
  "hel_prtopu": 1.566133914,
  "hel_pharmacap": 2.610797344,
  "hel_phlth": 1437.017995,
  "hel_sleep": 3486.779141,
  "hel_stroke": 339.0301333,
  "hel_perins": 0.759660007,
  "hel_perunin": 0.240356276,
  "hel_clincap": 1.305398672,
  "hel_groccap": 1.63174834,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 57,
  "eci_index": 34,
  "edi_index": 75,
  "fi_index": 83,
  "hi_index": 37,
  "cri_index": 45,
  "ci_weight": 57,
  "eci_weight": 34,
  "edi_weight": 75,
  "fi_weight": 83,
  "hi_weight": 37,
  "cri_weight": 46,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 57,
  "TEA": 202,
  "SLN": 202,
  "SCHOOLNAME": "Roberts Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4919 E. Grand Ave.",
  "CITY": "Dallas",
  "ZIP": 75223,
  "PHONE": 9727498700,
  "WEBSITE": "http://www.dallasisd.org/oranroberts",
  "POINT_X": -96.75421064,
  "POINT_Y": 32.7884957,
  "MasterID": "'057905202",
  "Feeder": "Madison",
  "HIGH_SLN": 32,
  "dem_totp": 62753,
  "dem_popwh": 18107,
  "dem_popbl": 15124,
  "dem_popas": 172,
  "dem_pophi": 27142,
  "dem_popm": 32092,
  "dem_popf": 30633,
  "dem_thh": 25974,
  "dem_popse": 6022,
  "dem_popch": 14223,
  "dem_perwh": 0.288543974,
  "dem_perbl": 0.241008398,
  "dem_peras": 0.002740905,
  "dem_perhi": 0.432521154,
  "dem_perm": 0.511401845,
  "dem_perf": 0.488151961,
  "dem_perse": 0.09596354,
  "dem_perch": 0.226650519,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.682740074,
  "comm_bvp": 0.099206288,
  "comm_cctrcap": 1.608529337,
  "comm_incarpct": 0.008258734,
  "comm_juvcrimecap": 514.6167688,
  "comm_libcap": 0.321705867,
  "comm_ltbvp": 0.096320651,
  "comm_ltrvp": 0.034680847,
  "comm_ocb": 1945.31772,
  "comm_ocbp": 0.25511686,
  "comm_parkcap": 0.23175338,
  "comm_rcb": 8085.823848,
  "comm_rcbp": 0.440606885,
  "comm_rvp": 0.039091969,
  "comm_u18bbp": 0.642324441,
  "comm_evrate": 275.2193695,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 1,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.407799084,
  "econ_fincap": 2.251941071,
  "econ_medinc": 28274.62974,
  "econ_paydaycap": 1.76938227,
  "econ_pctlwjobs": 0.146961539,
  "econ_pctmwjobs": 0.279327786,
  "econ_totjobs": 67419,
  "econ_pr": 0.266962491,
  "econ_pyr": 0.305580721,
  "econ_ur": 0.061795703,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 2166.686792,
  "edu_perbach": 0.19602319,
  "edu_perearlyed": 0.433722163,
  "edu_qeckids": 1.424046528,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 9.968325693,
  "fam_lcckids": 22.07272118,
  "fam_tphh": 2857.964874,
  "fam_tphhpct": 0.516243794,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3412.11616,
  "hel_castthma": 971.5992868,
  "hel_checkup": 6545.144541,
  "hel_fruitsveggies": 325.8472337,
  "hel_le": 74.40999138,
  "hel_mhlth": 1600.519026,
  "hel_obesity": 3743.361781,
  "hel_perpri": 0.434278948,
  "hel_perpub": 0.333397334,
  "hel_prtopu": 1.302586745,
  "hel_pharmacap": 4.82558801,
  "hel_phlth": 1517.699224,
  "hel_sleep": 3613.117013,
  "hel_stroke": 378.5923886,
  "hel_perins": 0.74434791,
  "hel_perunin": 0.255572089,
  "hel_clincap": 1.76938227,
  "hel_groccap": 1.286823469,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 27,
  "ci_index": 52,
  "eci_index": 39,
  "edi_index": 74,
  "fi_index": 86,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 52,
  "eci_weight": 39,
  "edi_weight": 74,
  "fi_weight": 86,
  "hi_weight": 33,
  "cri_weight": 44,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 58,
  "TEA": 131,
  "SLN": 131,
  "SCHOOLNAME": "Zaragoza Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4550 Worth St.",
  "CITY": "Dallas",
  "ZIP": 75246,
  "PHONE": 9727498600,
  "WEBSITE": "http://www.dallasisd.org/zaragoza",
  "POINT_X": -96.77086617,
  "POINT_Y": 32.79515424,
  "MasterID": "'057905131",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 85478,
  "dem_popwh": 39523,
  "dem_popbl": 12003,
  "dem_popas": 197,
  "dem_pophi": 28459,
  "dem_popm": 44620,
  "dem_popf": 40839,
  "dem_thh": 42067,
  "dem_popse": 6666,
  "dem_popch": 13413,
  "dem_perwh": 0.462376284,
  "dem_perbl": 0.140422097,
  "dem_peras": 0.002304687,
  "dem_perhi": 0.33293947,
  "dem_perm": 0.522005662,
  "dem_perf": 0.477772058,
  "dem_perse": 0.077984979,
  "dem_perch": 0.156917569,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 0,
  "dem_perch_sd": 0,
  "comm_bbp": 0.802172989,
  "comm_bvp": 0.103850698,
  "comm_cctrcap": 1.060062615,
  "comm_incarpct": 0.005219369,
  "comm_juvcrimecap": 335.0653576,
  "comm_libcap": 0.353354205,
  "comm_ltbvp": 0.095339669,
  "comm_ltrvp": 0.019735947,
  "comm_ocb": 2571.379287,
  "comm_ocbp": 0.243777866,
  "comm_parkcap": 0.106403375,
  "comm_rcb": 11743.64831,
  "comm_rcbp": 0.372588104,
  "comm_rvp": 0.024395863,
  "comm_u18bbp": 0.713485344,
  "comm_evrate": 258.1841392,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.378111928,
  "econ_fincap": 6.831514633,
  "econ_medinc": 37595.14506,
  "econ_paydaycap": 2.002340496,
  "econ_pctlwjobs": 0.125106183,
  "econ_pctmwjobs": 0.236368437,
  "econ_totjobs": 174228,
  "econ_pr": 0.202465808,
  "econ_pyr": 0.187656732,
  "econ_ur": 0.04082394,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 2221.883145,
  "edu_perbach": 0.307149922,
  "edu_perearlyed": 0.53674833,
  "edu_qeckids": 2.265686416,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 7.552288053,
  "fam_lcckids": 26.43300819,
  "fam_tphh": 3050.469425,
  "fam_tphhpct": 0.513918221,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2633.912036,
  "hel_castthma": 858.6520481,
  "hel_checkup": 6260.203985,
  "hel_fruitsveggies": 379.532825,
  "hel_le": 76.20166212,
  "hel_mhlth": 1337.115388,
  "hel_obesity": 3131.81282,
  "hel_perpri": 0.609831065,
  "hel_perpub": 0.227627874,
  "hel_prtopu": 2.679070247,
  "hel_pharmacap": 4.946958872,
  "hel_phlth": 1108.866027,
  "hel_sleep": 3247.295572,
  "hel_stroke": 237.5789576,
  "hel_perins": 0.813010324,
  "hel_perunin": 0.186801971,
  "hel_clincap": 1.531201556,
  "hel_groccap": 1.766771026,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 44,
  "ci_index": 57,
  "eci_index": 44,
  "edi_index": 87,
  "fi_index": 89,
  "hi_index": 46,
  "cri_index": 50,
  "ci_weight": 57,
  "eci_weight": 44,
  "edi_weight": 87,
  "fi_weight": 89,
  "hi_weight": 46,
  "cri_weight": 54,
  "ci_weight_sd": 2,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 59,
  "TEA": 122,
  "SLN": 122,
  "SCHOOLNAME": "Carr Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1952 Bayside St.",
  "CITY": "Dallas",
  "ZIP": 75212,
  "PHONE": 9727944300,
  "WEBSITE": "http://www.dallasisd.org/carr",
  "POINT_X": -96.85273658,
  "POINT_Y": 32.7878757,
  "MasterID": "'057905122",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 28543,
  "dem_popwh": 5055,
  "dem_popbl": 8235,
  "dem_popas": 36,
  "dem_pophi": 14134,
  "dem_popm": 14727,
  "dem_popf": 13807,
  "dem_thh": 8975,
  "dem_popse": 2814,
  "dem_popch": 7638,
  "dem_perwh": 0.177101216,
  "dem_perbl": 0.28851207,
  "dem_peras": 0.001261255,
  "dem_perhi": 0.495182707,
  "dem_perm": 0.515958379,
  "dem_perf": 0.483726308,
  "dem_perse": 0.098588095,
  "dem_perch": 0.267596258,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.681691994,
  "comm_bvp": 0.091155141,
  "comm_cctrcap": 2.295897332,
  "comm_incarpct": 0.009482542,
  "comm_juvcrimecap": 389.5029759,
  "comm_libcap": 0.382649555,
  "comm_ltbvp": 0.090082585,
  "comm_ltrvp": 0.016786172,
  "comm_ocb": 823.8649074,
  "comm_ocbp": 0.23098965,
  "comm_parkcap": 0.894704789,
  "comm_rcb": 2399.978677,
  "comm_rcbp": 0.443389029,
  "comm_rvp": 0.017091166,
  "comm_u18bbp": 0.68150257,
  "comm_evrate": 137.9451647,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.415227841,
  "econ_fincap": 3.443845999,
  "econ_medinc": 20743.09757,
  "econ_paydaycap": 2.295897332,
  "econ_pctlwjobs": 0.101404428,
  "econ_pctmwjobs": 0.286148801,
  "econ_totjobs": 75618,
  "econ_pr": 0.302254066,
  "econ_pyr": 0.30433918,
  "econ_ur": 0.079008645,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 2811.642385,
  "edu_perbach": 0.119107392,
  "edu_perearlyed": 0.476702509,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 13.63551108,
  "fam_lcckids": 19.08971552,
  "fam_tphh": 1388.44168,
  "fam_tphhpct": 0.494908275,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3773.24026,
  "hel_castthma": 1009.604053,
  "hel_checkup": 6658.761433,
  "hel_fruitsveggies": 337.5072546,
  "hel_le": 73.74725491,
  "hel_mhlth": 1747.704752,
  "hel_obesity": 4051.795023,
  "hel_perpri": 0.359362458,
  "hel_perpub": 0.364828192,
  "hel_prtopu": 0.985018334,
  "hel_pharmacap": 9.566238885,
  "hel_phlth": 1755.331044,
  "hel_sleep": 3778.260521,
  "hel_stroke": 448.5825185,
  "hel_perins": 0.700951726,
  "hel_perunin": 0.29836028,
  "hel_clincap": 4.591794665,
  "hel_groccap": 1.147948666,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 20,
  "ci_index": 62,
  "eci_index": 45,
  "edi_index": 63,
  "fi_index": 63,
  "hi_index": 35,
  "cri_index": 44,
  "ci_weight": 62,
  "eci_weight": 45,
  "edi_weight": 63,
  "fi_weight": 63,
  "hi_weight": 35,
  "cri_weight": 46,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 60,
  "TEA": 260,
  "SLN": 260,
  "SCHOOLNAME": "De Zavala Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3214 N. Winnetka Ave.",
  "CITY": "Dallas",
  "ZIP": 75212,
  "PHONE": 9728926400,
  "WEBSITE": "http://www.dallasisd.org/dezavala",
  "POINT_X": -96.83905037,
  "POINT_Y": 32.78110303,
  "MasterID": "'057905260",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 39224,
  "dem_popwh": 11910,
  "dem_popbl": 8847,
  "dem_popas": 60,
  "dem_pophi": 16732,
  "dem_popm": 20327,
  "dem_popf": 18879,
  "dem_thh": 15549,
  "dem_popse": 3749,
  "dem_popch": 8432,
  "dem_perwh": 0.303640628,
  "dem_perbl": 0.225550683,
  "dem_peras": 0.001529676,
  "dem_perhi": 0.426575566,
  "dem_perm": 0.518228636,
  "dem_perf": 0.481312462,
  "dem_perse": 0.095579237,
  "dem_perch": 0.214970426,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.762355445,
  "comm_bvp": 0.097154847,
  "comm_cctrcap": 1.883915504,
  "comm_incarpct": 0.007123501,
  "comm_juvcrimecap": 315.1733818,
  "comm_libcap": 0.269130786,
  "comm_ltbvp": 0.094422772,
  "comm_ltrvp": 0.016713766,
  "comm_ocb": 1205.083979,
  "comm_ocbp": 0.23617701,
  "comm_parkcap": 0.625862748,
  "comm_rcb": 3982.208092,
  "comm_rcbp": 0.381218757,
  "comm_rvp": 0.018556325,
  "comm_u18bbp": 0.72402448,
  "comm_evrate": 144.6577976,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.406263949,
  "econ_fincap": 4.306092581,
  "econ_medinc": 25778.92348,
  "econ_paydaycap": 2.15304629,
  "econ_pctlwjobs": 0.162097196,
  "econ_pctmwjobs": 0.289990526,
  "econ_totjobs": 70723,
  "econ_pr": 0.240605835,
  "econ_pyr": 0.313057267,
  "econ_ur": 0.061357999,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 2612.721755,
  "edu_perbach": 0.238589523,
  "edu_perearlyed": 0.562139918,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 12.28360016,
  "fam_lcckids": 19.65376026,
  "fam_tphh": 1667.175559,
  "fam_tphhpct": 0.489048548,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3247.972367,
  "hel_castthma": 927.2807497,
  "hel_checkup": 6514.196956,
  "hel_fruitsveggies": 352.8776327,
  "hel_le": 74.02625481,
  "hel_mhlth": 1513.149249,
  "hel_obesity": 3578.176352,
  "hel_perpri": 0.514673475,
  "hel_perpub": 0.291480785,
  "hel_prtopu": 1.765720081,
  "hel_pharmacap": 6.190008085,
  "hel_phlth": 1424.981277,
  "hel_sleep": 3490.652615,
  "hel_stroke": 344.8561009,
  "hel_perins": 0.770142435,
  "hel_perunin": 0.229535071,
  "hel_clincap": 2.15304629,
  "hel_groccap": 1.076523145,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 59,
  "eci_index": 38,
  "edi_index": 78,
  "fi_index": 65,
  "hi_index": 36,
  "cri_index": 44,
  "ci_weight": 59,
  "eci_weight": 38,
  "edi_weight": 78,
  "fi_weight": 65,
  "hi_weight": 36,
  "cri_weight": 46,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 61,
  "TEA": 105,
  "SLN": 105,
  "SCHOOLNAME": "Arcadia Park Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1300 N. Justin Ave.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725025300,
  "WEBSITE": "http://www.dallasisd.org/arcadiapark",
  "POINT_X": -96.91052995,
  "POINT_Y": 32.75939794,
  "MasterID": "'057905105",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 24670,
  "dem_popwh": 2232,
  "dem_popbl": 2408,
  "dem_popas": 49,
  "dem_pophi": 19617,
  "dem_popm": 12182,
  "dem_popf": 12477,
  "dem_thh": 7022,
  "dem_popse": 1706,
  "dem_popch": 8261,
  "dem_perwh": 0.09047426,
  "dem_perbl": 0.097608431,
  "dem_peras": 0.001986218,
  "dem_perhi": 0.795176328,
  "dem_perm": 0.493798135,
  "dem_perf": 0.505755979,
  "dem_perse": 0.069152817,
  "dem_perch": 0.334860154,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.614693416,
  "comm_bvp": 0.063389914,
  "comm_cctrcap": 0.811615529,
  "comm_incarpct": 0.013029554,
  "comm_juvcrimecap": 269.6783982,
  "comm_libcap": 0.405807765,
  "comm_ltbvp": 0.06104718,
  "comm_ltrvp": 0.026711126,
  "comm_ocb": 868.7009141,
  "comm_ocbp": 0.26544201,
  "comm_parkcap": 0.223527606,
  "comm_rcb": 1605.132049,
  "comm_rcbp": 0.427585928,
  "comm_rvp": 0.028240623,
  "comm_u18bbp": 0.572611751,
  "comm_evrate": 92.32126645,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.40737587,
  "econ_fincap": 1.623231058,
  "econ_medinc": 22243.60689,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.149747206,
  "econ_pctmwjobs": 0.351583289,
  "econ_totjobs": 15032,
  "econ_pr": 0.267407272,
  "econ_pyr": 0.172135206,
  "econ_ur": 0.063076301,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 1017.379372,
  "edu_perbach": 0.045417318,
  "edu_perearlyed": 0.240418118,
  "edu_qeckids": 1.21405653,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 4.856226118,
  "fam_lcckids": 12.1405653,
  "fam_tphh": 1629.89613,
  "fam_tphhpct": 0.56298022,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3132.039948,
  "hel_castthma": 934.9403406,
  "hel_checkup": 6236.564647,
  "hel_fruitsveggies": 339.9883674,
  "hel_le": 77.12438246,
  "hel_mhlth": 1766.188037,
  "hel_obesity": 3820.818646,
  "hel_perpri": 0.372097743,
  "hel_perpub": 0.354440656,
  "hel_prtopu": 1.049816766,
  "hel_pharmacap": 0.811615529,
  "hel_phlth": 1654.851705,
  "hel_sleep": 3624.631516,
  "hel_stroke": 316.5833597,
  "hel_perins": 0.708921903,
  "hel_perunin": 0.291037506,
  "hel_clincap": 0.405807765,
  "hel_groccap": 1.623231058,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 71,
  "eci_index": 41,
  "edi_index": 43,
  "fi_index": 75,
  "hi_index": 32,
  "cri_index": 42,
  "ci_weight": 71,
  "eci_weight": 41,
  "edi_weight": 43,
  "fi_weight": 75,
  "hi_weight": 32,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 62,
  "TEA": 103,
  "SLN": 103,
  "SCHOOLNAME": "Allen Charter School",
  "LEVEL": "Elementary",
  "ADDRESS": "5220 Nomas St.",
  "CITY": "Dallas",
  "ZIP": 75212,
  "PHONE": 9727945100,
  "WEBSITE": "http://www.dallasisd.org/allen",
  "POINT_X": -96.90755939,
  "POINT_Y": 32.78151298,
  "MasterID": "'057905103",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 21207,
  "dem_popwh": 3196,
  "dem_popbl": 2278,
  "dem_popas": 42,
  "dem_pophi": 15258,
  "dem_popm": 10507,
  "dem_popf": 10691,
  "dem_thh": 5790,
  "dem_popse": 1579,
  "dem_popch": 7009,
  "dem_perwh": 0.150704956,
  "dem_perbl": 0.107417362,
  "dem_peras": 0.001980478,
  "dem_perhi": 0.719479417,
  "dem_perm": 0.495449616,
  "dem_perf": 0.504125996,
  "dem_perse": 0.074456547,
  "dem_perch": 0.330504079,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.711448804,
  "comm_bvp": 0.096366286,
  "comm_cctrcap": 0.479786038,
  "comm_incarpct": 0.015706735,
  "comm_juvcrimecap": 170.377035,
  "comm_libcap": 0.479786038,
  "comm_ltbvp": 0.09476051,
  "comm_ltrvp": 0.022961708,
  "comm_ocb": 828.6957289,
  "comm_ocbp": 0.263487442,
  "comm_parkcap": 0.535003279,
  "comm_rcb": 1081.683619,
  "comm_rcbp": 0.407898561,
  "comm_rvp": 0.02347171,
  "comm_u18bbp": 0.691687891,
  "comm_evrate": 35.98395288,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.328735905,
  "econ_fincap": 1.919144154,
  "econ_medinc": 21506.42971,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.154731551,
  "econ_pctmwjobs": 0.293654841,
  "econ_totjobs": 13727,
  "econ_pr": 0.225970116,
  "econ_pyr": 0.180258119,
  "econ_ur": 0.068950673,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 1,
  "edu_oostkids": 1114.085025,
  "edu_perbach": 0.055086552,
  "edu_perearlyed": 0.231372549,
  "edu_qeckids": 1.428314134,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 4.284942402,
  "fam_lcckids": 11.42651307,
  "fam_tphh": 1351.0707,
  "fam_tphhpct": 0.542896433,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3339.286243,
  "hel_castthma": 940.6508972,
  "hel_checkup": 6351.024964,
  "hel_fruitsveggies": 353.6922089,
  "hel_le": 77.29714775,
  "hel_mhlth": 1737.335048,
  "hel_obesity": 3848.579136,
  "hel_perpri": 0.394376352,
  "hel_perpub": 0.347801009,
  "hel_prtopu": 1.133913765,
  "hel_pharmacap": 0.479786038,
  "hel_phlth": 1696.696361,
  "hel_sleep": 3651.529887,
  "hel_stroke": 351.9558552,
  "hel_perins": 0.715404951,
  "hel_perunin": 0.284739245,
  "hel_clincap": 0.479786038,
  "hel_groccap": 0.959572077,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 30,
  "ci_index": 64,
  "eci_index": 41,
  "edi_index": 46,
  "fi_index": 73,
  "hi_index": 29,
  "cri_index": 42,
  "ci_weight": 64,
  "eci_weight": 41,
  "edi_weight": 46,
  "fi_weight": 73,
  "hi_weight": 29,
  "cri_weight": 41,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 63,
  "TEA": 116,
  "SLN": 116,
  "SCHOOLNAME": "Burnet Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3200 Kinkaid Dr.",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9727943000,
  "WEBSITE": "http://www.dallasisd.org/burnet",
  "POINT_X": -96.86841769,
  "POINT_Y": 32.87644779,
  "MasterID": "'057905116",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 61063,
  "dem_popwh": 25687,
  "dem_popbl": 2127,
  "dem_popas": 35,
  "dem_pophi": 31731,
  "dem_popm": 32511,
  "dem_popf": 28553,
  "dem_thh": 20548,
  "dem_popse": 4676,
  "dem_popch": 16470,
  "dem_perwh": 0.420663904,
  "dem_perbl": 0.034832878,
  "dem_peras": 0.000573179,
  "dem_perhi": 0.519643647,
  "dem_perm": 0.532417339,
  "dem_perf": 0.467599037,
  "dem_perse": 0.07657665,
  "dem_perch": 0.269721435,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 0,
  "dem_perch_sd": 2,
  "comm_bbp": 0.702813855,
  "comm_bvp": 0.100580236,
  "comm_cctrcap": 0.328838714,
  "comm_incarpct": 0.001981585,
  "comm_juvcrimecap": 244.983283,
  "comm_libcap": 0.164419357,
  "comm_ltbvp": 0.096665386,
  "comm_ltrvp": 0.008537414,
  "comm_ocb": 2142.934999,
  "comm_ocbp": 0.247084427,
  "comm_parkcap": 0.050651573,
  "comm_rcb": 5377.677677,
  "comm_rcbp": 0.452495024,
  "comm_rvp": 0.01054447,
  "comm_u18bbp": 0.692430156,
  "comm_evrate": 130.5489694,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.26217838,
  "econ_fincap": 1.808612926,
  "econ_medinc": 39268.10021,
  "econ_paydaycap": 3.617225851,
  "econ_pctlwjobs": 0.247262936,
  "econ_pctmwjobs": 0.357863185,
  "econ_totjobs": 39367,
  "econ_pr": 0.166037473,
  "econ_pyr": 0.317267462,
  "econ_ur": 0.045696554,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 596.6822212,
  "edu_perbach": 0.161532314,
  "edu_perearlyed": 0.408553742,
  "edu_qeckids": 0.612610083,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 2.450440333,
  "fam_lcckids": 4.900880667,
  "fam_tphh": 5398.603174,
  "fam_tphhpct": 0.730775397,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2892.399941,
  "hel_castthma": 866.8688253,
  "hel_checkup": 6162.150457,
  "hel_fruitsveggies": 416.0192609,
  "hel_le": 78.72322532,
  "hel_mhlth": 1597.864286,
  "hel_obesity": 3494.272016,
  "hel_perpri": 0.397638183,
  "hel_perpub": 0.2532557,
  "hel_prtopu": 1.570105563,
  "hel_pharmacap": 1.315354855,
  "hel_phlth": 1448.187566,
  "hel_sleep": 3417.988408,
  "hel_stroke": 260.6675643,
  "hel_perins": 0.616860751,
  "hel_perunin": 0.383024438,
  "hel_clincap": 0.328838714,
  "hel_groccap": 0.986516141,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 37,
  "ci_index": 67,
  "eci_index": 42,
  "edi_index": 70,
  "fi_index": 82,
  "hi_index": 32,
  "cri_index": 48,
  "ci_weight": 67,
  "eci_weight": 42,
  "edi_weight": 70,
  "fi_weight": 82,
  "hi_weight": 32,
  "cri_weight": 48,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 64,
  "TEA": 278,
  "SLN": 278,
  "SCHOOLNAME": "Cigarroa Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "9990 Webb Chapel Rd",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9725022900,
  "WEBSITE": "http://www.dallasisd.org/cigarroa",
  "POINT_X": -96.86474879,
  "POINT_Y": 32.88002614,
  "MasterID": "'057905278",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 63772,
  "dem_popwh": 27897,
  "dem_popbl": 2138,
  "dem_popas": 48,
  "dem_pophi": 32169,
  "dem_popm": 33885,
  "dem_popf": 29879,
  "dem_thh": 21532,
  "dem_popse": 5186,
  "dem_popch": 17101,
  "dem_perwh": 0.437449037,
  "dem_perbl": 0.033525685,
  "dem_peras": 0.000752681,
  "dem_perhi": 0.504437684,
  "dem_perm": 0.531346045,
  "dem_perf": 0.468528508,
  "dem_perse": 0.081320956,
  "dem_perch": 0.268158439,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 2,
  "comm_bbp": 0.712120922,
  "comm_bvp": 0.095860904,
  "comm_cctrcap": 0.471699874,
  "comm_incarpct": 0.001770995,
  "comm_juvcrimecap": 237.8827158,
  "comm_libcap": 0.157233291,
  "comm_ltbvp": 0.092231326,
  "comm_ltrvp": 0.00931687,
  "comm_ocb": 2445.578507,
  "comm_ocbp": 0.251753853,
  "comm_parkcap": 0.04885109,
  "comm_rcb": 5342.306333,
  "comm_rcbp": 0.451690124,
  "comm_rvp": 0.011728609,
  "comm_u18bbp": 0.701939799,
  "comm_evrate": 122.8778173,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.254645751,
  "econ_fincap": 1.572332914,
  "econ_medinc": 42399.29806,
  "econ_paydaycap": 3.459132412,
  "econ_pctlwjobs": 0.261546513,
  "econ_pctmwjobs": 0.360329713,
  "econ_totjobs": 38215,
  "econ_pr": 0.160223968,
  "econ_pyr": 0.316697427,
  "econ_ur": 0.045080917,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 668.6821951,
  "edu_perbach": 0.170324416,
  "edu_perearlyed": 0.402162162,
  "edu_qeckids": 0.589666839,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 2.358667355,
  "fam_lcckids": 7.076002064,
  "fam_tphh": 5708.933638,
  "fam_tphhpct": 0.737521065,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2917.379007,
  "hel_castthma": 864.2392937,
  "hel_checkup": 6203.021318,
  "hel_fruitsveggies": 429.2567483,
  "hel_le": 79.43626974,
  "hel_mhlth": 1571.472631,
  "hel_obesity": 3456.434758,
  "hel_perpri": 0.414973883,
  "hel_perpub": 0.253031325,
  "hel_prtopu": 1.640009919,
  "hel_pharmacap": 1.415099623,
  "hel_phlth": 1432.713884,
  "hel_sleep": 3386.164938,
  "hel_stroke": 262.5119808,
  "hel_perins": 0.629260717,
  "hel_perunin": 0.370519678,
  "hel_clincap": 0.314466583,
  "hel_groccap": 0.943399749,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 38,
  "ci_index": 69,
  "eci_index": 42,
  "edi_index": 70,
  "fi_index": 88,
  "hi_index": 33,
  "cri_index": 48,
  "ci_weight": 69,
  "eci_weight": 42,
  "edi_weight": 70,
  "fi_weight": 88,
  "hi_weight": 33,
  "cri_weight": 49,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 65,
  "TEA": 265,
  "SLN": 265,
  "SCHOOLNAME": "Martinez Learning Center",
  "LEVEL": "Elementary",
  "ADDRESS": "4500 Bernal Dr.",
  "CITY": "Dallas",
  "ZIP": 75212,
  "PHONE": 9727946900,
  "WEBSITE": "http://www.dallasisd.org/martinez",
  "POINT_X": -96.89369491,
  "POINT_Y": 32.78678071,
  "MasterID": "'057905265",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 21277,
  "dem_popwh": 3097,
  "dem_popbl": 4748,
  "dem_popas": 30,
  "dem_pophi": 12774,
  "dem_popm": 10501,
  "dem_popf": 10768,
  "dem_thh": 5996,
  "dem_popse": 1774,
  "dem_popch": 6898,
  "dem_perwh": 0.145556234,
  "dem_perbl": 0.22315176,
  "dem_peras": 0.001409973,
  "dem_perhi": 0.600366593,
  "dem_perm": 0.493537623,
  "dem_perf": 0.506086384,
  "dem_perse": 0.083376416,
  "dem_perch": 0.32419984,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.697947548,
  "comm_bvp": 0.098034988,
  "comm_cctrcap": 0.999484769,
  "comm_incarpct": 0.015687886,
  "comm_juvcrimecap": 300.829036,
  "comm_libcap": 0,
  "comm_ltbvp": 0.097102439,
  "comm_ltrvp": 0.017783328,
  "comm_ocb": 698.8087211,
  "comm_ocbp": 0.258805659,
  "comm_parkcap": 0.808175442,
  "comm_rcb": 1435.829217,
  "comm_rcbp": 0.434529,
  "comm_rvp": 0.017909282,
  "comm_u18bbp": 0.696523182,
  "comm_evrate": 65.71612359,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.383233424,
  "econ_fincap": 1.998969539,
  "econ_medinc": 19448.82666,
  "econ_paydaycap": 1.499227154,
  "econ_pctlwjobs": 0.138357562,
  "econ_pctmwjobs": 0.29248491,
  "econ_totjobs": 23526,
  "econ_pr": 0.288618437,
  "econ_pyr": 0.214622183,
  "econ_ur": 0.082026733,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 0,
  "edu_oostkids": 939.1057528,
  "edu_perbach": 0.05785473,
  "edu_perearlyed": 0.265888457,
  "edu_qeckids": 1.490644052,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 8.943864312,
  "fam_lcckids": 14.90644052,
  "fam_tphh": 1106.345632,
  "fam_tphhpct": 0.458263192,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 3569.20424,
  "hel_castthma": 993.3073463,
  "hel_checkup": 6498.764288,
  "hel_fruitsveggies": 342.5674672,
  "hel_le": 76.53350416,
  "hel_mhlth": 1794.149651,
  "hel_obesity": 4022.091249,
  "hel_perpri": 0.362444322,
  "hel_perpub": 0.37981082,
  "hel_prtopu": 0.954275926,
  "hel_pharmacap": 1.499227154,
  "hel_phlth": 1765.494903,
  "hel_sleep": 3759.081293,
  "hel_stroke": 401.1322355,
  "hel_perins": 0.724538311,
  "hel_perunin": 0.275361594,
  "hel_clincap": 1.499227154,
  "hel_groccap": 0.999484769,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 23,
  "ci_index": 62,
  "eci_index": 43,
  "edi_index": 51,
  "fi_index": 47,
  "hi_index": 23,
  "cri_index": 43,
  "ci_weight": 62,
  "eci_weight": 43,
  "edi_weight": 51,
  "fi_weight": 47,
  "hi_weight": 23,
  "cri_weight": 37,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 66,
  "TEA": 271,
  "SLN": 271,
  "SCHOOLNAME": "Saldivar Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "9510 Brockbank Dr.",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9727942000,
  "WEBSITE": "http://www.dallasisd.org/saldivar",
  "POINT_X": -96.87281138,
  "POINT_Y": 32.86476868,
  "MasterID": "'057905271",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 52497,
  "dem_popwh": 20106,
  "dem_popbl": 2086,
  "dem_popas": 24,
  "dem_pophi": 28942,
  "dem_popm": 28202,
  "dem_popf": 24290,
  "dem_thh": 17444,
  "dem_popse": 3612,
  "dem_popch": 14268,
  "dem_perwh": 0.382993314,
  "dem_perbl": 0.039735604,
  "dem_peras": 0.000457169,
  "dem_perhi": 0.551307694,
  "dem_perm": 0.53721165,
  "dem_perf": 0.462693106,
  "dem_perse": 0.068803932,
  "dem_perch": 0.271786959,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 0,
  "dem_perch_sd": 2,
  "comm_bbp": 0.67949248,
  "comm_bvp": 0.116237404,
  "comm_cctrcap": 0.193039566,
  "comm_incarpct": 0.002785981,
  "comm_juvcrimecap": 247.7757744,
  "comm_libcap": 0.193039566,
  "comm_ltbvp": 0.11206062,
  "comm_ltrvp": 0.007422547,
  "comm_ocb": 1508.172687,
  "comm_ocbp": 0.246874822,
  "comm_parkcap": 0.187071206,
  "comm_rcb": 5131.387069,
  "comm_rcbp": 0.452480961,
  "comm_rvp": 0.008813303,
  "comm_u18bbp": 0.670141634,
  "comm_evrate": 166.9792246,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.281335084,
  "econ_fincap": 1.737356094,
  "econ_medinc": 31593.45585,
  "econ_paydaycap": 3.860791319,
  "econ_pctlwjobs": 0.211713269,
  "econ_pctmwjobs": 0.299847483,
  "econ_totjobs": 49175,
  "econ_pr": 0.180134053,
  "econ_pyr": 0.308389423,
  "econ_ur": 0.048051638,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 504.3192521,
  "edu_perbach": 0.138140879,
  "edu_perearlyed": 0.416610851,
  "edu_qeckids": 0.708313556,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.541567782,
  "fam_lcckids": 4.958194895,
  "fam_tphh": 4490.391614,
  "fam_tphhpct": 0.719531567,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2838.01611,
  "hel_castthma": 874.5263893,
  "hel_checkup": 6064.142853,
  "hel_fruitsveggies": 395.6048448,
  "hel_le": 77.847124,
  "hel_mhlth": 1665.121408,
  "hel_obesity": 3589.596269,
  "hel_perpri": 0.35850255,
  "hel_perpub": 0.255952266,
  "hel_prtopu": 1.400661754,
  "hel_pharmacap": 2.316474791,
  "hel_phlth": 1488.575166,
  "hel_sleep": 3492.900561,
  "hel_stroke": 256.4414053,
  "hel_perins": 0.589028967,
  "hel_perunin": 0.41091329,
  "hel_clincap": 0.386079132,
  "hel_groccap": 0.96519783,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 35,
  "ci_index": 61,
  "eci_index": 36,
  "edi_index": 71,
  "fi_index": 82,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 61,
  "eci_weight": 36,
  "edi_weight": 71,
  "fi_weight": 82,
  "hi_weight": 32,
  "cri_weight": 44,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 67,
  "TEA": 272,
  "SLN": 272,
  "SCHOOLNAME": "Moreno Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2115 S. Hampton Rd.",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9725023100,
  "WEBSITE": "http://www.dallasisd.org/moreno",
  "POINT_X": -96.85810526,
  "POINT_Y": 32.72396465,
  "MasterID": "'057905272",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 90940,
  "dem_popwh": 7858,
  "dem_popbl": 10323,
  "dem_popas": 55,
  "dem_pophi": 71749,
  "dem_popm": 46398,
  "dem_popf": 44516,
  "dem_thh": 26023,
  "dem_popse": 8041,
  "dem_popch": 28064,
  "dem_perwh": 0.086408621,
  "dem_perbl": 0.113514405,
  "dem_peras": 0.000604794,
  "dem_perhi": 0.78897075,
  "dem_perm": 0.51020453,
  "dem_perf": 0.489509567,
  "dem_perse": 0.088420937,
  "dem_perch": 0.308599076,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.739668624,
  "comm_bvp": 0.088572343,
  "comm_cctrcap": 0.221182026,
  "comm_incarpct": 0.003436675,
  "comm_juvcrimecap": 177.1018675,
  "comm_libcap": 0.221182026,
  "comm_ltbvp": 0.081269901,
  "comm_ltrvp": 0.020368153,
  "comm_ocb": 3318.574897,
  "comm_ocbp": 0.228037955,
  "comm_parkcap": 0.073502484,
  "comm_rcb": 5578.231539,
  "comm_rcbp": 0.48587717,
  "comm_rvp": 0.021635445,
  "comm_u18bbp": 0.752093642,
  "comm_evrate": 114.5722893,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.302875083,
  "econ_fincap": 0.884728103,
  "econ_medinc": 24551.84025,
  "econ_paydaycap": 2.433002282,
  "econ_pctlwjobs": 0.3430288,
  "econ_pctmwjobs": 0.456990273,
  "econ_totjobs": 10486,
  "econ_pr": 0.215249677,
  "econ_pyr": 0.372257922,
  "econ_ur": 0.074613341,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 1,
  "edu_oostkids": 825.9932229,
  "edu_perbach": 0.082295697,
  "edu_perearlyed": 0.481251762,
  "edu_qeckids": 0.360853308,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 5.773652934,
  "fam_lcckids": 8.299626092,
  "fam_tphh": 5738.19777,
  "fam_tphhpct": 0.602346431,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3306.044305,
  "hel_castthma": 926.0485027,
  "hel_checkup": 6402.397466,
  "hel_fruitsveggies": 354.1489274,
  "hel_le": 77.54523065,
  "hel_mhlth": 1651.331776,
  "hel_obesity": 3784.690834,
  "hel_perpri": 0.409172553,
  "hel_perpub": 0.340356368,
  "hel_prtopu": 1.202188623,
  "hel_pharmacap": 1.327092154,
  "hel_phlth": 1620.700462,
  "hel_sleep": 3560.095011,
  "hel_stroke": 346.3056143,
  "hel_perins": 0.723897784,
  "hel_perunin": 0.275969983,
  "hel_clincap": 0.110591013,
  "hel_groccap": 1.54827418,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 31,
  "ci_index": 63,
  "eci_index": 27,
  "edi_index": 71,
  "fi_index": 89,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 63,
  "eci_weight": 27,
  "edi_weight": 71,
  "fi_weight": 89,
  "hi_weight": 32,
  "cri_weight": 43,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 68,
  "TEA": 289,
  "SLN": 289,
  "SCHOOLNAME": "Botello Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "225 S. Marsalis Ave.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 2149325179,
  "WEBSITE": "http://www.dallasisd.org/botello",
  "POINT_X": -96.81640976,
  "POINT_Y": 32.74562788,
  "MasterID": "'057905289",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 58401,
  "dem_popwh": 8843,
  "dem_popbl": 13580,
  "dem_popas": 66,
  "dem_pophi": 35031,
  "dem_popm": 30185,
  "dem_popf": 28189,
  "dem_thh": 19882,
  "dem_popse": 5535,
  "dem_popch": 15905,
  "dem_perwh": 0.15141864,
  "dem_perbl": 0.232530265,
  "dem_peras": 0.001130118,
  "dem_perhi": 0.599835619,
  "dem_perm": 0.516857588,
  "dem_perf": 0.482680091,
  "dem_perse": 0.094775774,
  "dem_perch": 0.272341227,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.771072648,
  "comm_bvp": 0.14093164,
  "comm_cctrcap": 0.345236837,
  "comm_incarpct": 0.006946756,
  "comm_juvcrimecap": 329.8169314,
  "comm_libcap": 0.172618418,
  "comm_ltbvp": 0.134565914,
  "comm_ltrvp": 0.05840161,
  "comm_ocb": 2110.351147,
  "comm_ocbp": 0.244736674,
  "comm_parkcap": 0.243621149,
  "comm_rcb": 5033.753167,
  "comm_rcbp": 0.446408731,
  "comm_rvp": 0.061987393,
  "comm_u18bbp": 0.809343935,
  "comm_evrate": 137.5768794,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.365795462,
  "econ_fincap": 1.553565765,
  "econ_medinc": 26009.68338,
  "econ_paydaycap": 1.726184183,
  "econ_pctlwjobs": 0.238457296,
  "econ_pctmwjobs": 0.395130791,
  "econ_totjobs": 25384,
  "econ_pr": 0.245759317,
  "econ_pyr": 0.578136035,
  "econ_ur": 0.08625899,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1543.452933,
  "edu_perbach": 0.152080383,
  "edu_perearlyed": 0.535258563,
  "edu_qeckids": 1.279281337,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 8.315328692,
  "fam_lcckids": 15.35137605,
  "fam_tphh": 2916.439011,
  "fam_tphhpct": 0.511954288,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3602.615663,
  "hel_castthma": 957.0669989,
  "hel_checkup": 6620.840781,
  "hel_fruitsveggies": 334.6419276,
  "hel_le": 73.82594022,
  "hel_mhlth": 1602.914521,
  "hel_obesity": 3880.963633,
  "hel_perpri": 0.410983156,
  "hel_perpub": 0.354142317,
  "hel_prtopu": 1.160502815,
  "hel_pharmacap": 2.589276274,
  "hel_phlth": 1595.919376,
  "hel_sleep": 3667.677525,
  "hel_stroke": 404.4942269,
  "hel_perins": 0.738913716,
  "hel_perunin": 0.260794087,
  "hel_clincap": 0.863092091,
  "hel_groccap": 1.726184183,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 25,
  "ci_index": 56,
  "eci_index": 30,
  "edi_index": 79,
  "fi_index": 75,
  "hi_index": 29,
  "cri_index": 45,
  "ci_weight": 56,
  "eci_weight": 30,
  "edi_weight": 79,
  "fi_weight": 75,
  "hi_weight": 29,
  "cri_weight": 41,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 69,
  "TEA": 112,
  "SLN": 112,
  "SCHOOLNAME": "Bowie Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "330 N. Marsalis Ave.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 9729256600,
  "WEBSITE": "http://www.dallasisd.org/bowie",
  "POINT_X": -96.81485594,
  "POINT_Y": 32.75235824,
  "MasterID": "'057905112",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 52081,
  "dem_popwh": 10234,
  "dem_popbl": 11965,
  "dem_popas": 62,
  "dem_pophi": 28722,
  "dem_popm": 27306,
  "dem_popf": 24737,
  "dem_thh": 19119,
  "dem_popse": 4736,
  "dem_popch": 12833,
  "dem_perwh": 0.196501603,
  "dem_perbl": 0.229738292,
  "dem_peras": 0.001190453,
  "dem_perhi": 0.551487107,
  "dem_perm": 0.524298689,
  "dem_perf": 0.474971679,
  "dem_perse": 0.090935274,
  "dem_perch": 0.246404639,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.78525091,
  "comm_bvp": 0.134388376,
  "comm_cctrcap": 0.388337145,
  "comm_incarpct": 0.007396473,
  "comm_juvcrimecap": 368.6114462,
  "comm_libcap": 0.194168572,
  "comm_ltbvp": 0.130083497,
  "comm_ltrvp": 0.053667828,
  "comm_ocb": 1699.877649,
  "comm_ocbp": 0.236061623,
  "comm_parkcap": 0.299953162,
  "comm_rcb": 5082.026319,
  "comm_rcbp": 0.425978573,
  "comm_rvp": 0.057125098,
  "comm_u18bbp": 0.820001949,
  "comm_evrate": 153.004835,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.374094277,
  "econ_fincap": 3.106697158,
  "econ_medinc": 27455.26784,
  "econ_paydaycap": 1.747517151,
  "econ_pctlwjobs": 0.178112539,
  "econ_pctmwjobs": 0.350809826,
  "econ_totjobs": 40626,
  "econ_pr": 0.24383399,
  "econ_pyr": 0.578976203,
  "econ_ur": 0.078447291,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1678.481434,
  "edu_perbach": 0.185146352,
  "edu_perearlyed": 0.543231441,
  "edu_qeckids": 1.587216486,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 9.523298916,
  "fam_lcckids": 18.25298959,
  "fam_tphh": 2413.166004,
  "fam_tphhpct": 0.506040674,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3467.823727,
  "hel_castthma": 938.6333381,
  "hel_checkup": 6567.437237,
  "hel_fruitsveggies": 345.9151861,
  "hel_le": 73.58272303,
  "hel_mhlth": 1562.733425,
  "hel_obesity": 3792.7673,
  "hel_perpri": 0.444912796,
  "hel_perpub": 0.32708148,
  "hel_prtopu": 1.36025065,
  "hel_pharmacap": 2.135854296,
  "hel_phlth": 1519.21781,
  "hel_sleep": 3624.384705,
  "hel_stroke": 376.9308199,
  "hel_perins": 0.747206002,
  "hel_perunin": 0.252445957,
  "hel_clincap": 0.970842862,
  "hel_groccap": 0.970842862,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 2,
  "hi_gen": 28,
  "ci_index": 58,
  "eci_index": 35,
  "edi_index": 82,
  "fi_index": 73,
  "hi_index": 29,
  "cri_index": 45,
  "ci_weight": 58,
  "eci_weight": 35,
  "edi_weight": 82,
  "fi_weight": 73,
  "hi_weight": 29,
  "cri_weight": 43,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 70,
  "TEA": 130,
  "SLN": 130,
  "SCHOOLNAME": "Cowart Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1515 S. Ravinia",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727945500,
  "WEBSITE": "http://www.dallasisd.org/cowart",
  "POINT_X": -96.86992516,
  "POINT_Y": 32.72800453,
  "MasterID": "'057905130",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 89502,
  "dem_popwh": 7306,
  "dem_popbl": 8156,
  "dem_popas": 72,
  "dem_pophi": 73046,
  "dem_popm": 45772,
  "dem_popf": 43706,
  "dem_thh": 25612,
  "dem_popse": 7889,
  "dem_popch": 26968,
  "dem_perwh": 0.081629461,
  "dem_perbl": 0.091126455,
  "dem_peras": 0.000804451,
  "dem_perhi": 0.816138187,
  "dem_perm": 0.511407566,
  "dem_perf": 0.488324283,
  "dem_perse": 0.088143282,
  "dem_perch": 0.301311703,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.699765172,
  "comm_bvp": 0.085237162,
  "comm_cctrcap": 0.224759782,
  "comm_incarpct": 0.003159365,
  "comm_juvcrimecap": 147.784931,
  "comm_libcap": 0.224759782,
  "comm_ltbvp": 0.082826381,
  "comm_ltrvp": 0.020494138,
  "comm_ocb": 3213.816285,
  "comm_ocbp": 0.226433721,
  "comm_parkcap": 0.073252021,
  "comm_rcb": 5387.611028,
  "comm_rcbp": 0.471123686,
  "comm_rvp": 0.02170526,
  "comm_u18bbp": 0.691552423,
  "comm_evrate": 102.0971309,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.296645795,
  "econ_fincap": 0.674279345,
  "econ_medinc": 24417.7462,
  "econ_paydaycap": 1.573318472,
  "econ_pctlwjobs": 0.286708098,
  "econ_pctmwjobs": 0.478527038,
  "econ_totjobs": 10781,
  "econ_pr": 0.20686158,
  "econ_pyr": 0.310204908,
  "econ_ur": 0.067050504,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 661.6164618,
  "edu_perbach": 0.074559039,
  "edu_perearlyed": 0.461751152,
  "edu_qeckids": 0.374217456,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 5.613261837,
  "fam_lcckids": 7.11013166,
  "fam_tphh": 5675.661873,
  "fam_tphhpct": 0.613750338,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3202.784236,
  "hel_castthma": 911.2110047,
  "hel_checkup": 6327.583293,
  "hel_fruitsveggies": 352.0780157,
  "hel_le": 78.17727886,
  "hel_mhlth": 1656.362276,
  "hel_obesity": 3745.083532,
  "hel_perpri": 0.412489351,
  "hel_perpub": 0.325572793,
  "hel_prtopu": 1.266965054,
  "hel_pharmacap": 1.2361788,
  "hel_phlth": 1610.165374,
  "hel_sleep": 3532.842874,
  "hel_stroke": 328.9335793,
  "hel_perins": 0.712258441,
  "hel_perunin": 0.287562211,
  "hel_clincap": 0.224759782,
  "hel_groccap": 1.011419018,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 62,
  "eci_index": 33,
  "edi_index": 71,
  "fi_index": 89,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 33,
  "edi_weight": 71,
  "fi_weight": 89,
  "hi_weight": 32,
  "cri_weight": 44,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 71,
  "TEA": 136,
  "SLN": 136,
  "SCHOOLNAME": "Donald Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1218 Phinney Ave.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727945300,
  "WEBSITE": "http://www.dallasisd.org/donald",
  "POINT_X": -96.88707251,
  "POINT_Y": 32.73251662,
  "MasterID": "'057905136",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 75725,
  "dem_popwh": 4965,
  "dem_popbl": 6821,
  "dem_popas": 64,
  "dem_pophi": 62950,
  "dem_popm": 38160,
  "dem_popf": 37551,
  "dem_thh": 21315,
  "dem_popse": 6354,
  "dem_popch": 23233,
  "dem_perwh": 0.065566193,
  "dem_perbl": 0.090075933,
  "dem_peras": 0.000845163,
  "dem_perhi": 0.831297458,
  "dem_perm": 0.503928689,
  "dem_perf": 0.495886431,
  "dem_perse": 0.083908881,
  "dem_perch": 0.306807527,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.633384614,
  "comm_bvp": 0.072639079,
  "comm_cctrcap": 0.265585774,
  "comm_incarpct": 0.003518653,
  "comm_juvcrimecap": 170.1003744,
  "comm_libcap": 0.132792887,
  "comm_ltbvp": 0.072183545,
  "comm_ltrvp": 0.017592268,
  "comm_ocb": 2634.710477,
  "comm_ocbp": 0.242019778,
  "comm_parkcap": 0.082690436,
  "comm_rcb": 4762.46574,
  "comm_rcbp": 0.455832482,
  "comm_rvp": 0.018959752,
  "comm_u18bbp": 0.60657556,
  "comm_evrate": 98.8643044,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.33399148,
  "econ_fincap": 0.929550209,
  "econ_medinc": 23277.67002,
  "econ_paydaycap": 1.460721757,
  "econ_pctlwjobs": 0.269941987,
  "econ_pctmwjobs": 0.476885424,
  "econ_totjobs": 11032,
  "econ_pr": 0.2319264,
  "econ_pyr": 0.220052153,
  "econ_ur": 0.058737179,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 641.7930655,
  "edu_perbach": 0.055206969,
  "edu_perearlyed": 0.423406634,
  "edu_qeckids": 0.432475112,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.189701338,
  "fam_lcckids": 6.919601784,
  "fam_tphh": 4865.207165,
  "fam_tphhpct": 0.616688465,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3156.712138,
  "hel_castthma": 921.1031254,
  "hel_checkup": 6276.18904,
  "hel_fruitsveggies": 345.557829,
  "hel_le": 78.34952311,
  "hel_mhlth": 1706.230107,
  "hel_obesity": 3770.006501,
  "hel_perpri": 0.397676639,
  "hel_perpub": 0.329805856,
  "hel_prtopu": 1.205790109,
  "hel_pharmacap": 1.32792887,
  "hel_phlth": 1630.750433,
  "hel_sleep": 3565.349626,
  "hel_stroke": 324.2294953,
  "hel_perins": 0.701994483,
  "hel_perunin": 0.297753554,
  "hel_clincap": 0.265585774,
  "hel_groccap": 1.32792887,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 32,
  "ci_index": 60,
  "eci_index": 35,
  "edi_index": 68,
  "fi_index": 85,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 60,
  "eci_weight": 35,
  "edi_weight": 68,
  "fi_weight": 85,
  "hi_weight": 32,
  "cri_weight": 44,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 72,
  "TEA": 149,
  "SLN": 149,
  "SCHOOLNAME": "Hall Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2120 Keats Dr.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727945400,
  "WEBSITE": "http://www.dallasisd.org/hall",
  "POINT_X": -96.88125303,
  "POINT_Y": 32.72173546,
  "MasterID": "'057905149",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 80078,
  "dem_popwh": 5695,
  "dem_popbl": 9188,
  "dem_popas": 44,
  "dem_pophi": 64240,
  "dem_popm": 40069,
  "dem_popf": 39995,
  "dem_thh": 22770,
  "dem_popse": 7210,
  "dem_popch": 24308,
  "dem_perwh": 0.07111816,
  "dem_perbl": 0.11473813,
  "dem_peras": 0.000549464,
  "dem_perhi": 0.802217838,
  "dem_perm": 0.500374635,
  "dem_perf": 0.499450536,
  "dem_perse": 0.090037214,
  "dem_perch": 0.303554035,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.663215328,
  "comm_bvp": 0.08247769,
  "comm_cctrcap": 0.250979216,
  "comm_incarpct": 0.003442932,
  "comm_juvcrimecap": 145.5906245,
  "comm_libcap": 0.250979216,
  "comm_ltbvp": 0.08119317,
  "comm_ltrvp": 0.0214561,
  "comm_ocb": 2992.813272,
  "comm_ocbp": 0.241756644,
  "comm_parkcap": 0.075370551,
  "comm_rcb": 4902.277798,
  "comm_rcbp": 0.471249843,
  "comm_rvp": 0.022967861,
  "comm_u18bbp": 0.647708015,
  "comm_evrate": 115.0112258,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.307753955,
  "econ_fincap": 0.752937648,
  "econ_medinc": 24133.47684,
  "econ_paydaycap": 1.25489608,
  "econ_pctlwjobs": 0.271921784,
  "econ_pctmwjobs": 0.49332926,
  "econ_totjobs": 9819,
  "econ_pr": 0.218478479,
  "econ_pyr": 0.29323331,
  "econ_ur": 0.067989898,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 1,
  "edu_oostkids": 653.2978778,
  "edu_perbach": 0.062009825,
  "edu_perearlyed": 0.473557692,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.134796695,
  "fam_lcckids": 5.375235703,
  "fam_tphh": 5113.224191,
  "fam_tphhpct": 0.611585236,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3244.93992,
  "hel_castthma": 929.6437796,
  "hel_checkup": 6355.475948,
  "hel_fruitsveggies": 358.7038103,
  "hel_le": 78.41394878,
  "hel_mhlth": 1682.768345,
  "hel_obesity": 3778.872275,
  "hel_perpri": 0.413965493,
  "hel_perpub": 0.327097768,
  "hel_prtopu": 1.265571133,
  "hel_pharmacap": 1.25489608,
  "hel_phlth": 1627.832529,
  "hel_sleep": 3571.460991,
  "hel_stroke": 337.6687704,
  "hel_perins": 0.711656288,
  "hel_perunin": 0.288243475,
  "hel_clincap": 0.250979216,
  "hel_groccap": 0.752937648,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 32,
  "ci_index": 60,
  "eci_index": 33,
  "edi_index": 62,
  "fi_index": 77,
  "hi_index": 31,
  "cri_index": 44,
  "ci_weight": 60,
  "eci_weight": 33,
  "edi_weight": 62,
  "fi_weight": 77,
  "hi_weight": 31,
  "cri_weight": 42,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 73,
  "TEA": 152,
  "SLN": 152,
  "SCHOOLNAME": "Henderson Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2200 S. Edgefield St.",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9727492900,
  "WEBSITE": "http://www.dallasisd.org/henderson",
  "POINT_X": -96.84391019,
  "POINT_Y": 32.72396847,
  "MasterID": "'057905152",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 89800,
  "dem_popwh": 7911,
  "dem_popbl": 12923,
  "dem_popas": 67,
  "dem_pophi": 67892,
  "dem_popm": 45684,
  "dem_popf": 44081,
  "dem_thh": 25825,
  "dem_popse": 7816,
  "dem_popch": 28225,
  "dem_perwh": 0.088095768,
  "dem_perbl": 0.143908686,
  "dem_peras": 0.000746102,
  "dem_perhi": 0.756035635,
  "dem_perm": 0.508730512,
  "dem_perf": 0.490879733,
  "dem_perse": 0.087037862,
  "dem_perch": 0.314309577,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.749208625,
  "comm_bvp": 0.094204231,
  "comm_cctrcap": 0.224770603,
  "comm_incarpct": 0.004423978,
  "comm_juvcrimecap": 211.7984841,
  "comm_libcap": 0.224770603,
  "comm_ltbvp": 0.085745392,
  "comm_ltrvp": 0.024014789,
  "comm_ocb": 3196.896716,
  "comm_ocbp": 0.233228516,
  "comm_parkcap": 0.075062409,
  "comm_rcb": 5861.798818,
  "comm_rcbp": 0.483171896,
  "comm_rvp": 0.025974523,
  "comm_u18bbp": 0.778601781,
  "comm_evrate": 119.5779608,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.331792516,
  "econ_fincap": 1.573394221,
  "econ_medinc": 23602.726,
  "econ_paydaycap": 2.472476633,
  "econ_pctlwjobs": 0.312503993,
  "econ_pctmwjobs": 0.449492045,
  "econ_totjobs": 15651,
  "econ_pr": 0.236611174,
  "econ_pyr": 0.479519251,
  "econ_ur": 0.086333696,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1142.850643,
  "edu_perbach": 0.089131414,
  "edu_perearlyed": 0.46571835,
  "edu_qeckids": 0.719452718,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.993158976,
  "fam_lcckids": 12.23069621,
  "fam_tphh": 5633.347032,
  "fam_tphhpct": 0.601209858,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3425.507734,
  "hel_castthma": 947.812603,
  "hel_checkup": 6466.977709,
  "hel_fruitsveggies": 339.3175409,
  "hel_le": 76.44628911,
  "hel_mhlth": 1669.104216,
  "hel_obesity": 3854.896646,
  "hel_perpri": 0.385443151,
  "hel_perpub": 0.362728043,
  "hel_prtopu": 1.062622971,
  "hel_pharmacap": 1.685779522,
  "hel_phlth": 1647.430909,
  "hel_sleep": 3626.969237,
  "hel_stroke": 372.0855281,
  "hel_perins": 0.724129087,
  "hel_perunin": 0.275781703,
  "hel_clincap": 0.224770603,
  "hel_groccap": 1.910550125,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 27,
  "ci_index": 60,
  "eci_index": 26,
  "edi_index": 73,
  "fi_index": 81,
  "hi_index": 30,
  "cri_index": 45,
  "ci_weight": 60,
  "eci_weight": 26,
  "edi_weight": 73,
  "fi_weight": 81,
  "hi_weight": 30,
  "cri_weight": 41,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 74,
  "TEA": 157,
  "SLN": 157,
  "SCHOOLNAME": "Hogg Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1144 N. Madison Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9725028600,
  "WEBSITE": "http://www.dallasisd.org/hogg",
  "POINT_X": -96.82507455,
  "POINT_Y": 32.75687386,
  "MasterID": "'057905157",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 54066,
  "dem_popwh": 11627,
  "dem_popbl": 8382,
  "dem_popas": 74,
  "dem_pophi": 32706,
  "dem_popm": 28479,
  "dem_popf": 25558,
  "dem_thh": 19652,
  "dem_popse": 4945,
  "dem_popch": 13154,
  "dem_perwh": 0.215051974,
  "dem_perbl": 0.155032738,
  "dem_peras": 0.001368698,
  "dem_perhi": 0.604927311,
  "dem_perm": 0.526745089,
  "dem_perf": 0.472718529,
  "dem_perse": 0.091462287,
  "dem_perch": 0.243295232,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.805165323,
  "comm_bvp": 0.123785315,
  "comm_cctrcap": 0.93743821,
  "comm_incarpct": 0.006111638,
  "comm_juvcrimecap": 321.6595362,
  "comm_libcap": 0.187487642,
  "comm_ltbvp": 0.119555173,
  "comm_ltrvp": 0.043313555,
  "comm_ocb": 1806.309072,
  "comm_ocbp": 0.225487175,
  "comm_parkcap": 0.341437286,
  "comm_rcb": 4667.830619,
  "comm_rcbp": 0.400767663,
  "comm_rvp": 0.045918926,
  "comm_u18bbp": 0.835984989,
  "comm_evrate": 127.0228775,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.339299016,
  "econ_fincap": 1.874876421,
  "econ_medinc": 28925.29795,
  "econ_paydaycap": 2.249851705,
  "econ_pctlwjobs": 0.196269144,
  "econ_pctmwjobs": 0.319336575,
  "econ_totjobs": 55108,
  "econ_pr": 0.216370973,
  "econ_pyr": 0.514165488,
  "econ_ur": 0.071438994,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 1,
  "edu_oostkids": 1666.149394,
  "edu_perbach": 0.189570278,
  "edu_perearlyed": 0.526599846,
  "edu_qeckids": 1.552072095,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 10.08846862,
  "fam_lcckids": 18.62486514,
  "fam_tphh": 2655.484779,
  "fam_tphhpct": 0.534450784,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3252.714636,
  "hel_castthma": 898.1742511,
  "hel_checkup": 6455.407599,
  "hel_fruitsveggies": 355.1050421,
  "hel_le": 74.26505936,
  "hel_mhlth": 1519.088186,
  "hel_obesity": 3644.437708,
  "hel_perpri": 0.470673857,
  "hel_perpub": 0.302517402,
  "hel_prtopu": 1.555857134,
  "hel_pharmacap": 2.437339347,
  "hel_phlth": 1460.449886,
  "hel_sleep": 3507.898437,
  "hel_stroke": 328.7986992,
  "hel_perins": 0.747886614,
  "hel_perunin": 0.251908112,
  "hel_clincap": 1.312413495,
  "hel_groccap": 1.312413495,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 32,
  "ci_index": 58,
  "eci_index": 35,
  "edi_index": 81,
  "fi_index": 83,
  "hi_index": 34,
  "cri_index": 46,
  "ci_weight": 58,
  "eci_weight": 35,
  "edi_weight": 81,
  "fi_weight": 83,
  "hi_weight": 34,
  "cri_weight": 45,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 75,
  "TEA": 158,
  "SLN": 158,
  "SCHOOLNAME": "Hooe Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2419 Gladstone Dr.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727946700,
  "WEBSITE": "http://www.dallasisd.org/hooe",
  "POINT_X": -96.85745002,
  "POINT_Y": 32.74074893,
  "MasterID": "'057905158",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 86772,
  "dem_popwh": 10772,
  "dem_popbl": 6311,
  "dem_popas": 99,
  "dem_pophi": 68630,
  "dem_popm": 45070,
  "dem_popf": 41674,
  "dem_thh": 26191,
  "dem_popse": 7740,
  "dem_popch": 25345,
  "dem_perwh": 0.124141428,
  "dem_perbl": 0.072730835,
  "dem_peras": 0.001140921,
  "dem_perhi": 0.790923339,
  "dem_perm": 0.519407182,
  "dem_perf": 0.480270133,
  "dem_perse": 0.089199281,
  "dem_perch": 0.292087309,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 2,
  "comm_bbp": 0.72700755,
  "comm_bvp": 0.088161481,
  "comm_cctrcap": 0.231650541,
  "comm_incarpct": 0.003265417,
  "comm_juvcrimecap": 176.3024566,
  "comm_libcap": 0.347475812,
  "comm_ltbvp": 0.082735882,
  "comm_ltrvp": 0.021489381,
  "comm_ocb": 3141.340073,
  "comm_ocbp": 0.22114056,
  "comm_parkcap": 0.060680812,
  "comm_rcb": 5487.243673,
  "comm_rcbp": 0.457027426,
  "comm_rvp": 0.022521541,
  "comm_u18bbp": 0.714999248,
  "comm_evrate": 87.44807932,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.326977336,
  "econ_fincap": 1.737379059,
  "econ_medinc": 26566.30885,
  "econ_paydaycap": 2.316505412,
  "econ_pctlwjobs": 0.264498673,
  "econ_pctmwjobs": 0.45522769,
  "econ_totjobs": 19588,
  "econ_pr": 0.214708553,
  "econ_pyr": 0.338038868,
  "econ_ur": 0.066540668,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 996.6795274,
  "edu_perbach": 0.108565679,
  "edu_perearlyed": 0.431151242,
  "edu_qeckids": 0.398831343,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 6.780132839,
  "fam_lcckids": 9.571952244,
  "fam_tphh": 5524.682157,
  "fam_tphhpct": 0.621774857,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3193.68225,
  "hel_castthma": 892.8531886,
  "hel_checkup": 6332.675373,
  "hel_fruitsveggies": 357.1627723,
  "hel_le": 77.29783078,
  "hel_mhlth": 1614.836228,
  "hel_obesity": 3699.562646,
  "hel_perpri": 0.429690298,
  "hel_perpub": 0.323090785,
  "hel_prtopu": 1.329936716,
  "hel_pharmacap": 2.200680142,
  "hel_phlth": 1578.596093,
  "hel_sleep": 3489.300614,
  "hel_stroke": 321.8183069,
  "hel_perins": 0.725368789,
  "hel_perunin": 0.274550348,
  "hel_clincap": 0.463301082,
  "hel_groccap": 1.85320433,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 64,
  "eci_index": 34,
  "edi_index": 73,
  "fi_index": 90,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 64,
  "eci_weight": 34,
  "edi_weight": 73,
  "fi_weight": 90,
  "hi_weight": 33,
  "cri_weight": 46,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 76,
  "TEA": 275,
  "SLN": 275,
  "SCHOOLNAME": "Kahn Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "610 N. Franklin St.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725021400,
  "WEBSITE": "http://www.dallasisd.org/kahn",
  "POINT_X": -96.85984185,
  "POINT_Y": 32.75127894,
  "MasterID": "'057905275",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 72497,
  "dem_popwh": 10390,
  "dem_popbl": 4946,
  "dem_popas": 104,
  "dem_pophi": 55972,
  "dem_popm": 37753,
  "dem_popf": 34716,
  "dem_thh": 22605,
  "dem_popse": 6588,
  "dem_popch": 20727,
  "dem_perwh": 0.143316275,
  "dem_perbl": 0.068223513,
  "dem_peras": 0.001434542,
  "dem_perhi": 0.772059533,
  "dem_perm": 0.520752583,
  "dem_perf": 0.478861194,
  "dem_perse": 0.090872726,
  "dem_perch": 0.285901486,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.720771309,
  "comm_bvp": 0.084858245,
  "comm_cctrcap": 0.416492049,
  "comm_incarpct": 0.004023331,
  "comm_juvcrimecap": 169.9487318,
  "comm_libcap": 0.416492049,
  "comm_ltbvp": 0.083057051,
  "comm_ltrvp": 0.021075281,
  "comm_ocb": 2644.397202,
  "comm_ocbp": 0.221673323,
  "comm_parkcap": 0.074956567,
  "comm_rcb": 4766.721364,
  "comm_rcbp": 0.445744062,
  "comm_rvp": 0.021960828,
  "comm_u18bbp": 0.699070504,
  "comm_evrate": 93.36363441,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.35086259,
  "econ_fincap": 0.971814782,
  "econ_medinc": 26397.16057,
  "econ_paydaycap": 1.665968198,
  "econ_pctlwjobs": 0.219050077,
  "econ_pctmwjobs": 0.423902943,
  "econ_totjobs": 19370,
  "econ_pr": 0.222238141,
  "econ_pyr": 0.284756524,
  "econ_ur": 0.06149036,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 1519.2374,
  "edu_perbach": 0.121213497,
  "edu_perearlyed": 0.399034594,
  "edu_qeckids": 0.490234721,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.804694415,
  "fam_lcckids": 12.25586802,
  "fam_tphh": 4640.692407,
  "fam_tphhpct": 0.625876941,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3169.113945,
  "hel_castthma": 884.8675625,
  "hel_checkup": 6326.920849,
  "hel_fruitsveggies": 353.3794275,
  "hel_le": 76.68266325,
  "hel_mhlth": 1597.464204,
  "hel_obesity": 3671.690221,
  "hel_perpri": 0.440162777,
  "hel_perpub": 0.318245993,
  "hel_prtopu": 1.38308977,
  "hel_pharmacap": 1.388306831,
  "hel_phlth": 1555.640338,
  "hel_sleep": 3472.304221,
  "hel_stroke": 315.0029629,
  "hel_perins": 0.730254962,
  "hel_perunin": 0.269551255,
  "hel_clincap": 0.694153416,
  "hel_groccap": 1.527137514,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 33,
  "ci_index": 64,
  "eci_index": 34,
  "edi_index": 72,
  "fi_index": 79,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 64,
  "eci_weight": 34,
  "edi_weight": 72,
  "fi_weight": 79,
  "hi_weight": 33,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 77,
  "TEA": 190,
  "SLN": 190,
  "SCHOOLNAME": "Peabody Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3101 Raydell Place",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727945200,
  "WEBSITE": "http://www.dallasisd.org/peabody",
  "POINT_X": -96.87294286,
  "POINT_Y": 32.7428548,
  "MasterID": "'057905190",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 80013,
  "dem_popwh": 8140,
  "dem_popbl": 4750,
  "dem_popas": 101,
  "dem_pophi": 66111,
  "dem_popm": 41518,
  "dem_popf": 38468,
  "dem_thh": 23372,
  "dem_popse": 6834,
  "dem_popch": 23807,
  "dem_perwh": 0.101733468,
  "dem_perbl": 0.059365353,
  "dem_peras": 0.001262295,
  "dem_perhi": 0.826253234,
  "dem_perm": 0.51889068,
  "dem_perf": 0.480771875,
  "dem_perse": 0.085411121,
  "dem_perch": 0.29753915,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.679818328,
  "comm_bvp": 0.078547131,
  "comm_cctrcap": 0.125658737,
  "comm_incarpct": 0.003300851,
  "comm_juvcrimecap": 140.4265223,
  "comm_libcap": 0.125658737,
  "comm_ltbvp": 0.077644822,
  "comm_ltrvp": 0.019687683,
  "comm_ocb": 2786.871801,
  "comm_ocbp": 0.221637407,
  "comm_parkcap": 0.082246603,
  "comm_rcb": 4983.364551,
  "comm_rcbp": 0.460451399,
  "comm_rvp": 0.020708977,
  "comm_u18bbp": 0.647808815,
  "comm_evrate": 84.63115961,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.331543765,
  "econ_fincap": 1.507904848,
  "econ_medinc": 25094.78091,
  "econ_paydaycap": 1.633563586,
  "econ_pctlwjobs": 0.238038072,
  "econ_pctmwjobs": 0.428056937,
  "econ_totjobs": 17493,
  "econ_pr": 0.218437609,
  "econ_pyr": 0.23340225,
  "econ_ur": 0.059259035,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 721.2324536,
  "edu_perbach": 0.086563554,
  "edu_perearlyed": 0.374301676,
  "edu_qeckids": 0.424754095,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 7.220819617,
  "fam_lcckids": 9.344590093,
  "fam_tphh": 5294.434175,
  "fam_tphhpct": 0.647315896,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3135.330076,
  "hel_castthma": 895.6645486,
  "hel_checkup": 6273.990081,
  "hel_fruitsveggies": 352.885026,
  "hel_le": 77.81669369,
  "hel_mhlth": 1651.902036,
  "hel_obesity": 3709.724371,
  "hel_perpri": 0.412372038,
  "hel_perpub": 0.319788495,
  "hel_prtopu": 1.289514928,
  "hel_pharmacap": 1.88488106,
  "hel_phlth": 1596.465404,
  "hel_sleep": 3500.208127,
  "hel_stroke": 314.4702379,
  "hel_perins": 0.706749865,
  "hel_perunin": 0.293049656,
  "hel_clincap": 0.376976212,
  "hel_groccap": 1.256587374,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 3,
  "hi_gen": 32,
  "ci_index": 62,
  "eci_index": 35,
  "edi_index": 69,
  "fi_index": 92,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 35,
  "edi_weight": 69,
  "fi_weight": 92,
  "hi_weight": 32,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 78,
  "TEA": 192,
  "SLN": 192,
  "SCHOOLNAME": "Peeler Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "810 S. Llewellyn Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9725028300,
  "WEBSITE": "http://www.dallasisd.org/peeler",
  "POINT_X": -96.83117977,
  "POINT_Y": 32.73806156,
  "MasterID": "'057905192",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 77442,
  "dem_popwh": 10158,
  "dem_popbl": 11387,
  "dem_popas": 75,
  "dem_pophi": 54886,
  "dem_popm": 40049,
  "dem_popf": 37361,
  "dem_thh": 24495,
  "dem_popse": 7121,
  "dem_popch": 22609,
  "dem_perwh": 0.131169133,
  "dem_perbl": 0.147039074,
  "dem_peras": 0.000968467,
  "dem_perhi": 0.708736861,
  "dem_perm": 0.517148317,
  "dem_perf": 0.48243847,
  "dem_perse": 0.091952687,
  "dem_perch": 0.291947522,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.771697924,
  "comm_bvp": 0.125602164,
  "comm_cctrcap": 0.389314219,
  "comm_incarpct": 0.005301395,
  "comm_juvcrimecap": 258.3339251,
  "comm_libcap": 0.129771406,
  "comm_ltbvp": 0.116978299,
  "comm_ltrvp": 0.038781189,
  "comm_ocb": 3060.233255,
  "comm_ocbp": 0.239199494,
  "comm_parkcap": 0.085829736,
  "comm_rcb": 5277.674188,
  "comm_rcbp": 0.450694279,
  "comm_rvp": 0.041352413,
  "comm_u18bbp": 0.799809761,
  "comm_evrate": 107.9698101,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.33931609,
  "econ_fincap": 1.427485471,
  "econ_medinc": 26321.37147,
  "econ_paydaycap": 2.335885315,
  "econ_pctlwjobs": 0.255094211,
  "econ_pctmwjobs": 0.409412567,
  "econ_totjobs": 23458,
  "econ_pr": 0.224711932,
  "econ_pyr": 0.514055542,
  "econ_ur": 0.086617995,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1425.988504,
  "edu_perbach": 0.124873729,
  "edu_perearlyed": 0.502678204,
  "edu_qeckids": 0.898826665,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 10.33650665,
  "fam_lcckids": 15.72946664,
  "fam_tphh": 4465.091749,
  "fam_tphhpct": 0.564854076,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3423.378509,
  "hel_castthma": 931.3266828,
  "hel_checkup": 6495.850519,
  "hel_fruitsveggies": 341.8070769,
  "hel_le": 75.15599192,
  "hel_mhlth": 1610.125417,
  "hel_obesity": 3801.834397,
  "hel_perpri": 0.414052908,
  "hel_perpub": 0.348311557,
  "hel_prtopu": 1.18874295,
  "hel_pharmacap": 2.076342503,
  "hel_phlth": 1594.99285,
  "hel_sleep": 3588.031618,
  "hel_stroke": 368.098074,
  "hel_perins": 0.736711511,
  "hel_perunin": 0.263430647,
  "hel_clincap": 0.648857032,
  "hel_groccap": 1.81679969,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 29,
  "ci_index": 56,
  "eci_index": 31,
  "edi_index": 76,
  "fi_index": 83,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 56,
  "eci_weight": 31,
  "edi_weight": 76,
  "fi_weight": 83,
  "hi_weight": 32,
  "cri_weight": 42,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 79,
  "TEA": 197,
  "SLN": 197,
  "SCHOOLNAME": "Reagan Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "201 N. Adams Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9725028200,
  "WEBSITE": "http://www.dallasisd.org/reagan",
  "POINT_X": -96.83114496,
  "POINT_Y": 32.74683512,
  "MasterID": "'057905197",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 68086,
  "dem_popwh": 11059,
  "dem_popbl": 9558,
  "dem_popas": 86,
  "dem_pophi": 46283,
  "dem_popm": 35558,
  "dem_popf": 32503,
  "dem_thh": 22823,
  "dem_popse": 6469,
  "dem_popch": 18672,
  "dem_perwh": 0.162426931,
  "dem_perbl": 0.140381282,
  "dem_peras": 0.001263108,
  "dem_perhi": 0.67977264,
  "dem_perm": 0.52225127,
  "dem_perf": 0.477381547,
  "dem_perse": 0.09501219,
  "dem_perch": 0.274241401,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.785674936,
  "comm_bvp": 0.129047445,
  "comm_cctrcap": 0.295907326,
  "comm_incarpct": 0.005345756,
  "comm_juvcrimecap": 265.8021625,
  "comm_libcap": 0.147953663,
  "comm_ltbvp": 0.122088211,
  "comm_ltrvp": 0.041051401,
  "comm_ocb": 2556.298964,
  "comm_ocbp": 0.230672071,
  "comm_parkcap": 0.190444684,
  "comm_rcb": 5148.216829,
  "comm_rcbp": 0.438063387,
  "comm_rvp": 0.043326273,
  "comm_u18bbp": 0.811248841,
  "comm_evrate": 144.3287984,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.342146332,
  "econ_fincap": 1.775443958,
  "econ_medinc": 27509.22171,
  "econ_paydaycap": 2.515212274,
  "econ_pctlwjobs": 0.234881055,
  "econ_pctmwjobs": 0.412761536,
  "econ_totjobs": 27912,
  "econ_pr": 0.216295349,
  "econ_pyr": 0.501726876,
  "econ_ur": 0.079084734,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1645.406149,
  "edu_perbach": 0.146974879,
  "edu_perearlyed": 0.515873016,
  "edu_qeckids": 1.088951786,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.800566073,
  "fam_lcckids": 16.33427679,
  "fam_tphh": 3767.585207,
  "fam_tphhpct": 0.556328153,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3336.917882,
  "hel_castthma": 912.5540166,
  "hel_checkup": 6473.272708,
  "hel_fruitsveggies": 345.0723832,
  "hel_le": 74.61675627,
  "hel_mhlth": 1567.190974,
  "hel_obesity": 3720.849964,
  "hel_perpri": 0.440447948,
  "hel_perpub": 0.328372504,
  "hel_prtopu": 1.341305811,
  "hel_pharmacap": 2.367258611,
  "hel_phlth": 1538.118767,
  "hel_sleep": 3539.019139,
  "hel_stroke": 346.8819192,
  "hel_perins": 0.742695056,
  "hel_perunin": 0.257378619,
  "hel_clincap": 0.739768316,
  "hel_groccap": 1.775443958,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 31,
  "ci_index": 56,
  "eci_index": 33,
  "edi_index": 78,
  "fi_index": 86,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 56,
  "eci_weight": 33,
  "edi_weight": 78,
  "fi_weight": 86,
  "hi_weight": 33,
  "cri_weight": 44,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 80,
  "TEA": 204,
  "SLN": 204,
  "SCHOOLNAME": "Rosemont Lower",
  "LEVEL": "Elementary",
  "ADDRESS": "1919 Stevens Forest Dr.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9727495000,
  "WEBSITE": "http://www.dallasisd.org/rosemont",
  "POINT_X": -96.85048642,
  "POINT_Y": 32.75269208,
  "MasterID": "'057905204",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 70605,
  "dem_popwh": 11317,
  "dem_popbl": 5810,
  "dem_popas": 102,
  "dem_pophi": 52178,
  "dem_popm": 36950,
  "dem_popf": 33622,
  "dem_thh": 22944,
  "dem_popse": 6454,
  "dem_popch": 19640,
  "dem_perwh": 0.160286099,
  "dem_perbl": 0.08228879,
  "dem_peras": 0.001444657,
  "dem_perhi": 0.739012818,
  "dem_perm": 0.523334041,
  "dem_perf": 0.47619857,
  "dem_perse": 0.091409957,
  "dem_perch": 0.278167269,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.751490882,
  "comm_bvp": 0.091177654,
  "comm_cctrcap": 0.427678324,
  "comm_incarpct": 0.004389601,
  "comm_juvcrimecap": 206.8491902,
  "comm_libcap": 0.285118882,
  "comm_ltbvp": 0.087888154,
  "comm_ltrvp": 0.021915906,
  "comm_ocb": 2563.914512,
  "comm_ocbp": 0.224145669,
  "comm_parkcap": 0.072672205,
  "comm_rcb": 4994.377435,
  "comm_rcbp": 0.433724498,
  "comm_rvp": 0.022895541,
  "comm_u18bbp": 0.74344545,
  "comm_evrate": 106.9195809,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.358336632,
  "econ_fincap": 1.853272735,
  "econ_medinc": 27251.80892,
  "econ_paydaycap": 1.995832177,
  "econ_pctlwjobs": 0.223660074,
  "econ_pctmwjobs": 0.424373812,
  "econ_totjobs": 29983,
  "econ_pr": 0.223207481,
  "econ_pyr": 0.341858034,
  "econ_ur": 0.066932902,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 1826.174099,
  "edu_perbach": 0.137991347,
  "edu_perearlyed": 0.441663131,
  "edu_qeckids": 1.034952734,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 11.38448008,
  "fam_lcckids": 15.00681465,
  "fam_tphh": 4272.067883,
  "fam_tphhpct": 0.59395044,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3186.697268,
  "hel_castthma": 884.3837503,
  "hel_checkup": 6360.797371,
  "hel_fruitsveggies": 353.668402,
  "hel_le": 75.93806382,
  "hel_mhlth": 1570.385587,
  "hel_obesity": 3656.996095,
  "hel_perpri": 0.451230953,
  "hel_perpub": 0.313551854,
  "hel_prtopu": 1.439095154,
  "hel_pharmacap": 2.708629383,
  "hel_phlth": 1529.792412,
  "hel_sleep": 3468.588896,
  "hel_stroke": 315.8627905,
  "hel_perins": 0.737335115,
  "hel_perunin": 0.262352172,
  "hel_clincap": 0.997916088,
  "hel_groccap": 1.710713294,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 33,
  "ci_index": 64,
  "eci_index": 35,
  "edi_index": 74,
  "fi_index": 81,
  "hi_index": 35,
  "cri_index": 46,
  "ci_weight": 64,
  "eci_weight": 35,
  "edi_weight": 74,
  "fi_weight": 81,
  "hi_weight": 35,
  "cri_weight": 47,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 81,
  "TEA": 239,
  "SLN": 239,
  "SCHOOLNAME": "Salazar Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1120 S. Ravinia Dr.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725021800,
  "WEBSITE": "http://www.dallasisd.org/salazar",
  "POINT_X": -96.86802568,
  "POINT_Y": 32.73280556,
  "MasterID": "'057905239",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 90247,
  "dem_popwh": 8054,
  "dem_popbl": 7240,
  "dem_popas": 85,
  "dem_pophi": 73920,
  "dem_popm": 46370,
  "dem_popf": 43837,
  "dem_thh": 26153,
  "dem_popse": 7869,
  "dem_popch": 27073,
  "dem_perwh": 0.089243964,
  "dem_perbl": 0.080224273,
  "dem_peras": 0.00094186,
  "dem_perhi": 0.819085399,
  "dem_perm": 0.513812093,
  "dem_perf": 0.485744678,
  "dem_perse": 0.087194034,
  "dem_perch": 0.299987811,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.699196048,
  "comm_bvp": 0.084437265,
  "comm_cctrcap": 0.222893702,
  "comm_incarpct": 0.003085095,
  "comm_juvcrimecap": 160.3748652,
  "comm_libcap": 0.222893702,
  "comm_ltbvp": 0.08173919,
  "comm_ltrvp": 0.020788233,
  "comm_ocb": 3168.813049,
  "comm_ocbp": 0.222865361,
  "comm_parkcap": 0.079320603,
  "comm_rcb": 5603.40312,
  "comm_rcbp": 0.468884089,
  "comm_rvp": 0.021860974,
  "comm_u18bbp": 0.688918611,
  "comm_evrate": 117.1863637,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.303332947,
  "econ_fincap": 1.003021658,
  "econ_medinc": 24595.45907,
  "econ_paydaycap": 1.560255913,
  "econ_pctlwjobs": 0.286728605,
  "econ_pctmwjobs": 0.490595966,
  "econ_totjobs": 13239,
  "econ_pr": 0.209133482,
  "econ_pyr": 0.3080849,
  "econ_ur": 0.065055877,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 677.2738448,
  "edu_perbach": 0.080898577,
  "edu_perearlyed": 0.438585797,
  "edu_qeckids": 0.372742898,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 4.47291477,
  "fam_lcckids": 6.709372155,
  "fam_tphh": 5777.379899,
  "fam_tphhpct": 0.62302754,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3188.834079,
  "hel_castthma": 905.6374465,
  "hel_checkup": 6311.347049,
  "hel_fruitsveggies": 348.448439,
  "hel_le": 78.03169278,
  "hel_mhlth": 1654.834813,
  "hel_obesity": 3737.992956,
  "hel_perpri": 0.410866327,
  "hel_perpub": 0.324500367,
  "hel_prtopu": 1.266150579,
  "hel_pharmacap": 1.337362211,
  "hel_phlth": 1610.250936,
  "hel_sleep": 3522.365969,
  "hel_stroke": 326.9595452,
  "hel_perins": 0.711079741,
  "hel_perunin": 0.288697953,
  "hel_clincap": 0.111446851,
  "hel_groccap": 1.114468509,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 62,
  "eci_index": 34,
  "edi_index": 71,
  "fi_index": 88,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 34,
  "edi_weight": 71,
  "fi_weight": 88,
  "hi_weight": 32,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 82,
  "TEA": 211,
  "SLN": 211,
  "SCHOOLNAME": "Stevens Park Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2615 W. Colorado Blvd.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727944200,
  "WEBSITE": "http://www.dallasisd.org/stevenspark",
  "POINT_X": -96.86487729,
  "POINT_Y": 32.76074634,
  "MasterID": "'057905211",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 55992,
  "dem_popwh": 8912,
  "dem_popbl": 6325,
  "dem_popas": 83,
  "dem_pophi": 39515,
  "dem_popm": 29283,
  "dem_popf": 26688,
  "dem_thh": 18117,
  "dem_popse": 5209,
  "dem_popch": 15751,
  "dem_perwh": 0.159165595,
  "dem_perbl": 0.112962566,
  "dem_peras": 0.001482355,
  "dem_perhi": 0.705725818,
  "dem_perm": 0.522985426,
  "dem_perf": 0.47663952,
  "dem_perse": 0.093031147,
  "dem_perch": 0.281308044,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.712201359,
  "comm_bvp": 0.070962275,
  "comm_cctrcap": 1.080700446,
  "comm_incarpct": 0.005675603,
  "comm_juvcrimecap": 262.5574134,
  "comm_libcap": 0.180116741,
  "comm_ltbvp": 0.070012343,
  "comm_ltrvp": 0.02181156,
  "comm_ocb": 2043.152883,
  "comm_ocbp": 0.229930536,
  "comm_parkcap": 0.102883623,
  "comm_rcb": 4129.607223,
  "comm_rcbp": 0.446411656,
  "comm_rvp": 0.022326023,
  "comm_u18bbp": 0.687601795,
  "comm_evrate": 127.2524775,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.374502182,
  "econ_fincap": 1.80116741,
  "econ_medinc": 25217.4605,
  "econ_paydaycap": 1.621050669,
  "econ_pctlwjobs": 0.19222527,
  "econ_pctmwjobs": 0.376735813,
  "econ_totjobs": 23332,
  "econ_pr": 0.239358077,
  "econ_pyr": 0.233263858,
  "econ_ur": 0.063999609,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 1811.320192,
  "edu_perbach": 0.131055465,
  "edu_perearlyed": 0.424717999,
  "edu_qeckids": 0.648521372,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 12.32190607,
  "fam_lcckids": 15.56451293,
  "fam_tphh": 3589.413922,
  "fam_tphhpct": 0.619225683,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3280.34619,
  "hel_castthma": 906.8809328,
  "hel_checkup": 6409.738648,
  "hel_fruitsveggies": 343.6595394,
  "hel_le": 76.0945238,
  "hel_mhlth": 1603.707836,
  "hel_obesity": 3713.829104,
  "hel_perpri": 0.429199964,
  "hel_perpub": 0.319403789,
  "hel_prtopu": 1.343753514,
  "hel_pharmacap": 2.341517633,
  "hel_phlth": 1568.816774,
  "hel_sleep": 3513.157598,
  "hel_stroke": 339.87601,
  "hel_perins": 0.720014367,
  "hel_perunin": 0.279644428,
  "hel_clincap": 1.080700446,
  "hel_groccap": 1.440933928,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 61,
  "eci_index": 36,
  "edi_index": 73,
  "fi_index": 83,
  "hi_index": 34,
  "cri_index": 46,
  "ci_weight": 61,
  "eci_weight": 36,
  "edi_weight": 73,
  "fi_weight": 83,
  "hi_weight": 34,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 83,
  "TEA": 229,
  "SLN": 229,
  "SCHOOLNAME": "Winnetka Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1151 S. Edgefield Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9727495100,
  "WEBSITE": "http://www.dallasisd.org/winnetka",
  "POINT_X": -96.84523621,
  "POINT_Y": 32.734395,
  "MasterID": "'057905229",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 88697,
  "dem_popwh": 10588,
  "dem_popbl": 8833,
  "dem_popas": 94,
  "dem_pophi": 68276,
  "dem_popm": 46070,
  "dem_popf": 42590,
  "dem_thh": 26701,
  "dem_popse": 7918,
  "dem_popch": 26389,
  "dem_perwh": 0.119372696,
  "dem_perbl": 0.099586232,
  "dem_peras": 0.001059788,
  "dem_perhi": 0.769766734,
  "dem_perm": 0.519408774,
  "dem_perf": 0.480174076,
  "dem_perse": 0.089270212,
  "dem_perch": 0.297518518,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.758093661,
  "comm_bvp": 0.09574433,
  "comm_cctrcap": 0.453503172,
  "comm_incarpct": 0.003768289,
  "comm_juvcrimecap": 178.3241368,
  "comm_libcap": 0.226751586,
  "comm_ltbvp": 0.08755274,
  "comm_ltrvp": 0.024214903,
  "comm_ocb": 3263.171221,
  "comm_ocbp": 0.224727996,
  "comm_parkcap": 0.093717094,
  "comm_rcb": 5613.008212,
  "comm_rcbp": 0.460224508,
  "comm_rvp": 0.025989324,
  "comm_u18bbp": 0.776939836,
  "comm_evrate": 86.73248168,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.320105034,
  "econ_fincap": 1.247133724,
  "econ_medinc": 26152.49647,
  "econ_paydaycap": 2.60764324,
  "econ_pctlwjobs": 0.298950227,
  "econ_pctmwjobs": 0.467645062,
  "econ_totjobs": 19147,
  "econ_pr": 0.216116801,
  "econ_pyr": 0.423359675,
  "econ_ur": 0.075828285,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 1,
  "edu_oostkids": 1258.759259,
  "edu_perbach": 0.111293965,
  "edu_perearlyed": 0.469687691,
  "edu_qeckids": 0.768473296,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.453206257,
  "fam_lcckids": 11.91133609,
  "fam_tphh": 5567.035213,
  "fam_tphhpct": 0.609654784,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3293.026163,
  "hel_castthma": 911.5731783,
  "hel_checkup": 6401.353818,
  "hel_fruitsveggies": 351.8924019,
  "hel_le": 76.58503797,
  "hel_mhlth": 1615.229298,
  "hel_obesity": 3748.858166,
  "hel_perpri": 0.417415959,
  "hel_perpub": 0.338649919,
  "hel_prtopu": 1.232588392,
  "hel_pharmacap": 1.927388482,
  "hel_phlth": 1589.077558,
  "hel_sleep": 3536.924719,
  "hel_stroke": 341.4186993,
  "hel_perins": 0.729610971,
  "hel_perunin": 0.270501988,
  "hel_clincap": 0.453503172,
  "hel_groccap": 1.927388482,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 63,
  "eci_index": 31,
  "edi_index": 74,
  "fi_index": 83,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 63,
  "eci_weight": 31,
  "edi_weight": 74,
  "fi_weight": 83,
  "hi_weight": 33,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 84,
  "TEA": 171,
  "SLN": 171,
  "SCHOOLNAME": "Lakewood Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3000 Hillbrook St.",
  "CITY": "Dallas",
  "ZIP": 75214,
  "PHONE": 9727497300,
  "WEBSITE": "http://www.dallasisd.org/lakewood",
  "POINT_X": -96.74374317,
  "POINT_Y": 32.82575749,
  "MasterID": "'057905171",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 55331,
  "dem_popwh": 37984,
  "dem_popbl": 2789,
  "dem_popas": 273,
  "dem_pophi": 11641,
  "dem_popm": 26688,
  "dem_popf": 28650,
  "dem_thh": 25606,
  "dem_popse": 6332,
  "dem_popch": 10712,
  "dem_perwh": 0.68648678,
  "dem_perbl": 0.05040574,
  "dem_peras": 0.004933943,
  "dem_perhi": 0.21038839,
  "dem_perm": 0.482333592,
  "dem_perf": 0.517792919,
  "dem_perse": 0.114438561,
  "dem_perch": 0.193598525,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.911142015,
  "comm_bvp": 0.062524669,
  "comm_cctrcap": 0.54538765,
  "comm_incarpct": 0.004509409,
  "comm_juvcrimecap": 126.5791599,
  "comm_libcap": 0.181795883,
  "comm_ltbvp": 0.057135845,
  "comm_ltrvp": 0.009431225,
  "comm_ocb": 3203.565945,
  "comm_ocbp": 0.232345549,
  "comm_parkcap": 0.237983437,
  "comm_rcb": 4396.993848,
  "comm_rcbp": 0.371752707,
  "comm_rvp": 0.014155514,
  "comm_u18bbp": 0.928073593,
  "comm_evrate": 81.44455577,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.115228845,
  "econ_fincap": 2.181550601,
  "econ_medinc": 60616.93256,
  "econ_paydaycap": 0.363591767,
  "econ_pctlwjobs": 0.297181373,
  "econ_pctmwjobs": 0.387561275,
  "econ_totjobs": 13056,
  "econ_pr": 0.090589153,
  "econ_pyr": 0.182721598,
  "econ_ur": 0.022348142,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 1113.255196,
  "edu_perbach": 0.38097094,
  "edu_perearlyed": 0.643982357,
  "edu_qeckids": 0.945841288,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 1.891682575,
  "fam_lcckids": 22.70019091,
  "fam_tphh": 4497.658513,
  "fam_tphhpct": 0.742074932,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2574.381546,
  "hel_castthma": 796.2733692,
  "hel_checkup": 6483.562191,
  "hel_fruitsveggies": 462.4896818,
  "hel_le": 81.39092492,
  "hel_mhlth": 1074.841733,
  "hel_obesity": 2692.414338,
  "hel_perpri": 0.767733972,
  "hel_perpub": 0.181133377,
  "hel_prtopu": 4.238500852,
  "hel_pharmacap": 1.999754718,
  "hel_phlth": 900.8394329,
  "hel_sleep": 2891.141188,
  "hel_stroke": 199.391862,
  "hel_perins": 0.88953024,
  "hel_perunin": 0.110288245,
  "hel_clincap": 0.363591767,
  "hel_groccap": 1.454367067,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 54,
  "ci_index": 88,
  "eci_index": 63,
  "edi_index": 98,
  "fi_index": 80,
  "hi_index": 67,
  "cri_index": 67,
  "ci_weight": 88,
  "eci_weight": 63,
  "edi_weight": 98,
  "fi_weight": 80,
  "hi_weight": 67,
  "cri_weight": 78,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 85,
  "TEA": 125,
  "SLN": 125,
  "SCHOOLNAME": "Casa View Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2100 N. Farola Dr.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9727497700,
  "WEBSITE": "http://www.dallasisd.org/casaview",
  "POINT_X": -96.67472472,
  "POINT_Y": 32.84547966,
  "MasterID": "'057905125",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 67389,
  "dem_popwh": 21970,
  "dem_popbl": 7448,
  "dem_popas": 118,
  "dem_pophi": 34606,
  "dem_popm": 33734,
  "dem_popf": 33650,
  "dem_thh": 24123,
  "dem_popse": 7585,
  "dem_popch": 17753,
  "dem_perwh": 0.326017599,
  "dem_perbl": 0.110522489,
  "dem_peras": 0.001751028,
  "dem_perhi": 0.513525946,
  "dem_perm": 0.500586149,
  "dem_perf": 0.499339655,
  "dem_perse": 0.112555462,
  "dem_perch": 0.263440621,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.750208803,
  "comm_bvp": 0.213366848,
  "comm_cctrcap": 0.298196128,
  "comm_incarpct": 0.005228121,
  "comm_juvcrimecap": 183.0033538,
  "comm_libcap": 0.149098064,
  "comm_ltbvp": 0.184685611,
  "comm_ltrvp": 0.021746202,
  "comm_ocb": 2952.716583,
  "comm_ocbp": 0.219134573,
  "comm_parkcap": 0.049950889,
  "comm_rcb": 5193.757738,
  "comm_rcbp": 0.487629647,
  "comm_rvp": 0.027838392,
  "comm_u18bbp": 0.750414921,
  "comm_evrate": 190.9946202,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.258174243,
  "econ_fincap": 1.043686449,
  "econ_medinc": 31207.19408,
  "econ_paydaycap": 1.490980641,
  "econ_pctlwjobs": 0.306892703,
  "econ_pctmwjobs": 0.40923678,
  "econ_totjobs": 14334,
  "econ_pr": 0.165952474,
  "econ_pyr": 0.34857865,
  "econ_ur": 0.046375613,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 3,
  "edu_oostkids": 754.347367,
  "edu_perbach": 0.158242829,
  "edu_perearlyed": 0.32936035,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.367780444,
  "fam_lcckids": 14.73556089,
  "fam_tphh": 4999.60369,
  "fam_tphhpct": 0.670324038,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3269.05379,
  "hel_castthma": 913.3554073,
  "hel_checkup": 6534.971053,
  "hel_fruitsveggies": 387.5663089,
  "hel_le": 78.34658918,
  "hel_mhlth": 1510.038246,
  "hel_obesity": 3425.450221,
  "hel_perpri": 0.48643659,
  "hel_perpub": 0.286871334,
  "hel_prtopu": 1.6956612,
  "hel_pharmacap": 1.633432015,
  "hel_phlth": 1450.111555,
  "hel_sleep": 3402.971407,
  "hel_stroke": 331.0291008,
  "hel_perins": 0.725828544,
  "hel_perunin": 0.274111902,
  "hel_clincap": 0.125648617,
  "hel_groccap": 0.753891699,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 32,
  "ci_index": 49,
  "eci_index": 29,
  "edi_index": 54,
  "fi_index": 90,
  "hi_index": 31,
  "cri_index": 44,
  "ci_weight": 49,
  "eci_weight": 29,
  "edi_weight": 54,
  "fi_weight": 90,
  "hi_weight": 31,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 86,
  "TEA": 147,
  "SLN": 147,
  "SCHOOLNAME": "Gill Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10910 Ferguson Rd.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9727498400,
  "WEBSITE": "http://www.dallasisd.org/gill",
  "POINT_X": -96.66071817,
  "POINT_Y": 32.84420811,
  "MasterID": "'057905147",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 71546,
  "dem_popwh": 20142,
  "dem_popbl": 8784,
  "dem_popas": 158,
  "dem_pophi": 39456,
  "dem_popm": 35494,
  "dem_popf": 36042,
  "dem_thh": 24084,
  "dem_popse": 7736,
  "dem_popch": 20263,
  "dem_perwh": 0.281525173,
  "dem_perbl": 0.122774159,
  "dem_peras": 0.002208369,
  "dem_perhi": 0.551477371,
  "dem_perm": 0.496100411,
  "dem_perf": 0.503759819,
  "dem_perse": 0.10812624,
  "dem_perch": 0.283216392,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.768291808,
  "comm_bvp": 0.220920557,
  "comm_cctrcap": 0.280848412,
  "comm_incarpct": 0.005224948,
  "comm_juvcrimecap": 141.5288748,
  "comm_libcap": 0.140424206,
  "comm_ltbvp": 0.20006151,
  "comm_ltrvp": 0.020612997,
  "comm_ocb": 2895.372023,
  "comm_ocbp": 0.217077355,
  "comm_parkcap": 0.020684277,
  "comm_rcb": 5480.299757,
  "comm_rcbp": 0.509887375,
  "comm_rvp": 0.025794291,
  "comm_u18bbp": 0.78042654,
  "comm_evrate": 156.3623535,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.249697457,
  "econ_fincap": 0.70212103,
  "econ_medinc": 28313.82307,
  "econ_paydaycap": 0.982969443,
  "econ_pctlwjobs": 0.319840249,
  "econ_pctmwjobs": 0.403235633,
  "econ_totjobs": 14773,
  "econ_pr": 0.1704661,
  "econ_pyr": 0.345673358,
  "econ_ur": 0.049865321,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 415.1802054,
  "edu_perbach": 0.12943623,
  "edu_perearlyed": 0.355080214,
  "edu_qeckids": 0.496033698,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 7.440505473,
  "fam_lcckids": 10.41670766,
  "fam_tphh": 5100.847516,
  "fam_tphhpct": 0.626657366,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3326.398624,
  "hel_castthma": 921.4078868,
  "hel_checkup": 6545.08338,
  "hel_fruitsveggies": 380.466118,
  "hel_le": 78.28117378,
  "hel_mhlth": 1536.442893,
  "hel_obesity": 3472.909597,
  "hel_perpri": 0.457804457,
  "hel_perpub": 0.309555534,
  "hel_prtopu": 1.478908976,
  "hel_pharmacap": 1.216466207,
  "hel_phlth": 1491.858276,
  "hel_sleep": 3425.361738,
  "hel_stroke": 343.7004374,
  "hel_perins": 0.716097,
  "hel_perunin": 0.283804822,
  "hel_clincap": 0.221175674,
  "hel_groccap": 0.442351348,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 51,
  "eci_index": 29,
  "edi_index": 68,
  "fi_index": 88,
  "hi_index": 30,
  "cri_index": 44,
  "ci_weight": 51,
  "eci_weight": 29,
  "edi_weight": 68,
  "fi_weight": 88,
  "hi_weight": 30,
  "cri_weight": 39,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 87,
  "TEA": 153,
  "SLN": 153,
  "SCHOOLNAME": "Hexter Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "9720 Waterview Rd.",
  "CITY": "Dallas",
  "ZIP": 75218,
  "PHONE": 9725025800,
  "WEBSITE": "http://www.dallasisd.org/hexter",
  "POINT_X": -96.70958707,
  "POINT_Y": 32.84923321,
  "MasterID": "'057905153",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 44191,
  "dem_popwh": 28778,
  "dem_popbl": 2916,
  "dem_popas": 153,
  "dem_pophi": 9909,
  "dem_popm": 21468,
  "dem_popf": 22730,
  "dem_thh": 19006,
  "dem_popse": 7151,
  "dem_popch": 9460,
  "dem_perwh": 0.651218574,
  "dem_perbl": 0.065986287,
  "dem_peras": 0.003462243,
  "dem_perhi": 0.224231178,
  "dem_perm": 0.485800276,
  "dem_perf": 0.514358127,
  "dem_perse": 0.16182028,
  "dem_perch": 0.214070738,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.856553043,
  "comm_bvp": 0.136438378,
  "comm_cctrcap": 0.228311433,
  "comm_incarpct": 0.003275282,
  "comm_juvcrimecap": 227.6279126,
  "comm_libcap": 0.228311433,
  "comm_ltbvp": 0.118224725,
  "comm_ltrvp": 0.013311436,
  "comm_ocb": 2711.548303,
  "comm_ocbp": 0.2080552,
  "comm_parkcap": 0.428382544,
  "comm_rcb": 2829.037321,
  "comm_rcbp": 0.472883936,
  "comm_rvp": 0.020247164,
  "comm_u18bbp": 0.88070094,
  "comm_evrate": 64.72629119,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.134384454,
  "econ_fincap": 1.826491462,
  "econ_medinc": 51312.26052,
  "econ_paydaycap": 1.598180029,
  "econ_pctlwjobs": 0.294967824,
  "econ_pctmwjobs": 0.394661884,
  "econ_totjobs": 9479,
  "econ_pr": 0.091975835,
  "econ_pyr": 0.164405009,
  "econ_ur": 0.023083583,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1987.019442,
  "edu_perbach": 0.314747217,
  "edu_perearlyed": 0.510764662,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.192853951,
  "fam_lcckids": 21.28569301,
  "fam_tphh": 4191.769868,
  "fam_tphhpct": 0.836849207,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 3144.413164,
  "hel_castthma": 831.3986191,
  "hel_checkup": 6782.911479,
  "hel_fruitsveggies": 446.8379973,
  "hel_le": 79.83711137,
  "hel_mhlth": 1127.309567,
  "hel_obesity": 2862.821605,
  "hel_perpri": 0.71991881,
  "hel_perpub": 0.221378398,
  "hel_prtopu": 3.251983105,
  "hel_pharmacap": 2.283114328,
  "hel_phlth": 1102.245268,
  "hel_sleep": 2951.588188,
  "hel_stroke": 279.5077657,
  "hel_perins": 0.857074439,
  "hel_perunin": 0.142971173,
  "hel_clincap": 0,
  "hel_groccap": 1.141557164,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 41,
  "ci_index": 66,
  "eci_index": 57,
  "edi_index": 77,
  "fi_index": 91,
  "hi_index": 48,
  "cri_index": 59,
  "ci_weight": 66,
  "eci_weight": 57,
  "edi_weight": 77,
  "fi_weight": 91,
  "hi_weight": 48,
  "cri_weight": 59,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 88,
  "TEA": 159,
  "SLN": 159,
  "SCHOOLNAME": "Hotchkiss Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6929 Town North Dr.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9727497000,
  "WEBSITE": "http://www.dallasisd.org/hotchkiss",
  "POINT_X": -96.74049592,
  "POINT_Y": 32.85866034,
  "MasterID": "'057905159",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 72701,
  "dem_popwh": 39037,
  "dem_popbl": 10566,
  "dem_popas": 135,
  "dem_pophi": 15407,
  "dem_popm": 36352,
  "dem_popf": 36362,
  "dem_thh": 33470,
  "dem_popse": 8102,
  "dem_popch": 15737,
  "dem_perwh": 0.536952724,
  "dem_perbl": 0.145335002,
  "dem_peras": 0.001856921,
  "dem_perhi": 0.211922807,
  "dem_perm": 0.500020632,
  "dem_perf": 0.500158182,
  "dem_perse": 0.111442759,
  "dem_perch": 0.216461947,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.841802669,
  "comm_bvp": 0.122276799,
  "comm_cctrcap": 0.415848494,
  "comm_incarpct": 0.003261831,
  "comm_juvcrimecap": 175.5078013,
  "comm_libcap": 0.138616165,
  "comm_ltbvp": 0.109201046,
  "comm_ltrvp": 0.007517145,
  "comm_ocb": 2554.715781,
  "comm_ocbp": 0.221674796,
  "comm_parkcap": 0.291638178,
  "comm_rcb": 9471.329481,
  "comm_rcbp": 0.431462293,
  "comm_rvp": 0.011341046,
  "comm_u18bbp": 0.843547319,
  "comm_evrate": 148.3192963,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.259071839,
  "econ_fincap": 2.63370713,
  "econ_medinc": 54315.57292,
  "econ_paydaycap": 2.079242471,
  "econ_pctlwjobs": 0.298809027,
  "econ_pctmwjobs": 0.318643125,
  "econ_totjobs": 43158,
  "econ_pr": 0.166695847,
  "econ_pyr": 0.228122932,
  "econ_ur": 0.039509431,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 2133.647524,
  "edu_perbach": 0.325483998,
  "edu_perearlyed": 0.454587797,
  "edu_qeckids": 0.643052298,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.858313786,
  "fam_lcckids": 15.43325514,
  "fam_tphh": 5837.39078,
  "fam_tphhpct": 0.742113072,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2787.641395,
  "hel_castthma": 846.5684056,
  "hel_checkup": 6483.836713,
  "hel_fruitsveggies": 441.4183192,
  "hel_le": 81.47640922,
  "hel_mhlth": 1263.445982,
  "hel_obesity": 2963.500921,
  "hel_perpri": 0.658032234,
  "hel_perpub": 0.24456086,
  "hel_prtopu": 2.690668626,
  "hel_pharmacap": 4.019868777,
  "hel_phlth": 1062.854518,
  "hel_sleep": 3159.093848,
  "hel_stroke": 237.9223577,
  "hel_perins": 0.831476516,
  "hel_perunin": 0.168509662,
  "hel_clincap": 0.970313153,
  "hel_groccap": 1.247545483,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 3,
  "hi_gen": 45,
  "ci_index": 74,
  "eci_index": 47,
  "edi_index": 80,
  "fi_index": 97,
  "hi_index": 52,
  "cri_index": 59,
  "ci_weight": 74,
  "eci_weight": 47,
  "edi_weight": 80,
  "fi_weight": 97,
  "hi_weight": 52,
  "cri_weight": 62,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 89,
  "TEA": 166,
  "SLN": 166,
  "SCHOOLNAME": "Kiest Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2611 Healey Dr.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9725025600,
  "WEBSITE": "http://www.dallasisd.org/kiest",
  "POINT_X": -96.67050495,
  "POINT_Y": 32.82585781,
  "MasterID": "'057905166",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 74207,
  "dem_popwh": 19470,
  "dem_popbl": 12032,
  "dem_popas": 72,
  "dem_pophi": 40272,
  "dem_popm": 35994,
  "dem_popf": 38197,
  "dem_thh": 25583,
  "dem_popse": 7572,
  "dem_popch": 21476,
  "dem_perwh": 0.26237417,
  "dem_perbl": 0.162141038,
  "dem_peras": 0.000970259,
  "dem_perhi": 0.542698128,
  "dem_perm": 0.48504858,
  "dem_perf": 0.514735807,
  "dem_perse": 0.102038891,
  "dem_perch": 0.28940666,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.741235599,
  "comm_bvp": 0.248439772,
  "comm_cctrcap": 0.405741471,
  "comm_incarpct": 0.005565351,
  "comm_juvcrimecap": 184.4891686,
  "comm_libcap": 0.270494314,
  "comm_ltbvp": 0.2195355,
  "comm_ltrvp": 0.026192948,
  "comm_ocb": 3046.427163,
  "comm_ocbp": 0.229277989,
  "comm_parkcap": 0.012242512,
  "comm_rcb": 6022.050229,
  "comm_rcbp": 0.489510613,
  "comm_rvp": 0.033071428,
  "comm_u18bbp": 0.740325521,
  "comm_evrate": 154.4522534,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.261911564,
  "econ_fincap": 0.9467301,
  "econ_medinc": 28600.05771,
  "econ_paydaycap": 1.352471571,
  "econ_pctlwjobs": 0.296568074,
  "econ_pctmwjobs": 0.388913976,
  "econ_totjobs": 8858,
  "econ_pr": 0.187631093,
  "econ_pyr": 0.272264165,
  "econ_ur": 0.054207004,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 563.0947706,
  "edu_perbach": 0.123640972,
  "edu_perearlyed": 0.338285714,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.021131803,
  "fam_lcckids": 11.70188634,
  "fam_tphh": 5007.940543,
  "fam_tphhpct": 0.595409356,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3435.986034,
  "hel_castthma": 969.8911415,
  "hel_checkup": 6590.601165,
  "hel_fruitsveggies": 376.5029027,
  "hel_le": 77.97742144,
  "hel_mhlth": 1626.266672,
  "hel_obesity": 3637.042971,
  "hel_perpri": 0.448922807,
  "hel_perpub": 0.332680489,
  "hel_prtopu": 1.349411287,
  "hel_pharmacap": 0.885773816,
  "hel_phlth": 1563.852766,
  "hel_sleep": 3547.110188,
  "hel_stroke": 365.5071804,
  "hel_perins": 0.730951577,
  "hel_perunin": 0.268926859,
  "hel_clincap": 0.196838626,
  "hel_groccap": 0.68893519,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 29,
  "ci_index": 47,
  "eci_index": 31,
  "edi_index": 54,
  "fi_index": 84,
  "hi_index": 30,
  "cri_index": 43,
  "ci_weight": 47,
  "eci_weight": 31,
  "edi_weight": 54,
  "fi_weight": 84,
  "hi_weight": 30,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 90,
  "TEA": 198,
  "SLN": 198,
  "SCHOOLNAME": "Reilly Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "11230 Lippitt Ave.",
  "CITY": "Dallas",
  "ZIP": 75218,
  "PHONE": 9727497800,
  "WEBSITE": "http://www.dallasisd.org/reilly",
  "POINT_X": -96.68836387,
  "POINT_Y": 32.85475583,
  "MasterID": "'057905198",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 58668,
  "dem_popwh": 23355,
  "dem_popbl": 6461,
  "dem_popas": 197,
  "dem_pophi": 25405,
  "dem_popm": 29122,
  "dem_popf": 29540,
  "dem_thh": 22388,
  "dem_popse": 7144,
  "dem_popch": 14801,
  "dem_perwh": 0.398087543,
  "dem_perbl": 0.110128179,
  "dem_peras": 0.003357878,
  "dem_perhi": 0.433029931,
  "dem_perm": 0.496386446,
  "dem_perf": 0.503511284,
  "dem_perse": 0.12176996,
  "dem_perch": 0.252284039,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.763004473,
  "comm_bvp": 0.187162083,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.004145837,
  "comm_juvcrimecap": 232.8477169,
  "comm_libcap": 0.171513956,
  "comm_ltbvp": 0.166042151,
  "comm_ltrvp": 0.017730046,
  "comm_ocb": 2747.459135,
  "comm_ocbp": 0.216169344,
  "comm_parkcap": 0.170489924,
  "comm_rcb": 4792.778726,
  "comm_rcbp": 0.494992894,
  "comm_rvp": 0.024140174,
  "comm_u18bbp": 0.755929382,
  "comm_evrate": 148.0165443,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.273911954,
  "econ_fincap": 1.200597694,
  "econ_medinc": 36671.22253,
  "econ_paydaycap": 1.886653519,
  "econ_pctlwjobs": 0.279172245,
  "econ_pctmwjobs": 0.377733155,
  "econ_totjobs": 17928,
  "econ_pr": 0.160942632,
  "econ_pyr": 0.285931171,
  "econ_ur": 0.038817644,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 4,
  "edu_oostkids": 1201.98084,
  "edu_perbach": 0.205514612,
  "edu_perearlyed": 0.344262295,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.474160111,
  "fam_lcckids": 17.66619663,
  "fam_tphh": 4592.295209,
  "fam_tphhpct": 0.706109359,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3197.185381,
  "hel_castthma": 896.6281846,
  "hel_checkup": 6559.599074,
  "hel_fruitsveggies": 401.3312317,
  "hel_le": 78.55142,
  "hel_mhlth": 1438.491825,
  "hel_obesity": 3305.544594,
  "hel_perpri": 0.53315977,
  "hel_perpub": 0.274955467,
  "hel_prtopu": 1.939076808,
  "hel_pharmacap": 2.296787234,
  "hel_phlth": 1361.19492,
  "hel_sleep": 3327.760127,
  "hel_stroke": 312.032037,
  "hel_perins": 0.753751028,
  "hel_perunin": 0.246163332,
  "hel_clincap": 0.164056231,
  "hel_groccap": 1.148393617,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 35,
  "ci_index": 51,
  "eci_index": 37,
  "edi_index": 56,
  "fi_index": 92,
  "hi_index": 35,
  "cri_index": 44,
  "ci_weight": 51,
  "eci_weight": 37,
  "edi_weight": 56,
  "fi_weight": 92,
  "hi_weight": 35,
  "cri_weight": 42,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 91,
  "TEA": 199,
  "SLN": 199,
  "SCHOOLNAME": "Reinhardt Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10122 Losa Dr.",
  "CITY": "Dallas",
  "ZIP": 75218,
  "PHONE": 9727497900,
  "WEBSITE": "http://www.dallasisd.org/reinhardt",
  "POINT_X": -96.69219615,
  "POINT_Y": 32.83701322,
  "MasterID": "'057905199",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 55980,
  "dem_popwh": 23488,
  "dem_popbl": 5834,
  "dem_popas": 50,
  "dem_pophi": 24742,
  "dem_popm": 27247,
  "dem_popf": 28741,
  "dem_thh": 21835,
  "dem_popse": 7253,
  "dem_popch": 13167,
  "dem_perwh": 0.419578421,
  "dem_perbl": 0.104215791,
  "dem_peras": 0.000893176,
  "dem_perhi": 0.441979278,
  "dem_perm": 0.486727403,
  "dem_perf": 0.513415506,
  "dem_perse": 0.12956413,
  "dem_perch": 0.235209003,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 4,
  "dem_perch_sd": 1,
  "comm_bbp": 0.769118224,
  "comm_bvp": 0.203057583,
  "comm_cctrcap": 0.179648328,
  "comm_incarpct": 0.005076986,
  "comm_juvcrimecap": 238.6387286,
  "comm_libcap": 0.359296656,
  "comm_ltbvp": 0.172379558,
  "comm_ltrvp": 0.018586879,
  "comm_ocb": 3047.49905,
  "comm_ocbp": 0.22248486,
  "comm_parkcap": 0.16372829,
  "comm_rcb": 3773.303667,
  "comm_rcbp": 0.463188188,
  "comm_rvp": 0.02699206,
  "comm_u18bbp": 0.745854821,
  "comm_evrate": 129.6162687,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.25151263,
  "econ_fincap": 1.616834952,
  "econ_medinc": 39817.75746,
  "econ_paydaycap": 1.976131608,
  "econ_pctlwjobs": 0.294103884,
  "econ_pctmwjobs": 0.4112073,
  "econ_totjobs": 8548,
  "econ_pr": 0.155495597,
  "econ_pyr": 0.259932842,
  "econ_ur": 0.043236475,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1378.127957,
  "edu_perbach": 0.204382803,
  "edu_perearlyed": 0.328097731,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.647768908,
  "fam_lcckids": 19.88419916,
  "fam_tphh": 4021.669408,
  "fam_tphhpct": 0.706684421,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3272.778922,
  "hel_castthma": 905.3483637,
  "hel_checkup": 6608.890458,
  "hel_fruitsveggies": 408.87711,
  "hel_le": 78.45519243,
  "hel_mhlth": 1438.505676,
  "hel_obesity": 3350.355785,
  "hel_perpri": 0.555451903,
  "hel_perpub": 0.269796563,
  "hel_prtopu": 2.058780504,
  "hel_pharmacap": 2.154606328,
  "hel_phlth": 1388.902403,
  "hel_sleep": 3317.487935,
  "hel_stroke": 324.2130485,
  "hel_perins": 0.767805246,
  "hel_perunin": 0.232087116,
  "hel_clincap": 0.153900452,
  "hel_groccap": 0.923402712,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 33,
  "ci_index": 52,
  "eci_index": 32,
  "edi_index": 56,
  "fi_index": 92,
  "hi_index": 33,
  "cri_index": 44,
  "ci_weight": 52,
  "eci_weight": 32,
  "edi_weight": 56,
  "fi_weight": 92,
  "hi_weight": 33,
  "cri_weight": 41,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 92,
  "TEA": 250,
  "SLN": 250,
  "SCHOOLNAME": "Young Jr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4601 Veterans Dr.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9727492000,
  "WEBSITE": "http://www.dallasisd.org/young",
  "POINT_X": -96.78587966,
  "POINT_Y": 32.69628035,
  "MasterID": "'057905250",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 45906,
  "dem_popwh": 1080,
  "dem_popbl": 30090,
  "dem_popas": 67,
  "dem_pophi": 14153,
  "dem_popm": 21067,
  "dem_popf": 24848,
  "dem_thh": 16695,
  "dem_popse": 6304,
  "dem_popch": 12870,
  "dem_perwh": 0.023526336,
  "dem_perbl": 0.655469873,
  "dem_peras": 0.001459504,
  "dem_perhi": 0.308303925,
  "dem_perm": 0.458916046,
  "dem_perf": 0.541280007,
  "dem_perse": 0.137324097,
  "dem_perch": 0.280355509,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.455784475,
  "comm_bvp": 0.104784481,
  "comm_cctrcap": 1.316763485,
  "comm_incarpct": 0.014760103,
  "comm_juvcrimecap": 573.545043,
  "comm_libcap": 0.219460581,
  "comm_ltbvp": 0.098542279,
  "comm_ltrvp": 0.056896656,
  "comm_ocb": 2176.53849,
  "comm_ocbp": 0.283580093,
  "comm_parkcap": 0.196137422,
  "comm_rcb": 4892.899529,
  "comm_rcbp": 0.542281499,
  "comm_rvp": 0.06400932,
  "comm_u18bbp": 0.500619832,
  "comm_evrate": 262.2553942,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.475598739,
  "econ_fincap": 1.316763485,
  "econ_medinc": 18094.77638,
  "econ_paydaycap": 1.097302905,
  "econ_pctlwjobs": 0.351920236,
  "econ_pctmwjobs": 0.408788774,
  "econ_totjobs": 2708,
  "econ_pr": 0.356143412,
  "econ_pyr": 0.341979884,
  "econ_ur": 0.090400177,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1782.296284,
  "edu_perbach": 0.045140696,
  "edu_perearlyed": 0.440303658,
  "edu_qeckids": 5.462379153,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 22.62985649,
  "fam_lcckids": 20.28883686,
  "fam_tphh": 1510.958176,
  "fam_tphhpct": 0.356417245,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4990.445381,
  "hel_castthma": 1216.710476,
  "hel_checkup": 7437.853064,
  "hel_fruitsveggies": 267.4074052,
  "hel_le": 70.51837006,
  "hel_mhlth": 1849.645334,
  "hel_obesity": 4671.854133,
  "hel_perpri": 0.286060844,
  "hel_perpub": 0.490099659,
  "hel_prtopu": 0.58367893,
  "hel_pharmacap": 1.536224066,
  "hel_phlth": 2017.914832,
  "hel_sleep": 4236.312891,
  "hel_stroke": 702.7090915,
  "hel_perins": 0.749366203,
  "hel_perunin": 0.250458956,
  "hel_clincap": 0.219460581,
  "hel_groccap": 0.658381743,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 1,
  "ci_index": 11,
  "eci_index": 2,
  "edi_index": 76,
  "fi_index": 53,
  "hi_index": 2,
  "cri_index": 9,
  "ci_weight": 11,
  "eci_weight": 2,
  "edi_weight": 76,
  "fi_weight": 53,
  "hi_weight": 2,
  "cri_weight": 6,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 93,
  "TEA": 172,
  "SLN": 172,
  "SCHOOLNAME": "Brashear Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2959 S. Hampton Rd.",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9725022600,
  "WEBSITE": "http://www.dallasisd.org/brashear",
  "POINT_X": -96.85785449,
  "POINT_Y": 32.71258097,
  "MasterID": "'057905172",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 80355,
  "dem_popwh": 6349,
  "dem_popbl": 15289,
  "dem_popas": 37,
  "dem_pophi": 57566,
  "dem_popm": 40044,
  "dem_popf": 40284,
  "dem_thh": 23427,
  "dem_popse": 7497,
  "dem_popch": 25121,
  "dem_perwh": 0.079011885,
  "dem_perbl": 0.190268185,
  "dem_peras": 0.000460457,
  "dem_perhi": 0.716395993,
  "dem_perm": 0.498338622,
  "dem_perf": 0.501325369,
  "dem_perse": 0.093298488,
  "dem_perch": 0.312625226,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.731137124,
  "comm_bvp": 0.095733069,
  "comm_cctrcap": 0.251462192,
  "comm_incarpct": 0.004320106,
  "comm_juvcrimecap": 192.0290847,
  "comm_libcap": 0.125731096,
  "comm_ltbvp": 0.089735328,
  "comm_ltrvp": 0.018719307,
  "comm_ocb": 2923.971298,
  "comm_ocbp": 0.233439531,
  "comm_parkcap": 0.089899719,
  "comm_rcb": 5520.806408,
  "comm_rcbp": 0.505852907,
  "comm_rvp": 0.019952805,
  "comm_u18bbp": 0.745567158,
  "comm_evrate": 157.3524664,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.330189448,
  "econ_fincap": 1.383042054,
  "econ_medinc": 24284.57018,
  "econ_paydaycap": 1.885966437,
  "econ_pctlwjobs": 0.35373197,
  "econ_pctmwjobs": 0.423049993,
  "econ_totjobs": 7141,
  "econ_pr": 0.236042248,
  "econ_pyr": 0.415744149,
  "econ_ur": 0.085154393,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 836.8265257,
  "edu_perbach": 0.078591742,
  "edu_perearlyed": 0.480543545,
  "edu_qeckids": 0.402127115,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 6.031906721,
  "fam_lcckids": 8.846796524,
  "fam_tphh": 4781.811821,
  "fam_tphhpct": 0.559444767,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3458.424324,
  "hel_castthma": 963.3520648,
  "hel_checkup": 6529.845353,
  "hel_fruitsveggies": 352.2429414,
  "hel_le": 77.14837941,
  "hel_mhlth": 1665.733688,
  "hel_obesity": 3855.734416,
  "hel_perpri": 0.410825166,
  "hel_perpub": 0.356088377,
  "hel_prtopu": 1.153716867,
  "hel_pharmacap": 1.760235341,
  "hel_phlth": 1629.820447,
  "hel_sleep": 3631.321193,
  "hel_stroke": 372.1908676,
  "hel_perins": 0.737026508,
  "hel_perunin": 0.262848807,
  "hel_clincap": 0.377193287,
  "hel_groccap": 1.257310958,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 3,
  "hi_gen": 27,
  "ci_index": 60,
  "eci_index": 21,
  "edi_index": 71,
  "fi_index": 81,
  "hi_index": 27,
  "cri_index": 43,
  "ci_weight": 60,
  "eci_weight": 21,
  "edi_weight": 71,
  "fi_weight": 81,
  "hi_weight": 27,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 94,
  "TEA": 183,
  "SLN": 183,
  "SCHOOLNAME": "Marsalis Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5640 S. Marsalis Ave.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9727493500,
  "WEBSITE": "http://www.dallasisd.org/marsalis",
  "POINT_X": -96.81333695,
  "POINT_Y": 32.67817293,
  "MasterID": "'057905183",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 47661,
  "dem_popwh": 2694,
  "dem_popbl": 30492,
  "dem_popas": 32,
  "dem_pophi": 13771,
  "dem_popm": 21932,
  "dem_popf": 25729,
  "dem_thh": 16766,
  "dem_popse": 7378,
  "dem_popch": 12783,
  "dem_perwh": 0.056524202,
  "dem_perbl": 0.639768364,
  "dem_peras": 0.000671408,
  "dem_perhi": 0.288936447,
  "dem_perm": 0.460166593,
  "dem_perf": 0.539833407,
  "dem_perse": 0.15480162,
  "dem_perch": 0.26820671,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.575941879,
  "comm_bvp": 0.079673786,
  "comm_cctrcap": 0.642728214,
  "comm_incarpct": 0.00981299,
  "comm_juvcrimecap": 299.8168507,
  "comm_libcap": 0,
  "comm_ltbvp": 0.075479695,
  "comm_ltrvp": 0.021611671,
  "comm_ocb": 2361.516629,
  "comm_ocbp": 0.284967574,
  "comm_parkcap": 0.107662863,
  "comm_rcb": 4784.941037,
  "comm_rcbp": 0.563720435,
  "comm_rvp": 0.025630435,
  "comm_u18bbp": 0.627589321,
  "comm_evrate": 176.7502588,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.432131732,
  "econ_fincap": 1.071213689,
  "econ_medinc": 21137.33558,
  "econ_paydaycap": 0.428485476,
  "econ_pctlwjobs": 0.28656794,
  "econ_pctmwjobs": 0.395687191,
  "econ_totjobs": 3849,
  "econ_pr": 0.305890212,
  "econ_pyr": 0.344398379,
  "econ_ur": 0.088716504,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1770.442317,
  "edu_perbach": 0.074195054,
  "edu_perearlyed": 0.473306773,
  "edu_qeckids": 5.510491873,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 24.40360687,
  "fam_lcckids": 22.82918062,
  "fam_tphh": 1773.614062,
  "fam_tphhpct": 0.399508743,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4666.351047,
  "hel_castthma": 1150.102314,
  "hel_checkup": 7383.743779,
  "hel_fruitsveggies": 333.0075278,
  "hel_le": 72.69640816,
  "hel_mhlth": 1678.887208,
  "hel_obesity": 4381.444858,
  "hel_perpri": 0.382720216,
  "hel_perpub": 0.451527168,
  "hel_prtopu": 0.847612819,
  "hel_pharmacap": 1.499699165,
  "hel_phlth": 1768.813275,
  "hel_sleep": 4043.258806,
  "hel_stroke": 593.7067675,
  "hel_perins": 0.777442626,
  "hel_perunin": 0.222473,
  "hel_clincap": 0.428485476,
  "hel_groccap": 0.428485476,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 9,
  "ci_index": 55,
  "eci_index": 6,
  "edi_index": 78,
  "fi_index": 69,
  "hi_index": 15,
  "cri_index": 36,
  "ci_weight": 55,
  "eci_weight": 6,
  "edi_weight": 78,
  "fi_weight": 69,
  "hi_weight": 15,
  "cri_weight": 28,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 95,
  "TEA": 210,
  "SLN": 210,
  "SCHOOLNAME": "Stemmons Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2727 Knoxville St.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727944900,
  "WEBSITE": "http://www.dallasisd.org/stemmons",
  "POINT_X": -96.90152461,
  "POINT_Y": 32.71565926,
  "MasterID": "'057905210",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 52228,
  "dem_popwh": 3199,
  "dem_popbl": 7616,
  "dem_popas": 28,
  "dem_pophi": 40595,
  "dem_popm": 25593,
  "dem_popf": 26615,
  "dem_thh": 14526,
  "dem_popse": 4554,
  "dem_popch": 16173,
  "dem_perwh": 0.06125067,
  "dem_perbl": 0.145822164,
  "dem_peras": 0.000536111,
  "dem_perhi": 0.777265069,
  "dem_perm": 0.490024508,
  "dem_perf": 0.509592556,
  "dem_perse": 0.087194608,
  "dem_perch": 0.309661484,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.632466731,
  "comm_bvp": 0.088131531,
  "comm_cctrcap": 0.193358044,
  "comm_incarpct": 0.004759794,
  "comm_juvcrimecap": 190.9211825,
  "comm_libcap": 0.193358044,
  "comm_ltbvp": 0.077674906,
  "comm_ltrvp": 0.01489611,
  "comm_ocb": 1914.060324,
  "comm_ocbp": 0.256979981,
  "comm_parkcap": 0.073672914,
  "comm_rcb": 3175.164712,
  "comm_rcbp": 0.448121573,
  "comm_rvp": 0.016468855,
  "comm_u18bbp": 0.615804284,
  "comm_evrate": 145.6952863,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.289656824,
  "econ_fincap": 0.966790221,
  "econ_medinc": 23606.26351,
  "econ_paydaycap": 0.580074133,
  "econ_pctlwjobs": 0.164,
  "econ_pctmwjobs": 0.427533333,
  "econ_totjobs": 15000,
  "econ_pr": 0.213989344,
  "econ_pyr": 0.229743626,
  "econ_ur": 0.064684072,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 553.6621916,
  "edu_perbach": 0.055174031,
  "edu_perearlyed": 0.455153203,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.106970772,
  "fam_lcckids": 5.59254739,
  "fam_tphh": 3219.82464,
  "fam_tphhpct": 0.581467773,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3224.179005,
  "hel_castthma": 945.1804999,
  "hel_checkup": 6383.782082,
  "hel_fruitsveggies": 367.9668999,
  "hel_le": 77.55627815,
  "hel_mhlth": 1693.920252,
  "hel_obesity": 3774.996288,
  "hel_perpri": 0.412803447,
  "hel_perpub": 0.325549186,
  "hel_prtopu": 1.268021744,
  "hel_pharmacap": 0.773432177,
  "hel_phlth": 1596.908092,
  "hel_sleep": 3606.943544,
  "hel_stroke": 328.7828318,
  "hel_perins": 0.708036779,
  "hel_perunin": 0.291693918,
  "hel_clincap": 0.193358044,
  "hel_groccap": 0.773432177,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 32,
  "ci_index": 62,
  "eci_index": 36,
  "edi_index": 62,
  "fi_index": 56,
  "hi_index": 30,
  "cri_index": 44,
  "ci_weight": 62,
  "eci_weight": 36,
  "edi_weight": 62,
  "fi_weight": 56,
  "hi_weight": 30,
  "cri_weight": 41,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 96,
  "TEA": 213,
  "SLN": 213,
  "SCHOOLNAME": "Terry Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6661 Greenspan Ave.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727493200,
  "WEBSITE": "http://www.dallasisd.org/terry",
  "POINT_X": -96.830194,
  "POINT_Y": 32.66555424,
  "MasterID": "'057905213",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 46631,
  "dem_popwh": 2682,
  "dem_popbl": 31024,
  "dem_popas": 11,
  "dem_pophi": 12339,
  "dem_popm": 21482,
  "dem_popf": 25135,
  "dem_thh": 16375,
  "dem_popse": 7359,
  "dem_popch": 12900,
  "dem_perwh": 0.057515387,
  "dem_perbl": 0.665308486,
  "dem_peras": 0.000235895,
  "dem_perhi": 0.26460938,
  "dem_perm": 0.460680663,
  "dem_perf": 0.539019107,
  "dem_perse": 0.157813472,
  "dem_perch": 0.276640003,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.579314355,
  "comm_bvp": 0.0874553,
  "comm_cctrcap": 0.866354105,
  "comm_incarpct": 0.008842543,
  "comm_juvcrimecap": 263.2185399,
  "comm_libcap": 0.216588526,
  "comm_ltbvp": 0.086040387,
  "comm_ltrvp": 0.013031313,
  "comm_ocb": 2357.085103,
  "comm_ocbp": 0.281534473,
  "comm_parkcap": 0.058343694,
  "comm_rcb": 4480.891946,
  "comm_rcbp": 0.559315332,
  "comm_rvp": 0.014543539,
  "comm_u18bbp": 0.581034355,
  "comm_evrate": 213.7728753,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.434844656,
  "econ_fincap": 0.866354105,
  "econ_medinc": 23405.91624,
  "econ_paydaycap": 0.433177052,
  "econ_pctlwjobs": 0.290913719,
  "econ_pctmwjobs": 0.434461695,
  "econ_totjobs": 3929,
  "econ_pr": 0.288366479,
  "econ_pyr": 0.288023421,
  "econ_ur": 0.073419373,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 1,
  "edu_oostkids": 2559.031806,
  "edu_perbach": 0.084539664,
  "edu_perearlyed": 0.456580125,
  "edu_qeckids": 2.342005924,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 24.98139652,
  "fam_lcckids": 23.42005924,
  "fam_tphh": 1473.455584,
  "fam_tphhpct": 0.346220521,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4598.994451,
  "hel_castthma": 1151.465295,
  "hel_checkup": 7444.598053,
  "hel_fruitsveggies": 361.8919677,
  "hel_le": 74.22322961,
  "hel_mhlth": 1625.043665,
  "hel_obesity": 4346.684826,
  "hel_perpri": 0.418033668,
  "hel_perpub": 0.435899641,
  "hel_prtopu": 0.959013564,
  "hel_pharmacap": 1.082942631,
  "hel_phlth": 1664.851638,
  "hel_sleep": 4035.224689,
  "hel_stroke": 541.7320457,
  "hel_perins": 0.794358566,
  "hel_perunin": 0.205641434,
  "hel_clincap": 0.433177052,
  "hel_groccap": 0.216588526,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 11,
  "ci_index": 55,
  "eci_index": 16,
  "edi_index": 77,
  "fi_index": 52,
  "hi_index": 20,
  "cri_index": 38,
  "ci_weight": 55,
  "eci_weight": 16,
  "edi_weight": 77,
  "fi_weight": 52,
  "hi_weight": 20,
  "cri_weight": 31,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 97,
  "TEA": 215,
  "SLN": 215,
  "SCHOOLNAME": "Thornton Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6011 Old Ox Rd.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9727948000,
  "WEBSITE": "http://www.dallasisd.org/rlthornton",
  "POINT_X": -96.79795313,
  "POINT_Y": 32.67409167,
  "MasterID": "'057905215",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 38307,
  "dem_popwh": 1183,
  "dem_popbl": 26846,
  "dem_popas": 43,
  "dem_pophi": 9795,
  "dem_popm": 17641,
  "dem_popf": 20670,
  "dem_thh": 13721,
  "dem_popse": 5829,
  "dem_popch": 10191,
  "dem_perwh": 0.030882084,
  "dem_perbl": 0.700811862,
  "dem_peras": 0.00112251,
  "dem_perhi": 0.255697392,
  "dem_perm": 0.460516355,
  "dem_perf": 0.539588065,
  "dem_perse": 0.152165401,
  "dem_perch": 0.266034928,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.519485338,
  "comm_bvp": 0.072141118,
  "comm_cctrcap": 0.791783949,
  "comm_incarpct": 0.010260072,
  "comm_juvcrimecap": 401.6840614,
  "comm_libcap": 0,
  "comm_ltbvp": 0.068043487,
  "comm_ltrvp": 0.027620563,
  "comm_ocb": 2120.177607,
  "comm_ocbp": 0.288262279,
  "comm_parkcap": 0.164090248,
  "comm_rcb": 3684.602983,
  "comm_rcbp": 0.578682238,
  "comm_rvp": 0.032446379,
  "comm_u18bbp": 0.549324197,
  "comm_evrate": 202.9606188,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.399842862,
  "econ_fincap": 0.791783949,
  "econ_medinc": 20086.49873,
  "econ_paydaycap": 0.263927983,
  "econ_pctlwjobs": 0.255729795,
  "econ_pctmwjobs": 0.411640531,
  "econ_totjobs": 3316,
  "econ_pr": 0.291642537,
  "econ_pyr": 0.218542025,
  "econ_ur": 0.092590852,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 0,
  "edu_oostkids": 2146.577,
  "edu_perbach": 0.064163517,
  "edu_perearlyed": 0.543912176,
  "edu_qeckids": 7.89545563,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 28.62102666,
  "fam_lcckids": 27.63409471,
  "fam_tphh": 1283.199771,
  "fam_tphhpct": 0.357908095,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4845.470158,
  "hel_castthma": 1181.67116,
  "hel_checkup": 7491.213821,
  "hel_fruitsveggies": 310.669754,
  "hel_le": 71.34512725,
  "hel_mhlth": 1699.499403,
  "hel_obesity": 4497.067805,
  "hel_perpri": 0.381609678,
  "hel_perpub": 0.460938935,
  "hel_prtopu": 0.827896385,
  "hel_pharmacap": 1.319639914,
  "hel_phlth": 1819.223286,
  "hel_sleep": 4118.040416,
  "hel_stroke": 627.5792266,
  "hel_perins": 0.790143543,
  "hel_perunin": 0.209646522,
  "hel_clincap": 0.263927983,
  "hel_groccap": 0.527855966,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 6,
  "ci_index": 50,
  "eci_index": 15,
  "edi_index": 77,
  "fi_index": 55,
  "hi_index": 12,
  "cri_index": 31,
  "ci_weight": 50,
  "eci_weight": 15,
  "edi_weight": 77,
  "fi_weight": 55,
  "hi_weight": 12,
  "cri_weight": 26,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 98,
  "TEA": 277,
  "SLN": 277,
  "SCHOOLNAME": "Tolbert Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4000 Blue Ridge Rd.",
  "CITY": "Dallas",
  "ZIP": 75233,
  "PHONE": 9727945900,
  "WEBSITE": "http://www.dallasisd.org/tolbert",
  "POINT_X": -96.88790904,
  "POINT_Y": 32.69912321,
  "MasterID": "'057905277",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 46419,
  "dem_popwh": 3383,
  "dem_popbl": 12028,
  "dem_popas": 27,
  "dem_pophi": 30088,
  "dem_popm": 22247,
  "dem_popf": 24158,
  "dem_thh": 14183,
  "dem_popse": 4327,
  "dem_popch": 14168,
  "dem_perwh": 0.07287964,
  "dem_perbl": 0.259118034,
  "dem_peras": 0.000581658,
  "dem_perhi": 0.648182856,
  "dem_perm": 0.479264956,
  "dem_perf": 0.520433443,
  "dem_perse": 0.09321614,
  "dem_perch": 0.305219845,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.655356922,
  "comm_bvp": 0.11477888,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.005255191,
  "comm_juvcrimecap": 212.6564586,
  "comm_libcap": 0,
  "comm_ltbvp": 0.104504663,
  "comm_ltrvp": 0.017676962,
  "comm_ocb": 1704.913358,
  "comm_ocbp": 0.266072328,
  "comm_parkcap": 0.074825367,
  "comm_rcb": 3924.664726,
  "comm_rcbp": 0.504400064,
  "comm_rvp": 0.018945722,
  "comm_u18bbp": 0.658056966,
  "comm_evrate": 238.7406447,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.303603367,
  "econ_fincap": 1.088152437,
  "econ_medinc": 24443.80214,
  "econ_paydaycap": 0.652891462,
  "econ_pctlwjobs": 0.161529126,
  "econ_pctmwjobs": 0.386043689,
  "econ_totjobs": 16480,
  "econ_pr": 0.231938998,
  "econ_pyr": 0.358356441,
  "econ_ur": 0.078146003,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 765.6138929,
  "edu_perbach": 0.069743859,
  "edu_perearlyed": 0.551804424,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.665967755,
  "fam_lcckids": 5.665967755,
  "fam_tphh": 2603.944911,
  "fam_tphhpct": 0.514382661,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3407.208436,
  "hel_castthma": 973.5356554,
  "hel_checkup": 6477.817401,
  "hel_fruitsveggies": 360.1136406,
  "hel_le": 77.2684142,
  "hel_mhlth": 1635.731468,
  "hel_obesity": 3784.633408,
  "hel_perpri": 0.429901886,
  "hel_perpub": 0.329752442,
  "hel_prtopu": 1.303711002,
  "hel_pharmacap": 1.523413412,
  "hel_phlth": 1559.61271,
  "hel_sleep": 3619.701424,
  "hel_stroke": 362.9403751,
  "hel_perins": 0.7250222,
  "hel_perunin": 0.274652921,
  "hel_clincap": 0.435260975,
  "hel_groccap": 0.435260975,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 27,
  "ci_index": 38,
  "eci_index": 35,
  "edi_index": 64,
  "fi_index": 54,
  "hi_index": 29,
  "cri_index": 40,
  "ci_weight": 38,
  "eci_weight": 35,
  "edi_weight": 64,
  "fi_weight": 54,
  "hi_weight": 29,
  "cri_weight": 33,
  "ci_weight_sd": 1,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 99,
  "TEA": 219,
  "SLN": 219,
  "SCHOOLNAME": "Turner Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5505 S. Polk St.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727946300,
  "WEBSITE": "http://www.dallasisd.org/turner",
  "POINT_X": -96.8423843,
  "POINT_Y": 32.67845316,
  "MasterID": "'057905219",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 51875,
  "dem_popwh": 3804,
  "dem_popbl": 30969,
  "dem_popas": 15,
  "dem_pophi": 16165,
  "dem_popm": 23791,
  "dem_popf": 28072,
  "dem_thh": 18008,
  "dem_popse": 7249,
  "dem_popch": 14887,
  "dem_perwh": 0.07333012,
  "dem_perbl": 0.596992771,
  "dem_peras": 0.000289157,
  "dem_perhi": 0.311614458,
  "dem_perm": 0.458621687,
  "dem_perf": 0.541146988,
  "dem_perse": 0.139739759,
  "dem_perch": 0.286978313,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.624963774,
  "comm_bvp": 0.104494174,
  "comm_cctrcap": 0.784899035,
  "comm_incarpct": 0.0083496,
  "comm_juvcrimecap": 280.4777754,
  "comm_libcap": 0.196224759,
  "comm_ltbvp": 0.103447573,
  "comm_ltrvp": 0.010736611,
  "comm_ocb": 2247.754208,
  "comm_ocbp": 0.270962821,
  "comm_parkcap": 0.097608183,
  "comm_rcb": 5432.582806,
  "comm_rcbp": 0.558603819,
  "comm_rvp": 0.011621724,
  "comm_u18bbp": 0.640986174,
  "comm_evrate": 221.7339774,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.444084401,
  "econ_fincap": 1.373573311,
  "econ_medinc": 23309.57865,
  "econ_paydaycap": 0.588674276,
  "econ_pctlwjobs": 0.321780372,
  "econ_pctmwjobs": 0.382707041,
  "econ_totjobs": 5482,
  "econ_pr": 0.29874369,
  "econ_pyr": 0.355953287,
  "econ_ur": 0.077742909,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 2063.00147,
  "edu_perbach": 0.097958145,
  "edu_perearlyed": 0.455238095,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 16.92094382,
  "fam_lcckids": 21.65880809,
  "fam_tphh": 1878.510447,
  "fam_tphhpct": 0.374097422,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4356.934359,
  "hel_castthma": 1120.650515,
  "hel_checkup": 7288.304609,
  "hel_fruitsveggies": 353.4753107,
  "hel_le": 74.79139908,
  "hel_mhlth": 1625.664248,
  "hel_obesity": 4220.16412,
  "hel_perpri": 0.415893989,
  "hel_perpub": 0.424721836,
  "hel_prtopu": 0.979214991,
  "hel_pharmacap": 1.177348553,
  "hel_phlth": 1623.390625,
  "hel_sleep": 3963.953097,
  "hel_stroke": 503.3903695,
  "hel_perins": 0.786895379,
  "hel_perunin": 0.212950085,
  "hel_clincap": 0.196224759,
  "hel_groccap": 0.392449518,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 14,
  "ci_index": 58,
  "eci_index": 13,
  "edi_index": 60,
  "fi_index": 56,
  "hi_index": 21,
  "cri_index": 36,
  "ci_weight": 58,
  "eci_weight": 13,
  "edi_weight": 60,
  "fi_weight": 56,
  "hi_weight": 21,
  "cri_weight": 30,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 100,
  "TEA": 225,
  "SLN": 225,
  "SCHOOLNAME": "Webster Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3815 S. Franklin St.",
  "CITY": "Dallas",
  "ZIP": 75233,
  "PHONE": 9727946100,
  "WEBSITE": "http://www.dallasisd.org/webster",
  "POINT_X": -96.86153589,
  "POINT_Y": 32.69679112,
  "MasterID": "'057905225",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 58406,
  "dem_popwh": 4314,
  "dem_popbl": 21583,
  "dem_popas": 25,
  "dem_pophi": 31441,
  "dem_popm": 27941,
  "dem_popf": 30434,
  "dem_thh": 18854,
  "dem_popse": 6338,
  "dem_popch": 17759,
  "dem_perwh": 0.073862274,
  "dem_perbl": 0.369533952,
  "dem_peras": 0.000428038,
  "dem_perhi": 0.538317981,
  "dem_perm": 0.478392631,
  "dem_perf": 0.521076602,
  "dem_perse": 0.108516248,
  "dem_perch": 0.304061227,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.706286605,
  "comm_bvp": 0.106723743,
  "comm_cctrcap": 0.347001912,
  "comm_incarpct": 0.006173109,
  "comm_juvcrimecap": 229.3267885,
  "comm_libcap": 0.173500956,
  "comm_ltbvp": 0.105449739,
  "comm_ltrvp": 0.017273424,
  "comm_ocb": 2081.612029,
  "comm_ocbp": 0.239484447,
  "comm_parkcap": 0.13873354,
  "comm_rcb": 5356.913691,
  "comm_rcbp": 0.526377664,
  "comm_rvp": 0.018069763,
  "comm_u18bbp": 0.729209324,
  "comm_evrate": 260.8586875,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.356799766,
  "econ_fincap": 1.735009561,
  "econ_medinc": 24676.89712,
  "econ_paydaycap": 1.214506693,
  "econ_pctlwjobs": 0.254517611,
  "econ_pctmwjobs": 0.409290454,
  "econ_totjobs": 9795,
  "econ_pr": 0.253483961,
  "econ_pyr": 0.462075891,
  "econ_ur": 0.084430948,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1161.479894,
  "edu_perbach": 0.09576844,
  "edu_perearlyed": 0.500858369,
  "edu_qeckids": 0.567683232,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 10.78598142,
  "fam_lcckids": 14.19208081,
  "fam_tphh": 2922.578594,
  "fam_tphhpct": 0.472908585,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3806.276736,
  "hel_castthma": 1026.678325,
  "hel_checkup": 6858.855742,
  "hel_fruitsveggies": 347.0650786,
  "hel_le": 76.73423576,
  "hel_mhlth": 1629.675232,
  "hel_obesity": 3981.214246,
  "hel_perpri": 0.423346891,
  "hel_perpub": 0.3686008,
  "hel_prtopu": 1.148524071,
  "hel_pharmacap": 1.561508605,
  "hel_phlth": 1593.763614,
  "hel_sleep": 3761.796066,
  "hel_stroke": 419.2277847,
  "hel_perins": 0.754964046,
  "hel_perunin": 0.244606909,
  "hel_clincap": 0.347001912,
  "hel_groccap": 0.694003824,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 21,
  "ci_index": 58,
  "eci_index": 23,
  "edi_index": 72,
  "fi_index": 75,
  "hi_index": 23,
  "cri_index": 41,
  "ci_weight": 58,
  "eci_weight": 23,
  "edi_weight": 72,
  "fi_weight": 75,
  "hi_weight": 23,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 101,
  "TEA": 274,
  "SLN": 274,
  "SCHOOLNAME": "Bethune Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1665 Duncanville Rd.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725021300,
  "WEBSITE": "http://www.dallasisd.org/bethune",
  "POINT_X": -96.90978046,
  "POINT_Y": 32.72659121,
  "MasterID": "'057905274",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 46839,
  "dem_popwh": 2505,
  "dem_popbl": 5106,
  "dem_popas": 31,
  "dem_pophi": 38548,
  "dem_popm": 23021,
  "dem_popf": 23799,
  "dem_thh": 12841,
  "dem_popse": 3794,
  "dem_popch": 14616,
  "dem_perwh": 0.053481073,
  "dem_perbl": 0.109011721,
  "dem_peras": 0.000661842,
  "dem_perhi": 0.822989389,
  "dem_perm": 0.491492133,
  "dem_perf": 0.508102223,
  "dem_perse": 0.081000875,
  "dem_perch": 0.312047653,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.608290551,
  "comm_bvp": 0.075823795,
  "comm_cctrcap": 0.43042116,
  "comm_incarpct": 0.005700518,
  "comm_juvcrimecap": 169.915118,
  "comm_libcap": 0.21521058,
  "comm_ltbvp": 0.068196552,
  "comm_ltrvp": 0.015767305,
  "comm_ocb": 1734.914724,
  "comm_ocbp": 0.26893957,
  "comm_parkcap": 0.115861271,
  "comm_rcb": 2880.339905,
  "comm_rcbp": 0.450244655,
  "comm_rvp": 0.01712448,
  "comm_u18bbp": 0.590865791,
  "comm_evrate": 92.21773354,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.309578676,
  "econ_fincap": 0.64563174,
  "econ_medinc": 22739.2572,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.177463461,
  "econ_pctmwjobs": 0.41612447,
  "econ_totjobs": 10605,
  "econ_pr": 0.221773777,
  "econ_pyr": 0.161311451,
  "econ_ur": 0.056759624,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 418.8092619,
  "edu_perbach": 0.042138957,
  "edu_perearlyed": 0.364620939,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.750799749,
  "fam_lcckids": 4.813899562,
  "fam_tphh": 2913.064065,
  "fam_tphhpct": 0.590102731,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3153.729075,
  "hel_castthma": 935.6272358,
  "hel_checkup": 6295.34107,
  "hel_fruitsveggies": 352.1826431,
  "hel_le": 77.48115651,
  "hel_mhlth": 1729.697697,
  "hel_obesity": 3785.128499,
  "hel_perpri": 0.398448715,
  "hel_perpub": 0.325319792,
  "hel_prtopu": 1.224790885,
  "hel_pharmacap": 0.64563174,
  "hel_phlth": 1623.968311,
  "hel_sleep": 3602.275576,
  "hel_stroke": 319.4380241,
  "hel_perins": 0.697242399,
  "hel_perunin": 0.302736174,
  "hel_clincap": 0.21521058,
  "hel_groccap": 0.86084232,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 66,
  "eci_index": 42,
  "edi_index": 56,
  "fi_index": 51,
  "hi_index": 30,
  "cri_index": 43,
  "ci_weight": 66,
  "eci_weight": 42,
  "edi_weight": 56,
  "fi_weight": 51,
  "hi_weight": 30,
  "cri_weight": 42,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 102,
  "TEA": 236,
  "SLN": 236,
  "SCHOOLNAME": "Cochran Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6000 Keeneland Pkwy.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727944600,
  "WEBSITE": "http://www.dallasisd.org/cochran",
  "POINT_X": -96.9252509,
  "POINT_Y": 32.73548407,
  "MasterID": "'057905236",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 24409,
  "dem_popwh": 1472,
  "dem_popbl": 2999,
  "dem_popas": 29,
  "dem_pophi": 19526,
  "dem_popm": 12044,
  "dem_popf": 12365,
  "dem_thh": 6983,
  "dem_popse": 1820,
  "dem_popch": 7848,
  "dem_perwh": 0.060305625,
  "dem_perbl": 0.122864517,
  "dem_peras": 0.001188086,
  "dem_perhi": 0.799950838,
  "dem_perm": 0.493424557,
  "dem_perf": 0.506575443,
  "dem_perse": 0.074562661,
  "dem_perch": 0.321520751,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.592326115,
  "comm_bvp": 0.080476952,
  "comm_cctrcap": 0.412376087,
  "comm_incarpct": 0.011369554,
  "comm_juvcrimecap": 190.0436592,
  "comm_libcap": 0.412376087,
  "comm_ltbvp": 0.072945802,
  "comm_ltrvp": 0.021325485,
  "comm_ocb": 889.8269235,
  "comm_ocbp": 0.286787843,
  "comm_parkcap": 0.173641161,
  "comm_rcb": 1729.289375,
  "comm_rcbp": 0.445626004,
  "comm_rvp": 0.023765974,
  "comm_u18bbp": 0.571324906,
  "comm_evrate": 99.58882512,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.377102732,
  "econ_fincap": 0.412376087,
  "econ_medinc": 22213.21303,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.188250273,
  "econ_pctmwjobs": 0.510913059,
  "econ_totjobs": 5498,
  "econ_pr": 0.25675779,
  "econ_pyr": 0.137210612,
  "econ_ur": 0.056628009,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 907.4800334,
  "edu_perbach": 0.044636958,
  "edu_perearlyed": 0.268221574,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.834422676,
  "fam_lcckids": 6.390704461,
  "fam_tphh": 1565.878055,
  "fam_tphhpct": 0.564159749,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3116.725756,
  "hel_castthma": 953.2249392,
  "hel_checkup": 6279.280742,
  "hel_fruitsveggies": 347.0027105,
  "hel_le": 76.54220913,
  "hel_mhlth": 1768.227923,
  "hel_obesity": 3805.807638,
  "hel_perpri": 0.388770317,
  "hel_perpub": 0.33881957,
  "hel_prtopu": 1.147425803,
  "hel_pharmacap": 0.802903508,
  "hel_phlth": 1618.592467,
  "hel_sleep": 3633.948509,
  "hel_stroke": 312.3477591,
  "hel_perins": 0.707026761,
  "hel_perunin": 0.292932195,
  "hel_clincap": 0.401451754,
  "hel_groccap": 0.802903508,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 32,
  "ci_index": 68,
  "eci_index": 42,
  "edi_index": 46,
  "fi_index": 59,
  "hi_index": 30,
  "cri_index": 42,
  "ci_weight": 68,
  "eci_weight": 42,
  "edi_weight": 46,
  "fi_weight": 59,
  "hi_weight": 30,
  "cri_weight": 42,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 103,
  "TEA": 164,
  "SLN": 164,
  "SCHOOLNAME": "Jones Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3901 Meredith Ave.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9727944700,
  "WEBSITE": "http://www.dallasisd.org/jones",
  "POINT_X": -96.88483017,
  "POINT_Y": 32.74291973,
  "MasterID": "'057905164",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 70226,
  "dem_popwh": 5177,
  "dem_popbl": 4304,
  "dem_popas": 96,
  "dem_pophi": 59919,
  "dem_popm": 36381,
  "dem_popf": 33832,
  "dem_thh": 19840,
  "dem_popse": 5655,
  "dem_popch": 21400,
  "dem_perwh": 0.073719135,
  "dem_perbl": 0.061287842,
  "dem_peras": 0.001367015,
  "dem_perhi": 0.853230997,
  "dem_perm": 0.518055991,
  "dem_perf": 0.481758893,
  "dem_perse": 0.080525731,
  "dem_perch": 0.304730442,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.63918528,
  "comm_bvp": 0.070928598,
  "comm_cctrcap": 0.286169522,
  "comm_incarpct": 0.003840195,
  "comm_juvcrimecap": 169.7642091,
  "comm_libcap": 0.286169522,
  "comm_ltbvp": 0.070466348,
  "comm_ltrvp": 0.01846319,
  "comm_ocb": 2325.960668,
  "comm_ocbp": 0.227931857,
  "comm_parkcap": 0.08432891,
  "comm_rcb": 4399.667747,
  "comm_rcbp": 0.455664332,
  "comm_rvp": 0.01965815,
  "comm_u18bbp": 0.596394328,
  "comm_evrate": 97.79843417,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.354165198,
  "econ_fincap": 1.717017132,
  "econ_medinc": 23662.45251,
  "econ_paydaycap": 1.573932371,
  "econ_pctlwjobs": 0.241997439,
  "econ_pctmwjobs": 0.416742882,
  "econ_totjobs": 16401,
  "econ_pr": 0.23397854,
  "econ_pyr": 0.169500529,
  "econ_ur": 0.056334872,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 753.1610815,
  "edu_perbach": 0.063675404,
  "edu_perearlyed": 0.360160966,
  "edu_qeckids": 0.470725676,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 6.119433787,
  "fam_lcckids": 8.002336491,
  "fam_tphh": 4678.29603,
  "fam_tphhpct": 0.644001527,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3102.732712,
  "hel_castthma": 904.8901864,
  "hel_checkup": 6235.756142,
  "hel_fruitsveggies": 348.4717948,
  "hel_le": 77.91469021,
  "hel_mhlth": 1693.549856,
  "hel_obesity": 3743.646794,
  "hel_perpri": 0.394559475,
  "hel_perpub": 0.325660431,
  "hel_prtopu": 1.211567131,
  "hel_pharmacap": 1.717017132,
  "hel_phlth": 1614.815146,
  "hel_sleep": 3537.896177,
  "hel_stroke": 310.6547711,
  "hel_perins": 0.695473369,
  "hel_perunin": 0.304369556,
  "hel_clincap": 0.572339044,
  "hel_groccap": 1.144678088,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 61,
  "eci_index": 35,
  "edi_index": 63,
  "fi_index": 91,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 61,
  "eci_weight": 35,
  "edi_weight": 63,
  "fi_weight": 91,
  "hi_weight": 32,
  "cri_weight": 44,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 104,
  "TEA": 287,
  "SLN": 287,
  "SCHOOLNAME": "Soto Jr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4510 West Jefferson Blvd.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725025100,
  "WEBSITE": "http://www.dallasisd.org/soto",
  "POINT_X": -96.8944364,
  "POINT_Y": 32.73587915,
  "MasterID": "'057905287",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 64676,
  "dem_popwh": 4056,
  "dem_popbl": 4892,
  "dem_popas": 66,
  "dem_pophi": 54884,
  "dem_popm": 32588,
  "dem_popf": 32080,
  "dem_thh": 18016,
  "dem_popse": 5243,
  "dem_popch": 19892,
  "dem_perwh": 0.062712598,
  "dem_perbl": 0.075638568,
  "dem_peras": 0.001020471,
  "dem_perhi": 0.848599171,
  "dem_perm": 0.503865421,
  "dem_perf": 0.496010885,
  "dem_perse": 0.081065619,
  "dem_perch": 0.307563857,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.613658633,
  "comm_bvp": 0.066196137,
  "comm_cctrcap": 0.310804453,
  "comm_incarpct": 0.004193809,
  "comm_juvcrimecap": 168.143907,
  "comm_libcap": 0.310804453,
  "comm_ltbvp": 0.065454784,
  "comm_ltrvp": 0.016176316,
  "comm_ocb": 2267.127588,
  "comm_ocbp": 0.24695791,
  "comm_parkcap": 0.094606221,
  "comm_rcb": 3986.29183,
  "comm_rcbp": 0.450507908,
  "comm_rvp": 0.01736261,
  "comm_u18bbp": 0.581873341,
  "comm_evrate": 83.06249019,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.336987027,
  "econ_fincap": 1.087815587,
  "econ_medinc": 23288.56621,
  "econ_paydaycap": 0.93241336,
  "econ_pctlwjobs": 0.267578125,
  "econ_pctmwjobs": 0.463378906,
  "econ_totjobs": 10240,
  "econ_pr": 0.23164804,
  "econ_pyr": 0.164837493,
  "econ_ur": 0.053303394,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 491.8113362,
  "edu_perbach": 0.050992342,
  "edu_perearlyed": 0.389298893,
  "edu_qeckids": 0.50493977,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.029638621,
  "fam_lcckids": 4.544457932,
  "fam_tphh": 4235.544364,
  "fam_tphhpct": 0.628718812,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3103.471109,
  "hel_castthma": 916.1430213,
  "hel_checkup": 6238.858245,
  "hel_fruitsveggies": 343.80664,
  "hel_le": 78.18529332,
  "hel_mhlth": 1714.080855,
  "hel_obesity": 3756.277931,
  "hel_perpri": 0.396334745,
  "hel_perpub": 0.326179725,
  "hel_prtopu": 1.215080875,
  "hel_pharmacap": 1.087815587,
  "hel_phlth": 1622.436358,
  "hel_sleep": 3562.452202,
  "hel_stroke": 312.002535,
  "hel_perins": 0.697081141,
  "hel_perunin": 0.302670577,
  "hel_clincap": 0.310804453,
  "hel_groccap": 0.93241336,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 63,
  "eci_index": 36,
  "edi_index": 64,
  "fi_index": 64,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 63,
  "eci_weight": 36,
  "edi_weight": 64,
  "fi_weight": 64,
  "hi_weight": 32,
  "cri_weight": 43,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 105,
  "TEA": 114,
  "SLN": 114,
  "SCHOOLNAME": "Bryan Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2001 Deer Path Dr.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9725028500,
  "WEBSITE": "http://www.dallasisd.org/bryan",
  "POINT_X": -96.79500526,
  "POINT_Y": 32.71158036,
  "MasterID": "'057905114",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 56508,
  "dem_popwh": 1459,
  "dem_popbl": 30006,
  "dem_popas": 69,
  "dem_pophi": 24560,
  "dem_popm": 26928,
  "dem_popf": 29580,
  "dem_thh": 18802,
  "dem_popse": 7151,
  "dem_popch": 16580,
  "dem_perwh": 0.025819353,
  "dem_perbl": 0.53100446,
  "dem_peras": 0.001221066,
  "dem_perhi": 0.434628725,
  "dem_perm": 0.476534296,
  "dem_perf": 0.523465704,
  "dem_perse": 0.126548453,
  "dem_perch": 0.293409783,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.509381537,
  "comm_bvp": 0.136555747,
  "comm_cctrcap": 0.8897253,
  "comm_incarpct": 0.014297179,
  "comm_juvcrimecap": 491.9916867,
  "comm_libcap": 0.17794506,
  "comm_ltbvp": 0.129380765,
  "comm_ltrvp": 0.082268741,
  "comm_ocb": 2640.561975,
  "comm_ocbp": 0.285745071,
  "comm_parkcap": 0.092020641,
  "comm_rcb": 5240.596729,
  "comm_rcbp": 0.547110408,
  "comm_rvp": 0.090025023,
  "comm_u18bbp": 0.572755934,
  "comm_evrate": 210.5090059,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.446626043,
  "econ_fincap": 1.24561542,
  "econ_medinc": 18578.79889,
  "econ_paydaycap": 0.71178024,
  "econ_pctlwjobs": 0.350850547,
  "econ_pctmwjobs": 0.368772783,
  "econ_totjobs": 3292,
  "econ_pr": 0.337313849,
  "econ_pyr": 0.4550045,
  "econ_ur": 0.096767441,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1431.376783,
  "edu_perbach": 0.050605536,
  "edu_perearlyed": 0.419739081,
  "edu_qeckids": 3.036437809,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 17.61133929,
  "fam_lcckids": 16.39676417,
  "fam_tphh": 2352.398366,
  "fam_tphhpct": 0.464943305,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4775.916944,
  "hel_castthma": 1166.440455,
  "hel_checkup": 7235.932863,
  "hel_fruitsveggies": 274.8119615,
  "hel_le": 71.67789197,
  "hel_mhlth": 1841.154676,
  "hel_obesity": 4567.654894,
  "hel_perpri": 0.27403019,
  "hel_perpub": 0.476045196,
  "hel_prtopu": 0.575639019,
  "hel_pharmacap": 1.42356048,
  "hel_phlth": 2015.361951,
  "hel_sleep": 4146.612957,
  "hel_stroke": 671.3434031,
  "hel_perins": 0.722759281,
  "hel_perunin": 0.277134292,
  "hel_clincap": 0.17794506,
  "hel_groccap": 0.71178024,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 4,
  "ci_index": 16,
  "eci_index": 1,
  "edi_index": 74,
  "fi_index": 80,
  "hi_index": 3,
  "cri_index": 17,
  "ci_weight": 16,
  "eci_weight": 1,
  "edi_weight": 74,
  "fi_weight": 80,
  "hi_weight": 3,
  "cri_weight": 10,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 106,
  "TEA": 115,
  "SLN": 115,
  "SCHOOLNAME": "Budd Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2121 S. Marsalis Ave.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9725028400,
  "WEBSITE": "http://www.dallasisd.org/budd",
  "POINT_X": -96.81514418,
  "POINT_Y": 32.72206527,
  "MasterID": "'057905115",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 70872,
  "dem_popwh": 3677,
  "dem_popbl": 22561,
  "dem_popas": 47,
  "dem_pophi": 43911,
  "dem_popm": 35126,
  "dem_popf": 35727,
  "dem_thh": 21282,
  "dem_popse": 7312,
  "dem_popch": 22153,
  "dem_perwh": 0.051882267,
  "dem_perbl": 0.318334462,
  "dem_peras": 0.000663167,
  "dem_perhi": 0.619581781,
  "dem_perm": 0.495625917,
  "dem_perf": 0.504105994,
  "dem_perse": 0.103171916,
  "dem_perch": 0.312577605,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.680022105,
  "comm_bvp": 0.150589102,
  "comm_cctrcap": 0.285103269,
  "comm_incarpct": 0.00876221,
  "comm_juvcrimecap": 317.7439558,
  "comm_libcap": 0.285103269,
  "comm_ltbvp": 0.139795636,
  "comm_ltrvp": 0.048770844,
  "comm_ocb": 2954.510836,
  "comm_ocbp": 0.270279901,
  "comm_parkcap": 0.077591283,
  "comm_rcb": 5350.689059,
  "comm_rcbp": 0.515919075,
  "comm_rvp": 0.053403465,
  "comm_u18bbp": 0.745325098,
  "comm_evrate": 126.372024,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.385324826,
  "econ_fincap": 1.282964711,
  "econ_medinc": 20676.13332,
  "econ_paydaycap": 2.708481056,
  "econ_pctlwjobs": 0.296759792,
  "econ_pctmwjobs": 0.432320909,
  "econ_totjobs": 14783,
  "econ_pr": 0.284918286,
  "econ_pyr": 0.539356139,
  "econ_ur": 0.102709035,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1536.405104,
  "edu_perbach": 0.07252758,
  "edu_perearlyed": 0.48188711,
  "edu_qeckids": 2.28563687,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 11.42818435,
  "fam_lcckids": 14.17094859,
  "fam_tphh": 3729.425641,
  "fam_tphhpct": 0.527673717,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4073.623721,
  "hel_castthma": 1046.033801,
  "hel_checkup": 6821.2941,
  "hel_fruitsveggies": 297.7756571,
  "hel_le": 73.59550754,
  "hel_mhlth": 1753.150298,
  "hel_obesity": 4208.750876,
  "hel_perpri": 0.319940055,
  "hel_perpub": 0.421874116,
  "hel_prtopu": 0.758378016,
  "hel_pharmacap": 1.995722884,
  "hel_phlth": 1826.041372,
  "hel_sleep": 3885.570783,
  "hel_stroke": 517.5941461,
  "hel_perins": 0.717595996,
  "hel_perunin": 0.282418142,
  "hel_clincap": 0.570206538,
  "hel_groccap": 1.282964711,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 3,
  "hi_gen": 15,
  "ci_index": 49,
  "eci_index": 18,
  "edi_index": 76,
  "fi_index": 83,
  "hi_index": 12,
  "cri_index": 37,
  "ci_weight": 49,
  "eci_weight": 18,
  "edi_weight": 76,
  "fi_weight": 83,
  "hi_weight": 12,
  "cri_weight": 28,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 107,
  "TEA": 118,
  "SLN": 118,
  "SCHOOLNAME": "Bushman Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4200 Bonnie View Rd.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9727491800,
  "WEBSITE": "http://www.dallasisd.org/bushman",
  "POINT_X": -96.77364368,
  "POINT_Y": 32.70842776,
  "MasterID": "'057905118",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 34503,
  "dem_popwh": 684,
  "dem_popbl": 22658,
  "dem_popas": 43,
  "dem_pophi": 10726,
  "dem_popm": 15785,
  "dem_popf": 18724,
  "dem_thh": 12625,
  "dem_popse": 4377,
  "dem_popch": 9768,
  "dem_perwh": 0.019824363,
  "dem_perbl": 0.656696519,
  "dem_peras": 0.001246268,
  "dem_perhi": 0.310871518,
  "dem_perm": 0.45749645,
  "dem_perf": 0.542677448,
  "dem_perse": 0.126858534,
  "dem_perch": 0.283105817,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.438113791,
  "comm_bvp": 0.120871562,
  "comm_cctrcap": 1.161673761,
  "comm_incarpct": 0.021635325,
  "comm_juvcrimecap": 657.7141265,
  "comm_libcap": 0.29041844,
  "comm_ltbvp": 0.115512047,
  "comm_ltrvp": 0.124414226,
  "comm_ocb": 1535.1637,
  "comm_ocbp": 0.276834354,
  "comm_parkcap": 0.259307959,
  "comm_rcb": 3851.901116,
  "comm_rcbp": 0.542966631,
  "comm_rvp": 0.131637036,
  "comm_u18bbp": 0.482984586,
  "comm_evrate": 299.7118304,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.489452337,
  "econ_fincap": 2.323347522,
  "econ_medinc": 17647.44668,
  "econ_paydaycap": 1.161673761,
  "econ_pctlwjobs": 0.28108445,
  "econ_pctmwjobs": 0.331255843,
  "econ_totjobs": 3209,
  "econ_pr": 0.371757028,
  "econ_pyr": 0.344313745,
  "econ_ur": 0.093237406,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1462.501541,
  "edu_perbach": 0.042160311,
  "edu_perearlyed": 0.382867133,
  "edu_qeckids": 3.074635335,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 19.47269046,
  "fam_lcckids": 14.34829823,
  "fam_tphh": 1008.811744,
  "fam_tphhpct": 0.318370757,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 5013.888781,
  "hel_castthma": 1224.286894,
  "hel_checkup": 7414.207669,
  "hel_fruitsveggies": 260.9991956,
  "hel_le": 70.67848016,
  "hel_mhlth": 1896.220356,
  "hel_obesity": 4735.433987,
  "hel_perpri": 0.265443372,
  "hel_perpub": 0.492564571,
  "hel_prtopu": 0.538900659,
  "hel_pharmacap": 1.742510642,
  "hel_phlth": 2062.271861,
  "hel_sleep": 4274.062248,
  "hel_stroke": 717.6355562,
  "hel_perins": 0.739049772,
  "hel_perunin": 0.260747311,
  "hel_clincap": 0,
  "hel_groccap": 0.871255321,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 0,
  "ci_index": 0,
  "eci_index": 4,
  "edi_index": 69,
  "fi_index": 31,
  "hi_index": 0,
  "cri_index": 1,
  "ci_weight": 0,
  "eci_weight": 4,
  "edi_weight": 69,
  "fi_weight": 31,
  "hi_weight": 0,
  "cri_weight": 0,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 108,
  "TEA": 6,
  "SLN": 6,
  "SCHOOLNAME": "Hillcrest High School",
  "LEVEL": "High",
  "ADDRESS": "9924 Hillcrest Rd.",
  "CITY": "Dallas",
  "ZIP": 75230,
  "PHONE": 9725026800,
  "WEBSITE": "http://www.dallasisd.org/hillcrest",
  "POINT_X": -96.78462338,
  "POINT_Y": 32.88315319,
  "MasterID": "'057905006",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 56623,
  "dem_popwh": 35657,
  "dem_popbl": 6210,
  "dem_popas": 38,
  "dem_pophi": 9113,
  "dem_popm": 27179,
  "dem_popf": 29438,
  "dem_thh": 25363,
  "dem_popse": 9355,
  "dem_popch": 11906,
  "dem_perwh": 0.629726436,
  "dem_perbl": 0.109672748,
  "dem_peras": 0.000671105,
  "dem_perhi": 0.160941667,
  "dem_perm": 0.479999294,
  "dem_perf": 0.519894742,
  "dem_perse": 0.165215548,
  "dem_perch": 0.210267912,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.868245231,
  "comm_bvp": 0.105182767,
  "comm_cctrcap": 0.356942731,
  "comm_incarpct": 0.001916332,
  "comm_juvcrimecap": 163.1308066,
  "comm_libcap": 0.535414097,
  "comm_ltbvp": 0.082097965,
  "comm_ltrvp": 0.009724457,
  "comm_ocb": 3385.293026,
  "comm_ocbp": 0.292013769,
  "comm_parkcap": 0.069785064,
  "comm_rcb": 6253.317025,
  "comm_rcbp": 0.454132816,
  "comm_rvp": 0.012305196,
  "comm_u18bbp": 0.872204501,
  "comm_evrate": 127.9639692,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.200692194,
  "econ_fincap": 8.209682822,
  "econ_medinc": 67783.13703,
  "econ_paydaycap": 1.24929956,
  "econ_pctlwjobs": 0.226711996,
  "econ_pctmwjobs": 0.294042415,
  "econ_totjobs": 61770,
  "econ_pr": 0.128397048,
  "econ_pyr": 0.168465678,
  "econ_ur": 0.036040289,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1611.356324,
  "edu_perbach": 0.361871889,
  "edu_perearlyed": 0.513380282,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.686401176,
  "fam_lcckids": 16.86401176,
  "fam_tphh": 4854.651563,
  "fam_tphhpct": 0.768476872,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2806.815791,
  "hel_castthma": 737.0275177,
  "hel_checkup": 6063.249728,
  "hel_fruitsveggies": 479.9811965,
  "hel_le": 80.87508809,
  "hel_mhlth": 1030.426564,
  "hel_obesity": 2535.810377,
  "hel_perpri": 0.720151318,
  "hel_perpub": 0.249549437,
  "hel_prtopu": 2.885806221,
  "hel_pharmacap": 8.745096919,
  "hel_phlth": 973.2644791,
  "hel_sleep": 2661.923867,
  "hel_stroke": 247.4631281,
  "hel_perins": 0.870041577,
  "hel_perunin": 0.129833515,
  "hel_clincap": 1.427770925,
  "hel_groccap": 1.606242291,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 56,
  "ci_index": 74,
  "eci_index": 70,
  "edi_index": 78,
  "fi_index": 78,
  "hi_index": 66,
  "cri_index": 71,
  "ci_weight": 74,
  "eci_weight": 70,
  "edi_weight": 78,
  "fi_weight": 78,
  "hi_weight": 66,
  "cri_weight": 72,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 109,
  "TEA": 15,
  "SLN": 15,
  "SCHOOLNAME": "Seagoville High School",
  "LEVEL": "High",
  "ADDRESS": "15920 Seagoville Rd.",
  "CITY": "Dallas",
  "ZIP": 75253,
  "PHONE": 9728925900,
  "WEBSITE": "http://www.dallasisd.org/seagovillehs",
  "POINT_X": -96.58345455,
  "POINT_Y": 32.67756373,
  "MasterID": "'057905015",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 19973,
  "dem_popwh": 4685,
  "dem_popbl": 2520,
  "dem_popas": 57,
  "dem_pophi": 12439,
  "dem_popm": 10028,
  "dem_popf": 9942,
  "dem_thh": 5423,
  "dem_popse": 1149,
  "dem_popch": 7166,
  "dem_perwh": 0.234566665,
  "dem_perbl": 0.12617033,
  "dem_peras": 0.002853853,
  "dem_perhi": 0.622790768,
  "dem_perm": 0.502077805,
  "dem_perf": 0.497771992,
  "dem_perse": 0.057527662,
  "dem_perch": 0.358784359,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.791124017,
  "comm_bvp": 0.080503963,
  "comm_cctrcap": 0.507604995,
  "comm_incarpct": 0.00383532,
  "comm_juvcrimecap": 242.6509526,
  "comm_libcap": 0.507604995,
  "comm_ltbvp": 0.071298747,
  "comm_ltrvp": 0.015841677,
  "comm_ocb": 887.8608273,
  "comm_ocbp": 0.265863153,
  "comm_parkcap": 0.066181994,
  "comm_rcb": 972.4248106,
  "comm_rcbp": 0.466843054,
  "comm_rvp": 0.018750299,
  "comm_u18bbp": 0.804587865,
  "comm_evrate": 328.674234,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.292351728,
  "econ_fincap": 0,
  "econ_medinc": 23072.72934,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.234430082,
  "econ_pctmwjobs": 0.389541716,
  "econ_totjobs": 1702,
  "econ_pr": 0.218613713,
  "econ_pyr": 0.241385007,
  "econ_ur": 0.046686418,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 329.7411498,
  "edu_perbach": 0.04724699,
  "edu_perearlyed": 0.234013605,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.409150213,
  "fam_lcckids": 1.409150213,
  "fam_tphh": 1500.099324,
  "fam_tphhpct": 0.547791171,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3016.061089,
  "hel_castthma": 946.8336165,
  "hel_checkup": 6019.081974,
  "hel_fruitsveggies": 340.9826843,
  "hel_le": 75.22081188,
  "hel_mhlth": 1744.422935,
  "hel_obesity": 3641.053782,
  "hel_perpri": 0.319370668,
  "hel_perpub": 0.389082815,
  "hel_prtopu": 0.820829541,
  "hel_pharmacap": 0.858342922,
  "hel_phlth": 1554.17866,
  "hel_sleep": 3492.53454,
  "hel_stroke": 301.9714196,
  "hel_perins": 0.690038954,
  "hel_perunin": 0.309809278,
  "hel_clincap": 0.429171461,
  "hel_groccap": 0.429171461,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 65,
  "eci_index": 34,
  "edi_index": 40,
  "fi_index": 8,
  "hi_index": 28,
  "cri_index": 42,
  "ci_weight": 65,
  "eci_weight": 34,
  "edi_weight": 40,
  "fi_weight": 8,
  "hi_weight": 28,
  "cri_weight": 34,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 0,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 110,
  "TEA": 380,
  "SLN": 380,
  "SCHOOLNAME": "Wilmer-Hutchins High School",
  "LEVEL": "High",
  "ADDRESS": "5520 Langdon Rd.",
  "CITY": "Dallas",
  "ZIP": 75241,
  "PHONE": 9729252900,
  "WEBSITE": "http://www.dallasisd.org/wilmerhutchinshs",
  "POINT_X": -96.72974612,
  "POINT_Y": 32.65659488,
  "MasterID": "'057905380",
  "Feeder": "Wilmer-Hutchins",
  "HIGH_SLN": 380,
  "dem_totp": 8902,
  "dem_popwh": 728,
  "dem_popbl": 5841,
  "dem_popas": 9,
  "dem_pophi": 2112,
  "dem_popm": 4569,
  "dem_popf": 4333,
  "dem_thh": 2632,
  "dem_popse": 1027,
  "dem_popch": 2392,
  "dem_perwh": 0.081779375,
  "dem_perbl": 0.656144687,
  "dem_peras": 0.001011009,
  "dem_perhi": 0.237250056,
  "dem_perm": 0.513255448,
  "dem_perf": 0.486744552,
  "dem_perse": 0.115367333,
  "dem_perch": 0.268703662,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.636917681,
  "comm_bvp": 0.054609348,
  "comm_cctrcap": 2.534049494,
  "comm_incarpct": 0.018566507,
  "comm_juvcrimecap": 264.0491765,
  "comm_libcap": 1.267024747,
  "comm_ltbvp": 0.049356297,
  "comm_ltrvp": 0.027604292,
  "comm_ocb": 454.086479,
  "comm_ocbp": 0.268831944,
  "comm_parkcap": 0.077733271,
  "comm_rcb": 442.5456171,
  "comm_rcbp": 0.468889406,
  "comm_rvp": 0.030707838,
  "comm_u18bbp": 0.633554732,
  "comm_evrate": 108.9641283,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.374730437,
  "econ_fincap": 0,
  "econ_medinc": 19929.19753,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.284155986,
  "econ_pctmwjobs": 0.37251159,
  "econ_totjobs": 3667,
  "econ_pr": 0.24419282,
  "econ_pyr": 0.343817573,
  "econ_ur": 0.088731662,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1186.463642,
  "edu_perbach": 0.06557952,
  "edu_perearlyed": 0.388888889,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 8.660318557,
  "fam_lcckids": 12.99047784,
  "fam_tphh": 331.7905793,
  "fam_tphhpct": 0.397226209,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": -1,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 3997.84065,
  "hel_castthma": 893.1202248,
  "hel_checkup": 6120.494758,
  "hel_fruitsveggies": 335.3229139,
  "hel_le": 75.13770607,
  "hel_mhlth": 1227.399991,
  "hel_obesity": 3506.288192,
  "hel_perpri": 0.417088608,
  "hel_perpub": 0.421392405,
  "hel_prtopu": 0.989786723,
  "hel_pharmacap": 2.534049494,
  "hel_phlth": 1379.931896,
  "hel_sleep": 3221.375436,
  "hel_stroke": 494.018679,
  "hel_perins": 0.799367089,
  "hel_perunin": 0.200506329,
  "hel_clincap": 1.267024747,
  "hel_groccap": 0,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 83,
  "eci_index": 23,
  "edi_index": 59,
  "fi_index": 28,
  "hi_index": 32,
  "cri_index": 44,
  "ci_weight": 83,
  "eci_weight": 23,
  "edi_weight": 59,
  "fi_weight": 28,
  "hi_weight": 32,
  "cri_weight": 43,
  "ci_weight_sd": 4,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 1,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 111,
  "TEA": 23,
  "SLN": 23,
  "SCHOOLNAME": "Carter High School",
  "LEVEL": "High",
  "ADDRESS": "1819 W. Wheatland Rd.",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 2149325700,
  "WEBSITE": "http://www.dallasisd.org/carter",
  "POINT_X": -96.84862316,
  "POINT_Y": 32.6496796,
  "MasterID": "'057905023",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 39040,
  "dem_popwh": 2310,
  "dem_popbl": 25069,
  "dem_popas": 36,
  "dem_pophi": 11077,
  "dem_popm": 17598,
  "dem_popf": 21434,
  "dem_thh": 14025,
  "dem_popse": 5366,
  "dem_popch": 11351,
  "dem_perwh": 0.059170082,
  "dem_perbl": 0.64213627,
  "dem_peras": 0.000922131,
  "dem_perhi": 0.283734631,
  "dem_perm": 0.450768443,
  "dem_perf": 0.549026639,
  "dem_perse": 0.13744877,
  "dem_perch": 0.290753074,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.569484965,
  "comm_bvp": 0.110065293,
  "comm_cctrcap": 0.258106804,
  "comm_incarpct": 0.009594218,
  "comm_juvcrimecap": 376.7161938,
  "comm_libcap": 0.258106804,
  "comm_ltbvp": 0.101573756,
  "comm_ltrvp": 0.008570417,
  "comm_ocb": 1656.346032,
  "comm_ocbp": 0.302754423,
  "comm_parkcap": 0.082953757,
  "comm_rcb": 4995.96243,
  "comm_rcbp": 0.583608718,
  "comm_rvp": 0.009026776,
  "comm_u18bbp": 0.554860246,
  "comm_evrate": 322.5044518,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.440509661,
  "econ_fincap": 2.064854433,
  "econ_medinc": 21367.50878,
  "econ_paydaycap": 1.548640825,
  "econ_pctlwjobs": 0.252992347,
  "econ_pctmwjobs": 0.379423115,
  "econ_totjobs": 15289,
  "econ_pr": 0.312607863,
  "econ_pyr": 0.34497875,
  "econ_ur": 0.090502724,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1991.958404,
  "edu_perbach": 0.08490289,
  "edu_perearlyed": 0.544481054,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 18.67461004,
  "fam_lcckids": 19.56387718,
  "fam_tphh": 1233.28309,
  "fam_tphhpct": 0.317195428,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4237.29332,
  "hel_castthma": 1157.228761,
  "hel_checkup": 7141.556231,
  "hel_fruitsveggies": 311.8142334,
  "hel_le": 75.77741519,
  "hel_mhlth": 1709.706085,
  "hel_obesity": 4293.742184,
  "hel_perpri": 0.406480838,
  "hel_perpub": 0.430159833,
  "hel_prtopu": 0.944953031,
  "hel_pharmacap": 3.871602062,
  "hel_phlth": 1631.268601,
  "hel_sleep": 4028.227859,
  "hel_stroke": 478.4230308,
  "hel_perins": 0.782976862,
  "hel_perunin": 0.217151829,
  "hel_clincap": 0.516213608,
  "hel_groccap": 0.774320412,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 12,
  "ci_index": 54,
  "eci_index": 19,
  "edi_index": 65,
  "fi_index": 33,
  "hi_index": 17,
  "cri_index": 35,
  "ci_weight": 54,
  "eci_weight": 19,
  "edi_weight": 65,
  "fi_weight": 33,
  "hi_weight": 17,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 112,
  "TEA": 32,
  "SLN": 32,
  "SCHOOLNAME": "Madison High School",
  "LEVEL": "High",
  "ADDRESS": "3000 Martin Luther King Blvd.",
  "CITY": "Dallas",
  "ZIP": 75215,
  "PHONE": 9729252800,
  "WEBSITE": "http://www.dallasisd.org/madison",
  "POINT_X": -96.76486081,
  "POINT_Y": 32.77129099,
  "MasterID": "'057905032",
  "Feeder": "Madison",
  "HIGH_SLN": 32,
  "dem_totp": 43941,
  "dem_popwh": 8437,
  "dem_popbl": 19081,
  "dem_popas": 37,
  "dem_pophi": 15172,
  "dem_popm": 22545,
  "dem_popf": 21373,
  "dem_thh": 17698,
  "dem_popse": 4493,
  "dem_popch": 9373,
  "dem_perwh": 0.192007465,
  "dem_perbl": 0.434241369,
  "dem_peras": 0.000842038,
  "dem_perhi": 0.345281172,
  "dem_perm": 0.51307435,
  "dem_perf": 0.486402221,
  "dem_perse": 0.102250745,
  "dem_perch": 0.213308755,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.590885791,
  "comm_bvp": 0.090924615,
  "comm_cctrcap": 3.228758163,
  "comm_incarpct": 0.013531923,
  "comm_juvcrimecap": 865.6409337,
  "comm_libcap": 0.461251166,
  "comm_ltbvp": 0.088674678,
  "comm_ltrvp": 0.047915999,
  "comm_ocb": 1256.953135,
  "comm_ocbp": 0.261265719,
  "comm_parkcap": 0.198059525,
  "comm_rcb": 5868.698392,
  "comm_rcbp": 0.455055131,
  "comm_rvp": 0.053070996,
  "comm_u18bbp": 0.543600727,
  "comm_evrate": 404.5172727,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.454497667,
  "econ_fincap": 3.690009329,
  "econ_medinc": 23736.79053,
  "econ_paydaycap": 2.767506997,
  "econ_pctlwjobs": 0.139277706,
  "econ_pctmwjobs": 0.259818577,
  "econ_totjobs": 58868,
  "econ_pr": 0.318218673,
  "econ_pyr": 0.2792749,
  "econ_ur": 0.078172589,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 3281.481382,
  "edu_perbach": 0.16046276,
  "edu_perearlyed": 0.455341506,
  "edu_qeckids": 2.173166478,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 16.29874858,
  "fam_lcckids": 28.25116421,
  "fam_tphh": 1336.887295,
  "fam_tphhpct": 0.414695031,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4025.750428,
  "hel_castthma": 1066.854838,
  "hel_checkup": 6854.238636,
  "hel_fruitsveggies": 304.2936727,
  "hel_le": 70.89726088,
  "hel_mhlth": 1709.267078,
  "hel_obesity": 4143.02862,
  "hel_perpri": 0.376771834,
  "hel_perpub": 0.382761774,
  "hel_prtopu": 0.984350735,
  "hel_pharmacap": 6.226890742,
  "hel_phlth": 1710.286557,
  "hel_sleep": 3895.795987,
  "hel_stroke": 500.8693911,
  "hel_perins": 0.738797439,
  "hel_perunin": 0.260859625,
  "hel_clincap": 3.459383746,
  "hel_groccap": 1.383753498,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 15,
  "ci_index": 34,
  "eci_index": 41,
  "edi_index": 76,
  "fi_index": 54,
  "hi_index": 28,
  "cri_index": 42,
  "ci_weight": 34,
  "eci_weight": 41,
  "edi_weight": 76,
  "fi_weight": 54,
  "hi_weight": 28,
  "cri_weight": 34,
  "ci_weight_sd": 1,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 113,
  "TEA": 24,
  "SLN": 24,
  "SCHOOLNAME": "North Dallas High School",
  "LEVEL": "High",
  "ADDRESS": "3120 N. Haskell Ave.",
  "CITY": "Dallas",
  "ZIP": 75204,
  "PHONE": 9729251500,
  "WEBSITE": "http://www.dallasisd.org/northdallas",
  "POINT_X": -96.79568007,
  "POINT_Y": 32.80974145,
  "MasterID": "'057905024",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 102551,
  "dem_popwh": 61926,
  "dem_popbl": 9385,
  "dem_popas": 200,
  "dem_pophi": 22983,
  "dem_popm": 54211,
  "dem_popf": 48341,
  "dem_thh": 56747,
  "dem_popse": 9493,
  "dem_popch": 11878,
  "dem_perwh": 0.603855643,
  "dem_perbl": 0.091515441,
  "dem_peras": 0.001950249,
  "dem_perhi": 0.22411288,
  "dem_perm": 0.528624782,
  "dem_perf": 0.471384969,
  "dem_perse": 0.092568576,
  "dem_perch": 0.115825297,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.863059837,
  "comm_bvp": 0.104485381,
  "comm_cctrcap": 0.49135807,
  "comm_incarpct": 0.002933551,
  "comm_juvcrimecap": 228.5013332,
  "comm_libcap": 0.196543228,
  "comm_ltbvp": 0.093037965,
  "comm_ltrvp": 0.011963624,
  "comm_ocb": 4241.495793,
  "comm_ocbp": 0.258432777,
  "comm_parkcap": 0.037516894,
  "comm_rcb": 14002.71245,
  "comm_rcbp": 0.347057773,
  "comm_rvp": 0.017765577,
  "comm_u18bbp": 0.760628547,
  "comm_evrate": 209.6624883,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.300384008,
  "econ_fincap": 7.468642659,
  "econ_medinc": 55524.84108,
  "econ_paydaycap": 1.965432279,
  "econ_pctlwjobs": 0.133957573,
  "econ_pctmwjobs": 0.234494813,
  "econ_totjobs": 209962,
  "econ_pr": 0.140773851,
  "econ_pyr": 0.102360396,
  "econ_ur": 0.028902594,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1748.001537,
  "edu_perbach": 0.381663646,
  "edu_perearlyed": 0.620582765,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.977533345,
  "fam_lcckids": 23.05620005,
  "fam_tphh": 3708.293673,
  "fam_tphhpct": 0.602385553,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2116.720834,
  "hel_castthma": 731.510286,
  "hel_checkup": 5693.928333,
  "hel_fruitsveggies": 448.6341424,
  "hel_le": 79.84116282,
  "hel_mhlth": 1063.475827,
  "hel_obesity": 2548.247143,
  "hel_perpri": 0.741026294,
  "hel_perpub": 0.177847878,
  "hel_prtopu": 4.166629944,
  "hel_pharmacap": 4.422222627,
  "hel_phlth": 805.406285,
  "hel_sleep": 2799.596878,
  "hel_stroke": 161.4209824,
  "hel_perins": 0.87163486,
  "hel_perunin": 0.128208394,
  "hel_clincap": 0.884444525,
  "hel_groccap": 1.867160665,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 65,
  "ci_index": 65,
  "eci_index": 63,
  "edi_index": 90,
  "fi_index": 94,
  "hi_index": 75,
  "cri_index": 69,
  "ci_weight": 65,
  "eci_weight": 63,
  "edi_weight": 90,
  "fi_weight": 94,
  "hi_weight": 75,
  "cri_weight": 75,
  "ci_weight_sd": 3,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 114,
  "TEA": 22,
  "SLN": 22,
  "SCHOOLNAME": "Wilson High School",
  "LEVEL": "High",
  "ADDRESS": "100 S. Glasgow Dr.",
  "CITY": "Dallas",
  "ZIP": 75214,
  "PHONE": 9725024400,
  "WEBSITE": "http://www.dallasisd.org/woodrow",
  "POINT_X": -96.75149942,
  "POINT_Y": 32.80608098,
  "MasterID": "'057905022",
  "Feeder": "Wilson",
  "HIGH_SLN": 22,
  "dem_totp": 69101,
  "dem_popwh": 30600,
  "dem_popbl": 7532,
  "dem_popas": 252,
  "dem_pophi": 27673,
  "dem_popm": 35265,
  "dem_popf": 33805,
  "dem_thh": 30011,
  "dem_popse": 6149,
  "dem_popch": 14845,
  "dem_perwh": 0.44283006,
  "dem_perbl": 0.10899987,
  "dem_peras": 0.003646836,
  "dem_perhi": 0.400471773,
  "dem_perm": 0.510339937,
  "dem_perf": 0.489211444,
  "dem_perse": 0.088985688,
  "dem_perch": 0.214830466,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 4,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.787626551,
  "comm_bvp": 0.090091165,
  "comm_cctrcap": 0.581884763,
  "comm_incarpct": 0.005329207,
  "comm_juvcrimecap": 258.6760835,
  "comm_libcap": 0.145471191,
  "comm_ltbvp": 0.086317078,
  "comm_ltrvp": 0.020336776,
  "comm_ocb": 2678.661907,
  "comm_ocbp": 0.247416395,
  "comm_parkcap": 0.22326342,
  "comm_rcb": 7789.568898,
  "comm_rcbp": 0.406082309,
  "comm_rvp": 0.02499739,
  "comm_u18bbp": 0.750406697,
  "comm_evrate": 169.5466727,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.320393064,
  "econ_fincap": 1.600183098,
  "econ_medinc": 43780.67038,
  "econ_paydaycap": 1.600183098,
  "econ_pctlwjobs": 0.30481707,
  "econ_pctmwjobs": 0.342937769,
  "econ_totjobs": 20199,
  "econ_pr": 0.196193527,
  "econ_pyr": 0.299760975,
  "econ_ur": 0.043121438,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1621.749151,
  "edu_perbach": 0.275610058,
  "edu_perearlyed": 0.53648828,
  "edu_qeckids": 0.680549371,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 4.763845596,
  "fam_lcckids": 21.0970305,
  "fam_tphh": 4119.046622,
  "fam_tphhpct": 0.618204185,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2841.378636,
  "hel_castthma": 871.096392,
  "hel_checkup": 6348.086459,
  "hel_fruitsveggies": 395.01705,
  "hel_le": 78.94548378,
  "hel_mhlth": 1394.957739,
  "hel_obesity": 3264.60586,
  "hel_perpri": 0.565796916,
  "hel_perpub": 0.249263927,
  "hel_prtopu": 2.269870825,
  "hel_pharmacap": 2.473010242,
  "hel_phlth": 1232.558556,
  "hel_sleep": 3279.582817,
  "hel_stroke": 262.8159312,
  "hel_perins": 0.785893512,
  "hel_perunin": 0.213917937,
  "hel_clincap": 0.727355953,
  "hel_groccap": 1.454711907,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 41,
  "ci_index": 60,
  "eci_index": 34,
  "edi_index": 87,
  "fi_index": 89,
  "hi_index": 43,
  "cri_index": 48,
  "ci_weight": 60,
  "eci_weight": 34,
  "edi_weight": 87,
  "fi_weight": 89,
  "hi_weight": 43,
  "cri_weight": 51,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 115,
  "TEA": 12,
  "SLN": 12,
  "SCHOOLNAME": "Pinkston High School",
  "LEVEL": "High",
  "ADDRESS": "2200 Dennison St.",
  "CITY": "Dallas",
  "ZIP": 75212,
  "PHONE": 9725022700,
  "WEBSITE": "http://www.dallasisd.org/pinkston",
  "POINT_X": -96.85852378,
  "POINT_Y": 32.78112682,
  "MasterID": "'057905012",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 34105,
  "dem_popwh": 5846,
  "dem_popbl": 8184,
  "dem_popas": 52,
  "dem_pophi": 18991,
  "dem_popm": 17422,
  "dem_popf": 16662,
  "dem_thh": 11093,
  "dem_popse": 3488,
  "dem_popch": 9609,
  "dem_perwh": 0.171411816,
  "dem_perbl": 0.239964815,
  "dem_peras": 0.001524703,
  "dem_perhi": 0.556839173,
  "dem_perm": 0.510834189,
  "dem_perf": 0.488550066,
  "dem_perse": 0.102272394,
  "dem_perch": 0.281747544,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.681626516,
  "comm_bvp": 0.083831287,
  "comm_cctrcap": 1.841386368,
  "comm_incarpct": 0.009294517,
  "comm_juvcrimecap": 319.7203587,
  "comm_libcap": 0.306897728,
  "comm_ltbvp": 0.083435324,
  "comm_ltrvp": 0.019775178,
  "comm_ocb": 1124.131115,
  "comm_ocbp": 0.233069467,
  "comm_parkcap": 0.722576815,
  "comm_rcb": 2812.896944,
  "comm_rcbp": 0.447979111,
  "comm_rvp": 0.020038416,
  "comm_u18bbp": 0.671288877,
  "comm_evrate": 162.1954492,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.417885929,
  "econ_fincap": 2.148284096,
  "econ_medinc": 21918.11081,
  "econ_paydaycap": 0.920693184,
  "econ_pctlwjobs": 0.140697745,
  "econ_pctmwjobs": 0.346695689,
  "econ_totjobs": 33078,
  "econ_pr": 0.289173288,
  "econ_pyr": 0.29074521,
  "econ_ur": 0.077827252,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 2513.734717,
  "edu_perbach": 0.12641419,
  "edu_perearlyed": 0.432748538,
  "edu_qeckids": 1.072412422,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 15.01377391,
  "fam_lcckids": 19.3034236,
  "fam_tphh": 1809.692614,
  "fam_tphhpct": 0.516843981,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3705.204704,
  "hel_castthma": 986.9642915,
  "hel_checkup": 6629.951963,
  "hel_fruitsveggies": 332.766362,
  "hel_le": 74.37268531,
  "hel_mhlth": 1709.968997,
  "hel_obesity": 3982.071954,
  "hel_perpri": 0.378726537,
  "hel_perpub": 0.353484235,
  "hel_prtopu": 1.071409978,
  "hel_pharmacap": 3.682772735,
  "hel_phlth": 1726.403093,
  "hel_sleep": 3704.118356,
  "hel_stroke": 433.4779756,
  "hel_perins": 0.704361428,
  "hel_perunin": 0.295485217,
  "hel_clincap": 2.762079551,
  "hel_groccap": 1.227590912,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 3,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 3,
  "hi_gen": 22,
  "ci_index": 62,
  "eci_index": 41,
  "edi_index": 74,
  "fi_index": 77,
  "hi_index": 30,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 41,
  "edi_weight": 74,
  "fi_weight": 77,
  "hi_weight": 30,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 116,
  "TEA": 2,
  "SLN": 2,
  "SCHOOLNAME": "Adamson High School",
  "LEVEL": "High",
  "ADDRESS": "309 E. Ninth St.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 9727491400,
  "WEBSITE": "http://www.dallasisd.org/adamson",
  "POINT_X": -96.8204931,
  "POINT_Y": 32.74842987,
  "MasterID": "'057905002",
  "Feeder": "Adamson",
  "HIGH_SLN": 2,
  "dem_totp": 58120,
  "dem_popwh": 9858,
  "dem_popbl": 11797,
  "dem_popas": 71,
  "dem_pophi": 35384,
  "dem_popm": 30246,
  "dem_popf": 27848,
  "dem_thh": 20108,
  "dem_popse": 5503,
  "dem_popch": 15406,
  "dem_perwh": 0.169614591,
  "dem_perbl": 0.2029766,
  "dem_peras": 0.00122161,
  "dem_perhi": 0.60880936,
  "dem_perm": 0.520406056,
  "dem_perf": 0.479146593,
  "dem_perse": 0.094683414,
  "dem_perch": 0.265072264,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.791158725,
  "comm_bvp": 0.135432035,
  "comm_cctrcap": 0.347380766,
  "comm_incarpct": 0.006517145,
  "comm_juvcrimecap": 330.0391858,
  "comm_libcap": 0.173690383,
  "comm_ltbvp": 0.129395533,
  "comm_ltrvp": 0.050603533,
  "comm_ocb": 2066.092126,
  "comm_ocbp": 0.236478832,
  "comm_parkcap": 0.265990768,
  "comm_rcb": 4999.49797,
  "comm_rcbp": 0.439403362,
  "comm_rvp": 0.053760005,
  "comm_u18bbp": 0.831037924,
  "comm_evrate": 143.9024825,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 1,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.35462661,
  "econ_fincap": 1.563213449,
  "econ_medinc": 27066.0259,
  "econ_paydaycap": 1.563213449,
  "econ_pctlwjobs": 0.232636105,
  "econ_pctmwjobs": 0.407732673,
  "econ_totjobs": 27442,
  "econ_pr": 0.23308247,
  "econ_pyr": 0.572853203,
  "econ_ur": 0.081197695,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1554.102925,
  "edu_perbach": 0.161233742,
  "edu_perearlyed": 0.539356605,
  "edu_qeckids": 1.324331423,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 8.608154248,
  "fam_lcckids": 15.89197707,
  "fam_tphh": 2948.953686,
  "fam_tphhpct": 0.525206164,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3489.253607,
  "hel_castthma": 937.4591685,
  "hel_checkup": 6568.276953,
  "hel_fruitsveggies": 341.6912349,
  "hel_le": 74.07018751,
  "hel_mhlth": 1576.691283,
  "hel_obesity": 3804.804461,
  "hel_perpri": 0.429722069,
  "hel_perpub": 0.337423949,
  "hel_prtopu": 1.273537547,
  "hel_pharmacap": 2.257974981,
  "hel_phlth": 1554.482125,
  "hel_sleep": 3613.345103,
  "hel_stroke": 378.9086288,
  "hel_perins": 0.740787472,
  "hel_perunin": 0.258970548,
  "hel_clincap": 0.694761533,
  "hel_groccap": 1.736903832,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 28,
  "ci_index": 57,
  "eci_index": 32,
  "edi_index": 80,
  "fi_index": 79,
  "hi_index": 31,
  "cri_index": 46,
  "ci_weight": 57,
  "eci_weight": 32,
  "edi_weight": 80,
  "fi_weight": 79,
  "hi_weight": 31,
  "cri_weight": 43,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 117,
  "TEA": 18,
  "SLN": 18,
  "SCHOOLNAME": "Sunset High School",
  "LEVEL": "High",
  "ADDRESS": "2120 W. Jefferson Blvd.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9725021500,
  "WEBSITE": "http://www.dallasisd.org/sunset",
  "POINT_X": -96.85443731,
  "POINT_Y": 32.74617167,
  "MasterID": "'057905018",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 79935,
  "dem_popwh": 11163,
  "dem_popbl": 5704,
  "dem_popas": 107,
  "dem_pophi": 61936,
  "dem_popm": 41524,
  "dem_popf": 38385,
  "dem_thh": 24829,
  "dem_popse": 7218,
  "dem_popch": 23018,
  "dem_perwh": 0.139650966,
  "dem_perbl": 0.071357978,
  "dem_peras": 0.001338588,
  "dem_perhi": 0.774829549,
  "dem_perm": 0.519472071,
  "dem_perf": 0.480202665,
  "dem_perse": 0.090298367,
  "dem_perch": 0.287958967,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 2,
  "comm_bbp": 0.734151104,
  "comm_bvp": 0.092279899,
  "comm_cctrcap": 0.251565889,
  "comm_incarpct": 0.003607521,
  "comm_juvcrimecap": 178.6719427,
  "comm_libcap": 0.125782945,
  "comm_ltbvp": 0.087678582,
  "comm_ltrvp": 0.021786414,
  "comm_ocb": 2924.438456,
  "comm_ocbp": 0.221841273,
  "comm_parkcap": 0.057193025,
  "comm_rcb": 5260.752792,
  "comm_rcbp": 0.451038453,
  "comm_rvp": 0.0228176,
  "comm_u18bbp": 0.721789448,
  "comm_evrate": 90.87817751,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.346298206,
  "econ_fincap": 1.257829447,
  "econ_medinc": 26850.91755,
  "econ_paydaycap": 2.012527114,
  "econ_pctlwjobs": 0.254633111,
  "econ_pctmwjobs": 0.460214959,
  "econ_totjobs": 22609,
  "econ_pr": 0.220936257,
  "econ_pyr": 0.338316511,
  "econ_ur": 0.065517857,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 2,
  "edu_oostkids": 1123.492221,
  "edu_perbach": 0.120560457,
  "edu_perearlyed": 0.429080542,
  "edu_qeckids": 0.880134917,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.241416624,
  "fam_lcckids": 12.32188883,
  "fam_tphh": 5005.983207,
  "fam_tphhpct": 0.610824477,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3183.431776,
  "hel_castthma": 886.9857085,
  "hel_checkup": 6335.415171,
  "hel_fruitsveggies": 356.7755195,
  "hel_le": 76.70914123,
  "hel_mhlth": 1597.675109,
  "hel_obesity": 3680.008692,
  "hel_perpri": 0.439081296,
  "hel_perpub": 0.321483674,
  "hel_prtopu": 1.365796559,
  "hel_pharmacap": 2.138310059,
  "hel_phlth": 1559.944945,
  "hel_sleep": 3475.575109,
  "hel_stroke": 317.6643069,
  "hel_perins": 0.732730397,
  "hel_perunin": 0.267106534,
  "hel_clincap": 0.628914723,
  "hel_groccap": 1.63517828,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 63,
  "eci_index": 34,
  "edi_index": 74,
  "fi_index": 80,
  "hi_index": 33,
  "cri_index": 45,
  "ci_weight": 63,
  "eci_weight": 34,
  "edi_weight": 74,
  "fi_weight": 80,
  "hi_weight": 33,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 118,
  "TEA": 1,
  "SLN": 1,
  "SCHOOLNAME": "Adams High School",
  "LEVEL": "High",
  "ADDRESS": "2101 Millmar Dr.",
  "CITY": "Dallas",
  "ZIP": 75228,
  "PHONE": 9725024900,
  "WEBSITE": "http://www.dallasisd.org/bryanadams",
  "POINT_X": -96.68289648,
  "POINT_Y": 32.82790272,
  "MasterID": "'057905001",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 68212,
  "dem_popwh": 21196,
  "dem_popbl": 10463,
  "dem_popas": 42,
  "dem_pophi": 34464,
  "dem_popm": 32745,
  "dem_popf": 35463,
  "dem_thh": 24678,
  "dem_popse": 7522,
  "dem_popch": 18673,
  "dem_perwh": 0.310737114,
  "dem_perbl": 0.153389433,
  "dem_peras": 0.000615727,
  "dem_perhi": 0.505248343,
  "dem_perm": 0.480047499,
  "dem_perf": 0.51989386,
  "dem_perse": 0.110273852,
  "dem_perch": 0.273749487,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.743510603,
  "comm_bvp": 0.241812369,
  "comm_cctrcap": 0.441790935,
  "comm_incarpct": 0.005583757,
  "comm_juvcrimecap": 240.9335077,
  "comm_libcap": 0.29452729,
  "comm_ltbvp": 0.210848373,
  "comm_ltrvp": 0.02392539,
  "comm_ocb": 3131.962218,
  "comm_ocbp": 0.229942166,
  "comm_parkcap": 0.081035356,
  "comm_rcb": 5262.920101,
  "comm_rcbp": 0.475750446,
  "comm_rvp": 0.031984833,
  "comm_u18bbp": 0.725632977,
  "comm_evrate": 163.8308051,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.279459166,
  "econ_fincap": 1.472636451,
  "econ_medinc": 33103.05118,
  "econ_paydaycap": 1.619900096,
  "econ_pctlwjobs": 0.270171891,
  "econ_pctmwjobs": 0.392821031,
  "econ_totjobs": 9890,
  "econ_pr": 0.186357979,
  "econ_pyr": 0.23082274,
  "econ_ur": 0.048689902,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 851.70296,
  "edu_perbach": 0.15296496,
  "edu_perearlyed": 0.307149577,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.003250146,
  "fam_lcckids": 15.08392339,
  "fam_tphh": 4662.246761,
  "fam_tphhpct": 0.632572461,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3428.167664,
  "hel_castthma": 963.0225832,
  "hel_checkup": 6615.433942,
  "hel_fruitsveggies": 386.6997379,
  "hel_le": 77.95687227,
  "hel_mhlth": 1591.597889,
  "hel_obesity": 3605.62105,
  "hel_perpri": 0.488418947,
  "hel_perpub": 0.314534037,
  "hel_prtopu": 1.552833365,
  "hel_pharmacap": 1.324743438,
  "hel_phlth": 1532.273232,
  "hel_sleep": 3515.149628,
  "hel_stroke": 360.3296709,
  "hel_perins": 0.749834556,
  "hel_perunin": 0.250091913,
  "hel_clincap": 0.110395286,
  "hel_groccap": 0.772767005,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 30,
  "ci_index": 46,
  "eci_index": 33,
  "edi_index": 56,
  "fi_index": 87,
  "hi_index": 31,
  "cri_index": 44,
  "ci_weight": 46,
  "eci_weight": 33,
  "edi_weight": 56,
  "fi_weight": 87,
  "hi_weight": 31,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 119,
  "TEA": 8,
  "SLN": 8,
  "SCHOOLNAME": "Kimball High School",
  "LEVEL": "High",
  "ADDRESS": "3606 S. Westmoreland Rd.",
  "CITY": "Dallas",
  "ZIP": 75233,
  "PHONE": 9725022100,
  "WEBSITE": "http://www.dallasisd.org/kimball",
  "POINT_X": -96.87639925,
  "POINT_Y": 32.69824194,
  "MasterID": "'057905008",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 51666,
  "dem_popwh": 3677,
  "dem_popbl": 15700,
  "dem_popas": 28,
  "dem_pophi": 31339,
  "dem_popm": 24848,
  "dem_popf": 26793,
  "dem_thh": 16378,
  "dem_popse": 5354,
  "dem_popch": 15586,
  "dem_perwh": 0.07116866,
  "dem_perbl": 0.303874889,
  "dem_peras": 0.000541942,
  "dem_perhi": 0.606569117,
  "dem_perm": 0.480935238,
  "dem_perf": 0.518580885,
  "dem_perse": 0.103627144,
  "dem_perch": 0.301668409,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.667747617,
  "comm_bvp": 0.110730521,
  "comm_cctrcap": 0.389855956,
  "comm_incarpct": 0.005457014,
  "comm_juvcrimecap": 225.3696529,
  "comm_libcap": 0.194927978,
  "comm_ltbvp": 0.105564909,
  "comm_ltrvp": 0.018304927,
  "comm_ocb": 1917.34763,
  "comm_ocbp": 0.25324797,
  "comm_parkcap": 0.146782106,
  "comm_rcb": 4542.648221,
  "comm_rcbp": 0.515152182,
  "comm_rvp": 0.019365764,
  "comm_u18bbp": 0.676274234,
  "comm_evrate": 273.1915614,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.320449358,
  "econ_fincap": 1.364495847,
  "econ_medinc": 24660.33002,
  "econ_paydaycap": 1.169567869,
  "econ_pctlwjobs": 0.210082026,
  "econ_pctmwjobs": 0.416022935,
  "econ_totjobs": 12557,
  "econ_pr": 0.237030568,
  "econ_pyr": 0.38249626,
  "econ_ur": 0.075166065,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 1,
  "edu_oostkids": 974.2425242,
  "edu_perbach": 0.078141113,
  "edu_perearlyed": 0.54970446,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.087743232,
  "fam_lcckids": 9.020764113,
  "fam_tphh": 2767.22922,
  "fam_tphhpct": 0.504800745,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3618.502012,
  "hel_castthma": 1000.479128,
  "hel_checkup": 6693.802375,
  "hel_fruitsveggies": 348.4138415,
  "hel_le": 77.31142797,
  "hel_mhlth": 1634.11028,
  "hel_obesity": 3891.053666,
  "hel_perpri": 0.428510341,
  "hel_perpub": 0.342170735,
  "hel_prtopu": 1.252329016,
  "hel_pharmacap": 2.14420776,
  "hel_phlth": 1591.303143,
  "hel_sleep": 3698.869694,
  "hel_stroke": 391.8723757,
  "hel_perins": 0.735461048,
  "hel_perunin": 0.264208521,
  "hel_clincap": 0.389855956,
  "hel_groccap": 0.779711913,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 24,
  "ci_index": 57,
  "eci_index": 30,
  "edi_index": 64,
  "fi_index": 69,
  "hi_index": 25,
  "cri_index": 40,
  "ci_weight": 57,
  "eci_weight": 30,
  "edi_weight": 64,
  "fi_weight": 69,
  "hi_weight": 25,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 120,
  "TEA": 5,
  "SLN": 5,
  "SCHOOLNAME": "Molina High School",
  "LEVEL": "High",
  "ADDRESS": "2355 Duncanville Rd.",
  "CITY": "Dallas",
  "ZIP": 75211,
  "PHONE": 9725021000,
  "WEBSITE": "http://www.dallasisd.org/molina",
  "POINT_X": -96.91036404,
  "POINT_Y": 32.72269835,
  "MasterID": "'057905005",
  "Feeder": "Molina",
  "HIGH_SLN": 5,
  "dem_totp": 45491,
  "dem_popwh": 2490,
  "dem_popbl": 5660,
  "dem_popas": 23,
  "dem_pophi": 36657,
  "dem_popm": 22309,
  "dem_popf": 23167,
  "dem_thh": 12482,
  "dem_popse": 3731,
  "dem_popch": 14192,
  "dem_perwh": 0.054736102,
  "dem_perbl": 0.124420215,
  "dem_peras": 0.000505595,
  "dem_perhi": 0.805807742,
  "dem_perm": 0.490404695,
  "dem_perf": 0.509265569,
  "dem_perse": 0.082016223,
  "dem_perch": 0.311973797,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.618115166,
  "comm_bvp": 0.080749845,
  "comm_cctrcap": 0.221872086,
  "comm_incarpct": 0.00571455,
  "comm_juvcrimecap": 178.0537781,
  "comm_libcap": 0.221872086,
  "comm_ltbvp": 0.071111384,
  "comm_ltrvp": 0.014710814,
  "comm_ocb": 1710.045642,
  "comm_ocbp": 0.270793194,
  "comm_parkcap": 0.103787382,
  "comm_rcb": 2774.804886,
  "comm_rcbp": 0.449276059,
  "comm_rvp": 0.016077012,
  "comm_u18bbp": 0.604937575,
  "comm_evrate": 94.29563658,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.299568304,
  "econ_fincap": 0.665616258,
  "econ_medinc": 22817.96629,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.168103049,
  "econ_pctmwjobs": 0.422852377,
  "econ_totjobs": 10791,
  "econ_pr": 0.217926547,
  "econ_pyr": 0.169118507,
  "econ_ur": 0.059504445,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 2,
  "edu_oostkids": 431.2873317,
  "edu_perbach": 0.044571916,
  "edu_perearlyed": 0.38410596,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.124568137,
  "fam_lcckids": 4.249136273,
  "fam_tphh": 2786.409849,
  "fam_tphhpct": 0.577701673,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3177.823328,
  "hel_castthma": 940.7058965,
  "hel_checkup": 6329.15997,
  "hel_fruitsveggies": 357.7343602,
  "hel_le": 77.31188006,
  "hel_mhlth": 1720.418155,
  "hel_obesity": 3784.844802,
  "hel_perpri": 0.404819703,
  "hel_perpub": 0.324557532,
  "hel_prtopu": 1.247297205,
  "hel_pharmacap": 0.665616258,
  "hel_phlth": 1613.995048,
  "hel_sleep": 3608.38239,
  "hel_stroke": 322.3362563,
  "hel_perins": 0.701880214,
  "hel_perunin": 0.297921172,
  "hel_clincap": 0.221872086,
  "hel_groccap": 0.887488344,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 66,
  "eci_index": 42,
  "edi_index": 58,
  "fi_index": 45,
  "hi_index": 30,
  "cri_index": 44,
  "ci_weight": 66,
  "eci_weight": 42,
  "edi_weight": 58,
  "fi_weight": 45,
  "hi_weight": 30,
  "cri_weight": 42,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 121,
  "TEA": 60,
  "SLN": 60,
  "SCHOOLNAME": "Storey Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "3000 Maryland Ave.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9729258700,
  "WEBSITE": "http://www.dallasisd.org/storey",
  "POINT_X": -96.81208413,
  "POINT_Y": 32.70855602,
  "MasterID": "'057905060",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 69236,
  "dem_popwh": 3327,
  "dem_popbl": 29923,
  "dem_popas": 65,
  "dem_pophi": 35038,
  "dem_popm": 33326,
  "dem_popf": 35916,
  "dem_thh": 21657,
  "dem_popse": 7983,
  "dem_popch": 21068,
  "dem_perwh": 0.048053036,
  "dem_perbl": 0.432188457,
  "dem_peras": 0.000938818,
  "dem_perhi": 0.506066208,
  "dem_perm": 0.481339188,
  "dem_perf": 0.518747472,
  "dem_perse": 0.115301288,
  "dem_perch": 0.304292565,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 3,
  "dem_perch_sd": 3,
  "comm_bbp": 0.622262722,
  "comm_bvp": 0.130128572,
  "comm_cctrcap": 0.587146955,
  "comm_incarpct": 0.010271854,
  "comm_juvcrimecap": 304.9795631,
  "comm_libcap": 0.146786739,
  "comm_ltbvp": 0.118354264,
  "comm_ltrvp": 0.035497069,
  "comm_ocb": 2952.994768,
  "comm_ocbp": 0.27618488,
  "comm_parkcap": 0.078762149,
  "comm_rcb": 5911.998958,
  "comm_rcbp": 0.538733867,
  "comm_rvp": 0.041386302,
  "comm_u18bbp": 0.696759271,
  "comm_evrate": 169.7588632,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 1,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.404820384,
  "econ_fincap": 1.467867386,
  "econ_medinc": 19780.43991,
  "econ_paydaycap": 1.761440864,
  "econ_pctlwjobs": 0.34557596,
  "econ_pctmwjobs": 0.370246707,
  "econ_totjobs": 5391,
  "econ_pr": 0.310217187,
  "econ_pyr": 0.471610487,
  "econ_ur": 0.100719786,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1424.031983,
  "edu_perbach": 0.065795995,
  "edu_perearlyed": 0.455555556,
  "edu_qeckids": 2.880712036,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 15.36379753,
  "fam_lcckids": 17.28427222,
  "fam_tphh": 3457.177384,
  "fam_tphhpct": 0.512994703,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4381.479997,
  "hel_castthma": 1105.299014,
  "hel_checkup": 7033.325783,
  "hel_fruitsveggies": 298.8734929,
  "hel_le": 73.0488715,
  "hel_mhlth": 1781.068451,
  "hel_obesity": 4342.136634,
  "hel_perpri": 0.31407017,
  "hel_perpub": 0.450022444,
  "hel_prtopu": 0.697898903,
  "hel_pharmacap": 1.614654125,
  "hel_phlth": 1880.829651,
  "hel_sleep": 3991.353528,
  "hel_stroke": 581.9648832,
  "hel_perins": 0.731324481,
  "hel_perunin": 0.268762398,
  "hel_clincap": 0.293573477,
  "hel_groccap": 1.027507171,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 10,
  "ci_index": 44,
  "eci_index": 8,
  "edi_index": 77,
  "fi_index": 89,
  "hi_index": 9,
  "cri_index": 35,
  "ci_weight": 44,
  "eci_weight": 8,
  "edi_weight": 77,
  "fi_weight": 89,
  "hi_weight": 9,
  "cri_weight": 23,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 122,
  "TEA": 44,
  "SLN": 44,
  "SCHOOLNAME": "Cary Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "3978 Killion Dr.",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9725027600,
  "WEBSITE": "http://www.dallasisd.org/cary",
  "POINT_X": -96.84671465,
  "POINT_Y": 32.88185027,
  "MasterID": "'057905044",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 55819,
  "dem_popwh": 29476,
  "dem_popbl": 1326,
  "dem_popas": 58,
  "dem_pophi": 23404,
  "dem_popm": 29333,
  "dem_popf": 26478,
  "dem_thh": 19664,
  "dem_popse": 5869,
  "dem_popch": 14371,
  "dem_perwh": 0.528063921,
  "dem_perbl": 0.023755352,
  "dem_peras": 0.001039073,
  "dem_perhi": 0.419283756,
  "dem_perm": 0.525502069,
  "dem_perf": 0.47435461,
  "dem_perse": 0.10514341,
  "dem_perch": 0.257457138,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.76487855,
  "comm_bvp": 0.072576349,
  "comm_cctrcap": 0.358993076,
  "comm_incarpct": 0.001880646,
  "comm_juvcrimecap": 157.6728243,
  "comm_libcap": 0.179496538,
  "comm_ltbvp": 0.069600727,
  "comm_ltrvp": 0.011888655,
  "comm_ocb": 2977.258174,
  "comm_ocbp": 0.265441047,
  "comm_parkcap": 0.040568334,
  "comm_rcb": 3620.504655,
  "comm_rcbp": 0.428428911,
  "comm_rvp": 0.015919984,
  "comm_u18bbp": 0.748814295,
  "comm_evrate": 88.76103806,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.229505005,
  "econ_fincap": 0.89748269,
  "econ_medinc": 57782.09331,
  "econ_paydaycap": 1.256475766,
  "econ_pctlwjobs": 0.283201669,
  "econ_pctmwjobs": 0.367491429,
  "econ_totjobs": 13418,
  "econ_pr": 0.135196299,
  "econ_pyr": 0.297701076,
  "econ_ur": 0.041270434,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 734.542473,
  "edu_perbach": 0.223586755,
  "edu_perearlyed": 0.464561404,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.800924587,
  "fam_lcckids": 9.803236056,
  "fam_tphh": 5205.884377,
  "fam_tphhpct": 0.772827556,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2980.433852,
  "hel_castthma": 844.3488099,
  "hel_checkup": 6379.968521,
  "hel_fruitsveggies": 485.3857881,
  "hel_le": 81.96609348,
  "hel_mhlth": 1425.529432,
  "hel_obesity": 3259.715825,
  "hel_perpri": 0.509764225,
  "hel_perpub": 0.241221155,
  "hel_prtopu": 2.113265003,
  "hel_pharmacap": 1.615468842,
  "hel_phlth": 1328.283928,
  "hel_sleep": 3220.882804,
  "hel_stroke": 260.7591425,
  "hel_perins": 0.692883761,
  "hel_perunin": 0.306919163,
  "hel_clincap": 0.179496538,
  "hel_groccap": 0.89748269,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 42,
  "ci_index": 74,
  "eci_index": 41,
  "edi_index": 64,
  "fi_index": 93,
  "hi_index": 39,
  "cri_index": 50,
  "ci_weight": 74,
  "eci_weight": 41,
  "edi_weight": 64,
  "fi_weight": 93,
  "hi_weight": 39,
  "cri_weight": 52,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 123,
  "TEA": 54,
  "SLN": 54,
  "SCHOOLNAME": "Marsh Preparatory Academy Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "3838 Crown Shore Dr.",
  "CITY": "Dallas",
  "ZIP": 75244,
  "PHONE": 9725026600,
  "WEBSITE": "http://www.dallasisd.org/marsh",
  "POINT_X": -96.8501018,
  "POINT_Y": 32.91133344,
  "MasterID": "'057905054",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 45676,
  "dem_popwh": 26778,
  "dem_popbl": 2426,
  "dem_popas": 75,
  "dem_pophi": 12839,
  "dem_popm": 22770,
  "dem_popf": 22889,
  "dem_thh": 18341,
  "dem_popse": 6758,
  "dem_popch": 9343,
  "dem_perwh": 0.586259743,
  "dem_perbl": 0.053113232,
  "dem_peras": 0.001642,
  "dem_perhi": 0.281088537,
  "dem_perm": 0.498511253,
  "dem_perf": 0.50111656,
  "dem_perse": 0.147955162,
  "dem_perch": 0.204549435,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.901617386,
  "comm_bvp": 0.109548899,
  "comm_cctrcap": 0.87835074,
  "comm_incarpct": 0.001255162,
  "comm_juvcrimecap": 79.96108182,
  "comm_libcap": 0.219587685,
  "comm_ltbvp": 0.09485803,
  "comm_ltrvp": 0.006402519,
  "comm_ocb": 2831.943817,
  "comm_ocbp": 0.242054554,
  "comm_parkcap": 0.027222953,
  "comm_rcb": 2344.767445,
  "comm_rcbp": 0.352842468,
  "comm_rvp": 0.010399355,
  "comm_u18bbp": 0.909321917,
  "comm_evrate": 108.8056979,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.063837193,
  "econ_fincap": 2.415464534,
  "econ_medinc": 52471.92338,
  "econ_paydaycap": 0.87835074,
  "econ_pctlwjobs": 0.225499104,
  "econ_pctmwjobs": 0.336067915,
  "econ_totjobs": 38519,
  "econ_pr": 0.05195582,
  "econ_pyr": 0.164234396,
  "econ_ur": 0.031781443,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 883.8283473,
  "edu_perbach": 0.328516348,
  "edu_perearlyed": 0.49034749,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.153053221,
  "fam_lcckids": 19.37747899,
  "fam_tphh": 3957.109431,
  "fam_tphhpct": 0.795808337,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2136.800035,
  "hel_castthma": 528.344476,
  "hel_checkup": 4628.5627,
  "hel_fruitsveggies": 483.1486717,
  "hel_le": 81.51386392,
  "hel_mhlth": 693.6680708,
  "hel_obesity": 1840.223623,
  "hel_perpri": 0.738624663,
  "hel_perpub": 0.204372686,
  "hel_prtopu": 3.614106549,
  "hel_pharmacap": 2.415464534,
  "hel_phlth": 707.3368489,
  "hel_sleep": 1916.944198,
  "hel_stroke": 181.9809733,
  "hel_perins": 0.856507547,
  "hel_perunin": 0.14312003,
  "hel_clincap": 0.43917537,
  "hel_groccap": 0.87835074,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 81,
  "ci_index": 100,
  "eci_index": 84,
  "edi_index": 73,
  "fi_index": 81,
  "hi_index": 90,
  "cri_index": 93,
  "ci_weight": 100,
  "eci_weight": 84,
  "edi_weight": 73,
  "fi_weight": 81,
  "hi_weight": 90,
  "cri_weight": 94,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 124,
  "TEA": 56,
  "SLN": 56,
  "SCHOOLNAME": "Walker Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "12532 Nuestra Dr.",
  "CITY": "Dallas",
  "ZIP": 75230,
  "PHONE": 9725026100,
  "WEBSITE": "http://www.dallasisd.org/walker",
  "POINT_X": -96.80988923,
  "POINT_Y": 32.91939283,
  "MasterID": "'057905056",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 53500,
  "dem_popwh": 26526,
  "dem_popbl": 6479,
  "dem_popas": 37,
  "dem_pophi": 15663,
  "dem_popm": 26134,
  "dem_popf": 27377,
  "dem_thh": 24078,
  "dem_popse": 7194,
  "dem_popch": 11598,
  "dem_perwh": 0.495813084,
  "dem_perbl": 0.121102804,
  "dem_peras": 0.000691589,
  "dem_perhi": 0.292766355,
  "dem_perm": 0.488485981,
  "dem_perf": 0.511719626,
  "dem_perse": 0.13446729,
  "dem_perch": 0.216785047,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.853436598,
  "comm_bvp": 0.126942626,
  "comm_cctrcap": 0.375213801,
  "comm_incarpct": 0.001809208,
  "comm_juvcrimecap": 117.0486451,
  "comm_libcap": 0.1876069,
  "comm_ltbvp": 0.110428143,
  "comm_ltrvp": 0.006450136,
  "comm_ocb": 2311.459101,
  "comm_ocbp": 0.243976362,
  "comm_parkcap": 0.055493551,
  "comm_rcb": 5706.467616,
  "comm_rcbp": 0.390866227,
  "comm_rvp": 0.00949528,
  "comm_u18bbp": 0.836908876,
  "comm_evrate": 158.5278308,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.172790236,
  "econ_fincap": 5.628207011,
  "econ_medinc": 62866.05784,
  "econ_paydaycap": 1.500855203,
  "econ_pctlwjobs": 0.185671109,
  "econ_pctmwjobs": 0.279010395,
  "econ_totjobs": 87348,
  "econ_pr": 0.094061424,
  "econ_pyr": 0.163779513,
  "econ_ur": 0.032291869,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1409.327211,
  "edu_perbach": 0.328251217,
  "edu_perearlyed": 0.451973194,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.450005412,
  "fam_lcckids": 16.38752571,
  "fam_tphh": 3733.271473,
  "fam_tphhpct": 0.607834261,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2744.280192,
  "hel_castthma": 788.4482136,
  "hel_checkup": 6420.946367,
  "hel_fruitsveggies": 505.0260288,
  "hel_le": 81.72789237,
  "hel_mhlth": 1095.670901,
  "hel_obesity": 2729.619316,
  "hel_perpri": 0.68036264,
  "hel_perpub": 0.212103011,
  "hel_prtopu": 3.207699115,
  "hel_pharmacap": 2.251282805,
  "hel_phlth": 950.2979671,
  "hel_sleep": 2931.33115,
  "hel_stroke": 220.6905087,
  "hel_perins": 0.816146107,
  "hel_perunin": 0.183760042,
  "hel_clincap": 0,
  "hel_groccap": 0.938034502,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 52,
  "ci_index": 87,
  "eci_index": 81,
  "edi_index": 69,
  "fi_index": 76,
  "hi_index": 61,
  "cri_index": 73,
  "ci_weight": 87,
  "eci_weight": 81,
  "edi_weight": 69,
  "fi_weight": 76,
  "hi_weight": 61,
  "cri_weight": 75,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 125,
  "TEA": 83,
  "SLN": 83,
  "SCHOOLNAME": "Tasby Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "7001 Fair Oaks Ave.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9725021900,
  "WEBSITE": "http://www.dallasisd.org/tasby",
  "POINT_X": -96.75994386,
  "POINT_Y": 32.87248414,
  "MasterID": "'057905083",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 82994,
  "dem_popwh": 43111,
  "dem_popbl": 13356,
  "dem_popas": 68,
  "dem_pophi": 17819,
  "dem_popm": 41248,
  "dem_popf": 41747,
  "dem_thh": 38366,
  "dem_popse": 10212,
  "dem_popch": 17028,
  "dem_perwh": 0.519447189,
  "dem_perbl": 0.160927296,
  "dem_peras": 0.000819336,
  "dem_perhi": 0.214702268,
  "dem_perm": 0.496999783,
  "dem_perf": 0.503012266,
  "dem_perse": 0.123045039,
  "dem_perch": 0.205171458,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.835242959,
  "comm_bvp": 0.118461492,
  "comm_cctrcap": 0.244359336,
  "comm_incarpct": 0.002699868,
  "comm_juvcrimecap": 149.2973308,
  "comm_libcap": 0.244359336,
  "comm_ltbvp": 0.089054963,
  "comm_ltrvp": 0.007577137,
  "comm_ocb": 2875.302823,
  "comm_ocbp": 0.245973216,
  "comm_parkcap": 0.16740985,
  "comm_rcb": 11829.49833,
  "comm_rcbp": 0.443415341,
  "comm_rvp": 0.010102758,
  "comm_u18bbp": 0.827397457,
  "comm_evrate": 179.3597526,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.272428754,
  "econ_fincap": 3.176671367,
  "econ_medinc": 49735.30673,
  "econ_paydaycap": 2.077054355,
  "econ_pctlwjobs": 0.250199113,
  "econ_pctmwjobs": 0.30292736,
  "econ_totjobs": 61523,
  "econ_pr": 0.168332592,
  "econ_pyr": 0.209960928,
  "econ_ur": 0.043312986,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 1683.669958,
  "edu_perbach": 0.327749276,
  "edu_perearlyed": 0.450134771,
  "edu_qeckids": 0.592632861,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 4.741062888,
  "fam_lcckids": 13.6305558,
  "fam_tphh": 6015.622913,
  "fam_tphhpct": 0.693709201,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2765.570274,
  "hel_castthma": 809.6014301,
  "hel_checkup": 6195.277452,
  "hel_fruitsveggies": 430.8877104,
  "hel_le": 80.38135581,
  "hel_mhlth": 1217.715602,
  "hel_obesity": 2862.443458,
  "hel_perpri": 0.644755194,
  "hel_perpub": 0.257043407,
  "hel_prtopu": 2.50835142,
  "hel_pharmacap": 5.98680373,
  "hel_phlth": 1055.009833,
  "hel_sleep": 3022.50709,
  "hel_stroke": 244.3479299,
  "hel_perins": 0.826034226,
  "hel_perunin": 0.174002159,
  "hel_clincap": 0.977437344,
  "hel_groccap": 1.466156016,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 50,
  "ci_index": 74,
  "eci_index": 50,
  "edi_index": 79,
  "fi_index": 97,
  "hi_index": 55,
  "cri_index": 62,
  "ci_weight": 74,
  "eci_weight": 50,
  "edi_weight": 79,
  "fi_weight": 97,
  "hi_weight": 55,
  "cri_weight": 65,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 126,
  "TEA": 46,
  "SLN": 46,
  "SCHOOLNAME": "Young Men's Leadership Academy at Fred F. Florence Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "1625 N. Masters Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496000,
  "WEBSITE": "http://www.dallasisd.org/florence",
  "POINT_X": -96.64930405,
  "POINT_Y": 32.74148981,
  "MasterID": "'057905046",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 65520,
  "dem_popwh": 5300,
  "dem_popbl": 15951,
  "dem_popas": 57,
  "dem_pophi": 43722,
  "dem_popm": 31283,
  "dem_popf": 34228,
  "dem_thh": 17798,
  "dem_popse": 4009,
  "dem_popch": 23389,
  "dem_perwh": 0.080891331,
  "dem_perbl": 0.243452381,
  "dem_peras": 0.000869963,
  "dem_perhi": 0.667307692,
  "dem_perm": 0.477457265,
  "dem_perf": 0.522405372,
  "dem_perse": 0.061187424,
  "dem_perch": 0.356974969,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.666710071,
  "comm_bvp": 0.114931735,
  "comm_cctrcap": 0.153401848,
  "comm_incarpct": 0.005837213,
  "comm_juvcrimecap": 214.5310637,
  "comm_libcap": 0.153401848,
  "comm_ltbvp": 0.112439514,
  "comm_ltrvp": 0.018641055,
  "comm_ocb": 3581.592074,
  "comm_ocbp": 0.328266595,
  "comm_parkcap": 0.036781636,
  "comm_rcb": 3624.609935,
  "comm_rcbp": 0.525815121,
  "comm_rvp": 0.021147263,
  "comm_u18bbp": 0.670470508,
  "comm_evrate": 160.0748282,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.348824623,
  "econ_fincap": 0.613607391,
  "econ_medinc": 22352.50019,
  "econ_paydaycap": 1.227214782,
  "econ_pctlwjobs": 0.27193646,
  "econ_pctmwjobs": 0.410930408,
  "econ_totjobs": 5288,
  "econ_pr": 0.264510258,
  "econ_pyr": 0.307165753,
  "econ_ur": 0.050382372,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 494.4124045,
  "edu_perbach": 0.03993939,
  "edu_perearlyed": 0.276263031,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.2043411,
  "fam_lcckids": 5.638036192,
  "fam_tphh": 5066.237191,
  "fam_tphhpct": 0.609708627,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3416.784559,
  "hel_castthma": 998.6636583,
  "hel_checkup": 6260.554853,
  "hel_fruitsveggies": 336.4435184,
  "hel_le": 74.80145159,
  "hel_mhlth": 1762.017297,
  "hel_obesity": 3918.328449,
  "hel_perpri": 0.34993895,
  "hel_perpub": 0.378021978,
  "hel_prtopu": 0.925710594,
  "hel_pharmacap": 1.38061663,
  "hel_phlth": 1656.840916,
  "hel_sleep": 3666.084265,
  "hel_stroke": 371.112085,
  "hel_perins": 0.701190476,
  "hel_perunin": 0.298443223,
  "hel_clincap": 0.306803696,
  "hel_groccap": 0.767009239,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 27,
  "ci_index": 58,
  "eci_index": 26,
  "edi_index": 44,
  "fi_index": 80,
  "hi_index": 23,
  "cri_index": 41,
  "ci_weight": 58,
  "eci_weight": 26,
  "edi_weight": 44,
  "fi_weight": 80,
  "hi_weight": 23,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 127,
  "TEA": 45,
  "SLN": 45,
  "SCHOOLNAME": "Comstock Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "7044 Hodde St.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727941300,
  "WEBSITE": "http://www.dallasisd.org/comstock",
  "POINT_X": -96.70212108,
  "POINT_Y": 32.72105048,
  "MasterID": "'057905045",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 40885,
  "dem_popwh": 2049,
  "dem_popbl": 10568,
  "dem_popas": 0,
  "dem_pophi": 28134,
  "dem_popm": 19599,
  "dem_popf": 21298,
  "dem_thh": 11185,
  "dem_popse": 3333,
  "dem_popch": 14068,
  "dem_perwh": 0.05011618,
  "dem_perbl": 0.258481106,
  "dem_peras": 0,
  "dem_perhi": 0.688125229,
  "dem_perm": 0.479368962,
  "dem_perf": 0.520924544,
  "dem_perse": 0.08152134,
  "dem_perch": 0.344087073,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.526658928,
  "comm_bvp": 0.105461088,
  "comm_cctrcap": 0.734819848,
  "comm_incarpct": 0.010575291,
  "comm_juvcrimecap": 304.0456698,
  "comm_libcap": 0.244939949,
  "comm_ltbvp": 0.102733874,
  "comm_ltrvp": 0.02328451,
  "comm_ocb": 1481.61493,
  "comm_ocbp": 0.241282945,
  "comm_parkcap": 0.35207957,
  "comm_rcb": 2652.703029,
  "comm_rcbp": 0.526417254,
  "comm_rvp": 0.024047129,
  "comm_u18bbp": 0.521756906,
  "comm_evrate": 127.2463037,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.441724222,
  "econ_fincap": 0.734819848,
  "econ_medinc": 20461.29453,
  "econ_paydaycap": 1.959519595,
  "econ_pctlwjobs": 0.26779661,
  "econ_pctmwjobs": 0.369975787,
  "econ_totjobs": 4130,
  "econ_pr": 0.304061698,
  "econ_pyr": 0.055811462,
  "econ_ur": 0.039532397,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 848.7334268,
  "edu_perbach": 0.029557986,
  "edu_perearlyed": 0.301679213,
  "edu_qeckids": 1.428844153,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 7.144220764,
  "fam_lcckids": 7.85864284,
  "fam_tphh": 2712.59408,
  "fam_tphhpct": 0.583352475,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3609.163788,
  "hel_castthma": 1038.606984,
  "hel_checkup": 6538.680818,
  "hel_fruitsveggies": 292.7395042,
  "hel_le": 75.35802733,
  "hel_mhlth": 1850.583011,
  "hel_obesity": 4105.484826,
  "hel_perpri": 0.286706616,
  "hel_perpub": 0.398752599,
  "hel_prtopu": 0.719008771,
  "hel_pharmacap": 0.734819848,
  "hel_phlth": 1774.630083,
  "hel_sleep": 3852.146424,
  "hel_stroke": 416.5575068,
  "hel_perins": 0.666014431,
  "hel_perunin": 0.333887734,
  "hel_clincap": 0,
  "hel_groccap": 1.224699747,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 3,
  "hi_gen": 20,
  "ci_index": 50,
  "eci_index": 35,
  "edi_index": 47,
  "fi_index": 67,
  "hi_index": 15,
  "cri_index": 37,
  "ci_weight": 50,
  "eci_weight": 35,
  "edi_weight": 47,
  "fi_weight": 67,
  "hi_weight": 15,
  "cri_weight": 29,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 128,
  "TEA": 52,
  "SLN": 52,
  "SCHOOLNAME": "Piedmont Global Academy Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "7625 Hume Dr.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727494100,
  "WEBSITE": "http://www.dallasisd.org/hood",
  "POINT_X": -96.69113835,
  "POINT_Y": 32.75845838,
  "MasterID": "'057905052",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 59418,
  "dem_popwh": 4493,
  "dem_popbl": 12348,
  "dem_popas": 58,
  "dem_pophi": 41902,
  "dem_popm": 29489,
  "dem_popf": 29933,
  "dem_thh": 16912,
  "dem_popse": 4726,
  "dem_popch": 19746,
  "dem_perwh": 0.075616816,
  "dem_perbl": 0.207815813,
  "dem_peras": 0.000976135,
  "dem_perhi": 0.705207176,
  "dem_perm": 0.496297418,
  "dem_perf": 0.503769901,
  "dem_perse": 0.079538187,
  "dem_perch": 0.332323538,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.590184394,
  "comm_bvp": 0.099178757,
  "comm_cctrcap": 0.33927016,
  "comm_incarpct": 0.008013376,
  "comm_juvcrimecap": 216.1268385,
  "comm_libcap": 0.33927016,
  "comm_ltbvp": 0.09352746,
  "comm_ltrvp": 0.017866519,
  "comm_ocb": 2846.977326,
  "comm_ocbp": 0.285578158,
  "comm_parkcap": 0.324570927,
  "comm_rcb": 3605.970981,
  "comm_rcbp": 0.518735176,
  "comm_rvp": 0.021082817,
  "comm_u18bbp": 0.579103932,
  "comm_evrate": 144.6139058,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.375485471,
  "econ_fincap": 0.678540321,
  "econ_medinc": 22933.25205,
  "econ_paydaycap": 1.357080641,
  "econ_pctlwjobs": 0.2379782,
  "econ_pctmwjobs": 0.412160718,
  "econ_totjobs": 9358,
  "econ_pr": 0.263631066,
  "econ_pyr": 0.24609655,
  "econ_ur": 0.042848788,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 767.2475515,
  "edu_perbach": 0.046625019,
  "edu_perearlyed": 0.232568027,
  "edu_qeckids": 1.020275999,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.182483994,
  "fam_lcckids": 11.22303599,
  "fam_tphh": 4453.322328,
  "fam_tphhpct": 0.647593676,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3516.133076,
  "hel_castthma": 997.8851976,
  "hel_checkup": 6544.467114,
  "hel_fruitsveggies": 326.6295186,
  "hel_le": 75.23287898,
  "hel_mhlth": 1739.708368,
  "hel_obesity": 3970.204183,
  "hel_perpri": 0.354686812,
  "hel_perpub": 0.350774078,
  "hel_prtopu": 1.01115457,
  "hel_pharmacap": 1.865985881,
  "hel_phlth": 1665.843186,
  "hel_sleep": 3788.534204,
  "hel_stroke": 381.1067814,
  "hel_perins": 0.681611843,
  "hel_perunin": 0.31816796,
  "hel_clincap": 0.16963508,
  "hel_groccap": 1.357080641,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 24,
  "ci_index": 55,
  "eci_index": 34,
  "edi_index": 41,
  "fi_index": 82,
  "hi_index": 22,
  "cri_index": 42,
  "ci_weight": 55,
  "eci_weight": 34,
  "edi_weight": 41,
  "fi_weight": 82,
  "hi_weight": 22,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 129,
  "TEA": 352,
  "SLN": 352,
  "SCHOOLNAME": "Young Women's STEAM Academy at Balch Springs Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "710 Cheyenne Rd.",
  "CITY": "Balch Spr",
  "ZIP": 75180,
  "PHONE": 9728925800,
  "WEBSITE": "http://www.dallasisd.org/balchsprings",
  "POINT_X": -96.63837618,
  "POINT_Y": 32.72563844,
  "MasterID": "'057905352",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 53099,
  "dem_popwh": 5513,
  "dem_popbl": 12149,
  "dem_popas": 15,
  "dem_pophi": 35029,
  "dem_popm": 25559,
  "dem_popf": 27533,
  "dem_thh": 14047,
  "dem_popse": 3041,
  "dem_popch": 18769,
  "dem_perwh": 0.103824931,
  "dem_perbl": 0.228799036,
  "dem_peras": 0.000282491,
  "dem_perhi": 0.659692273,
  "dem_perm": 0.481346165,
  "dem_perf": 0.518522006,
  "dem_perse": 0.057270382,
  "dem_perch": 0.353471817,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 0,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.712549219,
  "comm_bvp": 0.107227967,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.006470838,
  "comm_juvcrimecap": 162.6994963,
  "comm_libcap": 0.189102966,
  "comm_ltbvp": 0.106066755,
  "comm_ltrvp": 0.018452584,
  "comm_ocb": 2888.929466,
  "comm_ocbp": 0.324674242,
  "comm_parkcap": 0.057449762,
  "comm_rcb": 2620.000008,
  "comm_rcbp": 0.508737024,
  "comm_rvp": 0.020226397,
  "comm_u18bbp": 0.727571766,
  "comm_evrate": 145.9874894,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.344188261,
  "econ_fincap": 0.189102966,
  "econ_medinc": 22527.42251,
  "econ_paydaycap": 0.756411862,
  "econ_pctlwjobs": 0.246945899,
  "econ_pctmwjobs": 0.426410704,
  "econ_totjobs": 6876,
  "econ_pr": 0.265569536,
  "econ_pyr": 0.218708707,
  "econ_ur": 0.051302736,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 327.3627977,
  "edu_perbach": 0.031027166,
  "edu_perearlyed": 0.349589322,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.853814134,
  "fam_lcckids": 5.393126815,
  "fam_tphh": 4007.328251,
  "fam_tphhpct": 0.613481669,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3095.041133,
  "hel_castthma": 937.3860991,
  "hel_checkup": 5781.519744,
  "hel_fruitsveggies": 336.357719,
  "hel_le": 74.25653339,
  "hel_mhlth": 1673.844428,
  "hel_obesity": 3623.330232,
  "hel_perpri": 0.337872966,
  "hel_perpub": 0.374190024,
  "hel_prtopu": 0.902944878,
  "hel_pharmacap": 1.891029656,
  "hel_phlth": 1541.643787,
  "hel_sleep": 3423.373893,
  "hel_stroke": 332.3983,
  "hel_perins": 0.686577004,
  "hel_perunin": 0.313196956,
  "hel_clincap": 0.378205931,
  "hel_groccap": 0.378205931,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 55,
  "eci_index": 31,
  "edi_index": 52,
  "fi_index": 70,
  "hi_index": 29,
  "cri_index": 42,
  "ci_weight": 55,
  "eci_weight": 31,
  "edi_weight": 52,
  "fi_weight": 70,
  "hi_weight": 29,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 130,
  "TEA": 42,
  "SLN": 42,
  "SCHOOLNAME": "Atwell Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "1303 Reynoldston Lane",
  "CITY": "Dallas",
  "ZIP": 75232,
  "PHONE": 9727946400,
  "WEBSITE": "http://www.dallasisd.org/atwellacademy",
  "POINT_X": -96.84175451,
  "POINT_Y": 32.67776538,
  "MasterID": "'057905042",
  "Feeder": "Carter",
  "HIGH_SLN": 23,
  "dem_totp": 51820,
  "dem_popwh": 3759,
  "dem_popbl": 31309,
  "dem_popas": 15,
  "dem_pophi": 15820,
  "dem_popm": 23735,
  "dem_popf": 28072,
  "dem_thh": 18021,
  "dem_popse": 7288,
  "dem_popch": 14852,
  "dem_perwh": 0.07253956,
  "dem_perbl": 0.604187572,
  "dem_peras": 0.000289464,
  "dem_perhi": 0.305287534,
  "dem_perm": 0.458027788,
  "dem_perf": 0.541721343,
  "dem_perse": 0.140640679,
  "dem_perch": 0.286607487,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.620325001,
  "comm_bvp": 0.103864978,
  "comm_cctrcap": 0.785552978,
  "comm_incarpct": 0.008407594,
  "comm_juvcrimecap": 292.8169943,
  "comm_libcap": 0.196388245,
  "comm_ltbvp": 0.102840317,
  "comm_ltrvp": 0.010786944,
  "comm_ocb": 2255.603568,
  "comm_ocbp": 0.271907898,
  "comm_parkcap": 0.093941461,
  "comm_rcb": 5442.064717,
  "comm_rcbp": 0.558793255,
  "comm_rvp": 0.011694495,
  "comm_u18bbp": 0.635424673,
  "comm_evrate": 229.9706343,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.445837283,
  "econ_fincap": 1.178329467,
  "econ_medinc": 23257.31744,
  "econ_paydaycap": 0.589164734,
  "econ_pctlwjobs": 0.319223016,
  "econ_pctmwjobs": 0.384277075,
  "econ_totjobs": 5457,
  "econ_pr": 0.299686395,
  "econ_pyr": 0.350399323,
  "econ_ur": 0.077097268,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 1,
  "edu_oostkids": 2135.488867,
  "edu_perbach": 0.096990498,
  "edu_perearlyed": 0.454252577,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 16.95909202,
  "fam_lcckids": 20.35091042,
  "fam_tphh": 1850.812159,
  "fam_tphhpct": 0.370334048,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4374.791404,
  "hel_castthma": 1124.252486,
  "hel_checkup": 7300.30856,
  "hel_fruitsveggies": 353.5717931,
  "hel_le": 74.74952879,
  "hel_mhlth": 1627.852771,
  "hel_obesity": 4231.163503,
  "hel_perpri": 0.414877983,
  "hel_perpub": 0.426712302,
  "hel_prtopu": 0.97226628,
  "hel_pharmacap": 1.178329467,
  "hel_phlth": 1626.806746,
  "hel_sleep": 3972.136912,
  "hel_stroke": 506.4721346,
  "hel_perins": 0.787659048,
  "hel_perunin": 0.212302278,
  "hel_clincap": 0.196388245,
  "hel_groccap": 0.392776489,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 13,
  "ci_index": 57,
  "eci_index": 12,
  "edi_index": 61,
  "fi_index": 55,
  "hi_index": 21,
  "cri_index": 35,
  "ci_weight": 57,
  "eci_weight": 12,
  "edi_weight": 61,
  "fi_weight": 55,
  "hi_weight": 21,
  "cri_weight": 30,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 2,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 131,
  "TEA": 58,
  "SLN": 58,
  "SCHOOLNAME": "Spence Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "4001 Capitol Ave.",
  "CITY": "Dallas",
  "ZIP": 75204,
  "PHONE": 9729252300,
  "WEBSITE": "http://www.dallasisd.org/spence",
  "POINT_X": -96.78800049,
  "POINT_Y": 32.80782539,
  "MasterID": "'057905058",
  "Feeder": "North Dallas",
  "HIGH_SLN": 24,
  "dem_totp": 104373,
  "dem_popwh": 62812,
  "dem_popbl": 9471,
  "dem_popas": 217,
  "dem_pophi": 23963,
  "dem_popm": 54695,
  "dem_popf": 49675,
  "dem_thh": 57490,
  "dem_popse": 9386,
  "dem_popch": 12375,
  "dem_perwh": 0.601803148,
  "dem_perbl": 0.090741859,
  "dem_peras": 0.002079082,
  "dem_perhi": 0.229590028,
  "dem_perm": 0.524033993,
  "dem_perf": 0.475937263,
  "dem_perse": 0.089927472,
  "dem_perch": 0.118565146,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 0,
  "comm_bbp": 0.859188018,
  "comm_bvp": 0.104599672,
  "comm_cctrcap": 0.481674898,
  "comm_incarpct": 0.003138869,
  "comm_juvcrimecap": 238.7257741,
  "comm_libcap": 0.192669959,
  "comm_ltbvp": 0.093562216,
  "comm_ltrvp": 0.013745657,
  "comm_ocb": 4240.914802,
  "comm_ocbp": 0.254177664,
  "comm_parkcap": 0.038605209,
  "comm_rcb": 14178.6545,
  "comm_rcbp": 0.347409118,
  "comm_rvp": 0.019867924,
  "comm_u18bbp": 0.76174226,
  "comm_evrate": 225.8091921,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.312092386,
  "econ_fincap": 7.128788486,
  "econ_medinc": 54241.57547,
  "econ_paydaycap": 1.734029632,
  "econ_pctlwjobs": 0.137902256,
  "econ_pctmwjobs": 0.237210758,
  "econ_totjobs": 201302,
  "econ_pr": 0.145101667,
  "econ_pyr": 0.115615572,
  "econ_ur": 0.029473731,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1750.533418,
  "edu_perbach": 0.381093548,
  "edu_perearlyed": 0.599886493,
  "edu_qeckids": 0.818388695,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.728720864,
  "fam_lcckids": 26.18843824,
  "fam_tphh": 3818.546906,
  "fam_tphhpct": 0.594243343,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2184.592685,
  "hel_castthma": 757.1803147,
  "hel_checkup": 5857.504886,
  "hel_fruitsveggies": 446.630013,
  "hel_le": 79.72644251,
  "hel_mhlth": 1100.017919,
  "hel_obesity": 2626.936165,
  "hel_perpri": 0.734384755,
  "hel_perpub": 0.180179228,
  "hel_prtopu": 4.075856922,
  "hel_pharmacap": 4.2387391,
  "hel_phlth": 836.730798,
  "hel_sleep": 2871.369432,
  "hel_stroke": 167.837614,
  "hel_perins": 0.87038122,
  "hel_perunin": 0.1294651,
  "hel_clincap": 0.867014816,
  "hel_groccap": 1.734029632,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 61,
  "ci_index": 62,
  "eci_index": 60,
  "edi_index": 96,
  "fi_index": 97,
  "hi_index": 72,
  "cri_index": 63,
  "ci_weight": 62,
  "eci_weight": 60,
  "edi_weight": 96,
  "fi_weight": 97,
  "hi_weight": 72,
  "cri_weight": 73,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 132,
  "TEA": 49,
  "SLN": 49,
  "SCHOOLNAME": "Greiner Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "501 S. Edgefield Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9729257100,
  "WEBSITE": "http://www.dallasisd.org/greineracademy",
  "POINT_X": -96.84494799,
  "POINT_Y": 32.74000383,
  "MasterID": "'057905049",
  "Feeder": "Sunset",
  "HIGH_SLN": 18,
  "dem_totp": 84234,
  "dem_popwh": 11675,
  "dem_popbl": 7960,
  "dem_popas": 104,
  "dem_pophi": 63539,
  "dem_popm": 44028,
  "dem_popf": 40183,
  "dem_thh": 26306,
  "dem_popse": 7668,
  "dem_popch": 24296,
  "dem_perwh": 0.13860199,
  "dem_perbl": 0.094498658,
  "dem_peras": 0.001234656,
  "dem_perhi": 0.75431536,
  "dem_perm": 0.522686801,
  "dem_perf": 0.47704015,
  "dem_perse": 0.091032125,
  "dem_perch": 0.288434599,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.762150752,
  "comm_bvp": 0.101480496,
  "comm_cctrcap": 0.238655238,
  "comm_incarpct": 0.00379984,
  "comm_juvcrimecap": 200.6311601,
  "comm_libcap": 0.238655238,
  "comm_ltbvp": 0.093403257,
  "comm_ltrvp": 0.024161726,
  "comm_ocb": 3117.516621,
  "comm_ocbp": 0.223758874,
  "comm_parkcap": 0.082236255,
  "comm_rcb": 5622.42832,
  "comm_rcbp": 0.453764351,
  "comm_rvp": 0.025870376,
  "comm_u18bbp": 0.772342652,
  "comm_evrate": 102.7410798,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.331705003,
  "econ_fincap": 1.789914283,
  "econ_medinc": 27086.57962,
  "econ_paydaycap": 2.744535233,
  "econ_pctlwjobs": 0.265001998,
  "econ_pctmwjobs": 0.426328406,
  "econ_totjobs": 25030,
  "econ_pr": 0.215875422,
  "econ_pyr": 0.407208057,
  "econ_ur": 0.073382677,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 1,
  "edu_oostkids": 1352.361545,
  "edu_perbach": 0.124239311,
  "edu_perearlyed": 0.468665768,
  "edu_qeckids": 0.833504804,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.751800445,
  "fam_lcckids": 12.50257206,
  "fam_tphh": 5203.674195,
  "fam_tphhpct": 0.601862316,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3251.948488,
  "hel_castthma": 899.0196649,
  "hel_checkup": 6391.143589,
  "hel_fruitsveggies": 357.231391,
  "hel_le": 76.33723003,
  "hel_mhlth": 1588.679697,
  "hel_obesity": 3703.911623,
  "hel_perpri": 0.433793268,
  "hel_perpub": 0.328690377,
  "hel_prtopu": 1.319762603,
  "hel_pharmacap": 2.625207615,
  "hel_phlth": 1558.445893,
  "hel_sleep": 3503.852322,
  "hel_stroke": 330.1775679,
  "hel_perins": 0.734173903,
  "hel_perunin": 0.265885572,
  "hel_clincap": 0.596638094,
  "hel_groccap": 1.909241901,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 32,
  "ci_index": 62,
  "eci_index": 33,
  "edi_index": 75,
  "fi_index": 81,
  "hi_index": 34,
  "cri_index": 45,
  "ci_weight": 62,
  "eci_weight": 33,
  "edi_weight": 75,
  "fi_weight": 81,
  "hi_weight": 34,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 133,
  "TEA": 163,
  "SLN": 163,
  "SCHOOLNAME": "Cedar Crest Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2020 Mouser St.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 9729257400,
  "WEBSITE": "http://www.dallasisd.org/cedarcrest",
  "POINT_X": -96.792955,
  "POINT_Y": 32.73745713,
  "MasterID": "'057905163",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 39620,
  "dem_popwh": 2625,
  "dem_popbl": 17508,
  "dem_popas": 35,
  "dem_pophi": 19002,
  "dem_popm": 20201,
  "dem_popf": 19413,
  "dem_thh": 13663,
  "dem_popse": 4409,
  "dem_popch": 10842,
  "dem_perwh": 0.066254417,
  "dem_perbl": 0.441898031,
  "dem_peras": 0.000883392,
  "dem_perhi": 0.479606259,
  "dem_perm": 0.509868753,
  "dem_perf": 0.489979808,
  "dem_perse": 0.111282181,
  "dem_perch": 0.273649672,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.640477868,
  "comm_bvp": 0.151658763,
  "comm_cctrcap": 0.75991772,
  "comm_incarpct": 0.015775436,
  "comm_juvcrimecap": 561.1325808,
  "comm_libcap": 0.253305907,
  "comm_ltbvp": 0.150008645,
  "comm_ltrvp": 0.119157797,
  "comm_ocb": 1562.043542,
  "comm_ocbp": 0.27002306,
  "comm_parkcap": 0.315432427,
  "comm_rcb": 3902.582662,
  "comm_rcbp": 0.494112682,
  "comm_rvp": 0.125638039,
  "comm_u18bbp": 0.694677928,
  "comm_evrate": 221.6426684,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.439632839,
  "econ_fincap": 1.519835441,
  "econ_medinc": 21139.17149,
  "econ_paydaycap": 1.519835441,
  "econ_pctlwjobs": 0.232986884,
  "econ_pctmwjobs": 0.394209354,
  "econ_totjobs": 8082,
  "econ_pr": 0.303690737,
  "econ_pyr": 0.567318195,
  "econ_ur": 0.104937881,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1840.141564,
  "edu_perbach": 0.098874886,
  "edu_perearlyed": 0.441468254,
  "edu_qeckids": 1.868164024,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 14.94531219,
  "fam_lcckids": 17.74755823,
  "fam_tphh": 1671.885354,
  "fam_tphhpct": 0.467052066,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4327.37961,
  "hel_castthma": 1085.020009,
  "hel_checkup": 6992.134784,
  "hel_fruitsveggies": 288.5667942,
  "hel_le": 71.17885425,
  "hel_mhlth": 1746.252546,
  "hel_obesity": 4327.367244,
  "hel_perpri": 0.313895343,
  "hel_perpub": 0.413551874,
  "hel_prtopu": 0.759022901,
  "hel_pharmacap": 1.773141347,
  "hel_phlth": 1837.451968,
  "hel_sleep": 4007.077687,
  "hel_stroke": 569.2198284,
  "hel_perins": 0.706359228,
  "hel_perunin": 0.293388221,
  "hel_clincap": 1.013223627,
  "hel_groccap": 0.75991772,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 1,
  "hi_gen": 11,
  "ci_index": 34,
  "eci_index": 12,
  "edi_index": 76,
  "fi_index": 65,
  "hi_index": 9,
  "cri_index": 23,
  "ci_weight": 34,
  "eci_weight": 12,
  "edi_weight": 76,
  "fi_weight": 65,
  "hi_weight": 9,
  "cri_weight": 20,
  "ci_weight_sd": 1,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 134,
  "TEA": 178,
  "SLN": 178,
  "SCHOOLNAME": "Holland at Lisbon Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4203 S. Lancaster Rd.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9727491900,
  "WEBSITE": "http://www.dallasisd.org/holland",
  "POINT_X": -96.79580466,
  "POINT_Y": 32.69737532,
  "MasterID": "'057905178",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 52861,
  "dem_popwh": 1627,
  "dem_popbl": 31098,
  "dem_popas": 66,
  "dem_pophi": 19432,
  "dem_popm": 24543,
  "dem_popf": 28317,
  "dem_thh": 18176,
  "dem_popse": 7009,
  "dem_popch": 14972,
  "dem_perwh": 0.030778835,
  "dem_perbl": 0.588297611,
  "dem_peras": 0.001248558,
  "dem_perhi": 0.367605607,
  "dem_perm": 0.464293146,
  "dem_perf": 0.535687936,
  "dem_perse": 0.132593027,
  "dem_perch": 0.283233386,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.502815969,
  "comm_bvp": 0.108335655,
  "comm_cctrcap": 0.957803943,
  "comm_incarpct": 0.012897199,
  "comm_juvcrimecap": 441.3875049,
  "comm_libcap": 0.191560789,
  "comm_ltbvp": 0.101144461,
  "comm_ltrvp": 0.044788312,
  "comm_ocb": 2477.494651,
  "comm_ocbp": 0.285825202,
  "comm_parkcap": 0.137093629,
  "comm_rcb": 5110.231954,
  "comm_rcbp": 0.536964662,
  "comm_rvp": 0.051756821,
  "comm_u18bbp": 0.564463035,
  "comm_evrate": 208.7054793,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.44396237,
  "econ_fincap": 1.532486309,
  "econ_medinc": 18912.94394,
  "econ_paydaycap": 1.149364732,
  "econ_pctlwjobs": 0.334963955,
  "econ_pctmwjobs": 0.370236869,
  "econ_totjobs": 3884,
  "econ_pr": 0.337351533,
  "econ_pyr": 0.387476923,
  "econ_ur": 0.095857666,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 2056.00905,
  "edu_perbach": 0.052984409,
  "edu_perearlyed": 0.444984802,
  "edu_qeckids": 4.697148613,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 22.81472183,
  "fam_lcckids": 20.80165814,
  "fam_tphh": 2036.070588,
  "fam_tphhpct": 0.421021745,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4815.905125,
  "hel_castthma": 1179.41814,
  "hel_checkup": 7324.341471,
  "hel_fruitsveggies": 281.6752164,
  "hel_le": 71.43110551,
  "hel_mhlth": 1814.018882,
  "hel_obesity": 4551.339824,
  "hel_perpri": 0.302060974,
  "hel_perpub": 0.472637477,
  "hel_prtopu": 0.639096536,
  "hel_pharmacap": 1.724047098,
  "hel_phlth": 1968.818456,
  "hel_sleep": 4149.411281,
  "hel_stroke": 669.0630438,
  "hel_perins": 0.743033526,
  "hel_perunin": 0.256757527,
  "hel_clincap": 0.383121577,
  "hel_groccap": 0.766243155,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 4,
  "ci_index": 22,
  "eci_index": 4,
  "edi_index": 77,
  "fi_index": 76,
  "hi_index": 4,
  "cri_index": 19,
  "ci_weight": 22,
  "eci_weight": 4,
  "edi_weight": 77,
  "fi_weight": 76,
  "hi_weight": 4,
  "cri_weight": 13,
  "ci_weight_sd": 1,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 135,
  "TEA": 185,
  "SLN": 185,
  "SCHOOLNAME": "Miller Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3111 Bonnie View Rd.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9725028700,
  "WEBSITE": "http://www.dallasisd.org/miller",
  "POINT_X": -96.78021798,
  "POINT_Y": 32.71867851,
  "MasterID": "'057905185",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 37672,
  "dem_popwh": 757,
  "dem_popbl": 23341,
  "dem_popas": 38,
  "dem_pophi": 13206,
  "dem_popm": 17727,
  "dem_popf": 19936,
  "dem_thh": 13455,
  "dem_popse": 4771,
  "dem_popch": 10787,
  "dem_perwh": 0.0200945,
  "dem_perbl": 0.619584838,
  "dem_peras": 0.001008707,
  "dem_perhi": 0.350552134,
  "dem_perm": 0.47056169,
  "dem_perf": 0.529199405,
  "dem_perse": 0.126645785,
  "dem_perch": 0.286339987,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.483276265,
  "comm_bvp": 0.141273033,
  "comm_cctrcap": 1.062404509,
  "comm_incarpct": 0.021402041,
  "comm_juvcrimecap": 693.1300846,
  "comm_libcap": 0.265601127,
  "comm_ltbvp": 0.136813507,
  "comm_ltrvp": 0.140302508,
  "comm_ocb": 1722.961593,
  "comm_ocbp": 0.280828699,
  "comm_parkcap": 0.19497202,
  "comm_rcb": 4057.507489,
  "comm_rcbp": 0.553062524,
  "comm_rvp": 0.147756834,
  "comm_u18bbp": 0.536128289,
  "comm_evrate": 308.6285098,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.492815057,
  "econ_fincap": 2.124809017,
  "econ_medinc": 18435.53415,
  "econ_paydaycap": 1.062404509,
  "econ_pctlwjobs": 0.275332651,
  "econ_pctmwjobs": 0.355168884,
  "econ_totjobs": 2931,
  "econ_pr": 0.363817931,
  "econ_pyr": 0.424656018,
  "econ_ur": 0.09655007,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1577.810912,
  "edu_perbach": 0.048525538,
  "edu_perearlyed": 0.362292052,
  "edu_qeckids": 1.856248132,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 15.77810912,
  "fam_lcckids": 13.92186099,
  "fam_tphh": 1241.317183,
  "fam_tphhpct": 0.357013945,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4957.666856,
  "hel_castthma": 1199.511807,
  "hel_checkup": 7343.453466,
  "hel_fruitsveggies": 267.206558,
  "hel_le": 70.85913857,
  "hel_mhlth": 1884.583638,
  "hel_obesity": 4705.330531,
  "hel_perpri": 0.269430877,
  "hel_perpub": 0.484789764,
  "hel_prtopu": 0.555768494,
  "hel_pharmacap": 1.328005636,
  "hel_phlth": 2067.817792,
  "hel_sleep": 4235.92228,
  "hel_stroke": 713.7196782,
  "hel_perins": 0.731392015,
  "hel_perunin": 0.268183266,
  "hel_clincap": 0,
  "hel_groccap": 0.265601127,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 1,
  "ci_index": 2,
  "eci_index": 0,
  "edi_index": 66,
  "fi_index": 40,
  "hi_index": 1,
  "cri_index": 2,
  "ci_weight": 2,
  "eci_weight": 0,
  "edi_weight": 66,
  "fi_weight": 40,
  "hi_weight": 1,
  "cri_weight": 1,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 136,
  "TEA": 189,
  "SLN": 189,
  "SCHOOLNAME": "Oliver Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4010 Idaho Ave.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9727493400,
  "WEBSITE": "http://www.dallasisd.org/oliver",
  "POINT_X": -96.81098205,
  "POINT_Y": 32.6949231,
  "MasterID": "'057905189",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 60468,
  "dem_popwh": 2627,
  "dem_popbl": 30242,
  "dem_popas": 49,
  "dem_pophi": 26761,
  "dem_popm": 28410,
  "dem_popf": 32058,
  "dem_thh": 19457,
  "dem_popse": 7566,
  "dem_popch": 17803,
  "dem_perwh": 0.043444466,
  "dem_perbl": 0.500132301,
  "dem_peras": 0.000810346,
  "dem_perhi": 0.442564662,
  "dem_perm": 0.469835285,
  "dem_perf": 0.530164715,
  "dem_perse": 0.125124033,
  "dem_perch": 0.294420189,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.586530824,
  "comm_bvp": 0.093044014,
  "comm_cctrcap": 0.505272804,
  "comm_incarpct": 0.010363149,
  "comm_juvcrimecap": 311.4713522,
  "comm_libcap": 0.168424268,
  "comm_ltbvp": 0.085726278,
  "comm_ltrvp": 0.029785395,
  "comm_ocb": 2717.339026,
  "comm_ocbp": 0.282787364,
  "comm_parkcap": 0.065095867,
  "comm_rcb": 5323.015698,
  "comm_rcbp": 0.540153254,
  "comm_rvp": 0.035210549,
  "comm_u18bbp": 0.659097454,
  "comm_evrate": 166.8242373,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 1,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.425417802,
  "econ_fincap": 1.347394143,
  "econ_medinc": 20130.22447,
  "econ_paydaycap": 1.347394143,
  "econ_pctlwjobs": 0.322768305,
  "econ_pctmwjobs": 0.387963892,
  "econ_totjobs": 4985,
  "econ_pr": 0.320488173,
  "econ_pyr": 0.426772226,
  "econ_ur": 0.097755785,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1751.31639,
  "edu_perbach": 0.063372239,
  "edu_perearlyed": 0.421459642,
  "edu_qeckids": 3.971238979,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 21.55815446,
  "fam_lcckids": 22.12547431,
  "fam_tphh": 2742.475278,
  "fam_tphhpct": 0.478503297,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4510.619614,
  "hel_castthma": 1126.502371,
  "hel_checkup": 7153.084183,
  "hel_fruitsveggies": 313.9914494,
  "hel_le": 72.85362995,
  "hel_mhlth": 1764.805419,
  "hel_obesity": 4384.526394,
  "hel_perpri": 0.329776465,
  "hel_perpub": 0.454737052,
  "hel_prtopu": 0.72520254,
  "hel_pharmacap": 1.684242678,
  "hel_phlth": 1866.712518,
  "hel_sleep": 4022.385048,
  "hel_stroke": 596.0436516,
  "hel_perins": 0.743540384,
  "hel_perunin": 0.256243881,
  "hel_clincap": 0.505272804,
  "hel_groccap": 0.673697071,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 9,
  "ci_index": 45,
  "eci_index": 6,
  "edi_index": 77,
  "fi_index": 92,
  "hi_index": 10,
  "cri_index": 37,
  "ci_weight": 45,
  "eci_weight": 6,
  "edi_weight": 77,
  "fi_weight": 92,
  "hi_weight": 10,
  "cri_weight": 24,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 137,
  "TEA": 191,
  "SLN": 191,
  "SCHOOLNAME": "Pease Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2914 Cummings St.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 2149323800,
  "WEBSITE": "http://www.dallasisd.org/pease",
  "POINT_X": -96.77264178,
  "POINT_Y": 32.69799781,
  "MasterID": "'057905191",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 35413,
  "dem_popwh": 808,
  "dem_popbl": 24176,
  "dem_popas": 56,
  "dem_pophi": 9877,
  "dem_popm": 16098,
  "dem_popf": 19322,
  "dem_thh": 13236,
  "dem_popse": 4503,
  "dem_popch": 10003,
  "dem_perwh": 0.02281648,
  "dem_perbl": 0.682687149,
  "dem_peras": 0.00158134,
  "dem_perhi": 0.278908875,
  "dem_perm": 0.454578827,
  "dem_perf": 0.545618841,
  "dem_perse": 0.127156694,
  "dem_perch": 0.282466891,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.426200375,
  "comm_bvp": 0.101464473,
  "comm_cctrcap": 0.852688891,
  "comm_incarpct": 0.018195749,
  "comm_juvcrimecap": 754.4103684,
  "comm_libcap": 0.28422963,
  "comm_ltbvp": 0.096587231,
  "comm_ltrvp": 0.090042112,
  "comm_ocb": 1543.075371,
  "comm_ocbp": 0.275278835,
  "comm_parkcap": 0.209073043,
  "comm_rcb": 4101.842749,
  "comm_rcbp": 0.537633198,
  "comm_rvp": 0.096636167,
  "comm_u18bbp": 0.459339614,
  "comm_evrate": 357.8451048,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.507165272,
  "econ_fincap": 2.273837044,
  "econ_medinc": 17201.90402,
  "econ_paydaycap": 1.136918522,
  "econ_pctlwjobs": 0.249090909,
  "econ_pctmwjobs": 0.314545455,
  "econ_totjobs": 2750,
  "econ_pr": 0.381516521,
  "econ_pyr": 0.330851973,
  "econ_ur": 0.089157711,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 0,
  "edu_oostkids": 1467.521568,
  "edu_perbach": 0.040359352,
  "edu_perearlyed": 0.406300485,
  "edu_qeckids": 3.009271841,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 21.06490289,
  "fam_lcckids": 16.04944982,
  "fam_tphh": 1031.684118,
  "fam_tphhpct": 0.309817965,
  "fam_affcckids_sd": 3,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": -1,
  "hel_bphigh": 4983.514431,
  "hel_castthma": 1237.636588,
  "hel_checkup": 7435.474437,
  "hel_fruitsveggies": 258.5201133,
  "hel_le": 70.43953738,
  "hel_mhlth": 1901.950856,
  "hel_obesity": 4738.889135,
  "hel_perpri": 0.263813911,
  "hel_perpub": 0.496424635,
  "hel_prtopu": 0.531427921,
  "hel_pharmacap": 1.989607413,
  "hel_phlth": 2033.092299,
  "hel_sleep": 4298.227456,
  "hel_stroke": 701.3707032,
  "hel_perins": 0.741669258,
  "hel_perunin": 0.258189424,
  "hel_clincap": 0,
  "hel_groccap": 1.136918522,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 0,
  "ci_index": 2,
  "eci_index": 7,
  "edi_index": 70,
  "fi_index": 30,
  "hi_index": 0,
  "cri_index": 4,
  "ci_weight": 2,
  "eci_weight": 7,
  "edi_weight": 70,
  "fi_weight": 30,
  "hi_weight": 0,
  "cri_weight": 2,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 138,
  "TEA": 121,
  "SLN": 121,
  "SCHOOLNAME": "Carpenter Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2121 Tosca Lane",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9727946000,
  "WEBSITE": "http://www.dallasisd.org/carpenter",
  "POINT_X": -96.85301532,
  "POINT_Y": 32.69574191,
  "MasterID": "'057905121",
  "Feeder": "Kimball",
  "HIGH_SLN": 8,
  "dem_totp": 60204,
  "dem_popwh": 4510,
  "dem_popbl": 24305,
  "dem_popas": 20,
  "dem_pophi": 30302,
  "dem_popm": 28585,
  "dem_popf": 31592,
  "dem_thh": 19420,
  "dem_popse": 6860,
  "dem_popch": 18320,
  "dem_perwh": 0.074911966,
  "dem_perbl": 0.403710717,
  "dem_peras": 0.000332204,
  "dem_perhi": 0.503322038,
  "dem_perm": 0.474802339,
  "dem_perf": 0.524749186,
  "dem_perse": 0.113945917,
  "dem_perch": 0.304298718,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 3,
  "dem_perch_sd": 3,
  "comm_bbp": 0.711152938,
  "comm_bvp": 0.101636577,
  "comm_cctrcap": 0.337856057,
  "comm_incarpct": 0.006794818,
  "comm_juvcrimecap": 223.9939888,
  "comm_libcap": 0.168928028,
  "comm_ltbvp": 0.098990928,
  "comm_ltrvp": 0.017034365,
  "comm_ocb": 2199.568261,
  "comm_ocbp": 0.244808604,
  "comm_parkcap": 0.114904837,
  "comm_rcb": 5559.097372,
  "comm_rcbp": 0.531881891,
  "comm_rvp": 0.017778872,
  "comm_u18bbp": 0.742634924,
  "comm_evrate": 217.9171568,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.382820182,
  "econ_fincap": 1.351424228,
  "econ_medinc": 24216.08656,
  "econ_paydaycap": 1.013568171,
  "econ_pctlwjobs": 0.296758734,
  "econ_pctmwjobs": 0.380501955,
  "econ_totjobs": 7929,
  "econ_pr": 0.270403858,
  "econ_pyr": 0.499992295,
  "econ_ur": 0.090034521,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1212.420252,
  "edu_perbach": 0.098789501,
  "edu_perearlyed": 0.483777038,
  "edu_qeckids": 0.550099933,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 12.10219852,
  "fam_lcckids": 14.85269818,
  "fam_tphh": 2885.448279,
  "fam_tphhpct": 0.460871543,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3941.84119,
  "hel_castthma": 1043.252391,
  "hel_checkup": 6935.087192,
  "hel_fruitsveggies": 348.0295285,
  "hel_le": 76.16243975,
  "hel_mhlth": 1638.650758,
  "hel_obesity": 4037.064094,
  "hel_perpri": 0.413905079,
  "hel_perpub": 0.386494588,
  "hel_prtopu": 1.070920763,
  "hel_pharmacap": 1.689280285,
  "hel_phlth": 1625.465824,
  "hel_sleep": 3797.73654,
  "hel_stroke": 448.7621396,
  "hel_perins": 0.759916736,
  "hel_perunin": 0.239800167,
  "hel_clincap": 0.506784085,
  "hel_groccap": 0.506784085,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 19,
  "ci_index": 59,
  "eci_index": 17,
  "edi_index": 73,
  "fi_index": 76,
  "hi_index": 22,
  "cri_index": 41,
  "ci_weight": 59,
  "eci_weight": 17,
  "edi_weight": 73,
  "fi_weight": 76,
  "hi_weight": 22,
  "cri_weight": 35,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 139,
  "TEA": 133,
  "SLN": 133,
  "SCHOOLNAME": "Jordan Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1111 W. Kiest Blvd.",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9729258100,
  "WEBSITE": "http://www.dallasisd.org/jordan",
  "POINT_X": -96.84167293,
  "POINT_Y": 32.70654591,
  "MasterID": "'057905133",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 75772,
  "dem_popwh": 5313,
  "dem_popbl": 24077,
  "dem_popas": 38,
  "dem_pophi": 45311,
  "dem_popm": 36709,
  "dem_popf": 39039,
  "dem_thh": 22937,
  "dem_popse": 8071,
  "dem_popch": 23931,
  "dem_perwh": 0.070118249,
  "dem_perbl": 0.317755899,
  "dem_peras": 0.000501505,
  "dem_perhi": 0.597991342,
  "dem_perm": 0.484466558,
  "dem_perf": 0.515216703,
  "dem_perse": 0.106516919,
  "dem_perch": 0.315829066,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.714933744,
  "comm_bvp": 0.09969784,
  "comm_cctrcap": 0.535936091,
  "comm_incarpct": 0.006243479,
  "comm_juvcrimecap": 221.2685353,
  "comm_libcap": 0.133984023,
  "comm_ltbvp": 0.091525897,
  "comm_ltrvp": 0.019830879,
  "comm_ocb": 2890.287027,
  "comm_ocbp": 0.249587587,
  "comm_parkcap": 0.087866674,
  "comm_rcb": 6012.126669,
  "comm_rcbp": 0.52891143,
  "comm_rvp": 0.021707994,
  "comm_u18bbp": 0.7569345,
  "comm_evrate": 203.1197785,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.376702986,
  "econ_fincap": 1.205856205,
  "econ_medinc": 22941.18684,
  "econ_paydaycap": 1.339840227,
  "econ_pctlwjobs": 0.316806944,
  "econ_pctmwjobs": 0.409258285,
  "econ_totjobs": 7604,
  "econ_pr": 0.272458252,
  "econ_pyr": 0.511708806,
  "econ_ur": 0.094689642,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1095.598788,
  "edu_perbach": 0.08344917,
  "edu_perearlyed": 0.466621939,
  "edu_qeckids": 1.265125621,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 9.699296429,
  "fam_lcckids": 13.49467329,
  "fam_tphh": 4060.80274,
  "fam_tphhpct": 0.517628629,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3879.764684,
  "hel_castthma": 1025.45969,
  "hel_checkup": 6799.019674,
  "hel_fruitsveggies": 341.4812897,
  "hel_le": 75.74457275,
  "hel_mhlth": 1686.130765,
  "hel_obesity": 4043.210653,
  "hel_perpri": 0.382928314,
  "hel_perpub": 0.399446739,
  "hel_prtopu": 0.958646741,
  "hel_pharmacap": 1.875776318,
  "hel_phlth": 1705.866202,
  "hel_sleep": 3775.87827,
  "hel_stroke": 456.8796858,
  "hel_perins": 0.746241,
  "hel_perunin": 0.253719293,
  "hel_clincap": 0.401952068,
  "hel_groccap": 1.071872182,
  "hel_bphigh_sd": 1,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 3,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 19,
  "ci_index": 58,
  "eci_index": 15,
  "edi_index": 75,
  "fi_index": 80,
  "hi_index": 19,
  "cri_index": 41,
  "ci_weight": 58,
  "eci_weight": 15,
  "edi_weight": 75,
  "fi_weight": 80,
  "hi_weight": 19,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 140,
  "TEA": 205,
  "SLN": 205,
  "SCHOOLNAME": "Russell Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3031 S. Beckley Ave.",
  "CITY": "Dallas",
  "ZIP": 75224,
  "PHONE": 9729258300,
  "WEBSITE": "http://www.dallasisd.org/russell",
  "POINT_X": -96.82387998,
  "POINT_Y": 32.70858235,
  "MasterID": "'057905205",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 72999,
  "dem_popwh": 4330,
  "dem_popbl": 26679,
  "dem_popas": 50,
  "dem_pophi": 41029,
  "dem_popm": 35472,
  "dem_popf": 37525,
  "dem_thh": 22252,
  "dem_popse": 8025,
  "dem_popch": 22631,
  "dem_perwh": 0.059315881,
  "dem_perbl": 0.36547076,
  "dem_peras": 0.000684941,
  "dem_perhi": 0.562048795,
  "dem_perm": 0.485924465,
  "dem_perf": 0.514048138,
  "dem_perse": 0.109933013,
  "dem_perch": 0.310017945,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.680706027,
  "comm_bvp": 0.113291761,
  "comm_cctrcap": 0.556628694,
  "comm_incarpct": 0.008561556,
  "comm_juvcrimecap": 247.381585,
  "comm_libcap": 0.139157173,
  "comm_ltbvp": 0.102176104,
  "comm_ltrvp": 0.024709003,
  "comm_ocb": 3072.802963,
  "comm_ocbp": 0.266027476,
  "comm_parkcap": 0.104932217,
  "comm_rcb": 5737.601169,
  "comm_rcbp": 0.535573445,
  "comm_rvp": 0.028784236,
  "comm_u18bbp": 0.744301983,
  "comm_evrate": 135.5390869,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.375969814,
  "econ_fincap": 1.113257388,
  "econ_medinc": 21142.61364,
  "econ_paydaycap": 1.669886081,
  "econ_pctlwjobs": 0.343147039,
  "econ_pctmwjobs": 0.381237525,
  "econ_totjobs": 6012,
  "econ_pr": 0.280373498,
  "econ_pyr": 0.503738447,
  "econ_ur": 0.10081419,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1133.681434,
  "edu_perbach": 0.07824902,
  "edu_perearlyed": 0.471161341,
  "edu_qeckids": 1.341105797,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 11.17588164,
  "fam_lcckids": 15.19919903,
  "fam_tphh": 3815.173504,
  "fam_tphhpct": 0.519916253,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4117.407731,
  "hel_castthma": 1058.116779,
  "hel_checkup": 6906.751653,
  "hel_fruitsveggies": 317.9579797,
  "hel_le": 74.14878021,
  "hel_mhlth": 1721.226271,
  "hel_obesity": 4177.990305,
  "hel_perpri": 0.347606361,
  "hel_perpub": 0.426048504,
  "hel_prtopu": 0.815884477,
  "hel_pharmacap": 1.391571734,
  "hel_phlth": 1783.962726,
  "hel_sleep": 3875.108471,
  "hel_stroke": 515.8084192,
  "hel_perins": 0.738910709,
  "hel_perunin": 0.26093823,
  "hel_clincap": 0.41747152,
  "hel_groccap": 0.834943041,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 15,
  "ci_index": 56,
  "eci_index": 12,
  "edi_index": 75,
  "fi_index": 84,
  "hi_index": 14,
  "cri_index": 39,
  "ci_weight": 56,
  "eci_weight": 12,
  "edi_weight": 75,
  "fi_weight": 84,
  "hi_weight": 14,
  "cri_weight": 29,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 141,
  "TEA": 233,
  "SLN": 233,
  "SCHOOLNAME": "N. Adams Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "12600 Welch Rd.",
  "CITY": "Dallas",
  "ZIP": 75244,
  "PHONE": 9727942600,
  "WEBSITE": "http://www.dallasisd.org/nathanadams",
  "POINT_X": -96.82826298,
  "POINT_Y": 32.92151437,
  "MasterID": "'057905233",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 58002,
  "dem_popwh": 26797,
  "dem_popbl": 7235,
  "dem_popas": 60,
  "dem_pophi": 17909,
  "dem_popm": 28513,
  "dem_popf": 29474,
  "dem_thh": 26443,
  "dem_popse": 6706,
  "dem_popch": 12142,
  "dem_perwh": 0.46200131,
  "dem_perbl": 0.124737078,
  "dem_peras": 0.001034447,
  "dem_perhi": 0.308765215,
  "dem_perm": 0.491586497,
  "dem_perf": 0.508154891,
  "dem_perse": 0.115616703,
  "dem_perch": 0.209337609,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 3,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.86254178,
  "comm_bvp": 0.121697019,
  "comm_cctrcap": 0.173000095,
  "comm_incarpct": 0.001381007,
  "comm_juvcrimecap": 106.3725415,
  "comm_libcap": 0,
  "comm_ltbvp": 0.101701926,
  "comm_ltrvp": 0.005626166,
  "comm_ocb": 2328.153972,
  "comm_ocbp": 0.249555483,
  "comm_parkcap": 0.008964819,
  "comm_rcb": 6453.132805,
  "comm_rcbp": 0.377146346,
  "comm_rvp": 0.009224657,
  "comm_u18bbp": 0.842714503,
  "comm_evrate": 222.9106222,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 1,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.161353532,
  "econ_fincap": 3.979002181,
  "econ_medinc": 56275.67626,
  "econ_paydaycap": 1.384000759,
  "econ_pctlwjobs": 0.178099274,
  "econ_pctmwjobs": 0.273534999,
  "econ_totjobs": 102645,
  "econ_pr": 0.089861681,
  "econ_pyr": 0.146761425,
  "econ_ur": 0.03446079,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1205.563959,
  "edu_perbach": 0.335238562,
  "edu_perearlyed": 0.427758007,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 3.298396604,
  "fam_lcckids": 18.14118132,
  "fam_tphh": 3927.035899,
  "fam_tphhpct": 0.609397163,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2257.358031,
  "hel_castthma": 660.3372211,
  "hel_checkup": 5322.242934,
  "hel_fruitsveggies": 482.1567371,
  "hel_le": 81.79461757,
  "hel_mhlth": 932.8381033,
  "hel_obesity": 2313.899165,
  "hel_perpri": 0.685626308,
  "hel_perpub": 0.193142699,
  "hel_prtopu": 3.54984326,
  "hel_pharmacap": 2.595001422,
  "hel_phlth": 800.5125886,
  "hel_sleep": 2481.547023,
  "hel_stroke": 183.2654622,
  "hel_perins": 0.813621188,
  "hel_perunin": 0.186067431,
  "hel_clincap": 0.173000095,
  "hel_groccap": 0.865000474,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 69,
  "ci_index": 76,
  "eci_index": 81,
  "edi_index": 66,
  "fi_index": 78,
  "hi_index": 77,
  "cri_index": 75,
  "ci_weight": 76,
  "eci_weight": 81,
  "edi_weight": 66,
  "fi_weight": 78,
  "hi_weight": 77,
  "cri_weight": 79,
  "ci_weight_sd": 3,
  "eci_weight_sd": 4,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 142,
  "TEA": 120,
  "SLN": 120,
  "SCHOOLNAME": "Caillet Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3033 Merrell Rd.",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9727943200,
  "WEBSITE": "http://www.dallasisd.org/caillet",
  "POINT_X": -96.87452286,
  "POINT_Y": 32.88872786,
  "MasterID": "'057905120",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 58544,
  "dem_popwh": 24594,
  "dem_popbl": 2135,
  "dem_popas": 43,
  "dem_pophi": 29895,
  "dem_popm": 30914,
  "dem_popf": 27628,
  "dem_thh": 19595,
  "dem_popse": 4836,
  "dem_popch": 15533,
  "dem_perwh": 0.420094288,
  "dem_perbl": 0.036468297,
  "dem_peras": 0.00073449,
  "dem_perhi": 0.510641569,
  "dem_perm": 0.528047281,
  "dem_perf": 0.471918557,
  "dem_perse": 0.082604537,
  "dem_perch": 0.265321809,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 1,
  "dem_perch_sd": 2,
  "comm_bbp": 0.71232015,
  "comm_bvp": 0.105200811,
  "comm_cctrcap": 0.342684129,
  "comm_incarpct": 0.001675447,
  "comm_juvcrimecap": 240.8114645,
  "comm_libcap": 0.342684129,
  "comm_ltbvp": 0.099162538,
  "comm_ltrvp": 0.007447049,
  "comm_ocb": 2239.717151,
  "comm_ocbp": 0.249078499,
  "comm_parkcap": 0.041483964,
  "comm_rcb": 4754.976037,
  "comm_rcbp": 0.448117656,
  "comm_rvp": 0.009275843,
  "comm_u18bbp": 0.694325463,
  "comm_evrate": 108.8878819,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.24058062,
  "econ_fincap": 2.74147303,
  "econ_medinc": 38820.94546,
  "econ_paydaycap": 3.598183352,
  "econ_pctlwjobs": 0.235221719,
  "econ_pctmwjobs": 0.367674208,
  "econ_totjobs": 55250,
  "econ_pr": 0.152777654,
  "econ_pyr": 0.286496455,
  "econ_ur": 0.041457976,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 648.862623,
  "edu_perbach": 0.163510269,
  "edu_perearlyed": 0.376344086,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.948536405,
  "fam_lcckids": 5.845609216,
  "fam_tphh": 5214.735071,
  "fam_tphhpct": 0.730341923,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2843.258214,
  "hel_castthma": 837.6369027,
  "hel_checkup": 6016.371172,
  "hel_fruitsveggies": 407.6152405,
  "hel_le": 78.23760016,
  "hel_mhlth": 1515.616082,
  "hel_obesity": 3334.773066,
  "hel_perpri": 0.415950669,
  "hel_perpub": 0.253335155,
  "hel_prtopu": 1.641898726,
  "hel_pharmacap": 1.542078579,
  "hel_phlth": 1390.168725,
  "hel_sleep": 3286.386123,
  "hel_stroke": 259.6813184,
  "hel_perins": 0.630869617,
  "hel_perunin": 0.368925405,
  "hel_clincap": 0.514026193,
  "hel_groccap": 1.028052386,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 41,
  "ci_index": 70,
  "eci_index": 49,
  "edi_index": 53,
  "fi_index": 77,
  "hi_index": 34,
  "cri_index": 45,
  "ci_weight": 70,
  "eci_weight": 49,
  "edi_weight": 53,
  "fi_weight": 77,
  "hi_weight": 34,
  "cri_weight": 48,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 143,
  "TEA": 135,
  "SLN": 135,
  "SCHOOLNAME": "DeGolyer Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3453 Flair Dr.",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9727942800,
  "WEBSITE": "http://www.dallasisd.org/degolyer",
  "POINT_X": -96.86145688,
  "POINT_Y": 32.90419029,
  "MasterID": "'057905135",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 50257,
  "dem_popwh": 26558,
  "dem_popbl": 1895,
  "dem_popas": 76,
  "dem_pophi": 19049,
  "dem_popm": 25400,
  "dem_popf": 24848,
  "dem_thh": 17969,
  "dem_popse": 6734,
  "dem_popch": 11735,
  "dem_perwh": 0.528443799,
  "dem_perbl": 0.03770619,
  "dem_peras": 0.001512227,
  "dem_perhi": 0.379031777,
  "dem_perm": 0.505402233,
  "dem_perf": 0.494418688,
  "dem_perse": 0.133991285,
  "dem_perch": 0.233499811,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 4,
  "dem_perch_sd": 1,
  "comm_bbp": 0.827812322,
  "comm_bvp": 0.105351824,
  "comm_cctrcap": 0.799337877,
  "comm_incarpct": 0.001354902,
  "comm_juvcrimecap": 132.7227185,
  "comm_libcap": 0.199834469,
  "comm_ltbvp": 0.094434329,
  "comm_ltrvp": 0.006949382,
  "comm_ocb": 2952.13419,
  "comm_ocbp": 0.242614634,
  "comm_parkcap": 0.029704798,
  "comm_rcb": 2411.672923,
  "comm_rcbp": 0.41478644,
  "comm_rvp": 0.009948678,
  "comm_u18bbp": 0.807027993,
  "comm_evrate": 33.87194254,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.114019914,
  "econ_fincap": 3.197351508,
  "econ_medinc": 45939.15443,
  "econ_paydaycap": 1.598675754,
  "econ_pctlwjobs": 0.260827019,
  "econ_pctmwjobs": 0.361087036,
  "econ_totjobs": 35767,
  "econ_pr": 0.081182611,
  "econ_pyr": 0.242673956,
  "econ_ur": 0.033702373,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 4,
  "edu_oostkids": 872.6285316,
  "edu_perbach": 0.266558686,
  "edu_perearlyed": 0.415929204,
  "edu_qeckids": 0.860580406,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.442321624,
  "fam_lcckids": 15.49044731,
  "fam_tphh": 4407.660308,
  "fam_tphhpct": 0.775297066,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2445.001592,
  "hel_castthma": 647.1505765,
  "hel_checkup": 5216.167994,
  "hel_fruitsveggies": 459.4868775,
  "hel_le": 80.6164572,
  "hel_mhlth": 989.0846262,
  "hel_obesity": 2402.765966,
  "hel_perpri": 0.612555233,
  "hel_perpub": 0.234524899,
  "hel_prtopu": 2.611898498,
  "hel_pharmacap": 2.198179162,
  "hel_phlth": 966.1956886,
  "hel_sleep": 2436.387429,
  "hel_stroke": 218.536385,
  "hel_perins": 0.774013773,
  "hel_perunin": 0.225747383,
  "hel_clincap": 0.599503408,
  "hel_groccap": 0.799337877,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 64,
  "ci_index": 91,
  "eci_index": 66,
  "edi_index": 73,
  "fi_index": 90,
  "hi_index": 65,
  "cri_index": 79,
  "ci_weight": 91,
  "eci_weight": 66,
  "edi_weight": 73,
  "fi_weight": 90,
  "hi_weight": 65,
  "cri_weight": 77,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 144,
  "TEA": 148,
  "SLN": 148,
  "SCHOOLNAME": "Gooch Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "4030 Calculus Rd.",
  "CITY": "Dallas",
  "ZIP": 75244,
  "PHONE": 9727942500,
  "WEBSITE": "http://www.dallasisd.org/gooch",
  "POINT_X": -96.84455159,
  "POINT_Y": 32.9169581,
  "MasterID": "'057905148",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 45230,
  "dem_popwh": 25939,
  "dem_popbl": 2849,
  "dem_popas": 73,
  "dem_pophi": 12065,
  "dem_popm": 22539,
  "dem_popf": 22669,
  "dem_thh": 19283,
  "dem_popse": 6677,
  "dem_popch": 8765,
  "dem_perwh": 0.573491046,
  "dem_perbl": 0.062989166,
  "dem_peras": 0.001613973,
  "dem_perhi": 0.266747734,
  "dem_perm": 0.498319699,
  "dem_perf": 0.501193898,
  "dem_perse": 0.147623259,
  "dem_perch": 0.193787309,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.912160866,
  "comm_bvp": 0.116493863,
  "comm_cctrcap": 0.443858079,
  "comm_incarpct": 0.001437685,
  "comm_juvcrimecap": 73.95721284,
  "comm_libcap": 0.221929039,
  "comm_ltbvp": 0.099132604,
  "comm_ltrvp": 0.005548104,
  "comm_ocb": 2594.380755,
  "comm_ocbp": 0.240071279,
  "comm_parkcap": 0.020660915,
  "comm_rcb": 2872.436014,
  "comm_rcbp": 0.338631614,
  "comm_rvp": 0.009574454,
  "comm_u18bbp": 0.925297256,
  "comm_evrate": 152.9091081,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.064179717,
  "econ_fincap": 3.328935591,
  "econ_medinc": 52980.89947,
  "econ_paydaycap": 1.331574236,
  "econ_pctlwjobs": 0.158787113,
  "econ_pctmwjobs": 0.278079596,
  "econ_totjobs": 79150,
  "econ_pr": 0.050060953,
  "econ_pyr": 0.117905627,
  "econ_ur": 0.029918401,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 964.9439983,
  "edu_perbach": 0.345045209,
  "edu_perearlyed": 0.508826584,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.29475386,
  "fam_lcckids": 22.9475386,
  "fam_tphh": 3724.815042,
  "fam_tphhpct": 0.77576167,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 1932.40099,
  "hel_castthma": 482.5163582,
  "hel_checkup": 4268.287533,
  "hel_fruitsveggies": 482.6632422,
  "hel_le": 81.77607435,
  "hel_mhlth": 613.7643736,
  "hel_obesity": 1645.579311,
  "hel_perpri": 0.754813978,
  "hel_perpub": 0.195971548,
  "hel_prtopu": 3.851650837,
  "hel_pharmacap": 2.663148473,
  "hel_phlth": 617.0836822,
  "hel_sleep": 1745.167045,
  "hel_stroke": 163.8699677,
  "hel_perins": 0.864743291,
  "hel_perunin": 0.134835693,
  "hel_clincap": 0.443858079,
  "hel_groccap": 0.665787118,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 88,
  "ci_index": 96,
  "eci_index": 97,
  "edi_index": 76,
  "fi_index": 82,
  "hi_index": 98,
  "cri_index": 100,
  "ci_weight": 96,
  "eci_weight": 97,
  "edi_weight": 76,
  "fi_weight": 82,
  "hi_weight": 98,
  "cri_weight": 100,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 145,
  "TEA": 182,
  "SLN": 182,
  "SCHOOLNAME": "Marcus Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2911 Northaven",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9727942900,
  "WEBSITE": "http://www.dallasisd.org/marcus",
  "POINT_X": -96.88002308,
  "POINT_Y": 32.90462748,
  "MasterID": "'057905182",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 43205,
  "dem_popwh": 19872,
  "dem_popbl": 1810,
  "dem_popas": 70,
  "dem_pophi": 19011,
  "dem_popm": 21876,
  "dem_popf": 21324,
  "dem_thh": 14971,
  "dem_popse": 5406,
  "dem_popch": 10264,
  "dem_perwh": 0.459946765,
  "dem_perbl": 0.041893299,
  "dem_peras": 0.001620183,
  "dem_perhi": 0.440018516,
  "dem_perm": 0.506330286,
  "dem_perf": 0.493553987,
  "dem_perse": 0.125124407,
  "dem_perch": 0.237565097,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 3,
  "dem_perch_sd": 1,
  "comm_bbp": 0.800327312,
  "comm_bvp": 0.117426383,
  "comm_cctrcap": 0.698623002,
  "comm_incarpct": 0.001934007,
  "comm_juvcrimecap": 164.0379874,
  "comm_libcap": 0.232874334,
  "comm_ltbvp": 0.105690866,
  "comm_ltrvp": 0.006020703,
  "comm_ocb": 2239.757561,
  "comm_ocbp": 0.235616451,
  "comm_parkcap": 0.038203124,
  "comm_rcb": 2294.721271,
  "comm_rcbp": 0.419373537,
  "comm_rvp": 0.008034071,
  "comm_u18bbp": 0.777885471,
  "comm_evrate": 47.04061547,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.140694347,
  "econ_fincap": 3.49311501,
  "econ_medinc": 37619.76728,
  "econ_paydaycap": 3.260240676,
  "econ_pctlwjobs": 0.242449901,
  "econ_pctmwjobs": 0.370005242,
  "econ_totjobs": 49602,
  "econ_pr": 0.094002519,
  "econ_pyr": 0.25923995,
  "econ_ur": 0.032169151,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 4,
  "edu_oostkids": 582.0773811,
  "edu_perbach": 0.225986966,
  "edu_perearlyed": 0.357142857,
  "edu_qeckids": 0.988246827,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.929480962,
  "fam_lcckids": 13.83545558,
  "fam_tphh": 3511.596494,
  "fam_tphhpct": 0.73855995,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2111.187367,
  "hel_castthma": 573.1097222,
  "hel_checkup": 4467.587715,
  "hel_fruitsveggies": 413.9346162,
  "hel_le": 78.62857969,
  "hel_mhlth": 922.0973297,
  "hel_obesity": 2172.351746,
  "hel_perpri": 0.566911271,
  "hel_perpub": 0.243593602,
  "hel_prtopu": 2.327283094,
  "hel_pharmacap": 2.561617674,
  "hel_phlth": 887.9058877,
  "hel_sleep": 2196.581957,
  "hel_stroke": 193.8931104,
  "hel_perins": 0.749623834,
  "hel_perunin": 0.250144679,
  "hel_clincap": 0.698623002,
  "hel_groccap": 0.931497336,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 69,
  "ci_index": 84,
  "eci_index": 63,
  "edi_index": 68,
  "fi_index": 88,
  "hi_index": 65,
  "cri_index": 75,
  "ci_weight": 84,
  "eci_weight": 63,
  "edi_weight": 68,
  "fi_weight": 88,
  "hi_weight": 65,
  "cri_weight": 73,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 146,
  "TEA": 193,
  "SLN": 193,
  "SCHOOLNAME": "Pershing Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5715 Meaders Lane",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9727948600,
  "WEBSITE": "http://www.dallasisd.org/pershing",
  "POINT_X": -96.80984842,
  "POINT_Y": 32.88759662,
  "MasterID": "'057905193",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 33813,
  "dem_popwh": 27947,
  "dem_popbl": 905,
  "dem_popas": 19,
  "dem_pophi": 2617,
  "dem_popm": 16090,
  "dem_popf": 17715,
  "dem_thh": 14727,
  "dem_popse": 7324,
  "dem_popch": 6823,
  "dem_perwh": 0.826516429,
  "dem_perbl": 0.026764854,
  "dem_peras": 0.000561914,
  "dem_perhi": 0.077396268,
  "dem_perm": 0.475852483,
  "dem_perf": 0.523910922,
  "dem_perse": 0.216603082,
  "dem_perch": 0.201786295,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 1,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.944336567,
  "comm_bvp": 0.077961247,
  "comm_cctrcap": 0.594585119,
  "comm_incarpct": 0.001504857,
  "comm_juvcrimecap": 35.38192771,
  "comm_libcap": 0.594585119,
  "comm_ltbvp": 0.068853567,
  "comm_ltrvp": 0.012263643,
  "comm_ocb": 3176.889124,
  "comm_ocbp": 0.285675184,
  "comm_parkcap": 0.021476657,
  "comm_rcb": 1498.775812,
  "comm_rcbp": 0.41551338,
  "comm_rvp": 0.016632819,
  "comm_u18bbp": 0.981321641,
  "comm_evrate": 6.986375153,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.023606592,
  "econ_fincap": 11.29711727,
  "econ_medinc": 81300.25703,
  "econ_paydaycap": 0.29729256,
  "econ_pctlwjobs": 0.267382249,
  "econ_pctmwjobs": 0.279037168,
  "econ_totjobs": 24968,
  "econ_pr": 0.037831999,
  "econ_pyr": 0.115534123,
  "econ_ur": 0.021068887,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 2036.894054,
  "edu_perbach": 0.41738959,
  "edu_perearlyed": 0.704081633,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.468560962,
  "fam_lcckids": 32.30834115,
  "fam_tphh": 3513.141368,
  "fam_tphhpct": 0.874642856,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 3,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 3,
  "hel_bphigh": 3095.294066,
  "hel_castthma": 716.267459,
  "hel_checkup": 6756.139551,
  "hel_fruitsveggies": 534.9669388,
  "hel_le": 82.49920843,
  "hel_mhlth": 797.0397349,
  "hel_obesity": 2309.704805,
  "hel_perpri": 0.875594672,
  "hel_perpub": 0.217798525,
  "hel_prtopu": 4.020204778,
  "hel_pharmacap": 2.675633037,
  "hel_phlth": 853.129942,
  "hel_sleep": 2435.265425,
  "hel_stroke": 245.6813542,
  "hel_perins": 0.955786156,
  "hel_perunin": 0.043916508,
  "hel_clincap": 0,
  "hel_groccap": 1.486462798,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 4,
  "hi_gen": 52,
  "ci_index": 86,
  "eci_index": 100,
  "edi_index": 98,
  "fi_index": 82,
  "hi_index": 66,
  "cri_index": 75,
  "ci_weight": 86,
  "eci_weight": 100,
  "edi_weight": 98,
  "fi_weight": 82,
  "hi_weight": 66,
  "cri_weight": 85,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 147,
  "TEA": 224,
  "SLN": 224,
  "SCHOOLNAME": "Walnut Hill Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10115 Midway Rd.",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9725027800,
  "WEBSITE": "http://www.dallasisd.org/walnuthill",
  "POINT_X": -96.83957713,
  "POINT_Y": 32.88287138,
  "MasterID": "'057905224",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 44350,
  "dem_popwh": 27313,
  "dem_popbl": 871,
  "dem_popas": 53,
  "dem_pophi": 14550,
  "dem_popm": 22847,
  "dem_popf": 21505,
  "dem_thh": 16392,
  "dem_popse": 5911,
  "dem_popch": 10573,
  "dem_perwh": 0.615851184,
  "dem_perbl": 0.019639233,
  "dem_peras": 0.001195039,
  "dem_perhi": 0.328072153,
  "dem_perm": 0.515152198,
  "dem_perf": 0.484892897,
  "dem_perse": 0.133280722,
  "dem_perch": 0.238399098,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 4,
  "dem_perch_sd": 1,
  "comm_bbp": 0.824719625,
  "comm_bvp": 0.067439815,
  "comm_cctrcap": 0.451641594,
  "comm_incarpct": 0.002112867,
  "comm_juvcrimecap": 132.3444754,
  "comm_libcap": 0.451641594,
  "comm_ltbvp": 0.063137815,
  "comm_ltrvp": 0.012366561,
  "comm_ocb": 3026.018675,
  "comm_ocbp": 0.26852407,
  "comm_parkcap": 0.047896942,
  "comm_rcb": 2137.258195,
  "comm_rcbp": 0.416724945,
  "comm_rvp": 0.016897879,
  "comm_u18bbp": 0.81453286,
  "comm_evrate": 59.61669034,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.153944235,
  "econ_fincap": 0.451641594,
  "econ_medinc": 65854.15734,
  "econ_paydaycap": 1.354924781,
  "econ_pctlwjobs": 0.266910995,
  "econ_pctmwjobs": 0.339685864,
  "econ_totjobs": 9550,
  "econ_pr": 0.095848782,
  "econ_pyr": 0.276684533,
  "econ_ur": 0.036528438,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 4,
  "edu_oostkids": 978.4334551,
  "edu_perbach": 0.274842129,
  "edu_perearlyed": 0.509641873,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 0.950858557,
  "fam_lcckids": 13.3120198,
  "fam_tphh": 4281.974251,
  "fam_tphhpct": 0.815218427,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 3040.848508,
  "hel_castthma": 821.1588145,
  "hel_checkup": 6579.694493,
  "hel_fruitsveggies": 505.3836944,
  "hel_le": 82.48970473,
  "hel_mhlth": 1257.856894,
  "hel_obesity": 3034.890056,
  "hel_perpri": 0.616467086,
  "hel_perpub": 0.232843966,
  "hel_prtopu": 2.647554479,
  "hel_pharmacap": 2.032387171,
  "hel_phlth": 1204.941096,
  "hel_sleep": 3046.225278,
  "hel_stroke": 258.5401997,
  "hel_perins": 0.770583858,
  "hel_perunin": 0.229100422,
  "hel_clincap": 0.225820797,
  "hel_groccap": 1.129103984,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 43,
  "ci_index": 79,
  "eci_index": 50,
  "edi_index": 73,
  "fi_index": 67,
  "hi_index": 47,
  "cri_index": 54,
  "ci_weight": 79,
  "eci_weight": 50,
  "edi_weight": 73,
  "fi_weight": 67,
  "hi_weight": 47,
  "cri_weight": 59,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 148,
  "TEA": 230,
  "SLN": 230,
  "SCHOOLNAME": "Withers Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3959 Northaven Rd.",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9727945000,
  "WEBSITE": "http://www.dallasisd.org/withers",
  "POINT_X": -96.84590768,
  "POINT_Y": 32.90324587,
  "MasterID": "'057905230",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 43039,
  "dem_popwh": 26949,
  "dem_popbl": 1768,
  "dem_popas": 70,
  "dem_pophi": 11636,
  "dem_popm": 21389,
  "dem_popf": 21645,
  "dem_thh": 16464,
  "dem_popse": 6799,
  "dem_popch": 9403,
  "dem_perwh": 0.626153024,
  "dem_perbl": 0.041079021,
  "dem_peras": 0.001626432,
  "dem_perhi": 0.270359441,
  "dem_perm": 0.496967866,
  "dem_perf": 0.50291596,
  "dem_perse": 0.157973001,
  "dem_perch": 0.218476266,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.907068495,
  "comm_bvp": 0.100266473,
  "comm_cctrcap": 0.930974984,
  "comm_incarpct": 0.00135146,
  "comm_juvcrimecap": 82.37163641,
  "comm_libcap": 0.232743746,
  "comm_ltbvp": 0.089642368,
  "comm_ltrvp": 0.007522246,
  "comm_ocb": 3107.844751,
  "comm_ocbp": 0.249338011,
  "comm_parkcap": 0.03662502,
  "comm_rcb": 1492.299344,
  "comm_rcbp": 0.372535536,
  "comm_rvp": 0.011969232,
  "comm_u18bbp": 0.9168615,
  "comm_evrate": 22.34339961,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.057050711,
  "econ_fincap": 2.560181206,
  "econ_medinc": 55524.80717,
  "econ_paydaycap": 0.930974984,
  "econ_pctlwjobs": 0.241139797,
  "econ_pctmwjobs": 0.33080882,
  "econ_totjobs": 23899,
  "econ_pr": 0.045379422,
  "econ_pyr": 0.20873059,
  "econ_ur": 0.032437795,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 1073.21653,
  "edu_perbach": 0.326994344,
  "edu_perearlyed": 0.491850431,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 1.066815636,
  "fam_lcckids": 16.00223454,
  "fam_tphh": 4043.612287,
  "fam_tphhpct": 0.819345363,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2741.382379,
  "hel_castthma": 677.6876401,
  "hel_checkup": 5919.51267,
  "hel_fruitsveggies": 493.7650946,
  "hel_le": 81.71529863,
  "hel_mhlth": 890.7891322,
  "hel_obesity": 2367.369234,
  "hel_perpri": 0.734333217,
  "hel_perpub": 0.215719102,
  "hel_prtopu": 3.40411771,
  "hel_pharmacap": 2.094693714,
  "hel_phlth": 913.2078833,
  "hel_sleep": 2453.8926,
  "hel_stroke": 234.2360079,
  "hel_perins": 0.855946983,
  "hel_perunin": 0.143866992,
  "hel_clincap": 0.698231238,
  "hel_groccap": 0.698231238,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 61,
  "ci_index": 100,
  "eci_index": 77,
  "edi_index": 73,
  "fi_index": 69,
  "hi_index": 73,
  "cri_index": 77,
  "ci_weight": 100,
  "eci_weight": 77,
  "edi_weight": 73,
  "fi_weight": 69,
  "hi_weight": 73,
  "cri_weight": 84,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 3,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 149,
  "TEA": 195,
  "SLN": 195,
  "SCHOOLNAME": "Preston Hollow Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6423 Walnut Hill Lane",
  "CITY": "Dallas",
  "ZIP": 75230,
  "PHONE": 9727948500,
  "WEBSITE": "http://www.dallasisd.org/prestonhollow",
  "POINT_X": -96.7956084,
  "POINT_Y": 32.88065682,
  "MasterID": "'057905195",
  "Feeder": "Hillcrest",
  "HIGH_SLN": 6,
  "dem_totp": 45223,
  "dem_popwh": 35426,
  "dem_popbl": 2677,
  "dem_popas": 24,
  "dem_pophi": 4058,
  "dem_popm": 21086,
  "dem_popf": 24135,
  "dem_thh": 20148,
  "dem_popse": 8696,
  "dem_popch": 9249,
  "dem_perwh": 0.783362448,
  "dem_perbl": 0.059195542,
  "dem_peras": 0.000530703,
  "dem_perhi": 0.0897331,
  "dem_perm": 0.466267165,
  "dem_perf": 0.53368861,
  "dem_perse": 0.192291533,
  "dem_perch": 0.204519824,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.931279209,
  "comm_bvp": 0.090524026,
  "comm_cctrcap": 0.222779146,
  "comm_incarpct": 0.001354026,
  "comm_juvcrimecap": 66.96739455,
  "comm_libcap": 0.668337438,
  "comm_ltbvp": 0.072594444,
  "comm_ltrvp": 0.011081719,
  "comm_ocb": 3654.363094,
  "comm_ocbp": 0.293957936,
  "comm_parkcap": 0.015043553,
  "comm_rcb": 3557.866595,
  "comm_rcbp": 0.461068177,
  "comm_rvp": 0.014102716,
  "comm_u18bbp": 0.965624875,
  "comm_evrate": 92.89890383,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.055564265,
  "econ_fincap": 9.579503272,
  "econ_medinc": 77950.17238,
  "econ_paydaycap": 0.891116583,
  "econ_pctlwjobs": 0.232476831,
  "econ_pctmwjobs": 0.283231289,
  "econ_totjobs": 59778,
  "econ_pr": 0.059806267,
  "econ_pyr": 0.171944245,
  "econ_ur": 0.025024267,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1636.78216,
  "edu_perbach": 0.424107957,
  "edu_perearlyed": 0.616788321,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.16648863,
  "fam_lcckids": 23.83137493,
  "fam_tphh": 4421.479168,
  "fam_tphhpct": 0.827979612,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2559.041906,
  "hel_castthma": 617.7197327,
  "hel_checkup": 5618.662803,
  "hel_fruitsveggies": 512.7486449,
  "hel_le": 81.62140924,
  "hel_mhlth": 732.3804366,
  "hel_obesity": 2034.123582,
  "hel_perpri": 0.843422079,
  "hel_perpub": 0.213100145,
  "hel_prtopu": 3.957867224,
  "hel_pharmacap": 7.574490959,
  "hel_phlth": 743.4881667,
  "hel_sleep": 2143.268397,
  "hel_stroke": 208.5732885,
  "hel_perins": 0.937217333,
  "hel_perunin": 0.06269355,
  "hel_clincap": 0.445558292,
  "hel_groccap": 2.005012313,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 4,
  "hi_gen": 71,
  "ci_index": 78,
  "eci_index": 97,
  "edi_index": 91,
  "fi_index": 87,
  "hi_index": 88,
  "cri_index": 89,
  "ci_weight": 78,
  "eci_weight": 97,
  "edi_weight": 91,
  "fi_weight": 87,
  "hi_weight": 88,
  "cri_weight": 92,
  "ci_weight_sd": 3,
  "eci_weight_sd": 4,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 150,
  "TEA": 176,
  "SLN": 176,
  "SCHOOLNAME": "Lowe Sr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7000 Holly Hill Dr.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9725021700,
  "WEBSITE": "http://www.dallasisd.org/lowe",
  "POINT_X": -96.76070396,
  "POINT_Y": 32.87311703,
  "MasterID": "'057905176",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 82638,
  "dem_popwh": 42897,
  "dem_popbl": 13288,
  "dem_popas": 65,
  "dem_pophi": 17768,
  "dem_popm": 41076,
  "dem_popf": 41563,
  "dem_thh": 38187,
  "dem_popse": 10218,
  "dem_popch": 16989,
  "dem_perwh": 0.519095331,
  "dem_perbl": 0.160797696,
  "dem_peras": 0.000786563,
  "dem_perhi": 0.215010044,
  "dem_perm": 0.497059464,
  "dem_perf": 0.502952637,
  "dem_perse": 0.123647717,
  "dem_perch": 0.205583388,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.835066745,
  "comm_bvp": 0.11803037,
  "comm_cctrcap": 0.245294528,
  "comm_incarpct": 0.002712591,
  "comm_juvcrimecap": 146.6816066,
  "comm_libcap": 0.245294528,
  "comm_ltbvp": 0.088232648,
  "comm_ltrvp": 0.007594549,
  "comm_ocb": 2892.612039,
  "comm_ocbp": 0.247942661,
  "comm_parkcap": 0.164835576,
  "comm_rcb": 11753.02114,
  "comm_rcbp": 0.443139282,
  "comm_rvp": 0.010113712,
  "comm_u18bbp": 0.827212716,
  "comm_evrate": 179.800889,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.272116644,
  "econ_fincap": 3.188828863,
  "econ_medinc": 50184.54431,
  "econ_paydaycap": 2.207650751,
  "econ_pctlwjobs": 0.251245775,
  "econ_pctmwjobs": 0.303796274,
  "econ_totjobs": 63615,
  "econ_pr": 0.167938966,
  "econ_pyr": 0.210253692,
  "econ_ur": 0.04332388,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 1790.699915,
  "edu_perbach": 0.327949266,
  "edu_perearlyed": 0.452702703,
  "edu_qeckids": 0.593733394,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 4.749867149,
  "fam_lcckids": 13.65586805,
  "fam_tphh": 5996.282778,
  "fam_tphhpct": 0.693415588,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2767.40369,
  "hel_castthma": 808.5529123,
  "hel_checkup": 6191.823676,
  "hel_fruitsveggies": 431.918984,
  "hel_le": 80.37357493,
  "hel_mhlth": 1215.845421,
  "hel_obesity": 2859.25914,
  "hel_perpri": 0.644778992,
  "hel_perpub": 0.257548629,
  "hel_prtopu": 2.503523292,
  "hel_pharmacap": 6.009715934,
  "hel_phlth": 1055.043571,
  "hel_sleep": 3018.621417,
  "hel_stroke": 244.5979521,
  "hel_perins": 0.826092252,
  "hel_perunin": 0.173859027,
  "hel_clincap": 0.981178112,
  "hel_groccap": 1.471767167,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 50,
  "ci_index": 74,
  "eci_index": 50,
  "edi_index": 80,
  "fi_index": 97,
  "hi_index": 55,
  "cri_index": 62,
  "ci_weight": 74,
  "eci_weight": 50,
  "edi_weight": 80,
  "fi_weight": 97,
  "hi_weight": 55,
  "cri_weight": 65,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 151,
  "TEA": 286,
  "SLN": 286,
  "SCHOOLNAME": "McShan Jr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "8307 Meadow Rd.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9725023800,
  "WEBSITE": "http://www.dallasisd.org/mcshan",
  "POINT_X": -96.76098599,
  "POINT_Y": 32.88837306,
  "MasterID": "'057905286",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 75569,
  "dem_popwh": 33395,
  "dem_popbl": 16687,
  "dem_popas": 30,
  "dem_pophi": 18163,
  "dem_popm": 37885,
  "dem_popf": 37687,
  "dem_thh": 33661,
  "dem_popse": 9478,
  "dem_popch": 16322,
  "dem_perwh": 0.441914012,
  "dem_perbl": 0.22081806,
  "dem_peras": 0.000396988,
  "dem_perhi": 0.240349879,
  "dem_perm": 0.50132991,
  "dem_perf": 0.498709788,
  "dem_perse": 0.1254218,
  "dem_perch": 0.215988037,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.807899701,
  "comm_bvp": 0.143448483,
  "comm_cctrcap": 0.533753472,
  "comm_incarpct": 0.003460731,
  "comm_juvcrimecap": 190.6363389,
  "comm_libcap": 0.266876736,
  "comm_ltbvp": 0.107253836,
  "comm_ltrvp": 0.008314865,
  "comm_ocb": 2408.05368,
  "comm_ocbp": 0.233346609,
  "comm_parkcap": 0.152178615,
  "comm_rcb": 10825.76777,
  "comm_rcbp": 0.463828699,
  "comm_rvp": 0.010851398,
  "comm_u18bbp": 0.799847988,
  "comm_evrate": 203.0931962,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.302478707,
  "econ_fincap": 3.736274305,
  "econ_medinc": 49573.83151,
  "econ_paydaycap": 2.001575521,
  "econ_pctlwjobs": 0.222753693,
  "econ_pctmwjobs": 0.30537055,
  "econ_totjobs": 66064,
  "econ_pr": 0.179825649,
  "econ_pyr": 0.207238673,
  "econ_ur": 0.047865069,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 2158.826329,
  "edu_perbach": 0.283881935,
  "edu_perearlyed": 0.429652716,
  "edu_qeckids": 1.231855252,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 6.775203885,
  "fam_lcckids": 14.1663354,
  "fam_tphh": 5220.66948,
  "fam_tphhpct": 0.648810739,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3131.040669,
  "hel_castthma": 885.7551573,
  "hel_checkup": 6664.569791,
  "hel_fruitsveggies": 432.1998858,
  "hel_le": 79.13123786,
  "hel_mhlth": 1338.693097,
  "hel_obesity": 3175.215025,
  "hel_perpri": 0.589996266,
  "hel_perpub": 0.278016322,
  "hel_prtopu": 2.122164133,
  "hel_pharmacap": 8.139740451,
  "hel_phlth": 1198.475708,
  "hel_sleep": 3293.625153,
  "hel_stroke": 284.346079,
  "hel_perins": 0.794858118,
  "hel_perunin": 0.20522189,
  "hel_clincap": 1.067506944,
  "hel_groccap": 1.200945312,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 2,
  "hi_gen": 36,
  "ci_index": 63,
  "eci_index": 47,
  "edi_index": 76,
  "fi_index": 90,
  "hi_index": 40,
  "cri_index": 51,
  "ci_weight": 63,
  "eci_weight": 47,
  "edi_weight": 76,
  "fi_weight": 90,
  "hi_weight": 40,
  "cri_weight": 52,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 152,
  "TEA": 141,
  "SLN": 141,
  "SCHOOLNAME": "Stone Elementary School at Vickery Meadow",
  "LEVEL": "Elementary",
  "ADDRESS": "6606 Ridgecrest Rd.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9725027900,
  "WEBSITE": "http://www.dallasisd.org/jillstone",
  "POINT_X": -96.74949329,
  "POINT_Y": 32.86549524,
  "MasterID": "'057905141",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 77200,
  "dem_popwh": 40917,
  "dem_popbl": 11580,
  "dem_popas": 108,
  "dem_pophi": 16457,
  "dem_popm": 38644,
  "dem_popf": 38561,
  "dem_thh": 35265,
  "dem_popse": 9215,
  "dem_popch": 16501,
  "dem_perwh": 0.530012953,
  "dem_perbl": 0.15,
  "dem_peras": 0.001398964,
  "dem_perhi": 0.213173575,
  "dem_perm": 0.500569948,
  "dem_perf": 0.499494819,
  "dem_perse": 0.119365285,
  "dem_perch": 0.213743523,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.837947192,
  "comm_bvp": 0.128309449,
  "comm_cctrcap": 0.394049524,
  "comm_incarpct": 0.003124074,
  "comm_juvcrimecap": 172.3921289,
  "comm_libcap": 0.262699682,
  "comm_ltbvp": 0.106065927,
  "comm_ltrvp": 0.007365631,
  "comm_ocb": 2524.581176,
  "comm_ocbp": 0.220411809,
  "comm_parkcap": 0.264067773,
  "comm_rcb": 10352.64837,
  "comm_rcbp": 0.434689661,
  "comm_rvp": 0.010297552,
  "comm_u18bbp": 0.83602716,
  "comm_evrate": 169.9666945,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.269260494,
  "econ_fincap": 3.152396188,
  "econ_medinc": 51177.39755,
  "econ_paydaycap": 2.101597459,
  "econ_pctlwjobs": 0.255314075,
  "econ_pctmwjobs": 0.303089658,
  "econ_totjobs": 58712,
  "econ_pr": 0.170535109,
  "econ_pyr": 0.230430404,
  "econ_ur": 0.04317704,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1716.448187,
  "edu_perbach": 0.324776702,
  "edu_perearlyed": 0.453446732,
  "edu_qeckids": 0.61301721,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.678103258,
  "fam_lcckids": 13.48637861,
  "fam_tphh": 5988.708915,
  "fam_tphhpct": 0.728681208,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2777.711806,
  "hel_castthma": 834.6239206,
  "hel_checkup": 6359.537543,
  "hel_fruitsveggies": 434.0480378,
  "hel_le": 80.88945288,
  "hel_mhlth": 1253.635533,
  "hel_obesity": 2924.873055,
  "hel_perpri": 0.648870985,
  "hel_perpub": 0.253872028,
  "hel_prtopu": 2.55589791,
  "hel_pharmacap": 5.648043171,
  "hel_phlth": 1064.204175,
  "hel_sleep": 3108.643223,
  "hel_stroke": 241.3131618,
  "hel_perins": 0.827205882,
  "hel_perunin": 0.172833229,
  "hel_clincap": 0.919448888,
  "hel_groccap": 1.576198094,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 4,
  "hi_gen": 47,
  "ci_index": 72,
  "eci_index": 49,
  "edi_index": 80,
  "fi_index": 97,
  "hi_index": 53,
  "cri_index": 60,
  "ci_weight": 72,
  "eci_weight": 49,
  "edi_weight": 80,
  "fi_weight": 97,
  "hi_weight": 53,
  "cri_weight": 63,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 153,
  "TEA": 101,
  "SLN": 101,
  "SCHOOLNAME": "J.Q. Adams Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "8239 Lake June Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727941200,
  "WEBSITE": "http://www.dallasisd.org/jqadams",
  "POINT_X": -96.67978436,
  "POINT_Y": 32.73511393,
  "MasterID": "'057905101",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 65580,
  "dem_popwh": 4066,
  "dem_popbl": 14532,
  "dem_popas": 18,
  "dem_pophi": 46670,
  "dem_popm": 31649,
  "dem_popf": 33938,
  "dem_thh": 17797,
  "dem_popse": 4517,
  "dem_popch": 22853,
  "dem_perwh": 0.06200061,
  "dem_perbl": 0.221591949,
  "dem_peras": 0.000274474,
  "dem_perhi": 0.711649893,
  "dem_perm": 0.482601403,
  "dem_perf": 0.517505337,
  "dem_perse": 0.068877707,
  "dem_perch": 0.348475145,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.574298261,
  "comm_bvp": 0.102957876,
  "comm_cctrcap": 0.458792064,
  "comm_incarpct": 0.006595354,
  "comm_juvcrimecap": 281.2586806,
  "comm_libcap": 0.305861376,
  "comm_ltbvp": 0.09722123,
  "comm_ltrvp": 0.01755066,
  "comm_ocb": 3035.492501,
  "comm_ocbp": 0.285549848,
  "comm_parkcap": 0.153131765,
  "comm_rcb": 3748.164274,
  "comm_rcbp": 0.523020194,
  "comm_rvp": 0.018662311,
  "comm_u18bbp": 0.56766524,
  "comm_evrate": 121.1211049,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.401395134,
  "econ_fincap": 0.76465344,
  "econ_medinc": 22361.23398,
  "econ_paydaycap": 1.988098943,
  "econ_pctlwjobs": 0.29671089,
  "econ_pctmwjobs": 0.381702598,
  "econ_totjobs": 7236,
  "econ_pr": 0.287334138,
  "econ_pyr": 0.211928122,
  "econ_ur": 0.044624668,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 843.3932695,
  "edu_perbach": 0.030893523,
  "edu_perearlyed": 0.280339358,
  "edu_qeckids": 0.882672182,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.826721816,
  "fam_lcckids": 10.15073009,
  "fam_tphh": 4940.26667,
  "fam_tphhpct": 0.62898467,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3565.529513,
  "hel_castthma": 1027.237029,
  "hel_checkup": 6518.09878,
  "hel_fruitsveggies": 321.9792739,
  "hel_le": 75.42848501,
  "hel_mhlth": 1833.796717,
  "hel_obesity": 4087.041035,
  "hel_perpri": 0.327421618,
  "hel_perpub": 0.371218129,
  "hel_prtopu": 0.882019472,
  "hel_pharmacap": 1.988098943,
  "hel_phlth": 1750.500938,
  "hel_sleep": 3831.341198,
  "hel_stroke": 398.5646574,
  "hel_perins": 0.675475784,
  "hel_perunin": 0.324142979,
  "hel_clincap": 0.305861376,
  "hel_groccap": 1.52930688,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 21,
  "ci_index": 55,
  "eci_index": 32,
  "edi_index": 42,
  "fi_index": 84,
  "hi_index": 19,
  "cri_index": 42,
  "ci_weight": 55,
  "eci_weight": 32,
  "edi_weight": 42,
  "fi_weight": 84,
  "hi_weight": 19,
  "cri_weight": 32,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 154,
  "TEA": 104,
  "SLN": 104,
  "SCHOOLNAME": "Anderson Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "620 N. St. Augustine Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496200,
  "WEBSITE": "http://www.dallasisd.org/anderson",
  "POINT_X": -96.65559294,
  "POINT_Y": 32.72229235,
  "MasterID": "'057905104",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 54483,
  "dem_popwh": 3951,
  "dem_popbl": 11629,
  "dem_popas": 9,
  "dem_pophi": 38682,
  "dem_popm": 26263,
  "dem_popf": 28222,
  "dem_thh": 14304,
  "dem_popse": 3297,
  "dem_popch": 19010,
  "dem_perwh": 0.072518033,
  "dem_perbl": 0.213442725,
  "dem_peras": 0.000165189,
  "dem_perhi": 0.70998293,
  "dem_perm": 0.482040269,
  "dem_perf": 0.517996439,
  "dem_perse": 0.060514289,
  "dem_perch": 0.348916176,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 0,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.644269229,
  "comm_bvp": 0.106558896,
  "comm_cctrcap": 0.36862949,
  "comm_incarpct": 0.007128473,
  "comm_juvcrimecap": 228.9202857,
  "comm_libcap": 0.184314745,
  "comm_ltbvp": 0.103627742,
  "comm_ltrvp": 0.016809988,
  "comm_ocb": 3021.748124,
  "comm_ocbp": 0.31917851,
  "comm_parkcap": 0.12093874,
  "comm_rcb": 2480.59285,
  "comm_rcbp": 0.512637637,
  "comm_rvp": 0.017561584,
  "comm_u18bbp": 0.647323688,
  "comm_evrate": 101.188795,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.379112633,
  "econ_fincap": 0.552944235,
  "econ_medinc": 22404.71514,
  "econ_paydaycap": 2.21177694,
  "econ_pctlwjobs": 0.241764537,
  "econ_pctmwjobs": 0.391148668,
  "econ_totjobs": 6982,
  "econ_pr": 0.28429689,
  "econ_pyr": 0.209410107,
  "econ_ur": 0.047559092,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 710.4092865,
  "edu_perbach": 0.025908479,
  "edu_perearlyed": 0.318181818,
  "edu_qeckids": 0.532540695,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.325406946,
  "fam_lcckids": 6.390488335,
  "fam_tphh": 4365.394501,
  "fam_tphhpct": 0.663299115,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3356.756734,
  "hel_castthma": 980.1622766,
  "hel_checkup": 6127.929437,
  "hel_fruitsveggies": 328.7490221,
  "hel_le": 74.96465407,
  "hel_mhlth": 1781.787714,
  "hel_obesity": 3912.919617,
  "hel_perpri": 0.321494778,
  "hel_perpub": 0.375805297,
  "hel_prtopu": 0.855482295,
  "hel_pharmacap": 2.21177694,
  "hel_phlth": 1695.358045,
  "hel_sleep": 3628.790268,
  "hel_stroke": 370.728746,
  "hel_perins": 0.675862196,
  "hel_perunin": 0.323660591,
  "hel_clincap": 0.36862949,
  "hel_groccap": 0.921573725,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 29,
  "ci_index": 58,
  "eci_index": 32,
  "edi_index": 45,
  "fi_index": 86,
  "hi_index": 27,
  "cri_index": 43,
  "ci_weight": 58,
  "eci_weight": 32,
  "edi_weight": 45,
  "fi_weight": 86,
  "hi_weight": 27,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 155,
  "TEA": 110,
  "SLN": 110,
  "SCHOOLNAME": "Blanton Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "8915 Greenmound Ave.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727941700,
  "WEBSITE": "http://www.dallasisd.org/blanton",
  "POINT_X": -96.66869089,
  "POINT_Y": 32.75192033,
  "MasterID": "'057905110",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 72886,
  "dem_popwh": 5344,
  "dem_popbl": 16912,
  "dem_popas": 89,
  "dem_pophi": 49885,
  "dem_popm": 34992,
  "dem_popf": 37895,
  "dem_thh": 20067,
  "dem_popse": 5023,
  "dem_popch": 25396,
  "dem_perwh": 0.073319979,
  "dem_perbl": 0.232033587,
  "dem_peras": 0.001221085,
  "dem_perhi": 0.684424992,
  "dem_perm": 0.480092199,
  "dem_perf": 0.519921521,
  "dem_perse": 0.068915841,
  "dem_perch": 0.348434542,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.623697925,
  "comm_bvp": 0.106920196,
  "comm_cctrcap": 0.276199522,
  "comm_incarpct": 0.006164249,
  "comm_juvcrimecap": 234.1275378,
  "comm_libcap": 0.138099761,
  "comm_ltbvp": 0.101214262,
  "comm_ltrvp": 0.018179401,
  "comm_ocb": 3797.416027,
  "comm_ocbp": 0.310942233,
  "comm_parkcap": 0.041767774,
  "comm_rcb": 4152.209469,
  "comm_rcbp": 0.528217959,
  "comm_rvp": 0.02085709,
  "comm_u18bbp": 0.616706938,
  "comm_evrate": 160.1266727,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.365971856,
  "econ_fincap": 0.690498804,
  "econ_medinc": 23033.1929,
  "econ_paydaycap": 1.519097369,
  "econ_pctlwjobs": 0.233860291,
  "econ_pctmwjobs": 0.416945721,
  "econ_totjobs": 12841,
  "econ_pr": 0.266410481,
  "econ_pyr": 0.282792592,
  "econ_ur": 0.046310229,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 593.8890551,
  "edu_perbach": 0.041002511,
  "edu_perearlyed": 0.224312086,
  "edu_qeckids": 0.398048965,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 6.368783432,
  "fam_lcckids": 7.562930326,
  "fam_tphh": 5534.455166,
  "fam_tphhpct": 0.622661827,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3552.548633,
  "hel_castthma": 1021.704768,
  "hel_checkup": 6560.81898,
  "hel_fruitsveggies": 340.4340929,
  "hel_le": 75.16085317,
  "hel_mhlth": 1786.849336,
  "hel_obesity": 4047.566059,
  "hel_perpri": 0.363351088,
  "hel_perpub": 0.359951553,
  "hel_prtopu": 1.009444423,
  "hel_pharmacap": 1.65719713,
  "hel_phlth": 1695.61003,
  "hel_sleep": 3823.229484,
  "hel_stroke": 384.0137371,
  "hel_perins": 0.697661616,
  "hel_perunin": 0.302131935,
  "hel_clincap": 0.138099761,
  "hel_groccap": 1.242897848,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 22,
  "ci_index": 57,
  "eci_index": 33,
  "edi_index": 35,
  "fi_index": 91,
  "hi_index": 21,
  "cri_index": 43,
  "ci_weight": 57,
  "eci_weight": 33,
  "edi_weight": 35,
  "fi_weight": 91,
  "hi_weight": 21,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 156,
  "TEA": 276,
  "SLN": 276,
  "SCHOOLNAME": "Cuellar Sr. Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "337 Pleasant Vista Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496400,
  "WEBSITE": "http://www.dallasisd.org/cuellar",
  "POINT_X": -96.64313368,
  "POINT_Y": 32.71704808,
  "MasterID": "'057905276",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 46974,
  "dem_popwh": 4450,
  "dem_popbl": 10266,
  "dem_popas": 8,
  "dem_pophi": 31973,
  "dem_popm": 22862,
  "dem_popf": 24109,
  "dem_thh": 12322,
  "dem_popse": 2682,
  "dem_popch": 16475,
  "dem_perwh": 0.094733257,
  "dem_perbl": 0.21854643,
  "dem_peras": 0.000170307,
  "dem_perhi": 0.680653127,
  "dem_perm": 0.486694767,
  "dem_perf": 0.513241368,
  "dem_perse": 0.057095414,
  "dem_perch": 0.350725933,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.692823987,
  "comm_bvp": 0.102445744,
  "comm_cctrcap": 0.213846158,
  "comm_incarpct": 0.007647818,
  "comm_juvcrimecap": 162.7430567,
  "comm_libcap": 0.213846158,
  "comm_ltbvp": 0.101145439,
  "comm_ltrvp": 0.017466921,
  "comm_ocb": 2572.179592,
  "comm_ocbp": 0.323003273,
  "comm_parkcap": 0.130907623,
  "comm_rcb": 2191.410221,
  "comm_rcbp": 0.502559991,
  "comm_rvp": 0.018632175,
  "comm_u18bbp": 0.706024125,
  "comm_evrate": 112.376156,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.356423643,
  "econ_fincap": 0.213846158,
  "econ_medinc": 22807.44998,
  "econ_paydaycap": 1.06923079,
  "econ_pctlwjobs": 0.277933833,
  "econ_pctmwjobs": 0.446629213,
  "econ_totjobs": 6408,
  "econ_pr": 0.2740592,
  "econ_pyr": 0.186282131,
  "econ_ur": 0.046726813,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 484.593913,
  "edu_perbach": 0.027604492,
  "edu_perearlyed": 0.340229885,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.534702052,
  "fam_lcckids": 5.534702052,
  "fam_tphh": 3711.423334,
  "fam_tphhpct": 0.641400019,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3094.729805,
  "hel_castthma": 931.5181532,
  "hel_checkup": 5741.49665,
  "hel_fruitsveggies": 329.4689692,
  "hel_le": 74.37368363,
  "hel_mhlth": 1690.241598,
  "hel_obesity": 3650.530188,
  "hel_perpri": 0.32430591,
  "hel_perpub": 0.37344575,
  "hel_prtopu": 0.868415051,
  "hel_pharmacap": 1.924615422,
  "hel_phlth": 1571.727604,
  "hel_sleep": 3418.344913,
  "hel_stroke": 335.4101255,
  "hel_perins": 0.675715381,
  "hel_perunin": 0.323986544,
  "hel_clincap": 0.427692316,
  "hel_groccap": 0.427692316,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 59,
  "eci_index": 34,
  "edi_index": 50,
  "fi_index": 73,
  "hi_index": 29,
  "cri_index": 42,
  "ci_weight": 59,
  "eci_weight": 34,
  "edi_weight": 50,
  "fi_weight": 73,
  "hi_weight": 29,
  "cri_weight": 39,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 157,
  "TEA": 137,
  "SLN": 137,
  "SCHOOLNAME": "Dorsey Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "133 N. St. Augustine",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496300,
  "WEBSITE": "http://www.dallasisd.org/dorsey",
  "POINT_X": -96.65818555,
  "POINT_Y": 32.71302397,
  "MasterID": "'057905137",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 46102,
  "dem_popwh": 3389,
  "dem_popbl": 9840,
  "dem_popas": 3,
  "dem_pophi": 32690,
  "dem_popm": 22484,
  "dem_popf": 23625,
  "dem_thh": 12112,
  "dem_popse": 2783,
  "dem_popch": 16246,
  "dem_perwh": 0.073510911,
  "dem_perbl": 0.213439764,
  "dem_peras": 0.0000651,
  "dem_perhi": 0.709079866,
  "dem_perm": 0.487701184,
  "dem_perf": 0.512450653,
  "dem_perse": 0.060366145,
  "dem_perch": 0.352392521,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.636982417,
  "comm_bvp": 0.116262569,
  "comm_cctrcap": 0.435861691,
  "comm_incarpct": 0.008704388,
  "comm_juvcrimecap": 216.7357865,
  "comm_libcap": 0.217930846,
  "comm_ltbvp": 0.114304792,
  "comm_ltrvp": 0.017701941,
  "comm_ocb": 2488.546229,
  "comm_ocbp": 0.317259407,
  "comm_parkcap": 0.144794937,
  "comm_rcb": 2147.750644,
  "comm_rcbp": 0.503045565,
  "comm_rvp": 0.018475783,
  "comm_u18bbp": 0.639264575,
  "comm_evrate": 83.35854845,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.379585858,
  "econ_fincap": 0.217930846,
  "econ_medinc": 22738.13013,
  "econ_paydaycap": 1.743446765,
  "econ_pctlwjobs": 0.256074444,
  "econ_pctmwjobs": 0.383939342,
  "econ_totjobs": 5803,
  "econ_pr": 0.286314157,
  "econ_pyr": 0.140091235,
  "econ_ur": 0.040915578,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 683.7838008,
  "edu_perbach": 0.025891646,
  "edu_perearlyed": 0.278466742,
  "edu_qeckids": 0.623890329,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 6.862793621,
  "fam_lcckids": 7.486683951,
  "fam_tphh": 3771.20859,
  "fam_tphhpct": 0.661250126,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3392.530374,
  "hel_castthma": 999.6398428,
  "hel_checkup": 6185.41823,
  "hel_fruitsveggies": 319.7466219,
  "hel_le": 75.087905,
  "hel_mhlth": 1839.809264,
  "hel_obesity": 3990.281174,
  "hel_perpri": 0.311917053,
  "hel_perpub": 0.37651295,
  "hel_prtopu": 0.828436456,
  "hel_pharmacap": 1.307585074,
  "hel_phlth": 1742.63819,
  "hel_sleep": 3694.468468,
  "hel_stroke": 377.0290702,
  "hel_perins": 0.671445924,
  "hel_perunin": 0.328076873,
  "hel_clincap": 0.435861691,
  "hel_groccap": 0.653792537,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 27,
  "ci_index": 58,
  "eci_index": 34,
  "edi_index": 38,
  "fi_index": 85,
  "hi_index": 23,
  "cri_index": 42,
  "ci_weight": 58,
  "eci_weight": 34,
  "edi_weight": 38,
  "fi_weight": 85,
  "hi_weight": 23,
  "cri_weight": 35,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 158,
  "TEA": 156,
  "SLN": 156,
  "SCHOOLNAME": "Hawthorne Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7800 Umphress Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727494700,
  "WEBSITE": "http://www.dallasisd.org/hawthorne",
  "POINT_X": -96.68880063,
  "POINT_Y": 32.74212558,
  "MasterID": "'057905156",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 61261,
  "dem_popwh": 4045,
  "dem_popbl": 12478,
  "dem_popas": 20,
  "dem_pophi": 44360,
  "dem_popm": 29853,
  "dem_popf": 31410,
  "dem_thh": 16623,
  "dem_popse": 4489,
  "dem_popch": 21165,
  "dem_perwh": 0.066028958,
  "dem_perbl": 0.203685869,
  "dem_peras": 0.000326472,
  "dem_perhi": 0.724114853,
  "dem_perm": 0.487308402,
  "dem_perf": 0.512724245,
  "dem_perse": 0.073276636,
  "dem_perch": 0.345488973,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.563992214,
  "comm_bvp": 0.095063916,
  "comm_cctrcap": 0.491952241,
  "comm_incarpct": 0.007248227,
  "comm_juvcrimecap": 233.6881309,
  "comm_libcap": 0.327968161,
  "comm_ltbvp": 0.089269091,
  "comm_ltrvp": 0.018500528,
  "comm_ocb": 2739.486534,
  "comm_ocbp": 0.278612546,
  "comm_parkcap": 0.279531536,
  "comm_rcb": 3522.748086,
  "comm_rcbp": 0.518540865,
  "comm_rvp": 0.020176765,
  "comm_u18bbp": 0.553432198,
  "comm_evrate": 125.4478214,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.403639239,
  "econ_fincap": 0.655936321,
  "econ_medinc": 22148.33858,
  "econ_paydaycap": 1.639840803,
  "econ_pctlwjobs": 0.264323475,
  "econ_pctmwjobs": 0.390055722,
  "econ_totjobs": 6999,
  "econ_pr": 0.285034805,
  "econ_pyr": 0.205735582,
  "econ_ur": 0.043759271,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 851.2529878,
  "edu_perbach": 0.03238965,
  "edu_perearlyed": 0.254660849,
  "edu_qeckids": 0.950589601,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 7.604716809,
  "fam_lcckids": 9.03060121,
  "fam_tphh": 4556.129886,
  "fam_tphhpct": 0.632241057,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3546.709339,
  "hel_castthma": 1012.816971,
  "hel_checkup": 6501.98801,
  "hel_fruitsveggies": 312.9804691,
  "hel_le": 75.13104372,
  "hel_mhlth": 1812.127088,
  "hel_obesity": 4052.578653,
  "hel_perpri": 0.329535036,
  "hel_perpub": 0.368975115,
  "hel_prtopu": 0.893109109,
  "hel_pharmacap": 1.311872642,
  "hel_phlth": 1741.181593,
  "hel_sleep": 3809.829246,
  "hel_stroke": 397.5335925,
  "hel_perins": 0.675458415,
  "hel_perunin": 0.324246889,
  "hel_clincap": 0.16398408,
  "hel_groccap": 1.311872642,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 22,
  "ci_index": 55,
  "eci_index": 32,
  "edi_index": 38,
  "fi_index": 88,
  "hi_index": 18,
  "cri_index": 42,
  "ci_weight": 55,
  "eci_weight": 32,
  "edi_weight": 38,
  "fi_weight": 88,
  "hi_weight": 18,
  "cri_weight": 32,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 159,
  "TEA": 170,
  "SLN": 170,
  "SCHOOLNAME": "Lagow Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "637 Edgeworth Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496600,
  "WEBSITE": "http://www.dallasisd.org/lagow",
  "POINT_X": -96.63672608,
  "POINT_Y": 32.70243249,
  "MasterID": "'057905170",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 32500,
  "dem_popwh": 3812,
  "dem_popbl": 6576,
  "dem_popas": 10,
  "dem_pophi": 21827,
  "dem_popm": 16226,
  "dem_popf": 16279,
  "dem_thh": 8750,
  "dem_popse": 1938,
  "dem_popch": 11196,
  "dem_perwh": 0.117292308,
  "dem_perbl": 0.202338462,
  "dem_peras": 0.000307692,
  "dem_perhi": 0.6716,
  "dem_perm": 0.499261538,
  "dem_perf": 0.500892308,
  "dem_perse": 0.059630769,
  "dem_perch": 0.344492308,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.691805934,
  "comm_bvp": 0.07792068,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.0095512,
  "comm_juvcrimecap": 119.3029697,
  "comm_libcap": 0,
  "comm_ltbvp": 0.076794378,
  "comm_ltrvp": 0.014769446,
  "comm_ocb": 1747.326889,
  "comm_ocbp": 0.317677396,
  "comm_parkcap": 0.093902081,
  "comm_rcb": 1575.875131,
  "comm_rcbp": 0.484643141,
  "comm_rvp": 0.015912623,
  "comm_u18bbp": 0.706836655,
  "comm_evrate": 130.4176407,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.325682867,
  "econ_fincap": 0,
  "econ_medinc": 23597.15512,
  "econ_paydaycap": 0.618093084,
  "econ_pctlwjobs": 0.275932401,
  "econ_pctmwjobs": 0.407925408,
  "econ_totjobs": 3432,
  "econ_pr": 0.256078293,
  "econ_pyr": 0.154407151,
  "econ_ur": 0.043409369,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 323.2231075,
  "edu_perbach": 0.037136017,
  "edu_perearlyed": 0.266821346,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.337707991,
  "fam_lcckids": 6.337707991,
  "fam_tphh": 2533.790532,
  "fam_tphhpct": 0.636471763,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2980.583903,
  "hel_castthma": 919.5583032,
  "hel_checkup": 5632.353819,
  "hel_fruitsveggies": 327.3614056,
  "hel_le": 74.4051917,
  "hel_mhlth": 1684.451021,
  "hel_obesity": 3568.767838,
  "hel_perpri": 0.325629347,
  "hel_perpub": 0.357696806,
  "hel_prtopu": 0.910350168,
  "hel_pharmacap": 1.854279252,
  "hel_phlth": 1535.259214,
  "hel_sleep": 3363.386548,
  "hel_stroke": 318.3663157,
  "hel_perins": 0.667630947,
  "hel_perunin": 0.332184403,
  "hel_clincap": 0.618093084,
  "hel_groccap": 0,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 52,
  "eci_index": 25,
  "edi_index": 41,
  "fi_index": 65,
  "hi_index": 29,
  "cri_index": 40,
  "ci_weight": 52,
  "eci_weight": 25,
  "edi_weight": 41,
  "fi_weight": 65,
  "hi_weight": 29,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 160,
  "TEA": 180,
  "SLN": 180,
  "SCHOOLNAME": "Macon Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "650 Holcomb Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727941500,
  "WEBSITE": "http://www.dallasisd.org/macon",
  "POINT_X": -96.6735568,
  "POINT_Y": 32.72251852,
  "MasterID": "'057905180",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 56204,
  "dem_popwh": 3493,
  "dem_popbl": 12460,
  "dem_popas": 2,
  "dem_pophi": 40050,
  "dem_popm": 27044,
  "dem_popf": 29179,
  "dem_thh": 15059,
  "dem_popse": 3802,
  "dem_popch": 19421,
  "dem_perwh": 0.062148602,
  "dem_perbl": 0.221692406,
  "dem_peras": 0.0000356,
  "dem_perhi": 0.712582734,
  "dem_perm": 0.481175717,
  "dem_perf": 0.519162337,
  "dem_perse": 0.067646431,
  "dem_perch": 0.345544801,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.587189941,
  "comm_bvp": 0.110155713,
  "comm_cctrcap": 0.535648226,
  "comm_incarpct": 0.007457629,
  "comm_juvcrimecap": 309.7314954,
  "comm_libcap": 0.357098817,
  "comm_ltbvp": 0.105306372,
  "comm_ltrvp": 0.016968461,
  "comm_ocb": 2763.338328,
  "comm_ocbp": 0.292220676,
  "comm_parkcap": 0.142356726,
  "comm_rcb": 2971.692304,
  "comm_rcbp": 0.530041764,
  "comm_rvp": 0.01730217,
  "comm_u18bbp": 0.583431525,
  "comm_evrate": 115.9678408,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.402800835,
  "econ_fincap": 0.714197634,
  "econ_medinc": 21890.73352,
  "econ_paydaycap": 2.678241128,
  "econ_pctlwjobs": 0.283127948,
  "econ_pctmwjobs": 0.378974593,
  "econ_totjobs": 6573,
  "econ_pr": 0.292436295,
  "econ_pyr": 0.155610318,
  "econ_ur": 0.043118075,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 1039.048445,
  "edu_perbach": 0.024812673,
  "edu_perearlyed": 0.284205895,
  "edu_qeckids": 1.040609359,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.845179551,
  "fam_lcckids": 9.88578891,
  "fam_tphh": 4260.859734,
  "fam_tphhpct": 0.638020501,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3562.79518,
  "hel_castthma": 1033.711187,
  "hel_checkup": 6487.836836,
  "hel_fruitsveggies": 319.6030216,
  "hel_le": 75.56226458,
  "hel_mhlth": 1868.142681,
  "hel_obesity": 4112.526112,
  "hel_perpri": 0.312433279,
  "hel_perpub": 0.373158494,
  "hel_prtopu": 0.837266962,
  "hel_pharmacap": 1.428395268,
  "hel_phlth": 1784.766698,
  "hel_sleep": 3830.735499,
  "hel_stroke": 401.3528651,
  "hel_perins": 0.667105544,
  "hel_perunin": 0.332485232,
  "hel_clincap": 0.178549409,
  "hel_groccap": 1.428395268,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 21,
  "ci_index": 54,
  "eci_index": 34,
  "edi_index": 41,
  "fi_index": 83,
  "hi_index": 18,
  "cri_index": 41,
  "ci_weight": 54,
  "eci_weight": 34,
  "edi_weight": 41,
  "fi_weight": 83,
  "hi_weight": 18,
  "cri_weight": 32,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 161,
  "TEA": 237,
  "SLN": 237,
  "SCHOOLNAME": "Runyon Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "10750 Cradlerock Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727496100,
  "WEBSITE": "http://www.dallasisd.org/runyon",
  "POINT_X": -96.64104066,
  "POINT_Y": 32.74042162,
  "MasterID": "'057905237",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 60581,
  "dem_popwh": 5757,
  "dem_popbl": 14849,
  "dem_popas": 47,
  "dem_pophi": 39404,
  "dem_popm": 28924,
  "dem_popf": 31650,
  "dem_thh": 16403,
  "dem_popse": 3646,
  "dem_popch": 21627,
  "dem_perwh": 0.095029795,
  "dem_perbl": 0.245109853,
  "dem_peras": 0.000775821,
  "dem_perhi": 0.650434955,
  "dem_perm": 0.477443423,
  "dem_perf": 0.522441029,
  "dem_perse": 0.060183886,
  "dem_perch": 0.356993117,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 0,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.69322053,
  "comm_bvp": 0.114077695,
  "comm_cctrcap": 0.165897825,
  "comm_incarpct": 0.005879238,
  "comm_juvcrimecap": 186.3696836,
  "comm_libcap": 0.165897825,
  "comm_ltbvp": 0.112350308,
  "comm_ltrvp": 0.018759702,
  "comm_ocb": 3284.381105,
  "comm_ocbp": 0.326717576,
  "comm_parkcap": 0.029534636,
  "comm_rcb": 3260.745749,
  "comm_rcbp": 0.513243058,
  "comm_rvp": 0.021717671,
  "comm_u18bbp": 0.699652348,
  "comm_evrate": 172.8655335,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.335960823,
  "econ_fincap": 0.165897825,
  "econ_medinc": 22674.17149,
  "econ_paydaycap": 0.6635913,
  "econ_pctlwjobs": 0.272864829,
  "econ_pctmwjobs": 0.438466711,
  "econ_totjobs": 5948,
  "econ_pr": 0.254438059,
  "econ_pyr": 0.286566155,
  "econ_ur": 0.051478557,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 388.7743078,
  "edu_perbach": 0.044061835,
  "edu_perearlyed": 0.297238053,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 4.689678019,
  "fam_lcckids": 5.158645821,
  "fam_tphh": 4602.638959,
  "fam_tphhpct": 0.597738969,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3298.139288,
  "hel_castthma": 975.2174621,
  "hel_checkup": 6087.344927,
  "hel_fruitsveggies": 340.0179874,
  "hel_le": 74.56306769,
  "hel_mhlth": 1712.995349,
  "hel_obesity": 3781.808435,
  "hel_perpri": 0.353143159,
  "hel_perpub": 0.379770866,
  "hel_prtopu": 0.929884808,
  "hel_pharmacap": 1.990773899,
  "hel_phlth": 1595.259703,
  "hel_sleep": 3556.245286,
  "hel_stroke": 355.2956551,
  "hel_perins": 0.703925647,
  "hel_perunin": 0.295876255,
  "hel_clincap": 0.33179565,
  "hel_groccap": 0.497693475,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 31,
  "ci_index": 59,
  "eci_index": 29,
  "edi_index": 47,
  "fi_index": 72,
  "hi_index": 29,
  "cri_index": 42,
  "ci_weight": 59,
  "eci_weight": 29,
  "edi_weight": 47,
  "fi_weight": 72,
  "hi_weight": 29,
  "cri_weight": 37,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 162,
  "TEA": 234,
  "SLN": 234,
  "SCHOOLNAME": "Gonzalez Personalized Learning Academy",
  "LEVEL": "Elementary",
  "ADDRESS": "6610 Lake June Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9725023300,
  "WEBSITE": "http://www.dallasisd.org/gonzalez",
  "POINT_X": -96.70777002,
  "POINT_Y": 32.73397257,
  "MasterID": "'057905234",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 41628,
  "dem_popwh": 2184,
  "dem_popbl": 10090,
  "dem_popas": 0,
  "dem_pophi": 29182,
  "dem_popm": 20171,
  "dem_popf": 21468,
  "dem_thh": 11257,
  "dem_popse": 3228,
  "dem_popch": 14512,
  "dem_perwh": 0.052464687,
  "dem_perbl": 0.242384933,
  "dem_peras": 0,
  "dem_perhi": 0.701018545,
  "dem_perm": 0.484553666,
  "dem_perf": 0.515710579,
  "dem_perse": 0.077543961,
  "dem_perch": 0.348611511,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.529593167,
  "comm_bvp": 0.106236683,
  "comm_cctrcap": 0.481240256,
  "comm_incarpct": 0.011386971,
  "comm_juvcrimecap": 306.0586608,
  "comm_libcap": 0.240620128,
  "comm_ltbvp": 0.102170929,
  "comm_ltrvp": 0.020792004,
  "comm_ocb": 1541.448464,
  "comm_ocbp": 0.247452291,
  "comm_parkcap": 0.701124248,
  "comm_rcb": 2536.334242,
  "comm_rcbp": 0.503892009,
  "comm_rvp": 0.022472629,
  "comm_u18bbp": 0.518170814,
  "comm_evrate": 130.0551791,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.44704089,
  "econ_fincap": 0.721860383,
  "econ_medinc": 21020.13453,
  "econ_paydaycap": 2.406201278,
  "econ_pctlwjobs": 0.291999088,
  "econ_pctmwjobs": 0.364485981,
  "econ_totjobs": 4387,
  "econ_pr": 0.305079207,
  "econ_pyr": 0.063517547,
  "econ_ur": 0.041533234,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 746.8538055,
  "edu_perbach": 0.031342613,
  "edu_perearlyed": 0.301762115,
  "edu_qeckids": 1.385628582,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 7.620957199,
  "fam_lcckids": 8.31377149,
  "fam_tphh": 2821.671489,
  "fam_tphhpct": 0.59279423,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3590.809417,
  "hel_castthma": 1031.303127,
  "hel_checkup": 6526.637101,
  "hel_fruitsveggies": 288.2358018,
  "hel_le": 74.88140574,
  "hel_mhlth": 1842.235445,
  "hel_obesity": 4093.673039,
  "hel_perpri": 0.297179783,
  "hel_perpub": 0.392476218,
  "hel_prtopu": 0.757191823,
  "hel_pharmacap": 0.962480511,
  "hel_phlth": 1767.016709,
  "hel_sleep": 3848.105027,
  "hel_stroke": 413.7323157,
  "hel_perins": 0.668204093,
  "hel_perunin": 0.331771884,
  "hel_clincap": 0,
  "hel_groccap": 1.203100639,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 2,
  "hi_gen": 20,
  "ci_index": 53,
  "eci_index": 35,
  "edi_index": 47,
  "fi_index": 71,
  "hi_index": 16,
  "cri_index": 38,
  "ci_weight": 53,
  "eci_weight": 35,
  "edi_weight": 47,
  "fi_weight": 71,
  "hi_weight": 16,
  "cri_weight": 30,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 163,
  "TEA": 161,
  "SLN": 161,
  "SCHOOLNAME": "Ireland Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1515 N. Jim Miller Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9727494900,
  "WEBSITE": "http://www.dallasisd.org/ireland",
  "POINT_X": -96.70139866,
  "POINT_Y": 32.73956568,
  "MasterID": "'057905161",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 49300,
  "dem_popwh": 2977,
  "dem_popbl": 10689,
  "dem_popas": 3,
  "dem_pophi": 35377,
  "dem_popm": 24050,
  "dem_popf": 25259,
  "dem_thh": 13353,
  "dem_popse": 3772,
  "dem_popch": 17098,
  "dem_perwh": 0.060385396,
  "dem_perbl": 0.216815416,
  "dem_peras": 0.0000609,
  "dem_perhi": 0.717586207,
  "dem_perm": 0.487829615,
  "dem_perf": 0.512352941,
  "dem_perse": 0.076511156,
  "dem_perch": 0.346815416,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 3,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.542614956,
  "comm_bvp": 0.099436294,
  "comm_cctrcap": 0.813839347,
  "comm_incarpct": 0.009195902,
  "comm_juvcrimecap": 270.9578711,
  "comm_libcap": 0.203459837,
  "comm_ltbvp": 0.094214468,
  "comm_ltrvp": 0.019281857,
  "comm_ocb": 2021.481189,
  "comm_ocbp": 0.262951897,
  "comm_parkcap": 0.479763651,
  "comm_rcb": 2888.852979,
  "comm_rcbp": 0.509540338,
  "comm_rvp": 0.021119291,
  "comm_u18bbp": 0.528375545,
  "comm_evrate": 114.0392385,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.432376429,
  "econ_fincap": 0.813839347,
  "econ_medinc": 21574.04665,
  "econ_paydaycap": 1.83113853,
  "econ_pctlwjobs": 0.358645707,
  "econ_pctmwjobs": 0.426844015,
  "econ_totjobs": 4135,
  "econ_pr": 0.298478221,
  "econ_pyr": 0.11937832,
  "econ_ur": 0.043065584,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 746.2574497,
  "edu_perbach": 0.031472504,
  "edu_perearlyed": 0.269961977,
  "edu_qeckids": 1.175208582,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 8.226460076,
  "fam_lcckids": 9.401668658,
  "fam_tphh": 3497.443446,
  "fam_tphhpct": 0.614954182,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3565.672737,
  "hel_castthma": 1019.445521,
  "hel_checkup": 6504.468772,
  "hel_fruitsveggies": 297.2490042,
  "hel_le": 74.97811549,
  "hel_mhlth": 1829.391789,
  "hel_obesity": 4071.461163,
  "hel_perpri": 0.311536039,
  "hel_perpub": 0.380910772,
  "hel_prtopu": 0.817871432,
  "hel_pharmacap": 1.424218857,
  "hel_phlth": 1760.332071,
  "hel_sleep": 3826.265648,
  "hel_stroke": 407.5798422,
  "hel_perins": 0.670947552,
  "hel_perunin": 0.328910203,
  "hel_clincap": 0.203459837,
  "hel_groccap": 1.424218857,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 21,
  "ci_index": 54,
  "eci_index": 34,
  "edi_index": 41,
  "fi_index": 80,
  "hi_index": 17,
  "cri_index": 40,
  "ci_weight": 54,
  "eci_weight": 34,
  "edi_weight": 41,
  "fi_weight": 80,
  "hi_weight": 17,
  "cri_weight": 31,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 164,
  "TEA": 207,
  "SLN": 207,
  "SCHOOLNAME": "San Jacinto Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7900 Hume Dr.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727494200,
  "WEBSITE": "http://www.dallasisd.org/sanjacinto",
  "POINT_X": -96.68595192,
  "POINT_Y": 32.75697135,
  "MasterID": "'057905207",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 63990,
  "dem_popwh": 4586,
  "dem_popbl": 13671,
  "dem_popas": 77,
  "dem_pophi": 45019,
  "dem_popm": 31474,
  "dem_popf": 32521,
  "dem_thh": 18108,
  "dem_popse": 4918,
  "dem_popch": 21586,
  "dem_perwh": 0.071667448,
  "dem_perbl": 0.213642757,
  "dem_peras": 0.001203313,
  "dem_perhi": 0.703531802,
  "dem_perm": 0.491858103,
  "dem_perf": 0.508220034,
  "dem_perse": 0.076855759,
  "dem_perch": 0.337333958,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.589722571,
  "comm_bvp": 0.097022851,
  "comm_cctrcap": 0.314986519,
  "comm_incarpct": 0.007483441,
  "comm_juvcrimecap": 244.188416,
  "comm_libcap": 0.157493259,
  "comm_ltbvp": 0.091232519,
  "comm_ltrvp": 0.017321054,
  "comm_ocb": 3023.813758,
  "comm_ocbp": 0.287899838,
  "comm_parkcap": 0.253888959,
  "comm_rcb": 3991.712664,
  "comm_rcbp": 0.524446332,
  "comm_rvp": 0.020378329,
  "comm_u18bbp": 0.580341403,
  "comm_evrate": 192.0630299,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 3,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.374540518,
  "econ_fincap": 0.629973038,
  "econ_medinc": 22898.51875,
  "econ_paydaycap": 1.259946075,
  "econ_pctlwjobs": 0.228557013,
  "econ_pctmwjobs": 0.400504541,
  "econ_totjobs": 9910,
  "econ_pr": 0.265372681,
  "econ_pyr": 0.260885693,
  "econ_ur": 0.043483908,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 639.1579175,
  "edu_perbach": 0.04384886,
  "edu_perearlyed": 0.223566133,
  "edu_qeckids": 0.9344414,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.344413999,
  "fam_lcckids": 11.2132968,
  "fam_tphh": 4825.298444,
  "fam_tphhpct": 0.64195054,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3522.263682,
  "hel_castthma": 1004.90117,
  "hel_checkup": 6545.410202,
  "hel_fruitsveggies": 328.6516571,
  "hel_le": 75.29648055,
  "hel_mhlth": 1755.930241,
  "hel_obesity": 3996.468419,
  "hel_perpri": 0.352734074,
  "hel_perpub": 0.354541597,
  "hel_prtopu": 0.994901804,
  "hel_pharmacap": 1.889919113,
  "hel_phlth": 1673.966772,
  "hel_sleep": 3803.574594,
  "hel_stroke": 382.0856013,
  "hel_perins": 0.683353504,
  "hel_perunin": 0.316473602,
  "hel_clincap": 0.157493259,
  "hel_groccap": 1.259946075,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 23,
  "ci_index": 53,
  "eci_index": 33,
  "edi_index": 38,
  "fi_index": 82,
  "hi_index": 21,
  "cri_index": 41,
  "ci_weight": 53,
  "eci_weight": 33,
  "edi_weight": 38,
  "fi_weight": 82,
  "hi_weight": 21,
  "cri_weight": 32,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 165,
  "TEA": 222,
  "SLN": 222,
  "SCHOOLNAME": "Urban Park Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6901 Military Pkwy.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9727941100,
  "WEBSITE": "http://www.dallasisd.org/urbanpark",
  "POINT_X": -96.70165322,
  "POINT_Y": 32.7739152,
  "MasterID": "'057905222",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 52552,
  "dem_popwh": 6516,
  "dem_popbl": 12776,
  "dem_popas": 43,
  "dem_pophi": 32280,
  "dem_popm": 26665,
  "dem_popf": 25891,
  "dem_thh": 16107,
  "dem_popse": 4610,
  "dem_popch": 16430,
  "dem_perwh": 0.123991475,
  "dem_perbl": 0.243111585,
  "dem_peras": 0.000818237,
  "dem_perhi": 0.614248744,
  "dem_perm": 0.507402192,
  "dem_perf": 0.492673923,
  "dem_perse": 0.087722637,
  "dem_perch": 0.312642716,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.654919684,
  "comm_bvp": 0.119375211,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.009631099,
  "comm_juvcrimecap": 270.2611337,
  "comm_libcap": 0.191969146,
  "comm_ltbvp": 0.116773291,
  "comm_ltrvp": 0.022728712,
  "comm_ocb": 2500.532943,
  "comm_ocbp": 0.272531912,
  "comm_parkcap": 0.304291101,
  "comm_rcb": 3361.748013,
  "comm_rcbp": 0.483809491,
  "comm_rvp": 0.02767986,
  "comm_u18bbp": 0.635191748,
  "comm_evrate": 162.0219589,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.378046768,
  "econ_fincap": 2.111660602,
  "econ_medinc": 24276.18447,
  "econ_paydaycap": 0.575907437,
  "econ_pctlwjobs": 0.238715096,
  "econ_pctmwjobs": 0.399468122,
  "econ_totjobs": 14289,
  "econ_pr": 0.24982834,
  "econ_pyr": 0.227837219,
  "econ_ur": 0.045840478,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 530.8049589,
  "edu_perbach": 0.0854637,
  "edu_perearlyed": 0.267371601,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.338317404,
  "fam_lcckids": 8.561370304,
  "fam_tphh": 3978.131738,
  "fam_tphhpct": 0.663358656,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3560.794982,
  "hel_castthma": 987.7755588,
  "hel_checkup": 6664.787667,
  "hel_fruitsveggies": 338.3532852,
  "hel_le": 75.66444904,
  "hel_mhlth": 1632.858539,
  "hel_obesity": 3836.408133,
  "hel_perpri": 0.407453607,
  "hel_perpub": 0.337043505,
  "hel_prtopu": 1.208905085,
  "hel_pharmacap": 2.303627594,
  "hel_phlth": 1584.346883,
  "hel_sleep": 3731.714636,
  "hel_stroke": 380.3123475,
  "hel_perins": 0.711988332,
  "hel_perunin": 0.287992477,
  "hel_clincap": 0.383937932,
  "hel_groccap": 0.575906898,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 25,
  "ci_index": 52,
  "eci_index": 35,
  "edi_index": 52,
  "fi_index": 89,
  "hi_index": 25,
  "cri_index": 44,
  "ci_weight": 52,
  "eci_weight": 35,
  "edi_weight": 52,
  "fi_weight": 89,
  "hi_weight": 25,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 166,
  "TEA": 303,
  "SLN": 303,
  "SCHOOLNAME": "Richardson Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "7203 Bruton Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9728928100,
  "WEBSITE": "http://www.dallasisd.org/richardson",
  "POINT_X": -96.6940325,
  "POINT_Y": 32.75040884,
  "MasterID": "'057905303",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 56282,
  "dem_popwh": 4132,
  "dem_popbl": 9598,
  "dem_popas": 25,
  "dem_pophi": 42082,
  "dem_popm": 27978,
  "dem_popf": 28311,
  "dem_thh": 15365,
  "dem_popse": 4421,
  "dem_popch": 18793,
  "dem_perwh": 0.073416012,
  "dem_perbl": 0.170534096,
  "dem_peras": 0.000444192,
  "dem_perhi": 0.747699087,
  "dem_perm": 0.49710387,
  "dem_perf": 0.503020504,
  "dem_perse": 0.078550869,
  "dem_perch": 0.333907821,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.566179453,
  "comm_bvp": 0.093940677,
  "comm_cctrcap": 0.357848349,
  "comm_incarpct": 0.008058792,
  "comm_juvcrimecap": 182.5250773,
  "comm_libcap": 0.178924175,
  "comm_ltbvp": 0.08822043,
  "comm_ltrvp": 0.018225155,
  "comm_ocb": 2622.719425,
  "comm_ocbp": 0.277598634,
  "comm_parkcap": 0.345230831,
  "comm_rcb": 2974.963767,
  "comm_rcbp": 0.502107669,
  "comm_rvp": 0.020642103,
  "comm_u18bbp": 0.553888812,
  "comm_evrate": 104.9390284,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.379832827,
  "econ_fincap": 0.715696698,
  "econ_medinc": 22308.10371,
  "econ_paydaycap": 1.431393397,
  "econ_pctlwjobs": 0.311427591,
  "econ_pctmwjobs": 0.426218257,
  "econ_totjobs": 5828,
  "econ_pr": 0.266588187,
  "econ_pyr": 0.225529829,
  "econ_ur": 0.042815756,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 741.7915078,
  "edu_perbach": 0.034902254,
  "edu_perearlyed": 0.228661276,
  "edu_qeckids": 1.068863844,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 9.085342674,
  "fam_lcckids": 11.22307036,
  "fam_tphh": 4227.575937,
  "fam_tphhpct": 0.660428153,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3485.452349,
  "hel_castthma": 988.087805,
  "hel_checkup": 6473.39831,
  "hel_fruitsveggies": 312.7024669,
  "hel_le": 74.97618668,
  "hel_mhlth": 1764.513472,
  "hel_obesity": 3975.170614,
  "hel_perpri": 0.335890284,
  "hel_perpub": 0.356542574,
  "hel_prtopu": 0.942076229,
  "hel_pharmacap": 1.610317571,
  "hel_phlth": 1703.124507,
  "hel_sleep": 3765.149326,
  "hel_stroke": 383.3565719,
  "hel_perins": 0.669581232,
  "hel_perunin": 0.330222079,
  "hel_clincap": 0.178924175,
  "hel_groccap": 1.431393397,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 4,
  "hi_gen": 24,
  "ci_index": 57,
  "eci_index": 32,
  "edi_index": 35,
  "fi_index": 83,
  "hi_index": 22,
  "cri_index": 41,
  "ci_weight": 57,
  "eci_weight": 32,
  "edi_weight": 35,
  "fi_weight": 83,
  "hi_weight": 22,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 167,
  "TEA": 119,
  "SLN": 119,
  "SCHOOLNAME": "Chapel Hill Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "12701 Templeton Trail",
  "CITY": "Dallas",
  "ZIP": 75234,
  "PHONE": 9727942400,
  "WEBSITE": "http://www.dallasisd.org/chapelhill",
  "POINT_X": -96.86579406,
  "POINT_Y": 32.9180539,
  "MasterID": "'057905119",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 55387,
  "dem_popwh": 26302,
  "dem_popbl": 2528,
  "dem_popas": 99,
  "dem_pophi": 22410,
  "dem_popm": 27727,
  "dem_popf": 27638,
  "dem_thh": 20680,
  "dem_popse": 7409,
  "dem_popch": 12077,
  "dem_perwh": 0.474876776,
  "dem_perbl": 0.045642479,
  "dem_peras": 0.001787423,
  "dem_perhi": 0.404607579,
  "dem_perm": 0.500604835,
  "dem_perf": 0.49899796,
  "dem_perse": 0.133767852,
  "dem_perch": 0.218047556,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 3,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.836272407,
  "comm_bvp": 0.116088261,
  "comm_cctrcap": 0.726040651,
  "comm_incarpct": 0.001452847,
  "comm_juvcrimecap": 77.90226901,
  "comm_libcap": 0.363020326,
  "comm_ltbvp": 0.100955416,
  "comm_ltrvp": 0.006540424,
  "comm_ocb": 2862.784964,
  "comm_ocbp": 0.23416277,
  "comm_parkcap": 0.019953212,
  "comm_rcb": 3224.728883,
  "comm_rcbp": 0.380948759,
  "comm_rvp": 0.00922345,
  "comm_u18bbp": 0.819904075,
  "comm_evrate": 95.83736599,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.129708508,
  "econ_fincap": 1.815101629,
  "econ_medinc": 41659.19451,
  "econ_paydaycap": 1.089060977,
  "econ_pctlwjobs": 0.253600893,
  "econ_pctmwjobs": 0.373213167,
  "econ_totjobs": 36727,
  "econ_pr": 0.084253436,
  "econ_pyr": 0.20196791,
  "econ_ur": 0.034204376,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 544.2563292,
  "edu_perbach": 0.262733469,
  "edu_perearlyed": 0.418828762,
  "edu_qeckids": 0.838607595,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 3.35443038,
  "fam_lcckids": 15.09493671,
  "fam_tphh": 4282.885192,
  "fam_tphhpct": 0.73630418,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 1470.592314,
  "hel_castthma": 390.9673495,
  "hel_checkup": 3149.483271,
  "hel_fruitsveggies": 447.9705175,
  "hel_le": 80.74772681,
  "hel_mhlth": 602.2643982,
  "hel_obesity": 1449.195325,
  "hel_perpri": 0.642049559,
  "hel_perpub": 0.229862014,
  "hel_prtopu": 2.793195568,
  "hel_pharmacap": 2.54114228,
  "hel_phlth": 581.2842529,
  "hel_sleep": 1476.827671,
  "hel_stroke": 130.7060363,
  "hel_perins": 0.804074556,
  "hel_perunin": 0.195564225,
  "hel_clincap": 0.544530489,
  "hel_groccap": 0.726040651,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 96,
  "ci_index": 92,
  "eci_index": 66,
  "edi_index": 72,
  "fi_index": 86,
  "hi_index": 93,
  "cri_index": 90,
  "ci_weight": 92,
  "eci_weight": 66,
  "edi_weight": 72,
  "fi_weight": 86,
  "hi_weight": 93,
  "cri_weight": 90,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 168,
  "TEA": 279,
  "SLN": 279,
  "SCHOOLNAME": "Junkins Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "2808 Running Duke Dr.",
  "CITY": "Carrollton",
  "ZIP": 75006,
  "PHONE": 9725022400,
  "WEBSITE": "http://www.dallasisd.org/junkins",
  "POINT_X": -96.85631569,
  "POINT_Y": 32.97378701,
  "MasterID": "'057905279",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 59105,
  "dem_popwh": 25158,
  "dem_popbl": 10464,
  "dem_popas": 61,
  "dem_pophi": 16446,
  "dem_popm": 28050,
  "dem_popf": 31054,
  "dem_thh": 27132,
  "dem_popse": 6386,
  "dem_popch": 11458,
  "dem_perwh": 0.425649268,
  "dem_perbl": 0.177040859,
  "dem_peras": 0.001032062,
  "dem_perhi": 0.278250571,
  "dem_perm": 0.474579139,
  "dem_perf": 0.525403942,
  "dem_perse": 0.108045005,
  "dem_perch": 0.193858388,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.85749019,
  "comm_bvp": 0.096971421,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.001144529,
  "comm_juvcrimecap": 71.69368379,
  "comm_libcap": 0,
  "comm_ltbvp": 0.072335807,
  "comm_ltrvp": 0.002736688,
  "comm_ocb": 1808.422144,
  "comm_ocbp": 0.190027549,
  "comm_parkcap": 0.002025231,
  "comm_rcb": 7319.097885,
  "comm_rcbp": 0.415505065,
  "comm_rvp": 0.00503328,
  "comm_u18bbp": 0.844561661,
  "comm_evrate": 64.18634928,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.178499874,
  "econ_fincap": 1.528246411,
  "econ_medinc": 41935.73737,
  "econ_paydaycap": 0.169805157,
  "econ_pctlwjobs": 0.200540343,
  "econ_pctmwjobs": 0.303603395,
  "econ_totjobs": 60332,
  "econ_pr": 0.106492164,
  "econ_pyr": 0.213756789,
  "econ_ur": 0.041051449,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 3,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 0,
  "edu_perbach": 0.296510413,
  "edu_perearlyed": 0.6394081,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 5.273875381,
  "fam_lcckids": 11.42672999,
  "fam_tphh": 3716.399695,
  "fam_tphhpct": 0.626963336,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2585.033086,
  "hel_castthma": 770.3803376,
  "hel_checkup": 5991.627677,
  "hel_fruitsveggies": 453.5664266,
  "hel_le": 79.91913074,
  "hel_mhlth": 1141.471335,
  "hel_obesity": 2809.150545,
  "hel_perpri": 0.684651526,
  "hel_perpub": 0.207727666,
  "hel_prtopu": 3.295909202,
  "hel_pharmacap": 2.974969475,
  "hel_phlth": 961.2352187,
  "hel_sleep": 2955.134435,
  "hel_stroke": 203.2037154,
  "hel_perins": 0.836541886,
  "hel_perunin": 0.163356344,
  "hel_clincap": 0,
  "hel_groccap": 0.297496948,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 55,
  "ci_index": 86,
  "eci_index": 62,
  "edi_index": 0,
  "fi_index": 84,
  "hi_index": 60,
  "cri_index": 44,
  "ci_weight": 86,
  "eci_weight": 62,
  "edi_weight": 0,
  "fi_weight": 84,
  "hi_weight": 60,
  "cri_weight": 63,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 0,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 3
}, {
  "OBJECTID": 169,
  "TEA": 304,
  "SLN": 304,
  "SCHOOLNAME": "Bush Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3939 Spring Valley Rd.",
  "CITY": "Addison",
  "ZIP": 75001,
  "PHONE": 9729251700,
  "WEBSITE": "http://www.dallasisd.org/georgehwbush",
  "POINT_X": -96.84982527,
  "POINT_Y": 32.94182652,
  "MasterID": "'057905304",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 54358,
  "dem_popwh": 22346,
  "dem_popbl": 5790,
  "dem_popas": 71,
  "dem_pophi": 19504,
  "dem_popm": 26585,
  "dem_popf": 27763,
  "dem_thh": 24099,
  "dem_popse": 5964,
  "dem_popch": 10505,
  "dem_perwh": 0.411089444,
  "dem_perbl": 0.10651606,
  "dem_peras": 0.001306155,
  "dem_perhi": 0.358806431,
  "dem_perm": 0.489072446,
  "dem_perf": 0.510743589,
  "dem_perse": 0.109717061,
  "dem_perch": 0.193255823,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 3,
  "dem_popse_sd": 2,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 0,
  "comm_bbp": 0.896090855,
  "comm_bvp": 0.121575739,
  "comm_cctrcap": 0.368495802,
  "comm_incarpct": 0.001669192,
  "comm_juvcrimecap": 18.51530829,
  "comm_libcap": 0.184247901,
  "comm_ltbvp": 0.097889829,
  "comm_ltrvp": 0.004942782,
  "comm_ocb": 1906.261278,
  "comm_ocbp": 0.220918365,
  "comm_parkcap": 0.00000176,
  "comm_rcb": 5486.100593,
  "comm_rcbp": 0.354521364,
  "comm_rvp": 0.008350899,
  "comm_u18bbp": 0.881780629,
  "comm_evrate": 166.9285981,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.160739316,
  "econ_fincap": 1.658231107,
  "econ_medinc": 43484.91094,
  "econ_paydaycap": 0.921239504,
  "econ_pctlwjobs": 0.174777946,
  "econ_pctmwjobs": 0.285890055,
  "econ_totjobs": 111347,
  "econ_pr": 0.089470994,
  "econ_pyr": 0.188985987,
  "econ_ur": 0.037466541,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 4,
  "edu_oostkids": 387.1130545,
  "edu_perbach": 0.315090275,
  "edu_perearlyed": 0.490650045,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.64667762,
  "fam_lcckids": 16.24918994,
  "fam_tphh": 3365.889623,
  "fam_tphhpct": 0.632699684,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 1311.253058,
  "hel_castthma": 416.4861837,
  "hel_checkup": 3243.795329,
  "hel_fruitsveggies": 460.8065807,
  "hel_le": 81.43885551,
  "hel_mhlth": 612.1323976,
  "hel_obesity": 1476.298008,
  "hel_perpri": 0.6916504,
  "hel_perpub": 0.200342529,
  "hel_prtopu": 3.452339369,
  "hel_pharmacap": 2.026726908,
  "hel_phlth": 498.7038911,
  "hel_sleep": 1612.772333,
  "hel_stroke": 104.0783719,
  "hel_perins": 0.837354057,
  "hel_perunin": 0.162443372,
  "hel_clincap": 0.184247901,
  "hel_groccap": 0.184247901,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 100,
  "ci_index": 93,
  "eci_index": 72,
  "edi_index": 70,
  "fi_index": 85,
  "hi_index": 100,
  "cri_index": 94,
  "ci_weight": 93,
  "eci_weight": 72,
  "edi_weight": 70,
  "fi_weight": 85,
  "hi_weight": 100,
  "cri_weight": 94,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 4,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 170,
  "TEA": 154,
  "SLN": 154,
  "SCHOOLNAME": "Smith Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "5229 Gus Thomasson Rd.",
  "CITY": "Mesquite",
  "ZIP": 75150,
  "PHONE": 9725024800,
  "WEBSITE": "http://www.dallasisd.org/lgsmith",
  "POINT_X": -96.65883478,
  "POINT_Y": 32.83281267,
  "MasterID": "'057905154",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 74081,
  "dem_popwh": 18594,
  "dem_popbl": 10290,
  "dem_popas": 154,
  "dem_pophi": 42072,
  "dem_popm": 36011,
  "dem_popf": 38054,
  "dem_thh": 24509,
  "dem_popse": 7493,
  "dem_popch": 21828,
  "dem_perwh": 0.250995532,
  "dem_perbl": 0.138902013,
  "dem_peras": 0.002078806,
  "dem_perhi": 0.5679189,
  "dem_perm": 0.486103049,
  "dem_perf": 0.513680971,
  "dem_perse": 0.101146043,
  "dem_perch": 0.29465045,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 3,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.760818177,
  "comm_bvp": 0.250286582,
  "comm_cctrcap": 0.271071034,
  "comm_incarpct": 0.005679734,
  "comm_juvcrimecap": 151.5066605,
  "comm_libcap": 0,
  "comm_ltbvp": 0.225659319,
  "comm_ltrvp": 0.023309297,
  "comm_ocb": 2912.987718,
  "comm_ocbp": 0.223255288,
  "comm_parkcap": 0.010908499,
  "comm_rcb": 5756.898164,
  "comm_rcbp": 0.502039115,
  "comm_rvp": 0.029000861,
  "comm_u18bbp": 0.772706869,
  "comm_evrate": 187.2423167,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.243730398,
  "econ_fincap": 0.677677585,
  "econ_medinc": 27459.27323,
  "econ_paydaycap": 0.677677585,
  "econ_pctlwjobs": 0.336959747,
  "econ_pctmwjobs": 0.410048462,
  "econ_totjobs": 10111,
  "econ_pr": 0.174559302,
  "econ_pyr": 0.310218559,
  "econ_ur": 0.051701267,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 2,
  "edu_oostkids": 450.0065689,
  "edu_perbach": 0.113053272,
  "edu_perearlyed": 0.350341358,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.909005663,
  "fam_lcckids": 9.672607929,
  "fam_tphh": 5176.231642,
  "fam_tphhpct": 0.601488464,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3348.525819,
  "hel_castthma": 945.3756103,
  "hel_checkup": 6549.121247,
  "hel_fruitsveggies": 373.9571173,
  "hel_le": 78.33529352,
  "hel_mhlth": 1586.397264,
  "hel_obesity": 3550.374092,
  "hel_perpri": 0.442666883,
  "hel_perpub": 0.325036544,
  "hel_prtopu": 1.361898813,
  "hel_pharmacap": 0.792061507,
  "hel_phlth": 1522.886725,
  "hel_sleep": 3494.31469,
  "hel_stroke": 349.789214,
  "hel_perins": 0.71840994,
  "hel_perunin": 0.281508852,
  "hel_clincap": 0.198015377,
  "hel_groccap": 0.396030754,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 48,
  "eci_index": 29,
  "edi_index": 53,
  "fi_index": 87,
  "hi_index": 29,
  "cri_index": 43,
  "ci_weight": 48,
  "eci_weight": 29,
  "edi_weight": 53,
  "fi_weight": 87,
  "hi_weight": 29,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 171,
  "TEA": 126,
  "SLN": 126,
  "SCHOOLNAME": "Central Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "902 Shady Lane",
  "CITY": "Seagoville",
  "ZIP": 75159,
  "PHONE": 9727496800,
  "WEBSITE": "http://www.dallasisd.org/central",
  "POINT_X": -96.53762355,
  "POINT_Y": 32.65819978,
  "MasterID": "'057905126",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 9955,
  "dem_popwh": 3887,
  "dem_popbl": 1373,
  "dem_popas": 18,
  "dem_pophi": 4541,
  "dem_popm": 4821,
  "dem_popf": 5136,
  "dem_thh": 2817,
  "dem_popse": 865,
  "dem_popch": 3212,
  "dem_perwh": 0.390457057,
  "dem_perbl": 0.137920643,
  "dem_peras": 0.001808137,
  "dem_perhi": 0.456152687,
  "dem_perm": 0.484279257,
  "dem_perf": 0.515921647,
  "dem_perse": 0.08689101,
  "dem_perch": 0.322651934,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 1,
  "dem_perch_sd": 4,
  "comm_bbp": 0.772287067,
  "comm_bvp": 0.108007401,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.001838596,
  "comm_juvcrimecap": 0,
  "comm_libcap": 0,
  "comm_ltbvp": 0.096162834,
  "comm_ltrvp": 0.022697493,
  "comm_ocb": 469.2434929,
  "comm_ocbp": 0.244254598,
  "comm_parkcap": 0,
  "comm_rcb": 396.5785715,
  "comm_rcbp": 0.442625919,
  "comm_rvp": 0.026711786,
  "comm_u18bbp": 0.753736528,
  "comm_evrate": 86.33398297,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.232583839,
  "econ_fincap": 0,
  "econ_medinc": 27714.32757,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.324418605,
  "econ_pctmwjobs": 0.475581395,
  "econ_totjobs": 2580,
  "econ_pr": 0.159572242,
  "econ_pyr": 0.200964611,
  "econ_ur": 0.051196026,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 2,
  "edu_oostkids": 0,
  "edu_perbach": 0.08729097,
  "edu_perearlyed": 0.340490798,
  "edu_qeckids": 6.233430251,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 6.233430251,
  "fam_lcckids": 6.233430251,
  "fam_tphh": 794.8466906,
  "fam_tphhpct": 0.625758501,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3178.764007,
  "hel_castthma": 965.4228341,
  "hel_checkup": 6280.169987,
  "hel_fruitsveggies": 376.9045427,
  "hel_le": 76.03439327,
  "hel_mhlth": 1735.698748,
  "hel_obesity": 3639.383333,
  "hel_perpri": 0.455526992,
  "hel_perpub": 0.396812339,
  "hel_prtopu": 1.147965794,
  "hel_pharmacap": 0,
  "hel_phlth": 1586.846257,
  "hel_sleep": 3481.582295,
  "hel_stroke": 315.7250428,
  "hel_perins": 0.795269923,
  "hel_perunin": 0.204524422,
  "hel_clincap": 0,
  "hel_groccap": 0,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 59,
  "eci_index": 36,
  "edi_index": 0,
  "fi_index": 63,
  "hi_index": 17,
  "cri_index": 36,
  "ci_weight": 59,
  "eci_weight": 36,
  "edi_weight": 0,
  "fi_weight": 63,
  "hi_weight": 17,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 0,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 172,
  "TEA": 208,
  "SLN": 208,
  "SCHOOLNAME": "Seagoville Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "304 N. Kaufman St.",
  "CITY": "Seagoville",
  "ZIP": 75159,
  "PHONE": 9728927900,
  "WEBSITE": "http://www.dallasisd.org/seagovillees",
  "POINT_X": -96.54013768,
  "POINT_Y": 32.64082544,
  "MasterID": "'057905208",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 6529,
  "dem_popwh": 2564,
  "dem_popbl": 915,
  "dem_popas": 18,
  "dem_pophi": 2941,
  "dem_popm": 3313,
  "dem_popf": 3218,
  "dem_thh": 1794,
  "dem_popse": 598,
  "dem_popch": 2007,
  "dem_perwh": 0.39270945,
  "dem_perbl": 0.140143973,
  "dem_peras": 0.002756931,
  "dem_perhi": 0.45045183,
  "dem_perm": 0.507428396,
  "dem_perf": 0.492877929,
  "dem_perse": 0.091591362,
  "dem_perch": 0.307397764,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 2,
  "dem_perch_sd": 3,
  "comm_bbp": 0.750379748,
  "comm_bvp": 0.134507386,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.002748403,
  "comm_juvcrimecap": 0,
  "comm_libcap": 0,
  "comm_ltbvp": 0.115633542,
  "comm_ltrvp": 0.023952347,
  "comm_ocb": 283.9077993,
  "comm_ocbp": 0.22864517,
  "comm_parkcap": 0.059554985,
  "comm_rcb": 242.6305248,
  "comm_rcbp": 0.438855999,
  "comm_rvp": 0.029693683,
  "comm_u18bbp": 0.734551832,
  "comm_evrate": 112.7983613,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 1,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 3,
  "econ_cpr": 0.235493369,
  "econ_fincap": 0,
  "econ_medinc": 23694.82323,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.316480124,
  "econ_pctmwjobs": 0.474720185,
  "econ_totjobs": 2591,
  "econ_pr": 0.172237578,
  "econ_pyr": 0.174985828,
  "econ_ur": 0.040958582,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 0,
  "edu_perbach": 0.080039771,
  "edu_perearlyed": 0.348837209,
  "edu_qeckids": 10.00381449,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 10.00381449,
  "fam_lcckids": 10.00381449,
  "fam_tphh": 461.749957,
  "fam_tphhpct": 0.603521529,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3142.524202,
  "hel_castthma": 959.0756982,
  "hel_checkup": 6210.886554,
  "hel_fruitsveggies": 365.636965,
  "hel_le": 76.26390958,
  "hel_mhlth": 1720.770944,
  "hel_obesity": 3611.178583,
  "hel_perpri": 0.439341564,
  "hel_perpub": 0.407572016,
  "hel_prtopu": 1.077948304,
  "hel_pharmacap": 0,
  "hel_phlth": 1564.520887,
  "hel_sleep": 3472.130647,
  "hel_stroke": 313.223778,
  "hel_perins": 0.786502058,
  "hel_perunin": 0.213333333,
  "hel_clincap": 0,
  "hel_groccap": 0,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 56,
  "eci_index": 36,
  "edi_index": 0,
  "fi_index": 64,
  "hi_index": 17,
  "cri_index": 36,
  "ci_weight": 56,
  "eci_weight": 36,
  "edi_weight": 0,
  "fi_weight": 64,
  "hi_weight": 17,
  "cri_weight": 26,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 0,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 173,
  "TEA": 244,
  "SLN": 244,
  "SCHOOLNAME": "Seagoville North Elementary",
  "LEVEL": "Elementary",
  "ADDRESS": "1906 Seagoville Rd.",
  "CITY": "Seagoville",
  "ZIP": 75159,
  "PHONE": 9728925300,
  "WEBSITE": "http://www.dallasisd.org/seagovillenorth",
  "POINT_X": -96.55654556,
  "POINT_Y": 32.66375585,
  "MasterID": "'057905244",
  "Feeder": "Seagoville",
  "HIGH_SLN": 15,
  "dem_totp": 14635,
  "dem_popwh": 4266,
  "dem_popbl": 1742,
  "dem_popas": 42,
  "dem_pophi": 8401,
  "dem_popm": 7164,
  "dem_popf": 7474,
  "dem_thh": 4035,
  "dem_popse": 1062,
  "dem_popch": 5070,
  "dem_perwh": 0.291492996,
  "dem_perbl": 0.119029723,
  "dem_peras": 0.002869833,
  "dem_perhi": 0.574034848,
  "dem_perm": 0.489511445,
  "dem_perf": 0.510693543,
  "dem_perse": 0.072565767,
  "dem_perch": 0.346429792,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.778033956,
  "comm_bvp": 0.122579394,
  "comm_cctrcap": 0,
  "comm_incarpct": 0.001888727,
  "comm_juvcrimecap": 45.31303278,
  "comm_libcap": 0,
  "comm_ltbvp": 0.109186942,
  "comm_ltrvp": 0.025404419,
  "comm_ocb": 672.9956623,
  "comm_ocbp": 0.265170702,
  "comm_parkcap": 0.161281934,
  "comm_rcb": 673.3994696,
  "comm_rcbp": 0.449946614,
  "comm_rvp": 0.029855573,
  "comm_u18bbp": 0.779175565,
  "comm_evrate": 190.3379084,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 0,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 0,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.293081314,
  "econ_fincap": 0,
  "econ_medinc": 23071.98504,
  "econ_paydaycap": 0,
  "econ_pctlwjobs": 0.285585042,
  "econ_pctmwjobs": 0.455669481,
  "econ_totjobs": 3316,
  "econ_pr": 0.206520336,
  "econ_pyr": 0.214767868,
  "econ_ur": 0.042663667,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 4,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 0,
  "edu_perbach": 0.050271248,
  "edu_perearlyed": 0.32832618,
  "edu_qeckids": 1.984802635,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 1.984802635,
  "fam_lcckids": 1.984802635,
  "fam_tphh": 1086.049424,
  "fam_tphhpct": 0.550190997,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3126.473651,
  "hel_castthma": 976.8043924,
  "hel_checkup": 6209.267598,
  "hel_fruitsveggies": 350.9354799,
  "hel_le": 75.76879721,
  "hel_mhlth": 1803.451089,
  "hel_obesity": 3716.320296,
  "hel_perpri": 0.343240986,
  "hel_perpub": 0.426841153,
  "hel_prtopu": 0.804142205,
  "hel_pharmacap": 0.441941932,
  "hel_phlth": 1621.682156,
  "hel_sleep": 3564.882358,
  "hel_stroke": 315.5763775,
  "hel_perins": 0.731936517,
  "hel_perunin": 0.267993874,
  "hel_clincap": 0.441941932,
  "hel_groccap": 0,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 0,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 0,
  "hi_gen": 32,
  "ci_index": 53,
  "eci_index": 35,
  "edi_index": 2,
  "fi_index": 19,
  "hi_index": 26,
  "cri_index": 36,
  "ci_weight": 53,
  "eci_weight": 35,
  "edi_weight": 2,
  "fi_weight": 19,
  "hi_weight": 26,
  "cri_weight": 26,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 0,
  "fi_weight_sd": 0,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 174,
  "TEA": 173,
  "SLN": 173,
  "SCHOOLNAME": "Lanier Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1400 Walmsley Ave.",
  "CITY": "Dallas",
  "ZIP": 75208,
  "PHONE": 9727944400,
  "WEBSITE": "http://www.dallasisd.org/lanier",
  "POINT_X": -96.84409245,
  "POINT_Y": 32.76891302,
  "MasterID": "'057905173",
  "Feeder": "Pinkston",
  "HIGH_SLN": 12,
  "dem_totp": 51171,
  "dem_popwh": 10033,
  "dem_popbl": 8460,
  "dem_popas": 90,
  "dem_pophi": 31264,
  "dem_popm": 26478,
  "dem_popf": 24665,
  "dem_thh": 17840,
  "dem_popse": 5010,
  "dem_popch": 13614,
  "dem_perwh": 0.196068085,
  "dem_perbl": 0.165328018,
  "dem_peras": 0.001758809,
  "dem_perhi": 0.610971058,
  "dem_perm": 0.51744152,
  "dem_perf": 0.482011295,
  "dem_perse": 0.097907018,
  "dem_perch": 0.266049129,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 2,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 3,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.739340106,
  "comm_bvp": 0.090247024,
  "comm_cctrcap": 1.398110105,
  "comm_incarpct": 0.006154098,
  "comm_juvcrimecap": 319.4531793,
  "comm_libcap": 0.39946003,
  "comm_ltbvp": 0.089190429,
  "comm_ltrvp": 0.021778896,
  "comm_ocb": 1661.34358,
  "comm_ocbp": 0.22569487,
  "comm_parkcap": 0.360292617,
  "comm_rcb": 4415.975782,
  "comm_rcbp": 0.421160014,
  "comm_rvp": 0.022616087,
  "comm_u18bbp": 0.730116897,
  "comm_evrate": 171.5680829,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 3,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.384280539,
  "econ_fincap": 2.396760181,
  "econ_medinc": 25739.37669,
  "econ_paydaycap": 1.398110105,
  "econ_pctlwjobs": 0.202800961,
  "econ_pctmwjobs": 0.414706626,
  "econ_totjobs": 31632,
  "econ_pr": 0.248814248,
  "econ_pyr": 0.356999396,
  "econ_ur": 0.068978822,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 1,
  "econ_ur_sd": 1,
  "edu_oostkids": 2182.047132,
  "edu_perbach": 0.162888199,
  "edu_perearlyed": 0.503040354,
  "edu_qeckids": 0.752689594,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 14.30110228,
  "fam_lcckids": 19.56992943,
  "fam_tphh": 2786.356592,
  "fam_tphhpct": 0.535152423,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3386.43954,
  "hel_castthma": 921.5483754,
  "hel_checkup": 6499.119099,
  "hel_fruitsveggies": 339.6976695,
  "hel_le": 74.57794437,
  "hel_mhlth": 1587.170155,
  "hel_obesity": 3741.905999,
  "hel_perpri": 0.435577689,
  "hel_perpub": 0.319262948,
  "hel_prtopu": 1.364322705,
  "hel_pharmacap": 3.994600301,
  "hel_phlth": 1560.249596,
  "hel_sleep": 3541.585302,
  "hel_stroke": 359.7982901,
  "hel_perins": 0.725796813,
  "hel_perunin": 0.27376494,
  "hel_clincap": 1.797570136,
  "hel_groccap": 1.997300151,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 30,
  "ci_index": 60,
  "eci_index": 35,
  "edi_index": 78,
  "fi_index": 90,
  "hi_index": 38,
  "cri_index": 46,
  "ci_weight": 60,
  "eci_weight": 35,
  "edi_weight": 78,
  "fi_weight": 90,
  "hi_weight": 38,
  "cri_weight": 48,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 175,
  "TEA": 194,
  "SLN": 194,
  "SCHOOLNAME": "Polk Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "6911 Victoria Ave.",
  "CITY": "Dallas",
  "ZIP": 75209,
  "PHONE": 9727948900,
  "WEBSITE": "http://www.dallasisd.org/polk",
  "POINT_X": -96.83168387,
  "POINT_Y": 32.84225703,
  "MasterID": "'057905194",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 49242,
  "dem_popwh": 30429,
  "dem_popbl": 3969,
  "dem_popas": 122,
  "dem_pophi": 12005,
  "dem_popm": 24993,
  "dem_popf": 24247,
  "dem_thh": 21749,
  "dem_popse": 5947,
  "dem_popch": 9729,
  "dem_perwh": 0.617948093,
  "dem_perbl": 0.080601925,
  "dem_peras": 0.00247756,
  "dem_perhi": 0.243795947,
  "dem_perm": 0.507554527,
  "dem_perf": 0.492404858,
  "dem_perse": 0.120770887,
  "dem_perch": 0.197575241,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 4,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 4,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 3,
  "dem_perf_sd": 1,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.871613274,
  "comm_bvp": 0.11923354,
  "comm_cctrcap": 0.817684539,
  "comm_incarpct": 0.00249938,
  "comm_juvcrimecap": 108.9092699,
  "comm_libcap": 0.204421135,
  "comm_ltbvp": 0.11147772,
  "comm_ltrvp": 0.009578507,
  "comm_ocb": 2874.863806,
  "comm_ocbp": 0.273957224,
  "comm_parkcap": 0.036231566,
  "comm_rcb": 4527.97638,
  "comm_rcbp": 0.402019728,
  "comm_rvp": 0.012354316,
  "comm_u18bbp": 0.869045311,
  "comm_evrate": 90.1497204,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.112714514,
  "econ_fincap": 5.519370637,
  "econ_medinc": 49305.91275,
  "econ_paydaycap": 1.839790212,
  "econ_pctlwjobs": 0.14906558,
  "econ_pctmwjobs": 0.239757512,
  "econ_totjobs": 49817,
  "econ_pr": 0.101250427,
  "econ_pyr": 0.156192394,
  "econ_ur": 0.030242694,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1238.229849,
  "edu_perbach": 0.326476926,
  "edu_perearlyed": 0.622144112,
  "edu_qeckids": 1.032718807,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 4,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.163594034,
  "fam_lcckids": 15.4907821,
  "fam_tphh": 3732.265667,
  "fam_tphhpct": 0.767222664,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2138.735211,
  "hel_castthma": 603.7770979,
  "hel_checkup": 4876.595212,
  "hel_fruitsveggies": 456.9385579,
  "hel_le": 80.53181068,
  "hel_mhlth": 899.3988802,
  "hel_obesity": 2280.309863,
  "hel_perpri": 0.72087701,
  "hel_perpub": 0.195896933,
  "hel_prtopu": 3.679879003,
  "hel_pharmacap": 5.519370637,
  "hel_phlth": 806.1691481,
  "hel_sleep": 2358.598929,
  "hel_stroke": 178.8138844,
  "hel_perins": 0.846829727,
  "hel_perunin": 0.15292507,
  "hel_clincap": 1.430947943,
  "hel_groccap": 1.635369078,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 4,
  "hi_gen": 71,
  "ci_index": 81,
  "eci_index": 72,
  "edi_index": 95,
  "fi_index": 90,
  "hi_index": 79,
  "cri_index": 79,
  "ci_weight": 81,
  "eci_weight": 72,
  "edi_weight": 95,
  "fi_weight": 90,
  "hi_weight": 79,
  "cri_weight": 84,
  "ci_weight_sd": 4,
  "eci_weight_sd": 3,
  "edi_weight_sd": 4,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 176,
  "TEA": 107,
  "SLN": 107,
  "SCHOOLNAME": "May Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "9818 Brockbank Dr.",
  "CITY": "Dallas",
  "ZIP": 75220,
  "PHONE": 9729253700,
  "WEBSITE": "Http://www.dallasisd.org/joemay",
  "POINT_X": -96.87501996,
  "POINT_Y": 32.87169062,
  "MasterID": "'057905107",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 55893,
  "dem_popwh": 21779,
  "dem_popbl": 2132,
  "dem_popas": 23,
  "dem_pophi": 30486,
  "dem_popm": 29887,
  "dem_popf": 26004,
  "dem_thh": 18582,
  "dem_popse": 3837,
  "dem_popch": 15286,
  "dem_perwh": 0.389655234,
  "dem_perbl": 0.038144311,
  "dem_peras": 0.000411501,
  "dem_perhi": 0.545435028,
  "dem_perm": 0.534718122,
  "dem_perf": 0.465246095,
  "dem_perse": 0.068649026,
  "dem_perch": 0.273486841,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 0,
  "dem_perch_sd": 2,
  "comm_bbp": 0.684690245,
  "comm_bvp": 0.108795956,
  "comm_cctrcap": 0.180285579,
  "comm_incarpct": 0.002409579,
  "comm_juvcrimecap": 258.7489572,
  "comm_libcap": 0.180285579,
  "comm_ltbvp": 0.104227045,
  "comm_ltrvp": 0.007524112,
  "comm_ocb": 1693.993612,
  "comm_ocbp": 0.246506372,
  "comm_parkcap": 0.150490597,
  "comm_rcb": 5326.182708,
  "comm_rcbp": 0.45471434,
  "comm_rvp": 0.009059258,
  "comm_u18bbp": 0.675294515,
  "comm_evrate": 158.921738,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 3,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.275297,
  "econ_fincap": 2.163426949,
  "econ_medinc": 34498.69952,
  "econ_paydaycap": 3.96628274,
  "econ_pctlwjobs": 0.21414498,
  "econ_pctmwjobs": 0.320396519,
  "econ_totjobs": 48724,
  "econ_pr": 0.176387375,
  "econ_pyr": 0.315843389,
  "econ_ur": 0.047214448,
  "econ_cpr_sd": 3,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 2,
  "econ_paydaycap_sd": 0,
  "econ_pctlwjobs_sd": 3,
  "econ_pctmwjobs_sd": 1,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 486.8667145,
  "edu_perbach": 0.142559388,
  "edu_perearlyed": 0.406364749,
  "edu_qeckids": 0.660606126,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 2.642424502,
  "fam_lcckids": 3.963636753,
  "fam_tphh": 4867.139011,
  "fam_tphhpct": 0.720858133,
  "fam_affcckids_sd": 0,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2858.405571,
  "hel_castthma": 873.0064672,
  "hel_checkup": 6092.973105,
  "hel_fruitsveggies": 395.6644064,
  "hel_le": 77.59342179,
  "hel_mhlth": 1648.389944,
  "hel_obesity": 3565.601165,
  "hel_perpri": 0.366088286,
  "hel_perpub": 0.254895262,
  "hel_prtopu": 1.436230248,
  "hel_pharmacap": 1.802855791,
  "hel_phlth": 1481.045512,
  "hel_sleep": 3476.908036,
  "hel_stroke": 259.0070034,
  "hel_perins": 0.594300099,
  "hel_perunin": 0.405645959,
  "hel_clincap": 0.360571158,
  "hel_groccap": 0.901427896,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 35,
  "ci_index": 63,
  "eci_index": 39,
  "edi_index": 70,
  "fi_index": 75,
  "hi_index": 32,
  "cri_index": 45,
  "ci_weight": 63,
  "eci_weight": 39,
  "edi_weight": 70,
  "fi_weight": 75,
  "hi_weight": 32,
  "cri_weight": 45,
  "ci_weight_sd": 3,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 177,
  "TEA": 13,
  "SLN": 13,
  "SCHOOLNAME": "Roosevelt High School",
  "LEVEL": "High",
  "ADDRESS": "525 Bonnie View Rd.",
  "CITY": "Dallas",
  "ZIP": 75203,
  "PHONE": 9729256800,
  "WEBSITE": "http://www.dallasisd.org/roosevelt",
  "POINT_X": -96.79671581,
  "POINT_Y": 32.7422883,
  "MasterID": "'057905013",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 40750,
  "dem_popwh": 4014,
  "dem_popbl": 15247,
  "dem_popas": 39,
  "dem_pophi": 20901,
  "dem_popm": 21116,
  "dem_popf": 19617,
  "dem_thh": 14069,
  "dem_popse": 4126,
  "dem_popch": 10721,
  "dem_perwh": 0.098503067,
  "dem_perbl": 0.374159509,
  "dem_peras": 0.000957055,
  "dem_perhi": 0.512907975,
  "dem_perm": 0.518184049,
  "dem_perf": 0.481398773,
  "dem_perse": 0.101251534,
  "dem_perch": 0.263092025,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 1,
  "dem_popse_sd": 1,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 3,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.698730939,
  "comm_bvp": 0.149771055,
  "comm_cctrcap": 0.741018998,
  "comm_incarpct": 0.013600504,
  "comm_juvcrimecap": 479.7755126,
  "comm_libcap": 0.494012665,
  "comm_ltbvp": 0.147805289,
  "comm_ltrvp": 0.109114489,
  "comm_ocb": 1442.032342,
  "comm_ocbp": 0.264557065,
  "comm_parkcap": 0.339897463,
  "comm_rcb": 4030.086642,
  "comm_rcbp": 0.466580766,
  "comm_rvp": 0.114933231,
  "comm_u18bbp": 0.743233702,
  "comm_evrate": 203.1627085,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.414100935,
  "econ_fincap": 2.223056993,
  "econ_medinc": 22371.96964,
  "econ_paydaycap": 1.97605066,
  "econ_pctlwjobs": 0.251670379,
  "econ_pctmwjobs": 0.410160718,
  "econ_totjobs": 16613,
  "econ_pr": 0.280537593,
  "econ_pyr": 0.580616794,
  "econ_ur": 0.099702484,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 2230.170568,
  "edu_perbach": 0.127100157,
  "edu_perearlyed": 0.456635319,
  "edu_qeckids": 1.895597593,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 2,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 14.21698195,
  "fam_lcckids": 19.90377473,
  "fam_tphh": 1708.89042,
  "fam_tphhpct": 0.466993037,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4028.063769,
  "hel_castthma": 1031.685212,
  "hel_checkup": 6837.504692,
  "hel_fruitsveggies": 303.6756823,
  "hel_le": 71.5440545,
  "hel_mhlth": 1679.493482,
  "hel_obesity": 4146.641823,
  "hel_perpri": 0.350108278,
  "hel_perpub": 0.385446402,
  "hel_prtopu": 0.908318968,
  "hel_pharmacap": 1.97605066,
  "hel_phlth": 1719.807669,
  "hel_sleep": 3885.042176,
  "hel_stroke": 500.9114325,
  "hel_perins": 0.715326312,
  "hel_perunin": 0.284304558,
  "hel_clincap": 0.98802533,
  "hel_groccap": 0.494012665,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 0,
  "hi_gen": 16,
  "ci_index": 45,
  "eci_index": 22,
  "edi_index": 76,
  "fi_index": 65,
  "hi_index": 16,
  "cri_index": 32,
  "ci_weight": 45,
  "eci_weight": 22,
  "edi_weight": 76,
  "fi_weight": 65,
  "hi_weight": 16,
  "cri_weight": 28,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 178,
  "TEA": 16,
  "SLN": 16,
  "SCHOOLNAME": "South Oak Cliff High School",
  "LEVEL": "High",
  "ADDRESS": "3601 S. Marsalis Ave.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 2149327000,
  "WEBSITE": "http://www.dallasisd.org/soc",
  "POINT_X": -96.81624215,
  "POINT_Y": 32.69955799,
  "MasterID": "'057905016",
  "Feeder": "SOC",
  "HIGH_SLN": 16,
  "dem_totp": 65389,
  "dem_popwh": 3209,
  "dem_popbl": 30045,
  "dem_popas": 50,
  "dem_pophi": 31221,
  "dem_popm": 31150,
  "dem_popf": 34232,
  "dem_thh": 20633,
  "dem_popse": 7904,
  "dem_popch": 19672,
  "dem_perwh": 0.049075533,
  "dem_perbl": 0.459480952,
  "dem_peras": 0.000764655,
  "dem_perhi": 0.477465629,
  "dem_perm": 0.476379819,
  "dem_perf": 0.523513129,
  "dem_perse": 0.1208766,
  "dem_perch": 0.300845708,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 4,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 3,
  "dem_perch_sd": 3,
  "comm_bbp": 0.621621041,
  "comm_bvp": 0.099847745,
  "comm_cctrcap": 0.466686835,
  "comm_incarpct": 0.009728524,
  "comm_juvcrimecap": 294.6868946,
  "comm_libcap": 0.155562278,
  "comm_ltbvp": 0.090604561,
  "comm_ltrvp": 0.027323393,
  "comm_ocb": 2846.156338,
  "comm_ocbp": 0.27566878,
  "comm_parkcap": 0.060023905,
  "comm_rcb": 5560.527622,
  "comm_rcbp": 0.538681374,
  "comm_rvp": 0.032340385,
  "comm_u18bbp": 0.692185583,
  "comm_evrate": 163.18483,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 1,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.407714886,
  "econ_fincap": 1.555622784,
  "econ_medinc": 20519.22986,
  "econ_paydaycap": 1.86674734,
  "econ_pctlwjobs": 0.349464166,
  "econ_pctmwjobs": 0.383958473,
  "econ_totjobs": 5972,
  "econ_pr": 0.307732618,
  "econ_pyr": 0.447552616,
  "econ_ur": 0.097071303,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1638.13083,
  "edu_perbach": 0.068692137,
  "edu_perearlyed": 0.432743363,
  "edu_qeckids": 3.083056769,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 19.5260262,
  "fam_lcckids": 22.09524018,
  "fam_tphh": 3152.775976,
  "fam_tphhpct": 0.497833503,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 4397.077983,
  "hel_castthma": 1104.84618,
  "hel_checkup": 7083.377925,
  "hel_fruitsveggies": 317.8538372,
  "hel_le": 73.38790962,
  "hel_mhlth": 1747.180702,
  "hel_obesity": 4321.108809,
  "hel_perpri": 0.335552147,
  "hel_perpub": 0.447638037,
  "hel_prtopu": 0.749605975,
  "hel_pharmacap": 2.177871897,
  "hel_phlth": 1839.504076,
  "hel_sleep": 3976.163912,
  "hel_stroke": 571.590754,
  "hel_perins": 0.743190184,
  "hel_perunin": 0.256671779,
  "hel_clincap": 0.622249113,
  "hel_groccap": 1.088935949,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 2,
  "hi_gen": 11,
  "ci_index": 50,
  "eci_index": 10,
  "edi_index": 77,
  "fi_index": 94,
  "hi_index": 11,
  "cri_index": 41,
  "ci_weight": 50,
  "eci_weight": 10,
  "edi_weight": 77,
  "fi_weight": 94,
  "hi_weight": 11,
  "cri_weight": 27,
  "ci_weight_sd": 2,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 179,
  "TEA": 7,
  "SLN": 7,
  "SCHOOLNAME": "Jefferson High School",
  "LEVEL": "High",
  "ADDRESS": "4001 Walnut Hill Lane",
  "CITY": "Dallas",
  "ZIP": 75229,
  "PHONE": 9725027300,
  "WEBSITE": "http://www.dallasisd.org/tjefferson",
  "POINT_X": -96.84495028,
  "POINT_Y": 32.88190618,
  "MasterID": "'057905007",
  "Feeder": "Jefferson",
  "HIGH_SLN": 7,
  "dem_totp": 53605,
  "dem_popwh": 29128,
  "dem_popbl": 1196,
  "dem_popas": 57,
  "dem_pophi": 21676,
  "dem_popm": 28096,
  "dem_popf": 25505,
  "dem_thh": 19039,
  "dem_popse": 5854,
  "dem_popch": 13671,
  "dem_perwh": 0.543382147,
  "dem_perbl": 0.022311352,
  "dem_peras": 0.001063334,
  "dem_perhi": 0.404365264,
  "dem_perm": 0.524130212,
  "dem_perf": 0.475795168,
  "dem_perse": 0.109206231,
  "dem_perch": 0.25503218,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 0,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 0,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 4,
  "dem_perf_sd": 0,
  "dem_perse_sd": 2,
  "dem_perch_sd": 2,
  "comm_bbp": 0.773053973,
  "comm_bvp": 0.070876476,
  "comm_cctrcap": 0.373773605,
  "comm_incarpct": 0.001952191,
  "comm_juvcrimecap": 155.1392977,
  "comm_libcap": 0.186886802,
  "comm_ltbvp": 0.06764222,
  "comm_ltrvp": 0.01203639,
  "comm_ocb": 2977.832947,
  "comm_ocbp": 0.266566294,
  "comm_parkcap": 0.041819204,
  "comm_rcb": 3350.301783,
  "comm_rcbp": 0.425634317,
  "comm_rvp": 0.016177259,
  "comm_u18bbp": 0.757168307,
  "comm_evrate": 83.63184409,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 4,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 4,
  "comm_ltrvp_sd": 3,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 3,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.221718252,
  "econ_fincap": 0.74754721,
  "econ_medinc": 59710.12876,
  "econ_paydaycap": 1.308207617,
  "econ_pctlwjobs": 0.271321462,
  "econ_pctmwjobs": 0.352014995,
  "econ_totjobs": 10670,
  "econ_pr": 0.130464701,
  "econ_pyr": 0.292465739,
  "econ_ur": 0.040342444,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 720.5234971,
  "edu_perbach": 0.232011044,
  "edu_perearlyed": 0.473142016,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 3,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.943916229,
  "fam_lcckids": 11.77566492,
  "fam_tphh": 5045.304285,
  "fam_tphhpct": 0.779218578,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 2,
  "hel_bphigh": 2985.035844,
  "hel_castthma": 840.9816694,
  "hel_checkup": 6406.779495,
  "hel_fruitsveggies": 489.7818516,
  "hel_le": 82.11858324,
  "hel_mhlth": 1401.72894,
  "hel_obesity": 3225.456604,
  "hel_perpri": 0.525540092,
  "hel_perpub": 0.239935077,
  "hel_prtopu": 2.190342897,
  "hel_pharmacap": 1.681981222,
  "hel_phlth": 1308.99949,
  "hel_sleep": 3194.718713,
  "hel_stroke": 259.4489369,
  "hel_perins": 0.704096862,
  "hel_perunin": 0.295679266,
  "hel_clincap": 0.186886802,
  "hel_groccap": 0.934434012,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 3,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 42,
  "ci_index": 75,
  "eci_index": 42,
  "edi_index": 65,
  "fi_index": 93,
  "hi_index": 40,
  "cri_index": 52,
  "ci_weight": 75,
  "eci_weight": 42,
  "edi_weight": 65,
  "fi_weight": 93,
  "hi_weight": 40,
  "cri_weight": 54,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 180,
  "TEA": 21,
  "SLN": 21,
  "SCHOOLNAME": "White High School",
  "LEVEL": "High",
  "ADDRESS": "4505 Ridgeside Dr.",
  "CITY": "Dallas",
  "ZIP": 75244,
  "PHONE": 9725026200,
  "WEBSITE": "http://www.dallasisd.org/wtwhite",
  "POINT_X": -96.83167016,
  "POINT_Y": 32.91685785,
  "MasterID": "'057905021",
  "Feeder": "White",
  "HIGH_SLN": 21,
  "dem_totp": 50540,
  "dem_popwh": 25999,
  "dem_popbl": 5104,
  "dem_popas": 62,
  "dem_pophi": 14545,
  "dem_popm": 25166,
  "dem_popf": 25360,
  "dem_thh": 22335,
  "dem_popse": 6567,
  "dem_popch": 10429,
  "dem_perwh": 0.514424218,
  "dem_perbl": 0.100989315,
  "dem_peras": 0.001226751,
  "dem_perhi": 0.287791848,
  "dem_perm": 0.497942224,
  "dem_perf": 0.501780768,
  "dem_perse": 0.129936684,
  "dem_perch": 0.206351405,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 1,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 3,
  "dem_popch_sd": 1,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 1,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 4,
  "dem_perch_sd": 0,
  "comm_bbp": 0.878461795,
  "comm_bvp": 0.121394889,
  "comm_cctrcap": 0.198530969,
  "comm_incarpct": 0.001356057,
  "comm_juvcrimecap": 96.02492751,
  "comm_libcap": 0.397061938,
  "comm_ltbvp": 0.10237797,
  "comm_ltrvp": 0.005934363,
  "comm_ocb": 2447.695734,
  "comm_ocbp": 0.253219186,
  "comm_parkcap": 0.013024702,
  "comm_rcb": 4598.561529,
  "comm_rcbp": 0.363017086,
  "comm_rvp": 0.009810075,
  "comm_u18bbp": 0.870822632,
  "comm_evrate": 211.9318092,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 4,
  "comm_juvcrimecap_sd": 4,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 0,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 4,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.132160363,
  "econ_fincap": 4.566212282,
  "econ_medinc": 56690.78994,
  "econ_paydaycap": 1.58824775,
  "econ_pctlwjobs": 0.189540955,
  "econ_pctmwjobs": 0.279022902,
  "econ_totjobs": 89817,
  "econ_pr": 0.077386422,
  "econ_pyr": 0.145190082,
  "econ_ur": 0.032480191,
  "econ_cpr_sd": 4,
  "econ_fincap_sd": 4,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 4,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 4,
  "econ_pr_sd": 4,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 4,
  "edu_oostkids": 1655.407441,
  "edu_perbach": 0.340431462,
  "edu_perearlyed": 0.428940568,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 2.880639399,
  "fam_lcckids": 24.00532832,
  "fam_tphh": 3841.844354,
  "fam_tphhpct": 0.677944616,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2318.139594,
  "hel_castthma": 632.7817356,
  "hel_checkup": 5280.703334,
  "hel_fruitsveggies": 484.8367244,
  "hel_le": 81.99647853,
  "hel_mhlth": 869.685453,
  "hel_obesity": 2215.686595,
  "hel_perpri": 0.709549335,
  "hel_perpub": 0.195334525,
  "hel_prtopu": 3.632482976,
  "hel_pharmacap": 2.779433563,
  "hel_phlth": 794.2155111,
  "hel_sleep": 2350.586624,
  "hel_stroke": 192.8276662,
  "hel_perins": 0.829600953,
  "hel_perunin": 0.170180663,
  "hel_clincap": 0.198530969,
  "hel_groccap": 0.992654844,
  "hel_bphigh_sd": 4,
  "hel_castthma_sd": 4,
  "hel_checkup_sd": 0,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 4,
  "hel_obesity_sd": 4,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 0,
  "hel_prtopu_sd": 4,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 0,
  "hel_stroke_sd": 0,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 71,
  "ci_index": 84,
  "eci_index": 87,
  "edi_index": 67,
  "fi_index": 84,
  "hi_index": 80,
  "cri_index": 85,
  "ci_weight": 84,
  "eci_weight": 87,
  "edi_weight": 67,
  "fi_weight": 84,
  "hi_weight": 80,
  "cri_weight": 85,
  "ci_weight_sd": 4,
  "eci_weight_sd": 4,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 3,
  "cri_weight_sd": 4
}, {
  "OBJECTID": 181,
  "TEA": 28,
  "SLN": 28,
  "SCHOOLNAME": "Conrad High School",
  "LEVEL": "High",
  "ADDRESS": "7502 Fair Oaks Ave.",
  "CITY": "Dallas",
  "ZIP": 75231,
  "PHONE": 9725022300,
  "WEBSITE": "http://www.dallasisd.org/conrad",
  "POINT_X": -96.75190459,
  "POINT_Y": 32.8763826,
  "MasterID": "'057905028",
  "Feeder": "Conrad",
  "HIGH_SLN": 28,
  "dem_totp": 81784,
  "dem_popwh": 39013,
  "dem_popbl": 15096,
  "dem_popas": 62,
  "dem_pophi": 19118,
  "dem_popm": 41128,
  "dem_popf": 40663,
  "dem_thh": 37526,
  "dem_popse": 9813,
  "dem_popch": 17421,
  "dem_perwh": 0.477024846,
  "dem_perbl": 0.184583782,
  "dem_peras": 0.000758094,
  "dem_perhi": 0.233762105,
  "dem_perm": 0.50288565,
  "dem_perf": 0.497199941,
  "dem_perse": 0.119986794,
  "dem_perch": 0.213012325,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 4,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 4,
  "dem_popf_sd": 4,
  "dem_thh_sd": 4,
  "dem_popse_sd": 4,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 4,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 0,
  "comm_bbp": 0.82196333,
  "comm_bvp": 0.14162706,
  "comm_cctrcap": 0.36989037,
  "comm_incarpct": 0.003159573,
  "comm_juvcrimecap": 176.7926091,
  "comm_libcap": 0.24659358,
  "comm_ltbvp": 0.110505441,
  "comm_ltrvp": 0.007540364,
  "comm_ocb": 2308.02712,
  "comm_ocbp": 0.214492068,
  "comm_parkcap": 0.194900353,
  "comm_rcb": 12042.52186,
  "comm_rcbp": 0.449899402,
  "comm_rvp": 0.010124714,
  "comm_u18bbp": 0.813335501,
  "comm_evrate": 191.788157,
  "comm_bbp_sd": 4,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 3,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 4,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 4,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 0,
  "comm_rcbp_sd": 2,
  "comm_rvp_sd": 4,
  "comm_u18bbp_sd": 4,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.288646264,
  "econ_fincap": 2.959122962,
  "econ_medinc": 46411.77385,
  "econ_paydaycap": 1.726155061,
  "econ_pctlwjobs": 0.24277241,
  "econ_pctmwjobs": 0.304901705,
  "econ_totjobs": 53614,
  "econ_pr": 0.178192139,
  "econ_pyr": 0.209872514,
  "econ_ur": 0.044777602,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 3,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 3,
  "econ_ur_sd": 3,
  "edu_oostkids": 1796.005021,
  "edu_perbach": 0.308217478,
  "edu_perearlyed": 0.41782502,
  "edu_qeckids": 0.578051181,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 4,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 5.780511815,
  "fam_lcckids": 12.71712599,
  "fam_tphh": 5859.618304,
  "fam_tphhpct": 0.6702094,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 2979.753277,
  "hel_castthma": 868.2218548,
  "hel_checkup": 6573.967985,
  "hel_fruitsveggies": 423.7266656,
  "hel_le": 79.84714451,
  "hel_mhlth": 1308.52482,
  "hel_obesity": 3087.154575,
  "hel_perpri": 0.61174471,
  "hel_perpub": 0.268751386,
  "hel_prtopu": 2.276247651,
  "hel_pharmacap": 5.794949134,
  "hel_phlth": 1143.960837,
  "hel_sleep": 3229.537763,
  "hel_stroke": 265.9372195,
  "hel_perins": 0.807645885,
  "hel_perunin": 0.19246496,
  "hel_clincap": 0.986374321,
  "hel_groccap": 1.232967901,
  "hel_bphigh_sd": 3,
  "hel_castthma_sd": 3,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 4,
  "hel_le_sd": 4,
  "hel_mhlth_sd": 3,
  "hel_obesity_sd": 3,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 4,
  "hel_sleep_sd": 1,
  "hel_stroke_sd": 1,
  "hel_perins_sd": 4,
  "hel_perunin_sd": 0,
  "hel_clincap_sd": 3,
  "hel_groccap_sd": 3,
  "hi_gen": 40,
  "ci_index": 67,
  "eci_index": 47,
  "edi_index": 75,
  "fi_index": 96,
  "hi_index": 45,
  "cri_index": 53,
  "ci_weight": 67,
  "eci_weight": 47,
  "edi_weight": 75,
  "fi_weight": 96,
  "hi_weight": 45,
  "cri_weight": 56,
  "ci_weight_sd": 3,
  "eci_weight_sd": 2,
  "edi_weight_sd": 3,
  "fi_weight_sd": 4,
  "hi_weight_sd": 2,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 182,
  "TEA": 14,
  "SLN": 14,
  "SCHOOLNAME": "Samuell High School",
  "LEVEL": "High",
  "ADDRESS": "8928 Palisade Dr.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9728925100,
  "WEBSITE": "http://www.dallasisd.org/samuell",
  "POINT_X": -96.66766042,
  "POINT_Y": 32.74531924,
  "MasterID": "'057905014",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 74513,
  "dem_popwh": 5031,
  "dem_popbl": 16801,
  "dem_popas": 74,
  "dem_pophi": 52093,
  "dem_popm": 35675,
  "dem_popf": 38832,
  "dem_thh": 20294,
  "dem_popse": 4937,
  "dem_popch": 26156,
  "dem_perwh": 0.06751842,
  "dem_perbl": 0.225477433,
  "dem_peras": 0.000993115,
  "dem_perhi": 0.699112906,
  "dem_perm": 0.478775516,
  "dem_perf": 0.521143961,
  "dem_perse": 0.066256895,
  "dem_perch": 0.351025995,
  "dem_totp_sd": 4,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 4,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.614899291,
  "comm_bvp": 0.117228134,
  "comm_cctrcap": 0.404575426,
  "comm_incarpct": 0.006035165,
  "comm_juvcrimecap": 241.4341745,
  "comm_libcap": 0.269716951,
  "comm_ltbvp": 0.111829016,
  "comm_ltrvp": 0.0182811,
  "comm_ocb": 3869.405091,
  "comm_ocbp": 0.309087165,
  "comm_parkcap": 0.050657408,
  "comm_rcb": 4135.388311,
  "comm_rcbp": 0.531368888,
  "comm_rvp": 0.020390077,
  "comm_u18bbp": 0.610418351,
  "comm_evrate": 154.0758082,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.363834274,
  "econ_fincap": 0.674292377,
  "econ_medinc": 22876.67517,
  "econ_paydaycap": 1.618301705,
  "econ_pctlwjobs": 0.279537517,
  "econ_pctmwjobs": 0.429965073,
  "econ_totjobs": 8303,
  "econ_pr": 0.267605859,
  "econ_pyr": 0.274482863,
  "econ_ur": 0.046484002,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 4,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 673.5899443,
  "edu_perbach": 0.036227515,
  "edu_perearlyed": 0.248502994,
  "edu_qeckids": 0.386676202,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 5.800143034,
  "fam_lcckids": 7.346847843,
  "fam_tphh": 5772.539701,
  "fam_tphhpct": 0.632074904,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3536.818899,
  "hel_castthma": 1023.745493,
  "hel_checkup": 6538.997851,
  "hel_fruitsveggies": 336.5964154,
  "hel_le": 75.31331626,
  "hel_mhlth": 1803.025606,
  "hel_obesity": 4060.165268,
  "hel_perpri": 0.355061463,
  "hel_perpub": 0.360583059,
  "hel_prtopu": 0.984687034,
  "hel_pharmacap": 1.888018656,
  "hel_phlth": 1706.532441,
  "hel_sleep": 3827.521279,
  "hel_stroke": 381.9593909,
  "hel_perins": 0.690347283,
  "hel_perunin": 0.309303419,
  "hel_clincap": 0.269716951,
  "hel_groccap": 1.213726279,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 3,
  "hi_gen": 23,
  "ci_index": 57,
  "eci_index": 31,
  "edi_index": 36,
  "fi_index": 93,
  "hi_index": 20,
  "cri_index": 43,
  "ci_weight": 57,
  "eci_weight": 31,
  "edi_weight": 36,
  "fi_weight": 93,
  "hi_weight": 20,
  "cri_weight": 33,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 4,
  "hi_weight_sd": 0,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 183,
  "TEA": 17,
  "SLN": 17,
  "SCHOOLNAME": "Spruce High School",
  "LEVEL": "High",
  "ADDRESS": "9733 Old Seagoville Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9728925500,
  "WEBSITE": "http://www.dallasisd.org/spruce",
  "POINT_X": -96.65385192,
  "POINT_Y": 32.71050456,
  "MasterID": "'057905017",
  "Feeder": "Spruce",
  "HIGH_SLN": 17,
  "dem_totp": 43042,
  "dem_popwh": 3470,
  "dem_popbl": 8920,
  "dem_popas": 3,
  "dem_pophi": 30465,
  "dem_popm": 21158,
  "dem_popf": 21891,
  "dem_thh": 11308,
  "dem_popse": 2531,
  "dem_popch": 15180,
  "dem_perwh": 0.08061893,
  "dem_perbl": 0.207239441,
  "dem_peras": 0.0000697,
  "dem_perhi": 0.707797035,
  "dem_perm": 0.491566377,
  "dem_perf": 0.508596255,
  "dem_perse": 0.05880303,
  "dem_perch": 0.352678779,
  "dem_totp_sd": 1,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 1,
  "dem_popf_sd": 1,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.653405218,
  "comm_bvp": 0.113246832,
  "comm_cctrcap": 0.466942941,
  "comm_incarpct": 0.008998975,
  "comm_juvcrimecap": 194.6419944,
  "comm_libcap": 0.23347147,
  "comm_ltbvp": 0.111650243,
  "comm_ltrvp": 0.017380375,
  "comm_ocb": 2347.220762,
  "comm_ocbp": 0.319681791,
  "comm_parkcap": 0.154711416,
  "comm_rcb": 1972.112393,
  "comm_rcbp": 0.496960135,
  "comm_rvp": 0.018284488,
  "comm_u18bbp": 0.658376486,
  "comm_evrate": 76.81211375,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 2,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 3,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 2,
  "comm_rcb_sd": 4,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 3,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 4,
  "econ_cpr": 0.363251446,
  "econ_fincap": 0.23347147,
  "econ_medinc": 23085.83975,
  "econ_paydaycap": 1.634300293,
  "econ_pctlwjobs": 0.243653032,
  "econ_pctmwjobs": 0.3825811,
  "econ_totjobs": 5672,
  "econ_pr": 0.277819317,
  "econ_pyr": 0.133062125,
  "econ_ur": 0.039179424,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 0,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 4,
  "econ_ur_sd": 3,
  "edu_oostkids": 609.2716911,
  "edu_perbach": 0.026805532,
  "edu_perearlyed": 0.270681265,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 6.012549584,
  "fam_lcckids": 6.680610648,
  "fam_tphh": 3572.376263,
  "fam_tphhpct": 0.663319343,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3292.528825,
  "hel_castthma": 977.0005649,
  "hel_checkup": 6030.326968,
  "hel_fruitsveggies": 319.9599654,
  "hel_le": 74.91725734,
  "hel_mhlth": 1804.379806,
  "hel_obesity": 3893.941695,
  "hel_perpri": 0.314483528,
  "hel_perpub": 0.373077459,
  "hel_prtopu": 0.842944327,
  "hel_pharmacap": 1.400828822,
  "hel_phlth": 1700.777309,
  "hel_sleep": 3608.32028,
  "hel_stroke": 362.8053942,
  "hel_perins": 0.671297802,
  "hel_perunin": 0.328284002,
  "hel_clincap": 0.466942941,
  "hel_groccap": 0.700414411,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 1,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 2,
  "hel_groccap_sd": 1,
  "hi_gen": 31,
  "ci_index": 58,
  "eci_index": 34,
  "edi_index": 39,
  "fi_index": 80,
  "hi_index": 28,
  "cri_index": 42,
  "ci_weight": 58,
  "eci_weight": 34,
  "edi_weight": 39,
  "fi_weight": 80,
  "hi_weight": 28,
  "cri_weight": 38,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 1,
  "fi_weight_sd": 3,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 184,
  "TEA": 25,
  "SLN": 25,
  "SCHOOLNAME": "Skyline High School",
  "LEVEL": "High",
  "ADDRESS": "7777 Forney Rd.",
  "CITY": "Dallas",
  "ZIP": 75227,
  "PHONE": 9725023400,
  "WEBSITE": "http://www.dallasisd.org/skyline",
  "POINT_X": -96.69054992,
  "POINT_Y": 32.78050945,
  "MasterID": "'057905025",
  "Feeder": "Skyline",
  "HIGH_SLN": 25,
  "dem_totp": 59481,
  "dem_popwh": 8292,
  "dem_popbl": 15747,
  "dem_popas": 75,
  "dem_pophi": 34036,
  "dem_popm": 29709,
  "dem_popf": 29773,
  "dem_thh": 19069,
  "dem_popse": 5066,
  "dem_popch": 18531,
  "dem_perwh": 0.139405861,
  "dem_perbl": 0.264740001,
  "dem_peras": 0.001260907,
  "dem_perhi": 0.572216338,
  "dem_perm": 0.499470419,
  "dem_perf": 0.500546393,
  "dem_perse": 0.085170054,
  "dem_perch": 0.311544863,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 2,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 3,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 3,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 1,
  "dem_perch_sd": 3,
  "comm_bbp": 0.678814388,
  "comm_bvp": 0.132299982,
  "comm_cctrcap": 0.169648776,
  "comm_incarpct": 0.008183417,
  "comm_juvcrimecap": 252.0010438,
  "comm_libcap": 0.169648776,
  "comm_ltbvp": 0.129493393,
  "comm_ltrvp": 0.022405394,
  "comm_ocb": 2765.800112,
  "comm_ocbp": 0.279727598,
  "comm_parkcap": 0.098263215,
  "comm_rcb": 4600.589501,
  "comm_rcbp": 0.50035225,
  "comm_rvp": 0.027913168,
  "comm_u18bbp": 0.660374489,
  "comm_evrate": 209.5162386,
  "comm_bbp_sd": 2,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 1,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.374265567,
  "econ_fincap": 2.035785315,
  "econ_medinc": 24967.85782,
  "econ_paydaycap": 1.187541434,
  "econ_pctlwjobs": 0.230980294,
  "econ_pctmwjobs": 0.391319531,
  "econ_totjobs": 20045,
  "econ_pr": 0.245001202,
  "econ_pyr": 0.234493236,
  "econ_ur": 0.041747493,
  "econ_cpr_sd": 1,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 2,
  "econ_pr_sd": 2,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 472.0411139,
  "edu_perbach": 0.092673222,
  "edu_perearlyed": 0.240909091,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 0,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 7.069740186,
  "fam_lcckids": 8.70121869,
  "fam_tphh": 4365.956448,
  "fam_tphhpct": 0.630359834,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3568.776344,
  "hel_castthma": 1005.481895,
  "hel_checkup": 6709.710994,
  "hel_fruitsveggies": 357.4612563,
  "hel_le": 76.42328084,
  "hel_mhlth": 1641.959138,
  "hel_obesity": 3836.282266,
  "hel_perpri": 0.429227225,
  "hel_perpub": 0.335518515,
  "hel_prtopu": 1.279295199,
  "hel_pharmacap": 2.091340955,
  "hel_phlth": 1564.110053,
  "hel_sleep": 3750.417574,
  "hel_stroke": 375.5808192,
  "hel_perins": 0.72664905,
  "hel_perunin": 0.27336789,
  "hel_clincap": 0.321744762,
  "hel_groccap": 0.804361906,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 2,
  "hel_le_sd": 2,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 2,
  "hel_perpub_sd": 2,
  "hel_prtopu_sd": 2,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 2,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 25,
  "ci_index": 50,
  "eci_index": 35,
  "edi_index": 51,
  "fi_index": 88,
  "hi_index": 25,
  "cri_index": 44,
  "ci_weight": 50,
  "eci_weight": 35,
  "edi_weight": 51,
  "fi_weight": 88,
  "hi_weight": 25,
  "cri_weight": 36,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}, {
  "OBJECTID": 185,
  "TEA": 9,
  "SLN": 9,
  "SCHOOLNAME": "Lincoln High School",
  "LEVEL": "High",
  "ADDRESS": "2826 Hatcher St.",
  "CITY": "Dallas",
  "ZIP": 75215,
  "PHONE": 9729257600,
  "WEBSITE": "http://www.dallasisd.org/lincoln",
  "POINT_X": -96.7496989,
  "POINT_Y": 32.75480271,
  "MasterID": "'057905009",
  "Feeder": "Lincoln",
  "HIGH_SLN": 9,
  "dem_totp": 25178,
  "dem_popwh": 967,
  "dem_popbl": 16163,
  "dem_popas": 5,
  "dem_pophi": 7852,
  "dem_popm": 12484,
  "dem_popf": 12688,
  "dem_thh": 9090,
  "dem_popse": 2912,
  "dem_popch": 7082,
  "dem_perwh": 0.038406545,
  "dem_perbl": 0.641949321,
  "dem_peras": 0.000198586,
  "dem_perhi": 0.31185956,
  "dem_perm": 0.495829693,
  "dem_perf": 0.503932004,
  "dem_perse": 0.115656526,
  "dem_perch": 0.281277306,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 0,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 0,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 0,
  "dem_perhi_sd": 0,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.471777605,
  "comm_bvp": 0.095575257,
  "comm_cctrcap": 4.409107253,
  "comm_incarpct": 0.027466878,
  "comm_juvcrimecap": 1119.3762,
  "comm_libcap": 0.400827932,
  "comm_ltbvp": 0.095401692,
  "comm_ltrvp": 0.067332583,
  "comm_ocb": 822.2575732,
  "comm_ocbp": 0.263841529,
  "comm_parkcap": 1.190866456,
  "comm_rcb": 2999.851745,
  "comm_rcbp": 0.500960616,
  "comm_rvp": 0.072022753,
  "comm_u18bbp": 0.500057826,
  "comm_evrate": 420.8693287,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 3,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 4,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 2,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 1,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.450248519,
  "econ_fincap": 0.801655864,
  "econ_medinc": 19031.25174,
  "econ_paydaycap": 2.00413966,
  "econ_pctlwjobs": 0.260877684,
  "econ_pctmwjobs": 0.313912232,
  "econ_totjobs": 5355,
  "econ_pr": 0.339885687,
  "econ_pyr": 0.298227125,
  "econ_ur": 0.111285521,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 1,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 0,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 0,
  "edu_oostkids": 3241.730203,
  "edu_perbach": 0.053463855,
  "edu_perearlyed": 0.404988124,
  "edu_qeckids": 1.426817871,
  "edu_oostkids_sd": 4,
  "edu_perbach_sd": 1,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 3,
  "fam_affcckids": 18.54863233,
  "fam_lcckids": 22.82908594,
  "fam_tphh": 864.9735793,
  "fam_tphhpct": 0.374208801,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 2,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4856.891324,
  "hel_castthma": 1203.428285,
  "hel_checkup": 7301.003018,
  "hel_fruitsveggies": 244.2453357,
  "hel_le": 70.52950398,
  "hel_mhlth": 1876.268248,
  "hel_obesity": 4646.033859,
  "hel_perpri": 0.257692,
  "hel_perpub": 0.496084073,
  "hel_prtopu": 0.519452275,
  "hel_pharmacap": 4.409107253,
  "hel_phlth": 2023.545287,
  "hel_sleep": 4237.469641,
  "hel_stroke": 674.7978529,
  "hel_perins": 0.729161672,
  "hel_perunin": 0.270718453,
  "hel_clincap": 2.805795524,
  "hel_groccap": 1.202483796,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 4,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 4,
  "hel_groccap_sd": 2,
  "hi_gen": 2,
  "ci_index": 15,
  "eci_index": 12,
  "edi_index": 73,
  "fi_index": 34,
  "hi_index": 7,
  "cri_index": 14,
  "ci_weight": 15,
  "eci_weight": 12,
  "edi_weight": 73,
  "fi_weight": 34,
  "hi_weight": 7,
  "cri_weight": 10,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 186,
  "TEA": 206,
  "SLN": 206,
  "SCHOOLNAME": "Sanger Preparatory School",
  "LEVEL": "Elementary",
  "ADDRESS": "8410 San Leandro Dr.",
  "CITY": "Dallas",
  "ZIP": 75218,
  "PHONE": 9727497600,
  "WEBSITE": "http://www.dallasisd.org/sanger",
  "POINT_X": -96.70943206,
  "POINT_Y": 32.8134598,
  "MasterID": "'057905206",
  "Feeder": "Adams",
  "HIGH_SLN": 1,
  "dem_totp": 55777,
  "dem_popwh": 21166,
  "dem_popbl": 11919,
  "dem_popas": 79,
  "dem_pophi": 20694,
  "dem_popm": 27220,
  "dem_popf": 28556,
  "dem_thh": 22586,
  "dem_popse": 5707,
  "dem_popch": 13878,
  "dem_perwh": 0.379475411,
  "dem_perbl": 0.213690231,
  "dem_peras": 0.001416354,
  "dem_perhi": 0.371013142,
  "dem_perm": 0.488014773,
  "dem_perf": 0.511967298,
  "dem_perse": 0.10231816,
  "dem_perch": 0.248812234,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 3,
  "dem_popbl_sd": 2,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 1,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 3,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 2,
  "dem_perf_sd": 2,
  "dem_perse_sd": 2,
  "dem_perch_sd": 1,
  "comm_bbp": 0.766198419,
  "comm_bvp": 0.158287638,
  "comm_cctrcap": 0.360196528,
  "comm_incarpct": 0.006311071,
  "comm_juvcrimecap": 273.9586825,
  "comm_libcap": 0.180098264,
  "comm_ltbvp": 0.134746475,
  "comm_ltrvp": 0.02174004,
  "comm_ocb": 2595.833528,
  "comm_ocbp": 0.238030771,
  "comm_parkcap": 0.290114361,
  "comm_rcb": 5068.552652,
  "comm_rcbp": 0.433378346,
  "comm_rvp": 0.030802789,
  "comm_u18bbp": 0.724072774,
  "comm_evrate": 198.9185325,
  "comm_bbp_sd": 3,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 3,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 3,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 2,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.291924914,
  "econ_fincap": 2.881572222,
  "econ_medinc": 42953.81264,
  "econ_paydaycap": 1.440786111,
  "econ_pctlwjobs": 0.286673354,
  "econ_pctmwjobs": 0.396326877,
  "econ_totjobs": 12959,
  "econ_pr": 0.176064064,
  "econ_pyr": 0.305310319,
  "econ_ur": 0.040117566,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 3,
  "econ_medinc_sd": 4,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 1,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 3,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 1093.981535,
  "edu_perbach": 0.222927528,
  "edu_perearlyed": 0.373846989,
  "edu_qeckids": 0,
  "edu_oostkids_sd": 2,
  "edu_perbach_sd": 3,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 0,
  "fam_affcckids": 9.455957413,
  "fam_lcckids": 16.00238947,
  "fam_tphh": 4037.211888,
  "fam_tphhpct": 0.655671697,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3346.069405,
  "hel_castthma": 949.4104568,
  "hel_checkup": 6748.660818,
  "hel_fruitsveggies": 414.3073134,
  "hel_le": 78.3706208,
  "hel_mhlth": 1431.550264,
  "hel_obesity": 3428.00803,
  "hel_perpri": 0.584466019,
  "hel_perpub": 0.268051061,
  "hel_prtopu": 2.180427929,
  "hel_pharmacap": 2.678240416,
  "hel_phlth": 1341.620358,
  "hel_sleep": 3425.497407,
  "hel_stroke": 328.3784358,
  "hel_perins": 0.799802229,
  "hel_perunin": 0.200287666,
  "hel_clincap": 0.167390026,
  "hel_groccap": 0.83695013,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 2,
  "hel_checkup_sd": 3,
  "hel_fruitsveggies_sd": 3,
  "hel_le_sd": 3,
  "hel_mhlth_sd": 2,
  "hel_obesity_sd": 2,
  "hel_perpri_sd": 4,
  "hel_perpub_sd": 1,
  "hel_prtopu_sd": 3,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 3,
  "hel_sleep_sd": 2,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 3,
  "hel_perunin_sd": 1,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 32,
  "ci_index": 54,
  "eci_index": 34,
  "edi_index": 57,
  "fi_index": 84,
  "hi_index": 34,
  "cri_index": 44,
  "ci_weight": 54,
  "eci_weight": 34,
  "edi_weight": 57,
  "fi_weight": 84,
  "hi_weight": 34,
  "cri_weight": 41,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 2
}, {
  "OBJECTID": 187,
  "TEA": 263,
  "SLN": 263,
  "SCHOOLNAME": "Starks Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "3033 Tips Blvd.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9725028800,
  "WEBSITE": "http://www.dallasisd.org/starks",
  "POINT_X": -96.77409825,
  "POINT_Y": 32.72176631,
  "MasterID": "'057905263",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 31536,
  "dem_popwh": 592,
  "dem_popbl": 20404,
  "dem_popas": 28,
  "dem_pophi": 10201,
  "dem_popm": 14864,
  "dem_popf": 16667,
  "dem_thh": 11464,
  "dem_popse": 4086,
  "dem_popch": 8925,
  "dem_perwh": 0.018772197,
  "dem_perbl": 0.647006596,
  "dem_peras": 0.000887874,
  "dem_perhi": 0.323471588,
  "dem_perm": 0.471334348,
  "dem_perf": 0.528507103,
  "dem_perse": 0.12956621,
  "dem_perch": 0.283009893,
  "dem_totp_sd": 0,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 1,
  "dem_pophi_sd": 0,
  "dem_popm_sd": 0,
  "dem_popf_sd": 0,
  "dem_thh_sd": 0,
  "dem_popse_sd": 1,
  "dem_popch_sd": 0,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 1,
  "dem_perm_sd": 0,
  "dem_perf_sd": 4,
  "dem_perse_sd": 4,
  "dem_perch_sd": 2,
  "comm_bbp": 0.476796797,
  "comm_bvp": 0.132494304,
  "comm_cctrcap": 1.586449146,
  "comm_incarpct": 0.024880372,
  "comm_juvcrimecap": 784.0424324,
  "comm_libcap": 0.317289829,
  "comm_ltbvp": 0.130020249,
  "comm_ltrvp": 0.141335107,
  "comm_ocb": 1412.538897,
  "comm_ocbp": 0.272559168,
  "comm_parkcap": 0.349423548,
  "comm_rcb": 3393.251191,
  "comm_rcbp": 0.538870036,
  "comm_rvp": 0.14844923,
  "comm_u18bbp": 0.525230269,
  "comm_evrate": 352.9849349,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 1,
  "comm_cctrcap_sd": 4,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 3,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 4,
  "comm_ocbp_sd": 1,
  "comm_parkcap_sd": 4,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 0,
  "econ_cpr": 0.511065764,
  "econ_fincap": 1.903738975,
  "econ_medinc": 18567.83117,
  "econ_paydaycap": 1.269159316,
  "econ_pctlwjobs": 0.236124177,
  "econ_pctmwjobs": 0.358733145,
  "econ_totjobs": 3189,
  "econ_pr": 0.367404754,
  "econ_pyr": 0.413648964,
  "econ_ur": 0.097087877,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 2,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1726.529532,
  "edu_perbach": 0.049039972,
  "edu_perearlyed": 0.331388565,
  "edu_qeckids": 1.121123073,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 1,
  "edu_qeckids_sd": 2,
  "fam_affcckids": 14.57459994,
  "fam_lcckids": 13.45347687,
  "fam_tphh": 964.3450384,
  "fam_tphhpct": 0.335404106,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 0,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 5009.829287,
  "hel_castthma": 1210.587506,
  "hel_checkup": 7384.360025,
  "hel_fruitsveggies": 266.4760821,
  "hel_le": 70.82164776,
  "hel_mhlth": 1887.71534,
  "hel_obesity": 4726.608754,
  "hel_perpri": 0.27435312,
  "hel_perpub": 0.483384069,
  "hel_prtopu": 0.567567568,
  "hel_pharmacap": 1.586449146,
  "hel_phlth": 2074.081315,
  "hel_sleep": 4258.120405,
  "hel_stroke": 724.1279646,
  "hel_perins": 0.734493912,
  "hel_perunin": 0.264935312,
  "hel_clincap": 0,
  "hel_groccap": 0.317289829,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 2,
  "hel_perunin_sd": 2,
  "hel_clincap_sd": 0,
  "hel_groccap_sd": 0,
  "hi_gen": 0,
  "ci_index": 3,
  "eci_index": 2,
  "edi_index": 60,
  "fi_index": 29,
  "hi_index": 1,
  "cri_index": 0,
  "ci_weight": 3,
  "eci_weight": 2,
  "edi_weight": 60,
  "fi_weight": 29,
  "hi_weight": 1,
  "cri_weight": 0,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 2,
  "fi_weight_sd": 1,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 188,
  "TEA": 51,
  "SLN": 51,
  "SCHOOLNAME": "Holmes Middle School",
  "LEVEL": "Middle",
  "ADDRESS": "2001 E. Kiest Blvd.",
  "CITY": "Dallas",
  "ZIP": 75216,
  "PHONE": 9729258500,
  "WEBSITE": "http://www.dallasisd.org/owholmes",
  "POINT_X": -96.79096836,
  "POINT_Y": 32.71629627,
  "MasterID": "'057905051",
  "Feeder": "Roosevelt",
  "HIGH_SLN": 13,
  "dem_totp": 50416,
  "dem_popwh": 1208,
  "dem_popbl": 27480,
  "dem_popas": 61,
  "dem_pophi": 21307,
  "dem_popm": 24105,
  "dem_popf": 26297,
  "dem_thh": 17044,
  "dem_popse": 6322,
  "dem_popch": 14775,
  "dem_perwh": 0.023960647,
  "dem_perbl": 0.545065059,
  "dem_peras": 0.001209933,
  "dem_perhi": 0.42262377,
  "dem_perm": 0.478122025,
  "dem_perf": 0.521600286,
  "dem_perse": 0.125396699,
  "dem_perch": 0.293061726,
  "dem_totp_sd": 2,
  "dem_popwh_sd": 0,
  "dem_popbl_sd": 4,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 2,
  "dem_popm_sd": 2,
  "dem_popf_sd": 2,
  "dem_thh_sd": 2,
  "dem_popse_sd": 2,
  "dem_popch_sd": 2,
  "dem_perwh_sd": 0,
  "dem_perbl_sd": 4,
  "dem_peras_sd": 2,
  "dem_perhi_sd": 2,
  "dem_perm_sd": 0,
  "dem_perf_sd": 3,
  "dem_perse_sd": 3,
  "dem_perch_sd": 2,
  "comm_bbp": 0.508448843,
  "comm_bvp": 0.145322308,
  "comm_cctrcap": 0.994806584,
  "comm_incarpct": 0.016429068,
  "comm_juvcrimecap": 556.4448564,
  "comm_libcap": 0.198961317,
  "comm_ltbvp": 0.13924514,
  "comm_ltrvp": 0.112941309,
  "comm_ocb": 2345.834389,
  "comm_ocbp": 0.283464171,
  "comm_parkcap": 0.09633144,
  "comm_rcb": 4867.39973,
  "comm_rcbp": 0.553939019,
  "comm_rvp": 0.120547537,
  "comm_u18bbp": 0.569651526,
  "comm_evrate": 226.0200559,
  "comm_bbp_sd": 0,
  "comm_bvp_sd": 0,
  "comm_cctrcap_sd": 3,
  "comm_incarpct_sd": 0,
  "comm_juvcrimecap_sd": 0,
  "comm_libcap_sd": 2,
  "comm_ltbvp_sd": 0,
  "comm_ltrvp_sd": 0,
  "comm_ocb_sd": 2,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 2,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 0,
  "comm_u18bbp_sd": 0,
  "comm_evrate_sd": 1,
  "econ_cpr": 0.457895205,
  "econ_fincap": 1.392729218,
  "econ_medinc": 18492.58109,
  "econ_paydaycap": 0.795845267,
  "econ_pctlwjobs": 0.302377892,
  "econ_pctmwjobs": 0.352506427,
  "econ_totjobs": 3112,
  "econ_pr": 0.343363978,
  "econ_pyr": 0.464676841,
  "econ_ur": 0.095675851,
  "econ_cpr_sd": 0,
  "econ_fincap_sd": 2,
  "econ_medinc_sd": 0,
  "econ_paydaycap_sd": 3,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 2,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 0,
  "econ_pyr_sd": 0,
  "econ_ur_sd": 0,
  "edu_oostkids": 1628.346644,
  "edu_perbach": 0.050110822,
  "edu_perearlyed": 0.400263331,
  "edu_qeckids": 2.724126549,
  "edu_oostkids_sd": 3,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 2,
  "edu_qeckids_sd": 4,
  "fam_affcckids": 17.70682257,
  "fam_lcckids": 16.34475929,
  "fam_tphh": 2026.566513,
  "fam_tphhpct": 0.44509323,
  "fam_affcckids_sd": 2,
  "fam_lcckids_sd": 1,
  "fam_tphh_sd": 1,
  "fam_tphhpct_sd": 0,
  "hel_bphigh": 4808.772395,
  "hel_castthma": 1171.743949,
  "hel_checkup": 7246.469178,
  "hel_fruitsveggies": 272.5078361,
  "hel_le": 71.41228618,
  "hel_mhlth": 1855.932517,
  "hel_obesity": 4606.496947,
  "hel_perpri": 0.268076656,
  "hel_perpub": 0.47812531,
  "hel_prtopu": 0.560682838,
  "hel_pharmacap": 1.193767901,
  "hel_phlth": 2032.483154,
  "hel_sleep": 4169.27938,
  "hel_stroke": 680.3534616,
  "hel_perins": 0.720822163,
  "hel_perunin": 0.278959388,
  "hel_clincap": 0.198961317,
  "hel_groccap": 0.59688395,
  "hel_bphigh_sd": 0,
  "hel_castthma_sd": 0,
  "hel_checkup_sd": 4,
  "hel_fruitsveggies_sd": 0,
  "hel_le_sd": 0,
  "hel_mhlth_sd": 0,
  "hel_obesity_sd": 0,
  "hel_perpri_sd": 0,
  "hel_perpub_sd": 4,
  "hel_prtopu_sd": 0,
  "hel_pharmacap_sd": 1,
  "hel_phlth_sd": 0,
  "hel_sleep_sd": 4,
  "hel_stroke_sd": 4,
  "hel_perins_sd": 1,
  "hel_perunin_sd": 3,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 1,
  "hi_gen": 3,
  "ci_index": 12,
  "eci_index": 0,
  "edi_index": 72,
  "fi_index": 72,
  "hi_index": 2,
  "cri_index": 12,
  "ci_weight": 12,
  "eci_weight": 0,
  "edi_weight": 72,
  "fi_weight": 72,
  "hi_weight": 2,
  "cri_weight": 7,
  "ci_weight_sd": 0,
  "eci_weight_sd": 0,
  "edi_weight_sd": 3,
  "fi_weight_sd": 3,
  "hi_weight_sd": 0,
  "cri_weight_sd": 0
}, {
  "OBJECTID": 189,
  "TEA": 273,
  "SLN": 273,
  "SCHOOLNAME": "Pleasant Grove Elementary School",
  "LEVEL": "Elementary",
  "ADDRESS": "1614 N. St. Augustine Rd.",
  "CITY": "Dallas",
  "ZIP": 75217,
  "PHONE": 9728925000,
  "WEBSITE": "http://www.dallasisd.org/pleasantgrove",
  "POINT_X": -96.65566288,
  "POINT_Y": 32.73846265,
  "MasterID": "'057905273",
  "Feeder": "Samuell",
  "HIGH_SLN": 14,
  "dem_totp": 67763,
  "dem_popwh": 4778,
  "dem_popbl": 15722,
  "dem_popas": 52,
  "dem_pophi": 46824,
  "dem_popm": 32435,
  "dem_popf": 35320,
  "dem_thh": 18396,
  "dem_popse": 4206,
  "dem_popch": 23979,
  "dem_perwh": 0.070510456,
  "dem_perbl": 0.232014521,
  "dem_peras": 0.00076738,
  "dem_perhi": 0.690996562,
  "dem_perm": 0.478653542,
  "dem_perf": 0.521228399,
  "dem_perse": 0.062069271,
  "dem_perch": 0.353865679,
  "dem_totp_sd": 3,
  "dem_popwh_sd": 1,
  "dem_popbl_sd": 3,
  "dem_popas_sd": 2,
  "dem_pophi_sd": 4,
  "dem_popm_sd": 3,
  "dem_popf_sd": 3,
  "dem_thh_sd": 2,
  "dem_popse_sd": 1,
  "dem_popch_sd": 4,
  "dem_perwh_sd": 1,
  "dem_perbl_sd": 2,
  "dem_peras_sd": 1,
  "dem_perhi_sd": 4,
  "dem_perm_sd": 1,
  "dem_perf_sd": 3,
  "dem_perse_sd": 0,
  "dem_perch_sd": 4,
  "comm_bbp": 0.638904016,
  "comm_bvp": 0.113134135,
  "comm_cctrcap": 0.296513827,
  "comm_incarpct": 0.00594629,
  "comm_juvcrimecap": 217.0483614,
  "comm_libcap": 0.148256913,
  "comm_ltbvp": 0.109710898,
  "comm_ltrvp": 0.017896237,
  "comm_ocb": 3650.63708,
  "comm_ocbp": 0.320548322,
  "comm_parkcap": 0.066259383,
  "comm_rcb": 3730.959834,
  "comm_rcbp": 0.532258603,
  "comm_rvp": 0.019720631,
  "comm_u18bbp": 0.640680927,
  "comm_evrate": 138.5460856,
  "comm_bbp_sd": 1,
  "comm_bvp_sd": 2,
  "comm_cctrcap_sd": 1,
  "comm_incarpct_sd": 2,
  "comm_juvcrimecap_sd": 2,
  "comm_libcap_sd": 1,
  "comm_ltbvp_sd": 2,
  "comm_ltrvp_sd": 2,
  "comm_ocb_sd": 0,
  "comm_ocbp_sd": 0,
  "comm_parkcap_sd": 1,
  "comm_rcb_sd": 3,
  "comm_rcbp_sd": 0,
  "comm_rvp_sd": 2,
  "comm_u18bbp_sd": 1,
  "comm_evrate_sd": 2,
  "econ_cpr": 0.358570695,
  "econ_fincap": 0.593027654,
  "econ_medinc": 22425.4247,
  "econ_paydaycap": 1.779082961,
  "econ_pctlwjobs": 0.305154301,
  "econ_pctmwjobs": 0.395108339,
  "econ_totjobs": 6092,
  "econ_pr": 0.270131715,
  "econ_pyr": 0.293695936,
  "econ_ur": 0.048658071,
  "econ_cpr_sd": 2,
  "econ_fincap_sd": 1,
  "econ_medinc_sd": 1,
  "econ_paydaycap_sd": 2,
  "econ_pctlwjobs_sd": 0,
  "econ_pctmwjobs_sd": 3,
  "econ_totjobs_sd": 1,
  "econ_pr_sd": 1,
  "econ_pyr_sd": 2,
  "econ_ur_sd": 3,
  "edu_oostkids": 637.1807539,
  "edu_perbach": 0.035998349,
  "edu_perearlyed": 0.282206271,
  "edu_qeckids": 0.422533656,
  "edu_oostkids_sd": 1,
  "edu_perbach_sd": 0,
  "edu_perearlyed_sd": 0,
  "edu_qeckids_sd": 1,
  "fam_affcckids": 5.91547119,
  "fam_lcckids": 6.760538503,
  "fam_tphh": 5338.0744,
  "fam_tphhpct": 0.62909,
  "fam_affcckids_sd": 1,
  "fam_lcckids_sd": 0,
  "fam_tphh_sd": 2,
  "fam_tphhpct_sd": 1,
  "hel_bphigh": 3447.96055,
  "hel_castthma": 1004.449389,
  "hel_checkup": 6321.714004,
  "hel_fruitsveggies": 332.4801624,
  "hel_le": 74.93826489,
  "hel_mhlth": 1781.150079,
  "hel_obesity": 3971.334635,
  "hel_perpri": 0.344775172,
  "hel_perpub": 0.371249797,
  "hel_prtopu": 0.92868784,
  "hel_pharmacap": 1.927339875,
  "hel_phlth": 1682.560831,
  "hel_sleep": 3713.240842,
  "hel_stroke": 375.1575864,
  "hel_perins": 0.690642386,
  "hel_perunin": 0.30904771,
  "hel_clincap": 0.296513827,
  "hel_groccap": 1.037798394,
  "hel_bphigh_sd": 2,
  "hel_castthma_sd": 1,
  "hel_checkup_sd": 2,
  "hel_fruitsveggies_sd": 1,
  "hel_le_sd": 1,
  "hel_mhlth_sd": 1,
  "hel_obesity_sd": 1,
  "hel_perpri_sd": 1,
  "hel_perpub_sd": 3,
  "hel_prtopu_sd": 1,
  "hel_pharmacap_sd": 2,
  "hel_phlth_sd": 1,
  "hel_sleep_sd": 3,
  "hel_stroke_sd": 2,
  "hel_perins_sd": 0,
  "hel_perunin_sd": 4,
  "hel_clincap_sd": 1,
  "hel_groccap_sd": 2,
  "hi_gen": 25,
  "ci_index": 58,
  "eci_index": 27,
  "edi_index": 41,
  "fi_index": 89,
  "hi_index": 22,
  "cri_index": 43,
  "ci_weight": 58,
  "eci_weight": 27,
  "edi_weight": 41,
  "fi_weight": 89,
  "hi_weight": 22,
  "cri_weight": 34,
  "ci_weight_sd": 2,
  "eci_weight_sd": 1,
  "edi_weight_sd": 2,
  "fi_weight_sd": 4,
  "hi_weight_sd": 1,
  "cri_weight_sd": 1
}];